/* oxlint-disable */

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Day` scalar type represents number of days by integer value. */
  Day: { input: any; output: any; }
  /**
   * Custom Decimal implementation.
   *
   * Returns Decimal as a float in the API,
   * parses float to the Decimal on the way back.
   */
  Decimal: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /** The `Hour` scalar type represents number of hours by integer value. */
  Hour: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONString: { input: string; output: string; }
  /**
   * Metadata is a map of key-value pairs, both keys and values are `String`.
   *
   * Example:
   * ```
   * {
   *     "key1": "value1",
   *     "key2": "value2"
   * }
   * ```
   */
  Metadata: { input: Record<string, string>; output: Record<string, string>; }
  /** The `Minute` scalar type represents number of minutes by integer value. */
  Minute: { input: any; output: any; }
  /**
   * Nonnegative Decimal scalar implementation.
   *
   * Should be used in places where value must be nonnegative (0 or greater).
   */
  PositiveDecimal: { input: number; output: number; }
  /**
   * Positive Integer scalar implementation.
   *
   * Should be used in places where value must be positive (greater than 0).
   */
  PositiveInt: { input: any; output: any; }
  UUID: { input: string; output: string; }
  /** Variables of this type must be set to null in mutations. They will be replaced with a filename from a following multipart part containing a binary file. See: https://github.com/jaydenseric/graphql-multipart-request-spec. */
  Upload: { input: any; output: any; }
  WeightScalar: { input: number; output: number; }
  /** _Any value scalar as defined by Federation spec. */
  _Any: { input: any; output: any; }
};

/**
 * Create a new address for the customer.
 *
 * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - ADDRESS_CREATED (async): An address was created.
 */
export type SaleorAccountAddressCreate = {
  __typename?: 'AccountAddressCreate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was created. */
  user: Maybe<SaleorUser>;
};

/**
 * Deletes an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
 *
 * Triggers the following webhook events:
 * - ADDRESS_DELETED (async): An address was deleted.
 */
export type SaleorAccountAddressDelete = {
  __typename?: 'AccountAddressDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was deleted. */
  user: Maybe<SaleorUser>;
};

/**
 * Updates an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
 *
 * Triggers the following webhook events:
 * - ADDRESS_UPDATED (async): An address was updated.
 */
export type SaleorAccountAddressUpdate = {
  __typename?: 'AccountAddressUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user object for which the address was edited. */
  user: Maybe<SaleorUser>;
};

/** Event sent when account change email is requested. */
export type SaleorAccountChangeEmailRequested = SaleorEvent & {
  __typename?: 'AccountChangeEmailRequested';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The new email address the user wants to change to. */
  newEmail: Maybe<Scalars['String']['output']>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * AccountConfirmMode set the account merging mode for anonymous objects.
 *
 *     This dictates the behavior of the `confirmAccount()` mutation for
 *     password-based authentication when attempting to merge orders & giftcard
 *     that aren't associated to a user account.
 *
 *     Modes:
 *
 *     - MERGE_DISABLED disables merging only when the authentication method
 *       is password (i.e., when not using OIDC)
 *     - REQUIRE_PASSWORD enables account merging who accounts that use password
 *       authentication but it requires the user to enter their password
 *
 */
export type SaleorAccountConfirmModeEnum =
  | 'MERGE_DISABLED'
  | 'REQUIRE_PASSWORD';

/** Event sent when account confirmation requested. This event is always sent. enableAccountConfirmationByEmail flag set to True is not required. */
export type SaleorAccountConfirmationRequested = SaleorEvent & {
  __typename?: 'AccountConfirmationRequested';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when account is confirmed. */
export type SaleorAccountConfirmed = SaleorEvent & {
  __typename?: 'AccountConfirmed';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Remove user account.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - ACCOUNT_DELETED (async): Account was deleted.
 */
export type SaleorAccountDelete = {
  __typename?: 'AccountDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user: Maybe<SaleorUser>;
};

/** Event sent when account delete is requested. */
export type SaleorAccountDeleteRequested = SaleorEvent & {
  __typename?: 'AccountDeleteRequested';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when account is deleted. */
export type SaleorAccountDeleted = SaleorEvent & {
  __typename?: 'AccountDeleted';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when account email is changed. */
export type SaleorAccountEmailChanged = SaleorEvent & {
  __typename?: 'AccountEmailChanged';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The new email address. */
  newEmail: Maybe<Scalars['String']['output']>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents errors in account mutations. */
export type SaleorAccountError = {
  __typename?: 'AccountError';
  /** A type of address that causes the error. */
  addressType: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorAccountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorAccountErrorCode =
  | 'ACCOUNT_NOT_CONFIRMED'
  | 'ACTIVATE_OWN_ACCOUNT'
  | 'ACTIVATE_SUPERUSER_ACCOUNT'
  | 'CHANNEL_INACTIVE'
  | 'DEACTIVATE_OWN_ACCOUNT'
  | 'DEACTIVATE_SUPERUSER_ACCOUNT'
  | 'DELETE_NON_STAFF_USER'
  | 'DELETE_OWN_ACCOUNT'
  | 'DELETE_STAFF_ACCOUNT'
  | 'DELETE_SUPERUSER_ACCOUNT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INACTIVE'
  | 'INVALID'
  | 'INVALID_CREDENTIALS'
  | 'INVALID_PASSWORD'
  | 'JWT_DECODE_ERROR'
  | 'JWT_INVALID_CSRF_TOKEN'
  | 'JWT_INVALID_TOKEN'
  | 'JWT_MISSING_TOKEN'
  | 'JWT_SIGNATURE_EXPIRED'
  | 'LEFT_NOT_MANAGEABLE_PERMISSION'
  | 'LOGIN_ATTEMPT_DELAYED'
  | 'MISSING_CHANNEL_SLUG'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_GROUP'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'OUT_OF_SCOPE_USER'
  | 'PASSWORD_ENTIRELY_NUMERIC'
  | 'PASSWORD_RESET_ALREADY_REQUESTED'
  | 'PASSWORD_TOO_COMMON'
  | 'PASSWORD_TOO_SHORT'
  | 'PASSWORD_TOO_SIMILAR'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNKNOWN_IP_ADDRESS';

/** Fields required to update the user. */
export type SaleorAccountInput = {
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<SaleorAddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<SaleorAddressInput>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
};

/**
 * Register a new user.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_CREATED (async): A new customer account was created.
 * - NOTIFY_USER (async): A notification for account confirmation.
 * - ACCOUNT_CONFIRMATION_REQUESTED (async): An user confirmation was requested. This event is always sent regardless of settings.
 */
export type SaleorAccountRegister = {
  __typename?: 'AccountRegister';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** Informs whether users need to confirm their email address. */
  requiresConfirmation: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The field always returns a `User` object constructed from the input data. The `user.id` is always empty. To determine whether the user exists in Saleor, query via an external app with the required permissions. */
  user: Maybe<SaleorUser>;
};

/** Fields required to create a user. */
export type SaleorAccountRegisterInput = {
  /** Slug of a channel which will be used to notify users. Optional when only one channel exists. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the user. */
  email: Scalars['String']['input'];
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * User public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Password. */
  password: Scalars['String']['input'];
  /** Base of frontend URL that will be needed to create confirmation URL. Required when account confirmation is enabled. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sends an email with the account removal link for the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for account delete request.
 * - ACCOUNT_DELETE_REQUESTED (async): An account delete requested.
 */
export type SaleorAccountRequestDeletion = {
  __typename?: 'AccountRequestDeletion';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
};

/**
 * Sets a default address for the authenticated user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer's address was updated.
 */
export type SaleorAccountSetDefaultAddress = {
  __typename?: 'AccountSetDefaultAddress';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user: Maybe<SaleorUser>;
};

/** Event sent when setting a new password is requested. */
export type SaleorAccountSetPasswordRequested = SaleorEvent & {
  __typename?: 'AccountSetPasswordRequested';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Updates the account of the logged-in user.
 *
 * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 */
export type SaleorAccountUpdate = {
  __typename?: 'AccountUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user: Maybe<SaleorUser>;
};

/** Represents user address data. */
export type SaleorAddress = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Address';
  /** The city of the address. */
  city: Scalars['String']['output'];
  /** The district of the address. */
  cityArea: Scalars['String']['output'];
  /** Company or organization name. */
  companyName: Scalars['String']['output'];
  /** The country of the address. */
  country: SaleorCountryDisplay;
  /** The country area of the address. */
  countryArea: Scalars['String']['output'];
  /** The given name of the address. */
  firstName: Scalars['String']['output'];
  /** The ID of the address. */
  id: Scalars['ID']['output'];
  /** Address is user's default billing address. */
  isDefaultBillingAddress: Maybe<Scalars['Boolean']['output']>;
  /** Address is user's default shipping address. */
  isDefaultShippingAddress: Maybe<Scalars['Boolean']['output']>;
  /** The family name of the address. */
  lastName: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** The phone number assigned the address. */
  phone: Maybe<Scalars['String']['output']>;
  /** The postal code of the address. */
  postalCode: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** The first line of the address. */
  streetAddress1: Scalars['String']['output'];
  /** The second line of the address. */
  streetAddress2: Scalars['String']['output'];
};


/** Represents user address data. */
export type SaleorAddressMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user address data. */
export type SaleorAddressMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user address data. */
export type SaleorAddressPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user address data. */
export type SaleorAddressPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Creates user address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - ADDRESS_CREATED (async): A new address was created.
 */
export type SaleorAddressCreate = {
  __typename?: 'AddressCreate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was created. */
  user: Maybe<SaleorUser>;
};

/** Event sent when new address is created. */
export type SaleorAddressCreated = SaleorEvent & {
  __typename?: 'AddressCreated';
  /** The address the event relates to. */
  address: Maybe<SaleorAddress>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes an address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - ADDRESS_DELETED (async): An address was deleted.
 */
export type SaleorAddressDelete = {
  __typename?: 'AddressDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was deleted. */
  user: Maybe<SaleorUser>;
};

/** Event sent when address is deleted. */
export type SaleorAddressDeleted = SaleorEvent & {
  __typename?: 'AddressDeleted';
  /** The address the event relates to. */
  address: Maybe<SaleorAddress>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Filtering options for addresses. */
export type SaleorAddressFilterInput = {
  country?: InputMaybe<SaleorCountryCodeEnumFilterInput>;
  phoneNumber?: InputMaybe<SaleorStringFilterInput>;
};

export type SaleorAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** District. */
  cityArea?: InputMaybe<Scalars['String']['input']>;
  /** Company or organization. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Country. */
  country?: InputMaybe<SaleorCountryCode>;
  /** State or province. */
  countryArea?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Address public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Phone number.
   *
   * Phone numbers are validated with Google's [libphonenumber](https://github.com/google/libphonenumber) library.
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determine if the address should be validated. By default, Saleor accepts only address inputs matching ruleset from [Google Address Data]{https://chromium-i18n.appspot.com/ssl-address), using [i18naddress](https://github.com/mirumee/google-i18n-address) library. Some mutations may require additional permissions to use the the field. More info about permissions can be found in relevant mutation.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address. */
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Address. */
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sets a default address for the given user.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer was updated.
 */
export type SaleorAddressSetDefault = {
  __typename?: 'AddressSetDefault';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user: Maybe<SaleorUser>;
};

export type SaleorAddressTypeEnum =
  | 'BILLING'
  | 'SHIPPING';

/**
 * Updates an address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - ADDRESS_UPDATED (async): An address was updated.
 */
export type SaleorAddressUpdate = {
  __typename?: 'AddressUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user object for which the address was edited. */
  user: Maybe<SaleorUser>;
};

/** Event sent when address is updated. */
export type SaleorAddressUpdated = SaleorEvent & {
  __typename?: 'AddressUpdated';
  /** The address the event relates to. */
  address: Maybe<SaleorAddress>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents address validation rules for a country. */
export type SaleorAddressValidationData = {
  __typename?: 'AddressValidationData';
  /**
   * The address format of the address validation rule.
   *
   * Many fields in the JSON refer to address fields by one-letter abbreviations. These are defined as follows:
   *
   * - `N`: Name
   * - `O`: Organization
   * - `A`: Street Address Line(s)
   * - `D`: Dependent locality (may be an inner-city district or a suburb)
   * - `C`: City or Locality
   * - `S`: Administrative area such as a state, province, island etc
   * - `Z`: Zip or postal code
   * - `X`: Sorting code
   *
   * [Click here for more information.](https://github.com/google/libaddressinput/wiki/AddressValidationMetadata)
   */
  addressFormat: Scalars['String']['output'];
  /**
   * The latin address format of the address validation rule.
   *
   * Many fields in the JSON refer to address fields by one-letter abbreviations. These are defined as follows:
   *
   * - `N`: Name
   * - `O`: Organization
   * - `A`: Street Address Line(s)
   * - `D`: Dependent locality (may be an inner-city district or a suburb)
   * - `C`: City or Locality
   * - `S`: Administrative area such as a state, province, island etc
   * - `Z`: Zip or postal code
   * - `X`: Sorting code
   *
   * [Click here for more information.](https://github.com/google/libaddressinput/wiki/AddressValidationMetadata)
   */
  addressLatinFormat: Scalars['String']['output'];
  /** The allowed fields to use in address. */
  allowedFields: Array<Scalars['String']['output']>;
  /** The available choices for the city area of the address validation rule. */
  cityAreaChoices: Array<SaleorChoiceValue>;
  /** The formal name of the city area of the address validation rule. */
  cityAreaType: Scalars['String']['output'];
  /** The available choices for the city of the address validation rule. */
  cityChoices: Array<SaleorChoiceValue>;
  /** The formal name of the city of the address validation rule. */
  cityType: Scalars['String']['output'];
  /** The available choices for the country area of the address validation rule. */
  countryAreaChoices: Array<SaleorChoiceValue>;
  /** The formal name of the county area of the address validation rule. */
  countryAreaType: Scalars['String']['output'];
  /** The country code of the address validation rule. */
  countryCode: Scalars['String']['output'];
  /** The country name of the address validation rule. */
  countryName: Scalars['String']['output'];
  /** The example postal code of the address validation rule. */
  postalCodeExamples: Array<Scalars['String']['output']>;
  /** The regular expression for postal code validation. */
  postalCodeMatchers: Array<Scalars['String']['output']>;
  /** The postal code prefix of the address validation rule. */
  postalCodePrefix: Scalars['String']['output'];
  /** The formal name of the postal code of the address validation rule. */
  postalCodeType: Scalars['String']['output'];
  /** The required fields to create a valid address. */
  requiredFields: Array<Scalars['String']['output']>;
  /** The list of fields that should be in upper case for address validation rule. */
  upperFields: Array<Scalars['String']['output']>;
};

/** Represents allocation. */
export type SaleorAllocation = SaleorNode & {
  __typename?: 'Allocation';
  /** The ID of allocation. */
  id: Scalars['ID']['output'];
  /**
   * Quantity allocated for orders.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantity: Scalars['Int']['output'];
  /**
   * The warehouse were items were allocated.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  warehouse: SaleorWarehouse;
};

/**
 * Determine the allocation strategy for the channel.
 *
 *     PRIORITIZE_SORTING_ORDER - allocate stocks according to the warehouses' order
 *     within the channel
 *
 *     PRIORITIZE_HIGH_STOCK - allocate stock in a warehouse with the most stock
 *
 */
export type SaleorAllocationStrategyEnum =
  | 'PRIORITIZE_HIGH_STOCK'
  | 'PRIORITIZE_SORTING_ORDER';

/** Lists current announcements that the user should see. */
export type SaleorAnnouncement = {
  __typename?: 'Announcement';
  /** The date & time at which this announcement was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Additional information about this announcement. */
  extra: Scalars['Metadata']['output'];
  /** Determine the how critical the announcement is. UNSET if no severity level was defined for this announcement. */
  importance: SaleorAnnouncementImportanceEnum;
  /** The announcement's description, may contain HTML formatting. */
  messageHtml: Scalars['String']['output'];
  /** The announcement's title. */
  title: Scalars['String']['output'];
  /** The announcement's type, for example "CUSTOM". Used to programatically distinguish between message types thus allowing to render the message differently, and allows to know the expected shape for the `extra` field. */
  type: Scalars['String']['output'];
  /** The date & time at which this announcement was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Defines a shop-level announcement's level/severity. */
export type SaleorAnnouncementImportanceEnum =
  | 'CRITICAL'
  | 'HIGH'
  | 'LOW'
  | 'MODERATE'
  | 'UNSET';

/** Represents app data. */
export type SaleorApp = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'App';
  /** Description of this app. */
  aboutApp: Maybe<Scalars['String']['output']>;
  /** JWT token used to authenticate by third-party app. */
  accessToken: Maybe<Scalars['String']['output']>;
  /** URL to iframe with the app. */
  appUrl: Maybe<Scalars['String']['output']>;
  /** The App's author name. */
  author: Maybe<Scalars['String']['output']>;
  /** App's brand data. */
  brand: Maybe<SaleorAppBrand>;
  /**
   * Circuit breaker last state change date.
   *
   * Added in Saleor 3.21.
   */
  breakerLastStateChange: Maybe<Scalars['DateTime']['output']>;
  /**
   * Circuit breaker state, if open, sync webhooks operation is disrupted.
   *
   * Added in Saleor 3.21.
   */
  breakerState: SaleorCircuitBreakerStateEnum;
  /**
   * URL to iframe with the configuration for the app.
   * @deprecated Use `appUrl` instead.
   */
  configurationUrl: Maybe<Scalars['String']['output']>;
  /** The date and time when the app was created. */
  created: Maybe<Scalars['DateTime']['output']>;
  /**
   * Description of the data privacy defined for this app.
   * @deprecated Use `dataPrivacyUrl` instead.
   */
  dataPrivacy: Maybe<Scalars['String']['output']>;
  /** URL to details about the privacy policy on the app owner page. */
  dataPrivacyUrl: Maybe<Scalars['String']['output']>;
  /** App's dashboard extensions. */
  extensions: Array<SaleorAppExtension>;
  /** Homepage of the app. */
  homepageUrl: Maybe<Scalars['String']['output']>;
  /** The ID of the app. */
  id: Scalars['ID']['output'];
  /**
   * Canonical app ID from the manifest
   *
   * Added in Saleor 3.19.
   */
  identifier: Maybe<Scalars['String']['output']>;
  /** Determine if app will be set active or not. */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** URL to manifest used during app's installation. */
  manifestUrl: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the app. */
  name: Maybe<Scalars['String']['output']>;
  /** List of the app's permissions. */
  permissions: Maybe<Array<SaleorPermission>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * List of problems associated with this app.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, MANAGE_APPS.
   */
  problems: Maybe<Array<SaleorAppProblem>>;
  /** Support page for the app. */
  supportUrl: Maybe<Scalars['String']['output']>;
  /**
   * Last 4 characters of the tokens.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  tokens: Maybe<Array<SaleorAppToken>>;
  /** Type of the app. */
  type: Maybe<SaleorAppTypeEnum>;
  /** Version number of the app. */
  version: Maybe<Scalars['String']['output']>;
  /**
   * List of webhooks assigned to this app.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  webhooks: Maybe<Array<SaleorWebhook>>;
};


/** Represents app data. */
export type SaleorAppMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents app data. */
export type SaleorAppMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents app data. */
export type SaleorAppPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents app data. */
export type SaleorAppPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents app data. */
export type SaleorAppProblemsArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Activate the app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_STATUS_CHANGED (async): An app was activated.
 */
export type SaleorAppActivate = {
  __typename?: 'AppActivate';
  app: Maybe<SaleorApp>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/** Represents the app's brand data. */
export type SaleorAppBrand = {
  __typename?: 'AppBrand';
  /** App's logos details. */
  logo: SaleorAppBrandLogo;
};

/** Represents the app's brand logo data. */
export type SaleorAppBrandLogo = {
  __typename?: 'AppBrandLogo';
  /** URL to the default logo image. */
  default: Scalars['String']['output'];
};


/** Represents the app's brand logo data. */
export type SaleorAppBrandLogoDefaultArgs = {
  format?: InputMaybe<SaleorIconThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorAppCountableConnection = {
  __typename?: 'AppCountableConnection';
  edges: Array<SaleorAppCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorAppCountableEdge = {
  __typename?: 'AppCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorApp;
};

/**
 * Creates a new app. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_INSTALLED (async): An app was installed.
 */
export type SaleorAppCreate = {
  __typename?: 'AppCreate';
  app: Maybe<SaleorApp>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  /** The newly created authentication token. */
  authToken: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAppError>;
};

/**
 * Deactivate the app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_STATUS_CHANGED (async): An app was deactivated.
 */
export type SaleorAppDeactivate = {
  __typename?: 'AppDeactivate';
  app: Maybe<SaleorApp>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/**
 * Deletes an app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_DELETED (async): An app was deleted.
 */
export type SaleorAppDelete = {
  __typename?: 'AppDelete';
  app: Maybe<SaleorApp>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/**
 * Deletes failed installation.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppDeleteFailedInstallation = {
  __typename?: 'AppDeleteFailedInstallation';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appInstallation: Maybe<SaleorAppInstallation>;
  errors: Array<SaleorAppError>;
};

/** Event sent when app is deleted. */
export type SaleorAppDeleted = SaleorEvent & {
  __typename?: 'AppDeleted';
  /** The application the event relates to. */
  app: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorAppError = {
  __typename?: 'AppError';
  /** The error code. */
  code: SaleorAppErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions: Maybe<Array<SaleorPermissionEnum>>;
};

export type SaleorAppErrorCode =
  | 'FORBIDDEN'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_CUSTOM_HEADERS'
  | 'INVALID_MANIFEST_FORMAT'
  | 'INVALID_PERMISSION'
  | 'INVALID_STATUS'
  | 'INVALID_URL_FORMAT'
  | 'MANIFEST_URL_CANT_CONNECT'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_APP'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_SALEOR_VERSION';

/** Represents app data. */
export type SaleorAppExtension = SaleorNode & {
  __typename?: 'AppExtension';
  /** JWT token used to authenticate by third-party app extension. */
  accessToken: Maybe<Scalars['String']['output']>;
  /** The app assigned to app extension. */
  app: SaleorApp;
  /** The ID of the app extension. */
  id: Scalars['ID']['output'];
  /** Label of the extension to show in the dashboard. */
  label: Scalars['String']['output'];
  /**
   * Place where given extension will be mounted.
   * @deprecated Use `mountName` instead.
   */
  mount: SaleorAppExtensionMountEnum;
  /**
   * Name of the extension mount point in the dashboard. Replaces `mount`
   *
   * Added in Saleor 3.22.
   */
  mountName: Scalars['String']['output'];
  /**
   * App extension options.
   *
   * Added in Saleor 3.22.
   * @deprecated Use `settings` field instead.
   */
  options: Maybe<SaleorAppExtensionPossibleOptions>;
  /** List of the app extension's permissions. */
  permissions: Array<SaleorPermission>;
  /**
   * App extension settings. Replaces `options` field.
   *
   * Added in Saleor 3.22.
   */
  settings: Scalars['JSON']['output'];
  /**
   * Type of way how app extension will be opened.
   * @deprecated Use `targetName` instead.
   */
  target: SaleorAppExtensionTargetEnum;
  /**
   * Name of the extension target in the dashboard. Replaces `target`
   *
   * Added in Saleor 3.22.
   */
  targetName: Scalars['String']['output'];
  /** URL of a view where extension's iframe is placed. */
  url: Scalars['String']['output'];
};

export type SaleorAppExtensionCountableConnection = {
  __typename?: 'AppExtensionCountableConnection';
  edges: Array<SaleorAppExtensionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorAppExtensionCountableEdge = {
  __typename?: 'AppExtensionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorAppExtension;
};

export type SaleorAppExtensionFilterInput = {
  /**
   * DEPRECATED: Use `mountName` instead.
   *
   * DEPRECATED: this field will be removed.
   */
  mount?: InputMaybe<Array<SaleorAppExtensionMountEnum>>;
  /**
   * Plain-text mount name (case insensitive)
   *
   * Added in Saleor 3.22.
   */
  mountName?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * DEPRECATED: Use `targetName` instead.
   *
   * DEPRECATED: this field will be removed.
   */
  target?: InputMaybe<SaleorAppExtensionTargetEnum>;
  /**
   * Plain-text target name (case insensitive)
   *
   * Added in Saleor 3.22.
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

/** All places where app extension can be mounted. */
export type SaleorAppExtensionMountEnum =
  | 'CATEGORY_DETAILS_MORE_ACTIONS'
  | 'CATEGORY_OVERVIEW_CREATE'
  | 'CATEGORY_OVERVIEW_MORE_ACTIONS'
  | 'COLLECTION_DETAILS_MORE_ACTIONS'
  | 'COLLECTION_DETAILS_WIDGETS'
  | 'COLLECTION_OVERVIEW_CREATE'
  | 'COLLECTION_OVERVIEW_MORE_ACTIONS'
  | 'CUSTOMER_DETAILS_MORE_ACTIONS'
  | 'CUSTOMER_DETAILS_WIDGETS'
  | 'CUSTOMER_OVERVIEW_CREATE'
  | 'CUSTOMER_OVERVIEW_MORE_ACTIONS'
  | 'DISCOUNT_DETAILS_MORE_ACTIONS'
  | 'DISCOUNT_OVERVIEW_CREATE'
  | 'DISCOUNT_OVERVIEW_MORE_ACTIONS'
  | 'DRAFT_ORDER_DETAILS_MORE_ACTIONS'
  | 'DRAFT_ORDER_DETAILS_WIDGETS'
  | 'DRAFT_ORDER_OVERVIEW_CREATE'
  | 'DRAFT_ORDER_OVERVIEW_MORE_ACTIONS'
  | 'GIFT_CARD_DETAILS_MORE_ACTIONS'
  | 'GIFT_CARD_DETAILS_WIDGETS'
  | 'GIFT_CARD_OVERVIEW_CREATE'
  | 'GIFT_CARD_OVERVIEW_MORE_ACTIONS'
  | 'MENU_DETAILS_MORE_ACTIONS'
  | 'MENU_OVERVIEW_CREATE'
  | 'MENU_OVERVIEW_MORE_ACTIONS'
  | 'NAVIGATION_CATALOG'
  | 'NAVIGATION_CUSTOMERS'
  | 'NAVIGATION_DISCOUNTS'
  | 'NAVIGATION_ORDERS'
  | 'NAVIGATION_PAGES'
  | 'NAVIGATION_TRANSLATIONS'
  | 'ORDER_DETAILS_MORE_ACTIONS'
  | 'ORDER_DETAILS_WIDGETS'
  | 'ORDER_OVERVIEW_CREATE'
  | 'ORDER_OVERVIEW_MORE_ACTIONS'
  | 'PAGE_DETAILS_MORE_ACTIONS'
  | 'PAGE_OVERVIEW_CREATE'
  | 'PAGE_OVERVIEW_MORE_ACTIONS'
  | 'PAGE_TYPE_DETAILS_MORE_ACTIONS'
  | 'PAGE_TYPE_OVERVIEW_CREATE'
  | 'PAGE_TYPE_OVERVIEW_MORE_ACTIONS'
  | 'PRODUCT_DETAILS_MORE_ACTIONS'
  | 'PRODUCT_DETAILS_WIDGETS'
  | 'PRODUCT_OVERVIEW_CREATE'
  | 'PRODUCT_OVERVIEW_MORE_ACTIONS'
  | 'TRANSLATIONS_MORE_ACTIONS'
  | 'VOUCHER_DETAILS_MORE_ACTIONS'
  | 'VOUCHER_DETAILS_WIDGETS'
  | 'VOUCHER_OVERVIEW_CREATE'
  | 'VOUCHER_OVERVIEW_MORE_ACTIONS';

/** Represents the options for an app extension. */
export type SaleorAppExtensionOptionsNewTab = {
  __typename?: 'AppExtensionOptionsNewTab';
  /**
   * Options controlling behavior of the NEW_TAB extension target
   * @deprecated Use `settings` field directly.
   */
  newTabTarget: Maybe<SaleorNewTabTargetOptions>;
};

/** Represents the options for an app extension. */
export type SaleorAppExtensionOptionsWidget = {
  __typename?: 'AppExtensionOptionsWidget';
  /**
   * Options for displaying a Widget
   * @deprecated Use `settings` field directly.
   */
  widgetTarget: Maybe<SaleorWidgetTargetOptions>;
};

export type SaleorAppExtensionPossibleOptions = SaleorAppExtensionOptionsNewTab | SaleorAppExtensionOptionsWidget;

/**
 * All available ways of opening an app extension.
 *
 *     POPUP - app's extension will be mounted as a popup window
 *     APP_PAGE - redirect to app's page
 *
 */
export type SaleorAppExtensionTargetEnum =
  | 'APP_PAGE'
  | 'NEW_TAB'
  | 'POPUP'
  | 'WIDGET';

/**
 * Fetch and validate manifest.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppFetchManifest = {
  __typename?: 'AppFetchManifest';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
  /** The validated manifest. */
  manifest: Maybe<SaleorManifest>;
};

export type SaleorAppFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SaleorAppTypeEnum>;
};

export type SaleorAppInput = {
  /**
   * Canonical app ID. If not provided, the identifier will be generated based on app.id.
   *
   * Added in Saleor 3.19.
   */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Name of the app. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to assign to this app. */
  permissions?: InputMaybe<Array<SaleorPermissionEnum>>;
};

/** Install new app by using app manifest. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
export type SaleorAppInstall = {
  __typename?: 'AppInstall';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appInstallation: Maybe<SaleorAppInstallation>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppInstallInput = {
  /** Determine if app will be set active or not. */
  activateAfterInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the app to install. */
  appName?: InputMaybe<Scalars['String']['input']>;
  /** URL to app's manifest in JSON format. */
  manifestUrl?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to assign to this app. */
  permissions?: InputMaybe<Array<SaleorPermissionEnum>>;
};

/** Represents ongoing installation of app. */
export type SaleorAppInstallation = SaleorJob & SaleorNode & {
  __typename?: 'AppInstallation';
  /** The name of the app installation. */
  appName: Scalars['String']['output'];
  /** App's brand data. */
  brand: Maybe<SaleorAppBrand>;
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the app installation. */
  id: Scalars['ID']['output'];
  /** The URL address of manifest for the app installation. */
  manifestUrl: Scalars['String']['output'];
  /** Job message. */
  message: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Event sent when new app is installed. */
export type SaleorAppInstalled = SaleorEvent & {
  __typename?: 'AppInstalled';
  /** The application the event relates to. */
  app: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents the app's manifest brand data. */
export type SaleorAppManifestBrand = {
  __typename?: 'AppManifestBrand';
  /** App's logos details. */
  logo: SaleorAppManifestBrandLogo;
};

/** Represents the app's manifest brand data. */
export type SaleorAppManifestBrandLogo = {
  __typename?: 'AppManifestBrandLogo';
  /** Data URL with a base64 encoded logo image. */
  default: Scalars['String']['output'];
};


/** Represents the app's manifest brand data. */
export type SaleorAppManifestBrandLogoDefaultArgs = {
  format?: InputMaybe<SaleorIconThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorAppManifestExtension = {
  __typename?: 'AppManifestExtension';
  /** Label of the extension to show in the dashboard. */
  label: Scalars['String']['output'];
  /**
   * Place where given extension will be mounted.
   * @deprecated Use `mountName` instead.
   */
  mount: SaleorAppExtensionMountEnum;
  /**
   * Name of the extension mount point in the dashboard. Replaces `mount`
   *
   * Added in Saleor 3.22.
   */
  mountName: Scalars['String']['output'];
  /** List of the app extension's permissions. */
  permissions: Array<SaleorPermission>;
  /**
   * JSON object with settings for this extension.
   *
   * Added in Saleor 3.22.
   */
  settings: Scalars['JSON']['output'];
  /**
   * Type of way how app extension will be opened.
   * @deprecated Use `targetName` instead.
   */
  target: SaleorAppExtensionTargetEnum;
  /**
   * Name of the extension target in the dashboard. Replaces `target`
   *
   * Added in Saleor 3.22.
   */
  targetName: Scalars['String']['output'];
  /** URL of a view where extension's iframe is placed. */
  url: Scalars['String']['output'];
};

export type SaleorAppManifestRequiredSaleorVersion = {
  __typename?: 'AppManifestRequiredSaleorVersion';
  /** Required Saleor version as semver range. */
  constraint: Scalars['String']['output'];
  /** Informs if the Saleor version matches the required one. */
  satisfied: Scalars['Boolean']['output'];
};

export type SaleorAppManifestWebhook = {
  __typename?: 'AppManifestWebhook';
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents: Maybe<Array<SaleorWebhookEventTypeAsyncEnum>>;
  /** The name of the webhook. */
  name: Scalars['String']['output'];
  /** Subscription query of a webhook */
  query: Scalars['String']['output'];
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents: Maybe<Array<SaleorWebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl: Scalars['String']['output'];
};

/**
 * Represents a problem associated with an app.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAppProblem = SaleorNode & {
  __typename?: 'AppProblem';
  /**
   * Number of occurrences.
   *
   * Added in Saleor 3.22.
   */
  count: Scalars['Int']['output'];
  /**
   * The date and time when the problem was created.
   *
   * Added in Saleor 3.22.
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Dismissal information. Null if the problem has not been dismissed.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, MANAGE_APPS.
   */
  dismissed: Maybe<SaleorAppProblemDismissed>;
  /**
   * The ID of the app problem.
   *
   * Added in Saleor 3.22.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether the problem has reached critical threshold.
   *
   * Added in Saleor 3.22.
   */
  isCritical: Scalars['Boolean']['output'];
  /**
   * Key identifying the type of problem.
   *
   * Added in Saleor 3.22.
   */
  key: Scalars['String']['output'];
  /**
   * The problem message.
   *
   * Added in Saleor 3.22.
   */
  message: Scalars['String']['output'];
  /**
   * The date and time when the problem was last updated.
   *
   * Added in Saleor 3.22.
   */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Add a problem to the calling app.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP.
 */
export type SaleorAppProblemCreate = {
  __typename?: 'AppProblemCreate';
  /** The created or updated app problem. */
  appProblem: Maybe<SaleorAppProblem>;
  errors: Array<SaleorAppProblemCreateError>;
};

export type SaleorAppProblemCreateError = {
  __typename?: 'AppProblemCreateError';
  /** The error code. */
  code: SaleorAppProblemCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorAppProblemCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorAppProblemCreateInput = {
  /** Time window in minutes for aggregating problems with the same key. Defaults to 60. If 0, a new problem is always created. */
  aggregationPeriod?: InputMaybe<Scalars['Minute']['input']>;
  /** If set, the problem becomes critical when count reaches this value. If sent again with higher value than already counted, problem can be de-escalated. */
  criticalThreshold?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Key identifying the type of problem. App can add multiple problems under the same key, to merge them together or delete them in batch. Must be between 3 and 128 characters. */
  key: Scalars['String']['input'];
  /** The problem message to display. Must be at least 3 characters. Messages longer than 2048 characters will be truncated to 2048 characters with '...' suffix. */
  message: Scalars['String']['input'];
};

/**
 * Dismiss problems for an app.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type SaleorAppProblemDismiss = {
  __typename?: 'AppProblemDismiss';
  errors: Array<SaleorAppProblemDismissError>;
};

/** Input for app callers to dismiss their own problems. */
export type SaleorAppProblemDismissByAppInput = {
  /** List of problem IDs to dismiss. Cannot be combined with keys. Max 100. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of problem keys to dismiss. Cannot be combined with ids. Max 100. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for staff callers to dismiss problems by IDs. */
export type SaleorAppProblemDismissByStaffWithIdsInput = {
  /** List of problem IDs to dismiss. Max 100. */
  ids: Array<Scalars['ID']['input']>;
};

/** Input for staff callers to dismiss problems by keys. */
export type SaleorAppProblemDismissByStaffWithKeysInput = {
  /** ID of the app whose problems to dismiss. */
  app: Scalars['ID']['input'];
  /** List of problem keys to dismiss. Max 100. */
  keys: Array<Scalars['String']['input']>;
};

export type SaleorAppProblemDismissError = {
  __typename?: 'AppProblemDismissError';
  /** The error code. */
  code: SaleorAppProblemDismissErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorAppProblemDismissErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_APP'
  | 'REQUIRED';

/** Input for dismissing app problems. Only one can be specified. */
export type SaleorAppProblemDismissInput = {
  /** For app callers only - dismiss own problems. */
  byApp?: InputMaybe<SaleorAppProblemDismissByAppInput>;
  /** For staff callers - dismiss problems by IDs. */
  byStaffWithIds?: InputMaybe<SaleorAppProblemDismissByStaffWithIdsInput>;
  /** For staff callers - dismiss problems by keys for specified app. */
  byStaffWithKeys?: InputMaybe<SaleorAppProblemDismissByStaffWithKeysInput>;
};

/**
 * Dismissal information for an app problem.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAppProblemDismissed = {
  __typename?: 'AppProblemDismissed';
  /**
   * Whether the problem was dismissed by an App or a User.
   *
   * Added in Saleor 3.22.
   */
  by: SaleorAppProblemDismissedByEnum;
  /**
   * The user who dismissed this problem. Null if dismissed by an app or the user was deleted.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  user: Maybe<SaleorUser>;
  /**
   * Email of the user who dismissed this problem. Preserved even if the user is deleted.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  userEmail: Maybe<Scalars['String']['output']>;
};

export type SaleorAppProblemDismissedByEnum =
  | 'APP'
  | 'USER';

/**
 * Re-enable sync webhooks for provided app. Can be used to manually re-enable sync webhooks for the app before the cooldown period ends.
 *
 * Added in Saleor 3.21.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppReenableSyncWebhooks = {
  __typename?: 'AppReenableSyncWebhooks';
  /** App for which sync webhooks were re-enabled. */
  app: Maybe<SaleorApp>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/**
 * Retry failed installation of new app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_INSTALLED (async): An app was installed.
 */
export type SaleorAppRetryInstall = {
  __typename?: 'AppRetryInstall';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appInstallation: Maybe<SaleorAppInstallation>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppSortField =
  /** Sort apps by creation date. */
  | 'CREATION_DATE'
  /** Sort apps by name. */
  | 'NAME';

export type SaleorAppSortingInput = {
  /** Specifies the direction in which to sort apps. */
  direction: SaleorOrderDirection;
  /** Sort apps by the selected field. */
  field: SaleorAppSortField;
};

/** Event sent when app status has changed. */
export type SaleorAppStatusChanged = SaleorEvent & {
  __typename?: 'AppStatusChanged';
  /** The application the event relates to. */
  app: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents token data. */
export type SaleorAppToken = SaleorNode & {
  __typename?: 'AppToken';
  /** Last 4 characters of the token. */
  authToken: Maybe<Scalars['String']['output']>;
  /** The ID of the app token. */
  id: Scalars['ID']['output'];
  /** Name of the authenticated token. */
  name: Maybe<Scalars['String']['output']>;
};

/**
 * Creates a new token.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppTokenCreate = {
  __typename?: 'AppTokenCreate';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appToken: Maybe<SaleorAppToken>;
  /** The newly created authentication token. */
  authToken: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAppError>;
};

/**
 * Deletes an authentication token assigned to app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppTokenDelete = {
  __typename?: 'AppTokenDelete';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appToken: Maybe<SaleorAppToken>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppTokenInput = {
  /** ID of app. */
  app: Scalars['ID']['input'];
  /** Name of the token. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Verify provided app token. */
export type SaleorAppTokenVerify = {
  __typename?: 'AppTokenVerify';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
  /** Determine if token is valid or not. */
  valid: Scalars['Boolean']['output'];
};

/** Enum determining type of your App. */
export type SaleorAppTypeEnum =
  /** Local Saleor App. The app is fully manageable from dashboard. You can change assigned permissions, add webhooks, or authentication token */
  | 'LOCAL'
  /** Third party external App. Installation is fully automated. Saleor uses a defined App manifest to gather all required information. */
  | 'THIRDPARTY';

/**
 * Updates an existing app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_UPDATED (async): An app was updated.
 */
export type SaleorAppUpdate = {
  __typename?: 'AppUpdate';
  app: Maybe<SaleorApp>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/** Event sent when app is updated. */
export type SaleorAppUpdated = SaleorEvent & {
  __typename?: 'AppUpdated';
  /** The application the event relates to. */
  app: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorAreaUnitsEnum =
  | 'SQ_CM'
  | 'SQ_DM'
  | 'SQ_FT'
  | 'SQ_INCH'
  | 'SQ_KM'
  | 'SQ_M'
  | 'SQ_MM'
  | 'SQ_YD';

/**
 * Assigns storefront's navigation menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS, MANAGE_SETTINGS.
 */
export type SaleorAssignNavigation = {
  __typename?: 'AssignNavigation';
  errors: Array<SaleorMenuError>;
  /** Assigned navigation menu. */
  menu: Maybe<SaleorMenu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

/**
 * Represents an attribute assigned to an object.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedAttribute = {
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
};

export type SaleorAssignedAttributeReferenceInput = {
  /** Returns objects with a reference pointing to a category identified by the given slug. */
  categorySlugs?: InputMaybe<SaleorContainsFilterInput>;
  /** Returns objects with a reference pointing to a collection identified by the given slug. */
  collectionSlugs?: InputMaybe<SaleorContainsFilterInput>;
  /** Returns objects with a reference pointing to a page identified by the given slug. */
  pageSlugs?: InputMaybe<SaleorContainsFilterInput>;
  /** Returns objects with a reference pointing to a product identified by the given slug. */
  productSlugs?: InputMaybe<SaleorContainsFilterInput>;
  /** Returns objects with a reference pointing to a product variant identified by the given sku. */
  productVariantSkus?: InputMaybe<SaleorContainsFilterInput>;
  /** Returns objects with a reference pointing to an object identified by the given ID. */
  referencedIds?: InputMaybe<SaleorContainsFilterInput>;
};

export type SaleorAssignedAttributeValueInput = {
  /** Filter by boolean value for attributes of boolean type. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by date value for attributes of date type. */
  date?: InputMaybe<SaleorDateRangeInput>;
  /** Filter by date time value for attributes of date time type. */
  dateTime?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by name assigned to AttributeValue. */
  name?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by numeric value for attributes of numeric type. */
  numeric?: InputMaybe<SaleorDecimalFilterInput>;
  /** Filter by reference attribute value. */
  reference?: InputMaybe<SaleorAssignedAttributeReferenceInput>;
  /** Filter by slug assigned to AttributeValue. */
  slug?: InputMaybe<SaleorStringFilterInput>;
};

export type SaleorAssignedAttributeWhereInput = {
  /** Filter by attribute slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Filter by value of the attribute. Only one value input field is allowed. If provided more than one, the error will be raised. */
  value?: InputMaybe<SaleorAssignedAttributeValueInput>;
};

/**
 * Represents a boolean attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedBooleanAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedBooleanAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned boolean value. */
  value: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents a single choice value of the attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedChoiceAttributeValue = {
  __typename?: 'AssignedChoiceAttributeValue';
  /** Name of a value displayed in the interface. */
  name: Maybe<Scalars['String']['output']>;
  /** Internal representation of a value (unique per attribute). */
  slug: Maybe<Scalars['String']['output']>;
  /** Translation of the name. */
  translation: Maybe<Scalars['String']['output']>;
};


/**
 * Represents a single choice value of the attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedChoiceAttributeValueTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Represents a date attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedDateAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedDateAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned date value. */
  value: Maybe<Scalars['Date']['output']>;
};

/**
 * Represents a date time attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedDateTimeAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedDateTimeAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned date time value. */
  value: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Represents file attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedFileAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedFileAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned file. */
  value: Maybe<SaleorFile>;
};

/**
 * Represents multi category reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiCategoryReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedMultiCategoryReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** List of assigned category references. */
  value: Array<SaleorCategory>;
};


/**
 * Represents multi category reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiCategoryReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents a multi choice attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiChoiceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedMultiChoiceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** List of assigned choice values. */
  value: Array<SaleorAssignedChoiceAttributeValue>;
};


/**
 * Represents a multi choice attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiChoiceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi collection reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiCollectionReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedMultiCollectionReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** List of assigned collection references. */
  value: Array<SaleorCollection>;
};


/**
 * Represents multi collection reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiCollectionReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi page reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiPageReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedMultiPageReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** List of assigned page references. */
  value: Array<SaleorPage>;
};


/**
 * Represents multi page reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiPageReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi product reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiProductReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedMultiProductReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** List of assigned product references. */
  value: Array<SaleorProduct>;
};


/**
 * Represents multi product reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiProductReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi product variant reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiProductVariantReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedMultiProductVariantReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** List of assigned product variant references. */
  value: Array<SaleorProductVariant>;
};


/**
 * Represents multi product variant reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedMultiProductVariantReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents a numeric value of an attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedNumericAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedNumericAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned numeric value. */
  value: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents plain text attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedPlainTextAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedPlainTextAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** Translation of the plain text content in the specified language. */
  translation: Maybe<Scalars['String']['output']>;
  /** The assigned plain text content. */
  value: Maybe<Scalars['String']['output']>;
};


/**
 * Represents plain text attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedPlainTextAttributeTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Represents single category reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSingleCategoryReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSingleCategoryReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned category reference. */
  value: Maybe<SaleorCategory>;
};

/**
 * Represents a single choice attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSingleChoiceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSingleChoiceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned choice value. */
  value: Maybe<SaleorAssignedChoiceAttributeValue>;
};

/**
 * Represents single collection reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSingleCollectionReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSingleCollectionReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned collection reference. */
  value: Maybe<SaleorCollection>;
};

/**
 * Represents single page reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSinglePageReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSinglePageReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned page reference. */
  value: Maybe<SaleorPage>;
};

/**
 * Represents single product reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSingleProductReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSingleProductReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned product reference. */
  value: Maybe<SaleorProduct>;
};

/**
 * Represents single product variant reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSingleProductVariantReferenceAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSingleProductVariantReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned product variant reference. */
  value: Maybe<SaleorProductVariant>;
};

/**
 * Represents a swatch attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSwatchAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedSwatchAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** The assigned swatch value. */
  value: Maybe<SaleorAssignedSwatchAttributeValue>;
};

/**
 * Represents a single swatch value.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSwatchAttributeValue = {
  __typename?: 'AssignedSwatchAttributeValue';
  /** File associated with the attribute. */
  file: Maybe<SaleorFile>;
  /** Hex color code. */
  hexColor: Maybe<Scalars['String']['output']>;
  /** Name of the selected swatch value.  */
  name: Maybe<Scalars['String']['output']>;
  /** Slug of the selected swatch value. */
  slug: Maybe<Scalars['String']['output']>;
  /**
   * Translation of the name.
   *
   * Added in Saleor 3.22.
   */
  translation: Maybe<Scalars['String']['output']>;
};


/**
 * Represents a single swatch value.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedSwatchAttributeValueTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Represents text attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedTextAttribute = SaleorAssignedAttribute & {
  __typename?: 'AssignedTextAttribute';
  /** Attribute assigned to an object. */
  attribute: SaleorAttribute;
  /** Translation of the rich text content in the specified language. */
  translation: Maybe<Scalars['JSON']['output']>;
  /** The assigned rich text content. */
  value: Maybe<Scalars['JSON']['output']>;
};


/**
 * Represents text attribute.
 *
 * Added in Saleor 3.22.
 */
export type SaleorAssignedTextAttributeTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/** Represents assigned attribute to variant with variant selection attached. */
export type SaleorAssignedVariantAttribute = {
  __typename?: 'AssignedVariantAttribute';
  /** Attribute assigned to variant. */
  attribute: SaleorAttribute;
  /** Determines, whether assigned attribute is allowed for variant selection. Supported variant types for variant selection are: ['dropdown', 'boolean', 'swatch', 'numeric'] */
  variantSelection: Scalars['Boolean']['output'];
};

/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttribute = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Attribute';
  /**
   * Whether the attribute can be displayed in the admin product list. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated Field no longer supported
   */
  availableInGrid: Scalars['Boolean']['output'];
  /** A list of predefined attribute choices available for selection. Available only for attributes with predefined choices. */
  choices: Maybe<SaleorAttributeValueCountableConnection>;
  /** The entity type which can be used as a reference. */
  entityType: Maybe<SaleorAttributeEntityTypeEnum>;
  /** External ID of this attribute. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** Whether the attribute can be filtered in dashboard. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  filterableInDashboard: Scalars['Boolean']['output'];
  /**
   * Whether the attribute can be filtered in storefront. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated Field no longer supported
   */
  filterableInStorefront: Scalars['Boolean']['output'];
  /** The ID of the attribute. */
  id: Scalars['ID']['output'];
  /** The input type to use for entering attribute values in the dashboard. */
  inputType: Maybe<SaleorAttributeInputTypeEnum>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of an attribute displayed in the interface. */
  name: Maybe<Scalars['String']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** A list of product types that use this attribute as a product attribute. */
  productTypes: SaleorProductTypeCountableConnection;
  /** A list of product types that use this attribute as a product variant attribute. */
  productVariantTypes: SaleorProductTypeCountableConnection;
  /**
   * The reference types (product or page type) that are used to narrow down the choices of reference objects.
   *
   * Added in Saleor 3.22.
   */
  referenceTypes: Maybe<Array<SaleorReferenceType>>;
  /** Internal representation of an attribute name. */
  slug: Maybe<Scalars['String']['output']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default). Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated Field no longer supported
   */
  storefrontSearchPosition: Scalars['Int']['output'];
  /** Returns translated attribute fields for the given language code. */
  translation: Maybe<SaleorAttributeTranslation>;
  /** The attribute type. */
  type: Maybe<SaleorAttributeTypeEnum>;
  /** The unit of attribute values. */
  unit: Maybe<SaleorMeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  valueRequired: Scalars['Boolean']['output'];
  /** Whether the attribute should be visible or not in storefront. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  visibleInStorefront: Scalars['Boolean']['output'];
  /** Flag indicating that attribute has predefined choices. */
  withChoices: Scalars['Boolean']['output'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeChoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeValueFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorAttributeChoicesSortingInput>;
  where?: InputMaybe<SaleorAttributeValueWhereInput>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeProductVariantTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeReferenceTypesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_CREATED (async): An attribute was created.
 */
export type SaleorAttributeBulkCreate = {
  __typename?: 'AttributeBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeBulkCreateError>;
  /** List of the created attributes. */
  results: Array<SaleorAttributeBulkCreateResult>;
};

export type SaleorAttributeBulkCreateError = {
  __typename?: 'AttributeBulkCreateError';
  /** The error code. */
  code: SaleorAttributeBulkCreateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeBulkCreateErrorCode =
  | 'ALREADY_EXISTS'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorAttributeBulkCreateResult = {
  __typename?: 'AttributeBulkCreateResult';
  /** Attribute data. */
  attribute: Maybe<SaleorAttribute>;
  /** List of errors occurred on create attempt. */
  errors: Maybe<Array<SaleorAttributeBulkCreateError>>;
};

/**
 * Deletes attributes.
 *
 * Requires one of the following permissions, depending on the type of each attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_DELETED (async): An attribute was deleted.
 */
export type SaleorAttributeBulkDelete = {
  __typename?: 'AttributeBulkDelete';
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeError>;
};

/**
 * Creates/updates translations for attributes.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorAttributeBulkTranslate = {
  __typename?: 'AttributeBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeBulkTranslateError>;
  /** List of the translations. */
  results: Array<SaleorAttributeBulkTranslateResult>;
};

export type SaleorAttributeBulkTranslateError = {
  __typename?: 'AttributeBulkTranslateError';
  /** The error code. */
  code: SaleorAttributeTranslateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeBulkTranslateInput = {
  /** External reference of an attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Attribute ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** Translation fields. */
  translationFields: SaleorNameTranslationInput;
};

export type SaleorAttributeBulkTranslateResult = {
  __typename?: 'AttributeBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors: Maybe<Array<SaleorAttributeBulkTranslateError>>;
  /** Attribute translation data. */
  translation: Maybe<SaleorAttributeTranslation>;
};

/**
 * Updates attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_UPDATED (async): An attribute was updated. Optionally called when new attribute value was created or deleted.
 * - ATTRIBUTE_VALUE_CREATED (async): Called optionally when an attribute value was created.
 * - ATTRIBUTE_VALUE_DELETED (async): Called optionally when an attribute value was deleted.
 */
export type SaleorAttributeBulkUpdate = {
  __typename?: 'AttributeBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeBulkUpdateError>;
  /** List of the updated attributes. */
  results: Array<SaleorAttributeBulkUpdateResult>;
};

export type SaleorAttributeBulkUpdateError = {
  __typename?: 'AttributeBulkUpdateError';
  /** The error code. */
  code: SaleorAttributeBulkUpdateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeBulkUpdateErrorCode =
  | 'ALREADY_EXISTS'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorAttributeBulkUpdateInput = {
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Fields to update. */
  fields: SaleorAttributeUpdateInput;
  /** ID of an attribute to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorAttributeBulkUpdateResult = {
  __typename?: 'AttributeBulkUpdateResult';
  /** Attribute data. */
  attribute: Maybe<SaleorAttribute>;
  /** List of errors occurred on update attempt. */
  errors: Maybe<Array<SaleorAttributeBulkUpdateError>>;
};

export type SaleorAttributeChoicesSortField =
  /** Sort attribute choice by name. */
  | 'NAME'
  /** Sort attribute choice by slug. */
  | 'SLUG';

export type SaleorAttributeChoicesSortingInput = {
  /** Specifies the direction in which to sort attribute choices. */
  direction: SaleorOrderDirection;
  /** Sort attribute choices by the selected field. */
  field: SaleorAttributeChoicesSortField;
};

export type SaleorAttributeCountableConnection = {
  __typename?: 'AttributeCountableConnection';
  edges: Array<SaleorAttributeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorAttributeCountableEdge = {
  __typename?: 'AttributeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorAttribute;
};

/**
 * Creates an attribute.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_CREATED (async): An attribute was created.
 */
export type SaleorAttributeCreate = {
  __typename?: 'AttributeCreate';
  /** The created attribute. */
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

/**
 * Represents an input for create of attribute.
 *
 * NOTE: Deprecated fields `filterableInStorefront`, `storefrontSearchPosition` and `availableInGrid` are not supported in bulk mutations: `attributeBulkCreate`, `attributeBulkUpdate`.
 */
export type SaleorAttributeCreateInput = {
  /**
   * Whether the attribute can be displayed in the admin product list.
   *
   * DEPRECATED: this field will be removed.
   */
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** The entity type which can be used as a reference. */
  entityType?: InputMaybe<SaleorAttributeEntityTypeEnum>;
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Whether the attribute can be filtered in dashboard. */
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the attribute can be filtered in storefront.
   *
   * DEPRECATED: this field will be removed.
   */
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: InputMaybe<SaleorAttributeInputTypeEnum>;
  /** Whether the attribute is for variants only. */
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of an attribute displayed in the interface. */
  name: Scalars['String']['input'];
  /**
   * Specifies reference types to narrow down the choices of reference objects. Applicable only for `REFERENCE` and `SINGLE_REFERENCE` attributes with `PRODUCT`, `PRODUCT_VARIANT` and `PAGE` entity types. Accepts `ProductType` IDs for `PRODUCT` and `PRODUCT_VARIANT` entity types, and `PageType` IDs for `PAGE` entity type. If omitted, all objects of the selected entity type are available as attribute values.
   *
   * A maximum of 100 reference types can be specified.
   *
   * Added in Saleor 3.22.
   */
  referenceTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default).
   *
   * DEPRECATED: this field will be removed.
   */
  storefrontSearchPosition?: InputMaybe<Scalars['Int']['input']>;
  /** The attribute type. */
  type: SaleorAttributeTypeEnum;
  /** The unit of attribute values. */
  unit?: InputMaybe<SaleorMeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. */
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of attribute's values. */
  values?: InputMaybe<Array<SaleorAttributeValueCreateInput>>;
  /** Whether the attribute should be visible or not in storefront. */
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when new attribute is created. */
export type SaleorAttributeCreated = SaleorEvent & {
  __typename?: 'AttributeCreated';
  /** The attribute the event relates to. */
  attribute: Maybe<SaleorAttribute>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes an attribute.
 *
 * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_DELETED (async): An attribute was deleted.
 */
export type SaleorAttributeDelete = {
  __typename?: 'AttributeDelete';
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

/** Event sent when attribute is deleted. */
export type SaleorAttributeDeleted = SaleorEvent & {
  __typename?: 'AttributeDeleted';
  /** The attribute the event relates to. */
  attribute: Maybe<SaleorAttribute>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeEntityTypeEnum =
  | 'CATEGORY'
  | 'COLLECTION'
  | 'PAGE'
  | 'PRODUCT'
  | 'PRODUCT_VARIANT';

export type SaleorAttributeEntityTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorAttributeEntityTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorAttributeEntityTypeEnum>>;
};

export type SaleorAttributeError = {
  __typename?: 'AttributeError';
  /** The error code. */
  code: SaleorAttributeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorAttributeFilterInput = {
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inCategory?: InputMaybe<Scalars['ID']['input']>;
  inCollection?: InputMaybe<Scalars['ID']['input']>;
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<SaleorAttributeTypeEnum>;
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorAttributeInput = {
  /**
   * The boolean value of the attribute. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The date range that the returned values should be in. In case of date/time attributes, the UTC midnight of the given date is used. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  date?: InputMaybe<SaleorDateRangeInput>;
  /**
   * The date/time range that the returned values should be in. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  dateTime?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Filter by value of the attribute. Only one value input field is allowed. If provided more than one, the error will be raised. Cannot be combined with deprecated fields of `AttributeInput`.  */
  value?: InputMaybe<SaleorAssignedAttributeValueInput>;
  /**
   * Slugs identifying the attributeValues associated with the Attribute. When specified, it filters the results to include only records with one of the matching values. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The range that the returned values should be in. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  valuesRange?: InputMaybe<SaleorIntRangeInput>;
};

export type SaleorAttributeInputTypeEnum =
  | 'BOOLEAN'
  | 'DATE'
  | 'DATE_TIME'
  | 'DROPDOWN'
  | 'FILE'
  | 'MULTISELECT'
  | 'NUMERIC'
  | 'PLAIN_TEXT'
  | 'REFERENCE'
  | 'RICH_TEXT'
  | 'SINGLE_REFERENCE'
  | 'SWATCH';

export type SaleorAttributeInputTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorAttributeInputTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorAttributeInputTypeEnum>>;
};

/**
 * Reorder the values of an attribute.
 *
 * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type SaleorAttributeReorderValues = {
  __typename?: 'AttributeReorderValues';
  /** Attribute from which values are reordered. */
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeSortField =
  /** Sort attributes based on whether they can be displayed or not in a product grid. */
  | 'AVAILABLE_IN_GRID'
  /** Sort attributes by the filterable in dashboard flag */
  | 'FILTERABLE_IN_DASHBOARD'
  /** Sort attributes by the filterable in storefront flag */
  | 'FILTERABLE_IN_STOREFRONT'
  /** Sort attributes by the variant only flag */
  | 'IS_VARIANT_ONLY'
  /** Sort attributes by name */
  | 'NAME'
  /** Sort attributes by slug */
  | 'SLUG'
  /** Sort attributes by their position in storefront */
  | 'STOREFRONT_SEARCH_POSITION'
  /** Sort attributes by the value required flag */
  | 'VALUE_REQUIRED'
  /** Sort attributes by visibility in the storefront */
  | 'VISIBLE_IN_STOREFRONT';

export type SaleorAttributeSortingInput = {
  /** Specifies the direction in which to sort attributes. */
  direction: SaleorOrderDirection;
  /** Sort attributes by the selected field. */
  field: SaleorAttributeSortField;
};

/** Represents attribute's original translatable fields and related translations. */
export type SaleorAttributeTranslatableContent = SaleorNode & {
  __typename?: 'AttributeTranslatableContent';
  /**
   * Custom attribute of a product.
   * @deprecated Get model fields from the root level queries.
   */
  attribute: Maybe<SaleorAttribute>;
  /** The ID of the attribute to translate. */
  attributeId: Scalars['ID']['output'];
  /** The ID of the attribute translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the attribute to translate. */
  name: Scalars['String']['output'];
  /** Returns translated attribute fields for the given language code. */
  translation: Maybe<SaleorAttributeTranslation>;
};


/** Represents attribute's original translatable fields and related translations. */
export type SaleorAttributeTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for an attribute.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorAttributeTranslate = {
  __typename?: 'AttributeTranslate';
  attribute: Maybe<SaleorAttribute>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorAttributeTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents attribute translations. */
export type SaleorAttributeTranslation = SaleorNode & {
  __typename?: 'AttributeTranslation';
  /** The ID of the attribute translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated attribute name. */
  name: Scalars['String']['output'];
  /** Represents the attribute fields to translate. */
  translatableContent: Maybe<SaleorAttributeTranslatableContent>;
};

export type SaleorAttributeTypeEnum =
  | 'PAGE_TYPE'
  | 'PRODUCT_TYPE';

export type SaleorAttributeTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorAttributeTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorAttributeTypeEnum>>;
};

/**
 * Updates attribute.
 *
 * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type SaleorAttributeUpdate = {
  __typename?: 'AttributeUpdate';
  /** The updated attribute. */
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

/**
 * Represents an input for update of attribute.
 *
 * NOTE: Deprecated fields `filterableInStorefront`, `storefrontSearchPosition` and `availableInGrid` are not supported in bulk mutations: `attributeBulkCreate`, `attributeBulkUpdate`.
 */
export type SaleorAttributeUpdateInput = {
  /** New values to be created for this attribute. */
  addValues?: InputMaybe<Array<SaleorAttributeValueUpdateInput>>;
  /**
   * Whether the attribute can be displayed in the admin product list.
   *
   * DEPRECATED: this field will be removed.
   */
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Whether the attribute can be filtered in dashboard. */
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the attribute can be filtered in storefront.
   *
   * DEPRECATED: this field will be removed.
   */
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the attribute is for variants only. */
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of an attribute displayed in the interface. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specifies reference types to narrow down the choices of reference objects. Applicable only for `REFERENCE` and `SINGLE_REFERENCE` attributes with `PRODUCT`, `PRODUCT_VARIANT` and `PAGE` entity types. Accepts `ProductType` IDs for `PRODUCT` and `PRODUCT_VARIANT` entity types, and `PageType` IDs for `PAGE` entity type. If omitted, all objects of the selected entity type are available as attribute values.
   *
   * A maximum of 100 reference types can be specified.
   *
   * Added in Saleor 3.22.
   */
  referenceTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of values to be removed from this attribute. */
  removeValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default).
   *
   * DEPRECATED: this field will be removed.
   */
  storefrontSearchPosition?: InputMaybe<Scalars['Int']['input']>;
  /** The unit of attribute values. */
  unit?: InputMaybe<SaleorMeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. */
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the attribute should be visible or not in storefront. */
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when attribute is updated. */
export type SaleorAttributeUpdated = SaleorEvent & {
  __typename?: 'AttributeUpdated';
  /** The attribute the event relates to. */
  attribute: Maybe<SaleorAttribute>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents a value of an attribute. */
export type SaleorAttributeValue = SaleorNode & {
  __typename?: 'AttributeValue';
  /** Represents the boolean value of the attribute value. */
  boolean: Maybe<Scalars['Boolean']['output']>;
  /** Represents the date value of the attribute value. */
  date: Maybe<Scalars['Date']['output']>;
  /** Represents the date/time value of the attribute value. */
  dateTime: Maybe<Scalars['DateTime']['output']>;
  /** External ID of this attribute value. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** Represents file URL and content type (if attribute value is a file). */
  file: Maybe<SaleorFile>;
  /** The ID of the attribute value. */
  id: Scalars['ID']['output'];
  /** The input type to use for entering attribute values in the dashboard. */
  inputType: Maybe<SaleorAttributeInputTypeEnum>;
  /** Name of a value displayed in the interface. */
  name: Maybe<Scalars['String']['output']>;
  /** Represents the text of the attribute value, plain text without formatting. */
  plainText: Maybe<Scalars['String']['output']>;
  /** The ID of the referenced object. */
  reference: Maybe<Scalars['ID']['output']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText: Maybe<Scalars['JSONString']['output']>;
  /** Internal representation of a value (unique per attribute). */
  slug: Maybe<Scalars['String']['output']>;
  /** Returns translated attribute value fields for the given language code. */
  translation: Maybe<SaleorAttributeValueTranslation>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value: Maybe<Scalars['String']['output']>;
};


/** Represents a value of an attribute. */
export type SaleorAttributeValueTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes values of attributes.
 *
 * Requires one of the following permissions, depending on the type of each value's attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type SaleorAttributeValueBulkDelete = {
  __typename?: 'AttributeValueBulkDelete';
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeError>;
};

/**
 * Creates/updates translations for attribute values.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorAttributeValueBulkTranslate = {
  __typename?: 'AttributeValueBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeValueBulkTranslateError>;
  /** List of the translations. */
  results: Array<SaleorAttributeValueBulkTranslateResult>;
};

export type SaleorAttributeValueBulkTranslateError = {
  __typename?: 'AttributeValueBulkTranslateError';
  /** The error code. */
  code: SaleorAttributeValueTranslateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeValueBulkTranslateInput = {
  /** External reference of an attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Attribute value ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** Translation fields. */
  translationFields: SaleorAttributeValueTranslationInput;
};

export type SaleorAttributeValueBulkTranslateResult = {
  __typename?: 'AttributeValueBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors: Maybe<Array<SaleorAttributeValueBulkTranslateError>>;
  /** Attribute value translation data. */
  translation: Maybe<SaleorAttributeValueTranslation>;
};

export type SaleorAttributeValueCountableConnection = {
  __typename?: 'AttributeValueCountableConnection';
  edges: Array<SaleorAttributeValueCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorAttributeValueCountableEdge = {
  __typename?: 'AttributeValueCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorAttributeValue;
};

/**
 * Creates a value for an attribute.
 *
 * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_CREATED (async): An attribute value was created.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type SaleorAttributeValueCreate = {
  __typename?: 'AttributeValueCreate';
  /** The updated attribute. */
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  attributeValue: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeValueCreateInput = {
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** External ID of this attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of a value displayed in the interface. */
  name: Scalars['String']['input'];
  /**
   * Represents the text of the attribute value, plain text without formatting.
   *
   * DEPRECATED: this field will be removed.The plain text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   *
   * DEPRECATED: this field will be removed.The rich text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new attribute value is created. */
export type SaleorAttributeValueCreated = SaleorEvent & {
  __typename?: 'AttributeValueCreated';
  /** The attribute value the event relates to. */
  attributeValue: Maybe<SaleorAttributeValue>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a value of an attribute.
 *
 * Requires one of the following permissions, depending on the type of the value's attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type SaleorAttributeValueDelete = {
  __typename?: 'AttributeValueDelete';
  /** The updated attribute. */
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  attributeValue: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorAttributeError>;
};

/** Event sent when attribute value is deleted. */
export type SaleorAttributeValueDeleted = SaleorEvent & {
  __typename?: 'AttributeValueDeleted';
  /** The attribute value the event relates to. */
  attributeValue: Maybe<SaleorAttributeValue>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeValueFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorAttributeValueInput = {
  /** Represents the boolean value of the attribute value. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Represents the date value of the attribute value. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Attribute value ID or external reference. */
  dropdown?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  file?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selected attribute. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of attribute value IDs or external references. */
  multiselect?: InputMaybe<Array<SaleorAttributeValueSelectableTypeInput>>;
  /** Numeric value of an attribute. */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /** Plain text content. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the referenced entity for single reference attribute.
   *
   * Added in Saleor 3.22.
   */
  reference?: InputMaybe<Scalars['ID']['input']>;
  /** List of entity IDs that will be used as references. */
  references?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Text content in JSON format. */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Attribute value ID or external reference. */
  swatch?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /**
   * The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created.
   *
   * DEPRECATED: this field will be removed.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Represents attribute value.
 * 1. If ID is provided, then attribute value will be resolved by ID.
 * 2. If externalReference is provided, then attribute value will be resolved by external reference.
 * 3. If value is provided, then attribute value will be resolved by value. If this attribute value doesn't exist, then it will be created.
 * 4. If externalReference and value is provided then new attribute value will be created.
 */
export type SaleorAttributeValueSelectableTypeInput = {
  /** External reference of an attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of an attribute value. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents attribute value's original translatable fields and related translations. */
export type SaleorAttributeValueTranslatableContent = SaleorNode & {
  __typename?: 'AttributeValueTranslatableContent';
  /** Associated attribute that can be translated. */
  attribute: Maybe<SaleorAttributeTranslatableContent>;
  /**
   * Represents a value of an attribute.
   * @deprecated Get model fields from the root level queries.
   */
  attributeValue: Maybe<SaleorAttributeValue>;
  /** The ID of the attribute value to translate. */
  attributeValueId: Scalars['ID']['output'];
  /** The ID of the attribute value translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the attribute value to translate. */
  name: Scalars['String']['output'];
  /** Attribute plain text value. */
  plainText: Maybe<Scalars['String']['output']>;
  /**
   * Attribute value.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText: Maybe<Scalars['JSONString']['output']>;
  /** Returns translated attribute value fields for the given language code. */
  translation: Maybe<SaleorAttributeValueTranslation>;
};


/** Represents attribute value's original translatable fields and related translations. */
export type SaleorAttributeValueTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for an attribute value.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorAttributeValueTranslate = {
  __typename?: 'AttributeValueTranslate';
  attributeValue: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorAttributeValueTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents attribute value translations. */
export type SaleorAttributeValueTranslation = SaleorNode & {
  __typename?: 'AttributeValueTranslation';
  /** The ID of the attribute value translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated attribute value name. */
  name: Scalars['String']['output'];
  /** Translated plain text attribute value . */
  plainText: Maybe<Scalars['String']['output']>;
  /**
   * Translated rich-text attribute value.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText: Maybe<Scalars['JSONString']['output']>;
  /** Represents the attribute value fields to translate. */
  translatableContent: Maybe<SaleorAttributeValueTranslatableContent>;
};

export type SaleorAttributeValueTranslationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Translated text. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Translated text.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
};

/**
 * Updates value of an attribute.
 *
 * Requires one of the following permissions, depending on the type of the value's attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type SaleorAttributeValueUpdate = {
  __typename?: 'AttributeValueUpdate';
  /** The updated attribute. */
  attribute: Maybe<SaleorAttribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  attributeValue: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeValueUpdateInput = {
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** External ID of this attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of a value displayed in the interface. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, plain text without formatting.
   *
   * DEPRECATED: this field will be removed.The plain text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   *
   * DEPRECATED: this field will be removed.The rich text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when attribute value is updated. */
export type SaleorAttributeValueUpdated = SaleorEvent & {
  __typename?: 'AttributeValueUpdated';
  /** The attribute value the event relates to. */
  attributeValue: Maybe<SaleorAttributeValue>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Where filtering options for attribute values. */
export type SaleorAttributeValueWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorAttributeValueWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorAttributeValueWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<SaleorStringFilterInput>;
  slug?: InputMaybe<SaleorStringFilterInput>;
};

/** Where filtering options. */
export type SaleorAttributeWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorAttributeWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorAttributeWhereInput>>;
  entityType?: InputMaybe<SaleorAttributeEntityTypeEnumFilterInput>;
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inCategory?: InputMaybe<Scalars['ID']['input']>;
  inCollection?: InputMaybe<Scalars['ID']['input']>;
  inputType?: InputMaybe<SaleorAttributeInputTypeEnumFilterInput>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  name?: InputMaybe<SaleorStringFilterInput>;
  slug?: InputMaybe<SaleorStringFilterInput>;
  type?: InputMaybe<SaleorAttributeTypeEnumFilterInput>;
  unit?: InputMaybe<SaleorMeasurementUnitsEnumFilterInput>;
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  withChoices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorBulkAttributeValueInput = {
  /** The boolean value of an attribute to resolve. If the passed value is non-existent, it will be created. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Represents the date value of the attribute value. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Attribute value ID. */
  dropdown?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  file?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selected attribute. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of attribute value IDs. */
  multiselect?: InputMaybe<Array<SaleorAttributeValueSelectableTypeInput>>;
  /** Numeric value of an attribute. */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /** Plain text content. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the referenced entity for single reference attribute.
   *
   * Added in Saleor 3.22.
   */
  reference?: InputMaybe<Scalars['ID']['input']>;
  /** List of entity IDs that will be used as references. */
  references?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Text content in JSON format. */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Attribute value ID. */
  swatch?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /**
   * The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created.
   *
   * DEPRECATED: this field will be removed.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorBulkProductError = {
  __typename?: 'BulkProductError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** Index of an input list item that caused the error. */
  index: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorBulkStockError = {
  __typename?: 'BulkStockError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** Index of an input list item that caused the error. */
  index: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
};

/** Synchronous webhook for calculating checkout/order taxes. */
export type SaleorCalculateTaxes = SaleorEvent & {
  __typename?: 'CalculateTaxes';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  taxBase: SaleorTaxableObject;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Card data used to check a payment balance.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorCardInput = {
  /** Payment method nonce, a token returned by the appropriate provider's SDK. */
  code: Scalars['String']['input'];
  /** Card security code. */
  cvc?: InputMaybe<Scalars['String']['input']>;
  /** Information about currency and amount. */
  money: SaleorMoneyInput;
};

/**
 * Represents a card payment method used for a transaction.
 *
 * Added in Saleor 3.22.
 */
export type SaleorCardPaymentMethodDetails = SaleorPaymentMethodDetails & {
  __typename?: 'CardPaymentMethodDetails';
  /** Card brand. */
  brand: Maybe<Scalars['String']['output']>;
  /** Two-digit number representing the card’s expiration month. */
  expMonth: Maybe<Scalars['Int']['output']>;
  /** Four-digit number representing the card’s expiration year. */
  expYear: Maybe<Scalars['Int']['output']>;
  /** First 4 digits of the card number. */
  firstDigits: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the card number. */
  lastDigits: Maybe<Scalars['String']['output']>;
  /** Name of the payment method. */
  name: Scalars['String']['output'];
};

export type SaleorCardPaymentMethodDetailsInput = {
  /** Brand of the payment method used for the transaction. Max length is 40 characters. */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month of the card used for the transaction. Value must be between 1 and 12. */
  expMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Expiration year of the card used for the transaction. Value must be between 2000 and 9999. */
  expYear?: InputMaybe<Scalars['Int']['input']>;
  /** First digits of the card used for the transaction. Max length is 4 characters. */
  firstDigits?: InputMaybe<Scalars['String']['input']>;
  /** Last digits of the card used for the transaction. Max length is 4 characters. */
  lastDigits?: InputMaybe<Scalars['String']['input']>;
  /** Name of the payment method used for the transaction. Max length is 256 characters. */
  name: Scalars['String']['input'];
};

export type SaleorCatalogueInput = {
  /** Categories related to the discount. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collections related to the discount. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Products related to the discount. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product variant related to the discount. */
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaleorCataloguePredicateInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorCataloguePredicateInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorCataloguePredicateInput>>;
  /** Defines the category conditions to be met. */
  categoryPredicate?: InputMaybe<SaleorCategoryWhereInput>;
  /** Defines the collection conditions to be met. */
  collectionPredicate?: InputMaybe<SaleorCollectionWhereInput>;
  /** Defines the product conditions to be met. */
  productPredicate?: InputMaybe<SaleorProductWhereInput>;
  /** Defines the product variant conditions to be met. */
  variantPredicate?: InputMaybe<SaleorProductVariantWhereInput>;
};

/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategory = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Category';
  /** List of ancestors of the category. */
  ancestors: Maybe<SaleorCategoryCountableConnection>;
  /** Background image of the category. */
  backgroundImage: Maybe<SaleorImage>;
  /** List of children of the category. */
  children: Maybe<SaleorCategoryCountableConnection>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the category. */
  id: Scalars['ID']['output'];
  /** Level of the category. */
  level: Scalars['Int']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of category */
  name: Scalars['String']['output'];
  /** Parent category. */
  parent: Maybe<SaleorCategory>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** List of products in the category. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  products: Maybe<SaleorProductCountableConnection>;
  /** SEO description of category. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title of category. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /** Slug of the category. */
  slug: Scalars['String']['output'];
  /** Returns translated category fields for the given language code. */
  translation: Maybe<SaleorCategoryTranslation>;
  /** The date and time when the category was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryBackgroundImageArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorProductOrder>;
  where?: InputMaybe<SaleorProductWhereInput>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes categories.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryBulkDelete = {
  __typename?: 'CategoryBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorCategoryCountableConnection = {
  __typename?: 'CategoryCountableConnection';
  edges: Array<SaleorCategoryCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorCategoryCountableEdge = {
  __typename?: 'CategoryCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCategory;
};

/**
 * Creates a new category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryCreate = {
  __typename?: 'CategoryCreate';
  category: Maybe<SaleorCategory>;
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** Event sent when new category is created. */
export type SaleorCategoryCreated = SaleorEvent & {
  __typename?: 'CategoryCreated';
  /** The category the event relates to. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryDelete = {
  __typename?: 'CategoryDelete';
  category: Maybe<SaleorCategory>;
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** Event sent when category is deleted. */
export type SaleorCategoryDeleted = SaleorEvent & {
  __typename?: 'CategoryDeleted';
  /** The category the event relates to. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorCategoryFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorCategoryInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Alt text for a product media. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Category description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /**
   * Fields required to update the category metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the category private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Category slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCategorySortField =
  /** Sort categories by name. */
  | 'NAME'
  /** Sort categories by product count. */
  | 'PRODUCT_COUNT'
  /** Sort categories by subcategory count. */
  | 'SUBCATEGORY_COUNT';

export type SaleorCategorySortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort categories. */
  direction: SaleorOrderDirection;
  /** Sort categories by the selected field. */
  field: SaleorCategorySortField;
};

/** Represents category original translatable fields and related translations. */
export type SaleorCategoryTranslatableContent = SaleorNode & {
  __typename?: 'CategoryTranslatableContent';
  /**
   * Represents a single category of products.
   * @deprecated Get model fields from the root level queries.
   */
  category: Maybe<SaleorCategory>;
  /** The ID of the category to translate. */
  categoryId: Scalars['ID']['output'];
  /**
   * Category description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the category translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the category translatable content. */
  name: Scalars['String']['output'];
  /** SEO description to translate. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Returns translated category fields for the given language code. */
  translation: Maybe<SaleorCategoryTranslation>;
};


/** Represents category original translatable fields and related translations. */
export type SaleorCategoryTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a category.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorCategoryTranslate = {
  __typename?: 'CategoryTranslate';
  category: Maybe<SaleorCategory>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

/** Represents category translations. */
export type SaleorCategoryTranslation = SaleorNode & {
  __typename?: 'CategoryTranslation';
  /**
   * Translated description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the category translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated category name. */
  name: Maybe<Scalars['String']['output']>;
  /** Translated SEO description. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Translated category slug.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Represents the category fields to translate. */
  translatableContent: Maybe<SaleorCategoryTranslatableContent>;
};

/**
 * Updates a category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryUpdate = {
  __typename?: 'CategoryUpdate';
  category: Maybe<SaleorCategory>;
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** Event sent when category is updated. */
export type SaleorCategoryUpdated = SaleorEvent & {
  __typename?: 'CategoryUpdated';
  /** The category the event relates to. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorCategoryWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorCategoryWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorCategoryWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
};

/** Represents channel. */
export type SaleorChannel = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Channel';
  /** Shipping methods that are available for the channel. */
  availableShippingMethodsPerCountry: Maybe<Array<SaleorShippingMethodsPerCountry>>;
  /**
   * Channel-specific checkout settings.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, MANAGE_CHECKOUTS.
   */
  checkoutSettings: SaleorCheckoutSettings;
  /** List of shippable countries for the channel. */
  countries: Maybe<Array<SaleorCountryDisplay>>;
  /**
   * A currency that is assigned to the channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  currencyCode: Scalars['String']['output'];
  /**
   * Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  defaultCountry: SaleorCountryDisplay;
  /**
   * Whether a channel has associated orders.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  hasOrders: Scalars['Boolean']['output'];
  /** The ID of the channel. */
  id: Scalars['ID']['output'];
  /**
   * Whether the channel is active.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  isActive: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * Name of the channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  name: Scalars['String']['output'];
  /**
   * Channel-specific order settings.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, MANAGE_ORDERS.
   */
  orderSettings: SaleorOrderSettings;
  /**
   * Channel-specific payment settings.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, HANDLE_PAYMENTS.
   */
  paymentSettings: SaleorPaymentSettings;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Slug of the channel. */
  slug: Scalars['String']['output'];
  /**
   * Define the stock setting for this channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  stockSettings: SaleorStockSettings;
  /**
   * Channel specific tax configuration.
   *
   * Added in Saleor 3.20.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxConfiguration: SaleorTaxConfiguration;
  /**
   * List of warehouses assigned to this channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  warehouses: Array<SaleorWarehouse>;
};


/** Represents channel. */
export type SaleorChannelAvailableShippingMethodsPerCountryArgs = {
  countries?: InputMaybe<Array<SaleorCountryCode>>;
};


/** Represents channel. */
export type SaleorChannelMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents channel. */
export type SaleorChannelMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents channel. */
export type SaleorChannelPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents channel. */
export type SaleorChannelPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Activate a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_STATUS_CHANGED (async): A channel was activated.
 */
export type SaleorChannelActivate = {
  __typename?: 'ChannelActivate';
  /** Activated channel. */
  channel: Maybe<SaleorChannel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

/**
 * Creates a new channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_CREATED (async): A channel was created.
 */
export type SaleorChannelCreate = {
  __typename?: 'ChannelCreate';
  channel: Maybe<SaleorChannel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

export type SaleorChannelCreateInput = {
  /** List of shipping zones to assign to the channel. */
  addShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to the channel. */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel checkout settings */
  checkoutSettings?: InputMaybe<SaleorCheckoutSettingsInput>;
  /** Currency of the channel. */
  currencyCode: Scalars['String']['input'];
  /** Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided. */
  defaultCountry: SaleorCountryCode;
  /** Determine if channel will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Channel public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Name of the channel. */
  name: Scalars['String']['input'];
  /** The channel order settings */
  orderSettings?: InputMaybe<SaleorOrderSettingsInput>;
  /** The channel payment settings */
  paymentSettings?: InputMaybe<SaleorPaymentSettingsInput>;
  /**
   * Channel private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Slug of the channel. */
  slug: Scalars['String']['input'];
  /** The channel stock settings. */
  stockSettings?: InputMaybe<SaleorStockSettingsInput>;
};

/** Event sent when new channel is created. */
export type SaleorChannelCreated = SaleorEvent & {
  __typename?: 'ChannelCreated';
  /** The channel the event relates to. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deactivate a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_STATUS_CHANGED (async): A channel was deactivated.
 */
export type SaleorChannelDeactivate = {
  __typename?: 'ChannelDeactivate';
  /** Deactivated channel. */
  channel: Maybe<SaleorChannel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

/**
 * Deletes a channel. Orders associated with the deleted channel will be moved to the target channel. Checkouts, product availability, and pricing will be removed.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_DELETED (async): A channel was deleted.
 */
export type SaleorChannelDelete = {
  __typename?: 'ChannelDelete';
  channel: Maybe<SaleorChannel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

export type SaleorChannelDeleteInput = {
  /** ID of a channel to migrate orders from the origin channel. Target channel has to have the same currency as the origin. */
  channelId: Scalars['ID']['input'];
};

/** Event sent when channel is deleted. */
export type SaleorChannelDeleted = SaleorEvent & {
  __typename?: 'ChannelDeleted';
  /** The channel the event relates to. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorChannelError = {
  __typename?: 'ChannelError';
  /** The error code. */
  code: SaleorChannelErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of shipping zone IDs which causes the error. */
  shippingZones: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouses IDs which causes the error. */
  warehouses: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorChannelErrorCode =
  | 'ALREADY_EXISTS'
  | 'CHANNELS_CURRENCY_MUST_BE_THE_SAME'
  | 'CHANNEL_WITH_ORDERS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorChannelListingUpdateInput = {
  /** ID of a channel listing. */
  channelListing: Scalars['ID']['input'];
  /** Cost price of the variant in channel. */
  costPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The threshold for preorder variant in channel. */
  preorderThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the particular variant in channel. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Price of the variant before discount. */
  priorPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

/** Event sent when channel metadata is updated. */
export type SaleorChannelMetadataUpdated = SaleorEvent & {
  __typename?: 'ChannelMetadataUpdated';
  /** The channel the event relates to. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Reorder the warehouses of a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type SaleorChannelReorderWarehouses = {
  __typename?: 'ChannelReorderWarehouses';
  /** Channel within the warehouses are reordered. */
  channel: Maybe<SaleorChannel>;
  errors: Array<SaleorChannelError>;
};

/** Event sent when channel status has changed. */
export type SaleorChannelStatusChanged = SaleorEvent & {
  __typename?: 'ChannelStatusChanged';
  /** The channel the event relates to. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Update a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 * Requires one of the following permissions when updating only `orderSettings` field: `MANAGE_CHANNELS`, `MANAGE_ORDERS`.
 * Requires one of the following permissions when updating only `checkoutSettings` field: `MANAGE_CHANNELS`, `MANAGE_CHECKOUTS`.
 * Requires one of the following permissions when updating only `paymentSettings` field: `MANAGE_CHANNELS`, `HANDLE_PAYMENTS`.
 *
 * Triggers the following webhook events:
 * - CHANNEL_UPDATED (async): A channel was updated.
 * - CHANNEL_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
 */
export type SaleorChannelUpdate = {
  __typename?: 'ChannelUpdate';
  channel: Maybe<SaleorChannel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

export type SaleorChannelUpdateInput = {
  /** List of shipping zones to assign to the channel. */
  addShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to the channel. */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel checkout settings */
  checkoutSettings?: InputMaybe<SaleorCheckoutSettingsInput>;
  /** Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided. */
  defaultCountry?: InputMaybe<SaleorCountryCode>;
  /** Determine if channel will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Channel public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Name of the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The channel order settings */
  orderSettings?: InputMaybe<SaleorOrderSettingsInput>;
  /** The channel payment settings */
  paymentSettings?: InputMaybe<SaleorPaymentSettingsInput>;
  /**
   * Channel private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** List of shipping zones to unassign from the channel. */
  removeShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to unassign from the channel. */
  removeWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Slug of the channel. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The channel stock settings. */
  stockSettings?: InputMaybe<SaleorStockSettingsInput>;
};

/** Event sent when channel is updated. */
export type SaleorChannelUpdated = SaleorEvent & {
  __typename?: 'ChannelUpdated';
  /** The channel the event relates to. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Checkout object. */
export type SaleorCheckout = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Checkout';
  /**
   * The authorize status of the checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  authorizeStatus: SaleorCheckoutAuthorizeStatusEnum;
  /** Collection points that can be used for this order. */
  availableCollectionPoints: Array<SaleorWarehouse>;
  /**
   * List of available payment gateways.
   *
   * Triggers the following webhook events:
   * - PAYMENT_LIST_GATEWAYS (sync): Fetch payment gateways available for checkout.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  availablePaymentGateways: Array<SaleorPaymentGateway>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * @deprecated Use `shippingMethods` instead.
   */
  availableShippingMethods: Array<SaleorShippingMethod>;
  /** The billing address of the checkout. */
  billingAddress: Maybe<SaleorAddress>;
  /** The channel for which checkout was created. */
  channel: SaleorChannel;
  /**
   * The charge status of the checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  chargeStatus: SaleorCheckoutChargeStatusEnum;
  /** The date and time when the checkout was created. */
  created: Scalars['DateTime']['output'];
  /**
   * The customer note for the checkout.
   *
   * Added in Saleor 3.21.
   */
  customerNote: Scalars['String']['output'];
  /**
   * The delivery method selected for this checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   */
  deliveryMethod: Maybe<SaleorDeliveryMethod>;
  /** The total discount applied to the checkout. Note: Only discount created via voucher are included in this field. */
  discount: Maybe<SaleorMoney>;
  /** The name of voucher assigned to the checkout. */
  discountName: Maybe<Scalars['String']['output']>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Email of a customer. */
  email: Maybe<Scalars['String']['output']>;
  /** List of gift cards associated with this checkout. */
  giftCards: Array<SaleorGiftCard>;
  /** The ID of the checkout. */
  id: Scalars['ID']['output'];
  /** Returns True, if checkout requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** Checkout language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** @deprecated Use `updatedAt` instead. */
  lastChange: Scalars['DateTime']['output'];
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<SaleorCheckoutLine>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * The note for the checkout.
   * @deprecated Use `customerNote` instead.
   */
  note: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** List of problems with the checkout. */
  problems: Maybe<Array<SaleorCheckoutProblem>>;
  /** The number of items purchased. */
  quantity: Scalars['Int']['output'];
  /** The shipping address of the checkout. */
  shippingAddress: Maybe<SaleorAddress>;
  /**
   * The shipping method related with checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * @deprecated Use `deliveryMethod` instead.
   */
  shippingMethod: Maybe<SaleorShippingMethod>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   */
  shippingMethods: Array<SaleorShippingMethod>;
  /**
   * The price of the shipping, with all the taxes included. Set to 0 when no delivery method is selected.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  shippingPrice: SaleorTaxedMoney;
  /** Date when oldest stock reservation for this checkout expires or null if no stock is reserved. */
  stockReservationExpires: Maybe<Scalars['DateTime']['output']>;
  /** List of user's stored payment methods that can be used in this checkout session. It uses the channel that the checkout was created in. When `amount` is not provided, `checkout.total` will be used as a default value. */
  storedPaymentMethods: Maybe<Array<SaleorStoredPaymentMethod>>;
  /**
   * The price of the checkout before shipping, with taxes included.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  subtotalPrice: SaleorTaxedMoney;
  /** Returns True if checkout has to be exempt from taxes. */
  taxExemption: Scalars['Boolean']['output'];
  /** The checkout's token. */
  token: Scalars['UUID']['output'];
  /**
   * The difference between the paid and the checkout total amount.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  totalBalance: SaleorMoney;
  /**
   * The sum of the checkout line prices, with all the taxes,shipping costs, and discounts included.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  totalPrice: SaleorTaxedMoney;
  /** List of transactions for the checkout. Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_PAYMENTS. */
  transactions: Maybe<Array<SaleorTransactionItem>>;
  /** Translation of the discountName field in the language set in Checkout.languageCode field.Note: this field is set automatically when Checkout.languageCode is defined; otherwise it's null */
  translatedDiscountName: Maybe<Scalars['String']['output']>;
  /** Time of last modification of the given checkout. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user assigned to the checkout. Requires one of the following permissions: MANAGE_USERS, HANDLE_PAYMENTS, OWNER. */
  user: Maybe<SaleorUser>;
  /**
   * The voucher assigned to the checkout.
   *
   * Added in Saleor 3.18.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  voucher: Maybe<SaleorVoucher>;
  /** The code of voucher assigned to the checkout. */
  voucherCode: Maybe<Scalars['String']['output']>;
};


/** Checkout object. */
export type SaleorCheckoutMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Checkout object. */
export type SaleorCheckoutMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Checkout object. */
export type SaleorCheckoutPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Checkout object. */
export type SaleorCheckoutPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Checkout object. */
export type SaleorCheckoutStoredPaymentMethodsArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

/**
 * Adds a gift card or a voucher to a checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutAddPromoCode = {
  __typename?: 'CheckoutAddPromoCode';
  /** The checkout with the added gift card or voucher. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutAddressValidationRules = {
  /** Determines if an error should be raised when the provided address doesn't match the expected format. Example: using letters for postal code when the numbers are expected. */
  checkFieldsFormat?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if an error should be raised when the provided address doesn't have all the required fields. The list of required fields is dynamic and depends on the country code (use the `addressValidationRules` query to fetch them). Note: country code is mandatory for all addresses regardless of the rules provided in this input. */
  checkRequiredFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if Saleor should apply normalization on address fields. Example: converting city field to uppercase letters. */
  enableFieldsNormalization?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Determine a current authorize status for checkout.
 *
 *     We treat the checkout as fully authorized when the sum of authorized and charged
 *     funds cover the checkout.total.
 *     We treat the checkout as partially authorized when the sum of authorized and charged
 *     funds covers only part of the checkout.total
 *     We treat the checkout as not authorized when the sum of authorized and charged funds
 *     is 0.
 *
 *     NONE - the funds are not authorized
 *     PARTIAL - the cover funds don't cover fully the checkout's total
 *     FULL - the cover funds covers the checkout's total
 *
 */
export type SaleorCheckoutAuthorizeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'PARTIAL';

export type SaleorCheckoutAutoCompleteInput = {
  /** Specifies the earliest date on which fully paid checkouts can begin to be automatically completed. Fully paid checkouts dated before this cut-off will not be automatically completed. Must be less than the threshold of the oldest modified checkout eligible for automatic completion. Default is current date time. */
  cutOffDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The time in minutes after which the fully paid checkout will be automatically completed. Default is 30. Set to 0 for immediate completion. Should be less than the threshold for the oldest modified checkout eligible for automatic completion. */
  delay?: InputMaybe<Scalars['Minute']['input']>;
  /** Default `false`. Determines if the paid checkouts should be automatically completed. This setting applies only to checkouts where payment was processed through transactions.When enabled, the checkout will be automatically completed once the checkout `charge_status` reaches `FULL`. This occurs when the total sum of charged and authorized transaction amounts equals or exceeds the checkout's total amount. */
  enabled: Scalars['Boolean']['input'];
};

/**
 * Updates billing address in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutBillingAddressUpdate = {
  __typename?: 'CheckoutBillingAddressUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Determine the current charge status for the checkout.
 *
 *     The checkout is considered overcharged when the sum of the transactionItem's charge
 *     amounts exceeds the value of `checkout.total`.
 *     If the sum of the transactionItem's charge amounts equals
 *     `checkout.total`, we consider the checkout to be fully charged.
 *     If the sum of the transactionItem's charge amounts covers a part of the
 *     `checkout.total`, we treat the checkout as partially charged.
 *
 *
 *     NONE - the funds are not charged.
 *     PARTIAL - the funds that are charged don't cover the checkout's total
 *     FULL - the funds that are charged fully cover the checkout's total
 *     OVERCHARGED - the charged funds are bigger than checkout's total
 *
 */
export type SaleorCheckoutChargeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'OVERCHARGED'
  | 'PARTIAL';

/**
 * Completes the checkout. As a result a new order is created. The mutation allows to create the unpaid order when setting `orderSettings.allowUnpaidOrders` for given `Channel` is set to `true`. When `orderSettings.allowUnpaidOrders` is set to `false`, checkout can be completed only when attached `Payment`/`TransactionItem`s fully cover the checkout's total. When processing the checkout with `Payment`, in case of required additional confirmation step like 3D secure, the `confirmationNeeded` flag will be set to True and no order will be created until payment is confirmed with second call of this mutation.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
 * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
 * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
 * - ORDER_CREATED (async): Triggered when order is created.
 * - NOTIFY_USER (async): A notification for order placement.
 * - NOTIFY_USER (async): A staff notification for order placement.
 * - ORDER_UPDATED (async): Triggered when order received the update after placement.
 * - ORDER_PAID (async): Triggered when newly created order is paid.
 * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
 * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
 */
export type SaleorCheckoutComplete = {
  __typename?: 'CheckoutComplete';
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  /** Confirmation data used to process additional authorization steps. */
  confirmationData: Maybe<Scalars['JSONString']['output']>;
  /** Set to true if payment needs to be confirmed before checkout is complete. */
  confirmationNeeded: Scalars['Boolean']['output'];
  errors: Array<SaleorCheckoutError>;
  /** Placed order. */
  order: Maybe<SaleorOrder>;
};

export type SaleorCheckoutCountableConnection = {
  __typename?: 'CheckoutCountableConnection';
  edges: Array<SaleorCheckoutCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorCheckoutCountableEdge = {
  __typename?: 'CheckoutCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCheckout;
};

/**
 * Create a new checkout.
 *
 * `skipValidation` field requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_CREATED (async): A checkout was created.
 */
export type SaleorCheckoutCreate = {
  __typename?: 'CheckoutCreate';
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  /**
   * Whether the checkout was created or the current active one was returned. Refer to checkoutLinesAdd and checkoutLinesUpdate to merge a cart with an active checkout.
   * @deprecated Always returns `true`.
   */
  created: Maybe<Scalars['Boolean']['output']>;
  errors: Array<SaleorCheckoutError>;
};

/** Creates a new checkout from existing order. */
export type SaleorCheckoutCreateFromOrder = {
  __typename?: 'CheckoutCreateFromOrder';
  /** Created checkout. */
  checkout: Maybe<SaleorCheckout>;
  errors: Array<SaleorCheckoutCreateFromOrderError>;
  /** Variants that were not attached to the checkout. */
  unavailableVariants: Maybe<Array<SaleorCheckoutCreateFromOrderUnavailableVariant>>;
};

export type SaleorCheckoutCreateFromOrderError = {
  __typename?: 'CheckoutCreateFromOrderError';
  /** The error code. */
  code: SaleorCheckoutCreateFromOrderErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorCheckoutCreateFromOrderErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'ORDER_NOT_FOUND'
  | 'TAX_ERROR';

export type SaleorCheckoutCreateFromOrderUnavailableVariant = {
  __typename?: 'CheckoutCreateFromOrderUnavailableVariant';
  /** The error code. */
  code: SaleorCheckoutCreateFromOrderUnavailableVariantErrorCode;
  /** Order line ID that is unavailable. */
  lineId: Scalars['ID']['output'];
  /** The error message. */
  message: Scalars['String']['output'];
  /** Variant ID that is unavailable. */
  variantId: Scalars['ID']['output'];
};

export type SaleorCheckoutCreateFromOrderUnavailableVariantErrorCode =
  | 'INSUFFICIENT_STOCK'
  | 'NOT_FOUND'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'QUANTITY_GREATER_THAN_LIMIT'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL';

export type SaleorCheckoutCreateInput = {
  /** Billing address of the customer. `skipValidation` requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** Slug of a channel in which to create a checkout. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checkout language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<SaleorCheckoutLineInput>;
  /**
   * Checkout public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   *
   * Added in Saleor 3.21.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Checkout private metadata. Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_CHECKOUTS
   *
   * Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   *
   * Added in Saleor 3.21.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Indicates whether the billing address should be saved to the user’s address book upon checkout completion. Can only be set when a billing address is provided. If not specified along with the address, the default behavior is to save the address.
   *
   * Added in Saleor 3.21.
   */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the shipping address should be saved to the user’s address book upon checkout completion.Can only be set when a shipping address is provided. If not specified along with the address, the default behavior is to save the address.
   *
   * Added in Saleor 3.21.
   */
  saveShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mailing address to where the checkout will be shipped. Note: the address will be ignored if the checkout doesn't contain shippable items. `skipValidation` requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** The checkout validation rules that can be changed. */
  validationRules?: InputMaybe<SaleorCheckoutValidationRules>;
};

/** Event sent when new checkout is created. */
export type SaleorCheckoutCreated = SaleorEvent & {
  __typename?: 'CheckoutCreated';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Sets the customer as the owner of the checkout.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutCustomerAttach = {
  __typename?: 'CheckoutCustomerAttach';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Removes the user assigned as the owner of the checkout.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutCustomerDetach = {
  __typename?: 'CheckoutCustomerDetach';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Updates customer note in the existing checkout object.
 *
 * Added in Saleor 3.21.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutCustomerNoteUpdate = {
  __typename?: 'CheckoutCustomerNoteUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Updates the delivery method (shipping method or pick up point) of the checkout. Updates the checkout shipping_address for click and collect delivery for a warehouse address.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout delivery method with the external one.
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutDeliveryMethodUpdate = {
  __typename?: 'CheckoutDeliveryMethodUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Updates email address in the existing checkout object.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutEmailUpdate = {
  __typename?: 'CheckoutEmailUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutError = {
  __typename?: 'CheckoutError';
  /** A type of address that causes the error. */
  addressType: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorCheckoutErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** List of line Ids which cause the error. */
  lines: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorCheckoutErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_NOT_FULLY_PAID'
  | 'DELIVERY_METHOD_NOT_APPLICABLE'
  | 'EMAIL_NOT_SET'
  | 'GIFT_CARD_NOT_APPLICABLE'
  | 'GRAPHQL_ERROR'
  | 'INACTIVE_PAYMENT'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_SHIPPING_METHOD'
  | 'MISSING_ADDRESS_DATA'
  | 'MISSING_CHANNEL_SLUG'
  | 'NON_EDITABLE_GIFT_LINE'
  | 'NON_REMOVABLE_GIFT_LINE'
  | 'NOT_FOUND'
  | 'NO_LINES'
  | 'PAYMENT_ERROR'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'QUANTITY_GREATER_THAN_LIMIT'
  | 'REQUIRED'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_CHANGE_FORBIDDEN'
  | 'SHIPPING_METHOD_NOT_APPLICABLE'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'SHIPPING_NOT_REQUIRED'
  | 'TAX_ERROR'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'UNIQUE'
  | 'VOUCHER_NOT_APPLICABLE'
  | 'ZERO_QUANTITY';

export type SaleorCheckoutFilterInput = {
  authorizeStatus?: InputMaybe<Array<SaleorCheckoutAuthorizeStatusEnum>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  chargeStatus?: InputMaybe<Array<SaleorCheckoutChargeStatusEnum>>;
  created?: InputMaybe<SaleorDateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<SaleorDateRangeInput>;
};

/** Filter shipping methods for checkout. */
export type SaleorCheckoutFilterShippingMethods = SaleorEvent & {
  __typename?: 'CheckoutFilterShippingMethods';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods: Maybe<Array<SaleorShippingMethod>>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when a checkout was fully authorized. A checkout is considered fully authorized when its `authorizeStatus` is `FULL`.
 *
 * It is triggered only for checkouts whose payments are processed through the Transaction API.
 */
export type SaleorCheckoutFullyAuthorized = SaleorEvent & {
  __typename?: 'CheckoutFullyAuthorized';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when a checkout was fully paid. A checkout is considered fully paid when its `chargeStatus` is `FULL` or `OVERCHARGED`. This event is not sent if payments are only authorized but not fully charged.
 *
 * It is triggered only for checkouts whose payments are processed through the Transaction API.
 */
export type SaleorCheckoutFullyPaid = SaleorEvent & {
  __typename?: 'CheckoutFullyPaid';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Updates language code in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutLanguageCodeUpdate = {
  __typename?: 'CheckoutLanguageCodeUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Represents an item in the checkout. */
export type SaleorCheckoutLine = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'CheckoutLine';
  /** The ID of the checkout line. */
  id: Scalars['ID']['output'];
  /**
   * Determine if the line is a gift.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  isGift: Maybe<Scalars['Boolean']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * The sum of the checkout line price prior to promotion.
   *
   * Added in Saleor 3.21.
   */
  priorTotalPrice: Maybe<SaleorMoney>;
  /**
   * The unit price of the checkout line prior to promotion.
   *
   * Added in Saleor 3.21.
   */
  priorUnitPrice: Maybe<SaleorMoney>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** List of problems with the checkout line. */
  problems: Maybe<Array<SaleorCheckoutLineProblem>>;
  /** The quantity of product variant assigned to the checkout line. */
  quantity: Scalars['Int']['output'];
  /** Indicates whether the item need to be delivered. */
  requiresShipping: Scalars['Boolean']['output'];
  /**
   * The sum of the checkout line price, taxes and discounts.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  totalPrice: SaleorTaxedMoney;
  /** The sum of the checkout line price, without discounts. */
  undiscountedTotalPrice: SaleorMoney;
  /** The unit price of the checkout line, without discounts. */
  undiscountedUnitPrice: SaleorMoney;
  /**
   * The unit price of the checkout line, with taxes and discounts.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  unitPrice: SaleorTaxedMoney;
  /** The product variant from which the checkout line was created. */
  variant: SaleorProductVariant;
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLineMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLineMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLinePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLinePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorCheckoutLineCountableConnection = {
  __typename?: 'CheckoutLineCountableConnection';
  edges: Array<SaleorCheckoutLineCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorCheckoutLineCountableEdge = {
  __typename?: 'CheckoutLineCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCheckoutLine;
};

/**
 * Deletes a CheckoutLine.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutLineDelete = {
  __typename?: 'CheckoutLineDelete';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutLineInput = {
  /** Flag that allow force splitting the same variant into multiple lines by skipping the matching logic.  */
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the object's metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Custom price of the item. Can be set only by apps with `HANDLE_CHECKOUTS` permission. When the line with the same variant will be provided multiple times, the last price will be used. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The number of items purchased. */
  quantity: Scalars['Int']['input'];
  /** ID of the product variant. */
  variantId: Scalars['ID']['input'];
};

/** Represents an problem in the checkout line. */
export type SaleorCheckoutLineProblem = SaleorCheckoutLineProblemInsufficientStock | SaleorCheckoutLineProblemVariantNotAvailable;

/** Indicates insufficient stock for a given checkout line.Placing the order will not be possible until solving this problem. */
export type SaleorCheckoutLineProblemInsufficientStock = {
  __typename?: 'CheckoutLineProblemInsufficientStock';
  /** Available quantity of a variant. */
  availableQuantity: Maybe<Scalars['Int']['output']>;
  /** The line that has variant with insufficient stock. */
  line: SaleorCheckoutLine;
  /** The variant with insufficient stock. */
  variant: SaleorProductVariant;
};

/** The variant assigned to the checkout line is not available.Placing the order will not be possible until solving this problem. */
export type SaleorCheckoutLineProblemVariantNotAvailable = {
  __typename?: 'CheckoutLineProblemVariantNotAvailable';
  /** The line that has variant that is not available. */
  line: SaleorCheckoutLine;
};

export type SaleorCheckoutLineUpdateInput = {
  /** ID of the line. */
  lineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Checkout line public metadata. Will add and update keys. To delete keys use deleteMetadata mutation.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Custom price of the item. Can be set only by apps with `HANDLE_CHECKOUTS` permission. When the line with the same variant will be provided multiple times, the last price will be used. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The number of items purchased. Optional for apps, required for any other users. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * ID of the product variant.
   *
   * DEPRECATED: this field will be removed. Use `lineId` instead.
   */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Adds a checkout line to the existing checkout.If line was already in checkout, its quantity will be increased.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutLinesAdd = {
  __typename?: 'CheckoutLinesAdd';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Deletes checkout lines.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutLinesDelete = {
  __typename?: 'CheckoutLinesDelete';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Updates checkout line in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutLinesUpdate = {
  __typename?: 'CheckoutLinesUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Event sent when checkout metadata is updated. */
export type SaleorCheckoutMetadataUpdated = SaleorEvent & {
  __typename?: 'CheckoutMetadataUpdated';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Creates a new payment for given checkout. */
export type SaleorCheckoutPaymentCreate = {
  __typename?: 'CheckoutPaymentCreate';
  /** Related checkout object. */
  checkout: Maybe<SaleorCheckout>;
  errors: Array<SaleorPaymentError>;
  /** A newly created payment. */
  payment: Maybe<SaleorPayment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/** Represents an problem in the checkout. */
export type SaleorCheckoutProblem = SaleorCheckoutLineProblemInsufficientStock | SaleorCheckoutLineProblemVariantNotAvailable;

/**
 * Remove a gift card or a voucher from a checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutRemovePromoCode = {
  __typename?: 'CheckoutRemovePromoCode';
  /** The checkout with the removed gift card or voucher. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Represents the channel-specific checkout settings. */
export type SaleorCheckoutSettings = {
  __typename?: 'CheckoutSettings';
  /**
   * The date time defines the earliest checkout creation date on which fully paid checkouts can begin to be automatically completed.
   *
   * Added in Saleor 3.22.
   */
  automaticCompletionCutOffDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time in minutes to wait after a checkout is fully paid before automatically completing it.
   *
   * Added in Saleor 3.22.
   */
  automaticCompletionDelay: Maybe<Scalars['Minute']['output']>;
  /**
   * Default `false`. Determines if the paid checkouts should be automatically completed. This setting applies only to checkouts where payment was processed through transactions.When enabled, the checkout will be automatically completed once the checkout `charge_status` reaches `FULL`. This occurs when the total sum of charged and authorized transaction amounts equals or exceeds the checkout's total amount.
   *
   * Added in Saleor 3.20.
   */
  automaticallyCompleteFullyPaidCheckouts: Scalars['Boolean']['output'];
  /**
   * Default `true`. Determines if the checkout mutations should use legacy error flow. In legacy flow, all mutations can raise an exception unrelated to the requested action - (e.g. out-of-stock exception when updating checkoutShippingAddress.) If `false`, the errors will be aggregated in `checkout.problems` field. Some of the `problems` can block the finalizing checkout process. The legacy flow will be removed in Saleor 4.0. The flow with `checkout.problems` will be the default one.
   *
   * DEPRECATED: this field will be removed.
   */
  useLegacyErrorFlow: Scalars['Boolean']['output'];
};

export type SaleorCheckoutSettingsInput = {
  /**
   * Settings for automatic completion of fully paid checkouts.
   *
   * Added in Saleor 3.22.
   */
  automaticCompletion?: InputMaybe<SaleorCheckoutAutoCompleteInput>;
  /**
   * Default `false`. Determines if the paid checkouts should be automatically completed. This setting applies only to checkouts where payment was processed through transactions.When enabled, the checkout will be automatically completed once the checkout `authorize_status` reaches `FULL`. This occurs when the total sum of charged and authorized transaction amounts equals or exceeds the checkout's total amount.
   *
   * Added in Saleor 3.20.
   *
   * DEPRECATED: this field will be removed. Use `automatic_completion` instead.
   */
  automaticallyCompleteFullyPaidCheckouts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Default `true`. Determines if the checkout mutations should use legacy error flow. In legacy flow, all mutations can raise an exception unrelated to the requested action - (e.g. out-of-stock exception when updating checkoutShippingAddress.) If `false`, the errors will be aggregated in `checkout.problems` field. Some of the `problems` can block the finalizing checkout process. The legacy flow will be removed in Saleor 4.0. The flow with `checkout.problems` will be the default one.
   *
   * DEPRECATED: this field will be removed.
   */
  useLegacyErrorFlow?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Updates shipping address in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutShippingAddressUpdate = {
  __typename?: 'CheckoutShippingAddressUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Updates the shipping method of the checkout.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout shipping method with the external one.
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type SaleorCheckoutShippingMethodUpdate = {
  __typename?: 'CheckoutShippingMethodUpdate';
  /** An updated checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutSortField =
  /** Sort checkouts by creation date. */
  | 'CREATION_DATE'
  /** Sort checkouts by customer. */
  | 'CUSTOMER'
  /** Sort checkouts by payment. */
  | 'PAYMENT';

export type SaleorCheckoutSortingInput = {
  /** Specifies the direction in which to sort checkouts. */
  direction: SaleorOrderDirection;
  /** Sort checkouts by the selected field. */
  field: SaleorCheckoutSortField;
};

/** Event sent when checkout is updated. */
export type SaleorCheckoutUpdated = SaleorEvent & {
  __typename?: 'CheckoutUpdated';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorCheckoutValidationRules = {
  /** The validation rules that can be applied to provided billing address data. */
  billingAddress?: InputMaybe<SaleorCheckoutAddressValidationRules>;
  /** The validation rules that can be applied to provided shipping address data. */
  shippingAddress?: InputMaybe<SaleorCheckoutAddressValidationRules>;
};

export type SaleorChoiceValue = {
  __typename?: 'ChoiceValue';
  /** The raw name of the choice. */
  raw: Maybe<Scalars['String']['output']>;
  /** The verbose name of the choice. */
  verbose: Maybe<Scalars['String']['output']>;
};

/** Enum determining the state of a circuit breaker. */
export type SaleorCircuitBreakerStateEnum =
  /** The breaker is conducting (requests are passing through). */
  | 'CLOSED'
  /** The breaker is in a trial period (to close or open). Note that unlike classic breaker patterns, this is not a state where we are throttling the number of requests, it's a state similar to CLOSED but with different thresholds. */
  | 'HALF_OPEN'
  /** The breaker is tripped (no requests are passing). Breaker will enter half-open state after cooldown period. */
  | 'OPEN';

/** Represents a collection of products. */
export type SaleorCollection = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Collection';
  /** Background image of the collection. */
  backgroundImage: Maybe<SaleorImage>;
  /** Channel given to retrieve this collection. Also used by federation gateway to resolve this object in a federated query. */
  channel: Maybe<Scalars['String']['output']>;
  /**
   * List of channels in which the collection is available.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  channelListings: Maybe<Array<SaleorCollectionChannelListing>>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the collection. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the collection. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** List of products in this collection. */
  products: Maybe<SaleorProductCountableConnection>;
  /** SEO description of the collection. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title of the collection. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /** Slug of the collection. */
  slug: Scalars['String']['output'];
  /** Returns translated collection fields for the given language code. */
  translation: Maybe<SaleorCollectionTranslation>;
};


/** Represents a collection of products. */
export type SaleorCollectionBackgroundImageArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a collection of products. */
export type SaleorCollectionMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a collection of products. */
export type SaleorCollectionMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a collection of products. */
export type SaleorCollectionPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a collection of products. */
export type SaleorCollectionPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a collection of products. */
export type SaleorCollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorProductOrder>;
  where?: InputMaybe<SaleorProductWhereInput>;
};


/** Represents a collection of products. */
export type SaleorCollectionTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Adds products to a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionAddProducts = {
  __typename?: 'CollectionAddProducts';
  /** Collection to which products will be added. */
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/**
 * Deletes collections.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionBulkDelete = {
  __typename?: 'CollectionBulkDelete';
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorCollectionError>;
};

/** Represents collection channel listing. */
export type SaleorCollectionChannelListing = SaleorNode & {
  __typename?: 'CollectionChannelListing';
  /** The channel to which the collection belongs. */
  channel: SaleorChannel;
  /** The ID of the collection channel listing. */
  id: Scalars['ID']['output'];
  /** Indicates if the collection is published in the channel. */
  isPublished: Scalars['Boolean']['output'];
  /** @deprecated Use the `publishedAt` field to fetch the publication date. */
  publicationDate: Maybe<Scalars['Date']['output']>;
  /** The collection publication date. */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SaleorCollectionChannelListingError = {
  __typename?: 'CollectionChannelListingError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channels IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Manage collection's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionChannelListingUpdate = {
  __typename?: 'CollectionChannelListingUpdate';
  /** An updated collection instance. */
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionChannelListingErrors: Array<SaleorCollectionChannelListingError>;
  errors: Array<SaleorCollectionChannelListingError>;
};

export type SaleorCollectionChannelListingUpdateInput = {
  /** List of channels to which the collection should be assigned. */
  addChannels?: InputMaybe<Array<SaleorPublishableChannelListingInput>>;
  /** List of channels from which the collection should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a connection to a list of collections. */
export type SaleorCollectionCountableConnection = {
  __typename?: 'CollectionCountableConnection';
  edges: Array<SaleorCollectionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorCollectionCountableEdge = {
  __typename?: 'CollectionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCollection;
};

/**
 * Creates a new collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionCreate = {
  __typename?: 'CollectionCreate';
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

export type SaleorCollectionCreateInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Alt text for an image. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** Informs whether a collection is published. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the collection metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Name of the collection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the collection private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** List of products to be added to the collection. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Slug of the collection. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new collection is created. */
export type SaleorCollectionCreated = SaleorEvent & {
  __typename?: 'CollectionCreated';
  /** The collection the event relates to. */
  collection: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new collection is created. */
export type SaleorCollectionCreatedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionDelete = {
  __typename?: 'CollectionDelete';
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/** Event sent when collection is deleted. */
export type SaleorCollectionDeleted = SaleorEvent & {
  __typename?: 'CollectionDeleted';
  /** The collection the event relates to. */
  collection: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when collection is deleted. */
export type SaleorCollectionDeletedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCollectionError = {
  __typename?: 'CollectionError';
  /** The error code. */
  code: SaleorCollectionErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of products IDs which causes the error. */
  products: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorCollectionErrorCode =
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorCollectionFilterInput = {
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  published?: InputMaybe<SaleorCollectionPublished>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorCollectionInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Alt text for an image. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** Informs whether a collection is published. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the collection metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Name of the collection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the collection private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Slug of the collection. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when collection metadata is updated. */
export type SaleorCollectionMetadataUpdated = SaleorEvent & {
  __typename?: 'CollectionMetadataUpdated';
  /** The collection the event relates to. */
  collection: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when collection metadata is updated. */
export type SaleorCollectionMetadataUpdatedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCollectionPublished =
  | 'HIDDEN'
  | 'PUBLISHED';

/**
 * Remove products from a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionRemoveProducts = {
  __typename?: 'CollectionRemoveProducts';
  /** Collection from which products will be removed. */
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/**
 * Reorder the products of a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionReorderProducts = {
  __typename?: 'CollectionReorderProducts';
  /** Collection from which products are reordered. */
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

export type SaleorCollectionSortField =
  /**
   * Sort collections by availability.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'AVAILABILITY'
  /** Sort collections by name. */
  | 'NAME'
  /** Sort collections by product count. */
  | 'PRODUCT_COUNT'
  /**
   * Sort collections by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort collections by published at.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED_AT';

export type SaleorCollectionSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort collections. */
  direction: SaleorOrderDirection;
  /** Sort collections by the selected field. */
  field: SaleorCollectionSortField;
};

/** Represents collection's original translatable fields and related translations. */
export type SaleorCollectionTranslatableContent = SaleorNode & {
  __typename?: 'CollectionTranslatableContent';
  /**
   * Represents a collection of products.
   * @deprecated Get model fields from the root level queries.
   */
  collection: Maybe<SaleorCollection>;
  /** The ID of the collection to translate. */
  collectionId: Scalars['ID']['output'];
  /**
   * Collection's description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the collection translatable content. */
  id: Scalars['ID']['output'];
  /** Collection's name to translate. */
  name: Scalars['String']['output'];
  /** SEO description to translate. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Returns translated collection fields for the given language code. */
  translation: Maybe<SaleorCollectionTranslation>;
};


/** Represents collection's original translatable fields and related translations. */
export type SaleorCollectionTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a collection.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorCollectionTranslate = {
  __typename?: 'CollectionTranslate';
  collection: Maybe<SaleorCollection>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

/** Represents collection translations. */
export type SaleorCollectionTranslation = SaleorNode & {
  __typename?: 'CollectionTranslation';
  /**
   * Translated description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the collection translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated collection name. */
  name: Maybe<Scalars['String']['output']>;
  /** Translated SEO description. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Translated collection slug.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Represents the collection fields to translate. */
  translatableContent: Maybe<SaleorCollectionTranslatableContent>;
};

/**
 * Updates a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionUpdate = {
  __typename?: 'CollectionUpdate';
  collection: Maybe<SaleorCollection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/** Event sent when collection is updated. */
export type SaleorCollectionUpdated = SaleorEvent & {
  __typename?: 'CollectionUpdated';
  /** The collection the event relates to. */
  collection: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when collection is updated. */
export type SaleorCollectionUpdatedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCollectionWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorCollectionWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorCollectionWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
};

/** Stores information about a single configuration field. */
export type SaleorConfigurationItem = {
  __typename?: 'ConfigurationItem';
  /** Help text for the field. */
  helpText: Maybe<Scalars['String']['output']>;
  /** Label for the field. */
  label: Maybe<Scalars['String']['output']>;
  /** Name of the field. */
  name: Scalars['String']['output'];
  /** Type of the field. */
  type: Maybe<SaleorConfigurationTypeFieldEnum>;
  /** Current value of the field. */
  value: Maybe<Scalars['String']['output']>;
};

export type SaleorConfigurationItemInput = {
  /** Name of the field to update. */
  name: Scalars['String']['input'];
  /** Value of the given field to update. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorConfigurationTypeFieldEnum =
  | 'BOOLEAN'
  | 'MULTILINE'
  | 'OUTPUT'
  | 'PASSWORD'
  | 'SECRET'
  | 'SECRETMULTILINE'
  | 'STRING';

/**
 * Confirm user account with token sent by email during registration.
 *
 * Triggers the following webhook events:
 * - ACCOUNT_CONFIRMED (async): Account was confirmed.
 */
export type SaleorConfirmAccount = {
  __typename?: 'ConfirmAccount';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An activated user account. */
  user: Maybe<SaleorUser>;
};

/**
 * Confirm the email change of the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - NOTIFY_USER (async): A notification that account email change was confirmed.
 * - ACCOUNT_EMAIL_CHANGED (async): An account email was changed.
 */
export type SaleorConfirmEmailChange = {
  __typename?: 'ConfirmEmailChange';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** A user instance with a new email. */
  user: Maybe<SaleorUser>;
};

/** Define the filtering options for fields that can contain multiple values. */
export type SaleorContainsFilterInput = {
  /** The field contains all of the specified values. */
  containsAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The field contains at least one of the specified values. */
  containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Represents country codes defined by the ISO 3166-1 alpha-2 standard.
 *
 * The `EU` value is DEPRECATED and will be removed in Saleor 3.21.
 */
export type SaleorCountryCode =
  /** Andorra */
  | 'AD'
  /** United Arab Emirates */
  | 'AE'
  /** Afghanistan */
  | 'AF'
  /** Antigua and Barbuda */
  | 'AG'
  /** Anguilla */
  | 'AI'
  /** Albania */
  | 'AL'
  /** Armenia */
  | 'AM'
  /** Angola */
  | 'AO'
  /** Antarctica */
  | 'AQ'
  /** Argentina */
  | 'AR'
  /** American Samoa */
  | 'AS'
  /** Austria */
  | 'AT'
  /** Australia */
  | 'AU'
  /** Aruba */
  | 'AW'
  /** Åland Islands */
  | 'AX'
  /** Azerbaijan */
  | 'AZ'
  /** Bosnia and Herzegovina */
  | 'BA'
  /** Barbados */
  | 'BB'
  /** Bangladesh */
  | 'BD'
  /** Belgium */
  | 'BE'
  /** Burkina Faso */
  | 'BF'
  /** Bulgaria */
  | 'BG'
  /** Bahrain */
  | 'BH'
  /** Burundi */
  | 'BI'
  /** Benin */
  | 'BJ'
  /** Saint Barthélemy */
  | 'BL'
  /** Bermuda */
  | 'BM'
  /** Brunei */
  | 'BN'
  /** Bolivia */
  | 'BO'
  /** Bonaire, Sint Eustatius and Saba */
  | 'BQ'
  /** Brazil */
  | 'BR'
  /** Bahamas */
  | 'BS'
  /** Bhutan */
  | 'BT'
  /** Bouvet Island */
  | 'BV'
  /** Botswana */
  | 'BW'
  /** Belarus */
  | 'BY'
  /** Belize */
  | 'BZ'
  /** Canada */
  | 'CA'
  /** Cocos (Keeling) Islands */
  | 'CC'
  /** Congo (the Democratic Republic of the) */
  | 'CD'
  /** Central African Republic */
  | 'CF'
  /** Congo */
  | 'CG'
  /** Switzerland */
  | 'CH'
  /** Côte d'Ivoire */
  | 'CI'
  /** Cook Islands */
  | 'CK'
  /** Chile */
  | 'CL'
  /** Cameroon */
  | 'CM'
  /** China */
  | 'CN'
  /** Colombia */
  | 'CO'
  /** Costa Rica */
  | 'CR'
  /** Cuba */
  | 'CU'
  /** Cabo Verde */
  | 'CV'
  /** Curaçao */
  | 'CW'
  /** Christmas Island */
  | 'CX'
  /** Cyprus */
  | 'CY'
  /** Czechia */
  | 'CZ'
  /** Germany */
  | 'DE'
  /** Djibouti */
  | 'DJ'
  /** Denmark */
  | 'DK'
  /** Dominica */
  | 'DM'
  /** Dominican Republic */
  | 'DO'
  /** Algeria */
  | 'DZ'
  /** Ecuador */
  | 'EC'
  /** Estonia */
  | 'EE'
  /** Egypt */
  | 'EG'
  /** Western Sahara */
  | 'EH'
  /** Eritrea */
  | 'ER'
  /** Spain */
  | 'ES'
  /** Ethiopia */
  | 'ET'
  /** European Union */
  | 'EU'
  /** Finland */
  | 'FI'
  /** Fiji */
  | 'FJ'
  /** Falkland Islands (Malvinas) */
  | 'FK'
  /** Micronesia */
  | 'FM'
  /** Faroe Islands */
  | 'FO'
  /** France */
  | 'FR'
  /** Gabon */
  | 'GA'
  /** United Kingdom */
  | 'GB'
  /** Grenada */
  | 'GD'
  /** Georgia */
  | 'GE'
  /** French Guiana */
  | 'GF'
  /** Guernsey */
  | 'GG'
  /** Ghana */
  | 'GH'
  /** Gibraltar */
  | 'GI'
  /** Greenland */
  | 'GL'
  /** Gambia */
  | 'GM'
  /** Guinea */
  | 'GN'
  /** Guadeloupe */
  | 'GP'
  /** Equatorial Guinea */
  | 'GQ'
  /** Greece */
  | 'GR'
  /** South Georgia and the South Sandwich Islands */
  | 'GS'
  /** Guatemala */
  | 'GT'
  /** Guam */
  | 'GU'
  /** Guinea-Bissau */
  | 'GW'
  /** Guyana */
  | 'GY'
  /** Hong Kong */
  | 'HK'
  /** Heard Island and McDonald Islands */
  | 'HM'
  /** Honduras */
  | 'HN'
  /** Croatia */
  | 'HR'
  /** Haiti */
  | 'HT'
  /** Hungary */
  | 'HU'
  /** Indonesia */
  | 'ID'
  /** Ireland */
  | 'IE'
  /** Israel */
  | 'IL'
  /** Isle of Man */
  | 'IM'
  /** India */
  | 'IN'
  /** British Indian Ocean Territory */
  | 'IO'
  /** Iraq */
  | 'IQ'
  /** Iran */
  | 'IR'
  /** Iceland */
  | 'IS'
  /** Italy */
  | 'IT'
  /** Jersey */
  | 'JE'
  /** Jamaica */
  | 'JM'
  /** Jordan */
  | 'JO'
  /** Japan */
  | 'JP'
  /** Kenya */
  | 'KE'
  /** Kyrgyzstan */
  | 'KG'
  /** Cambodia */
  | 'KH'
  /** Kiribati */
  | 'KI'
  /** Comoros */
  | 'KM'
  /** Saint Kitts and Nevis */
  | 'KN'
  /** North Korea */
  | 'KP'
  /** South Korea */
  | 'KR'
  /** Kuwait */
  | 'KW'
  /** Cayman Islands */
  | 'KY'
  /** Kazakhstan */
  | 'KZ'
  /** Laos */
  | 'LA'
  /** Lebanon */
  | 'LB'
  /** Saint Lucia */
  | 'LC'
  /** Liechtenstein */
  | 'LI'
  /** Sri Lanka */
  | 'LK'
  /** Liberia */
  | 'LR'
  /** Lesotho */
  | 'LS'
  /** Lithuania */
  | 'LT'
  /** Luxembourg */
  | 'LU'
  /** Latvia */
  | 'LV'
  /** Libya */
  | 'LY'
  /** Morocco */
  | 'MA'
  /** Monaco */
  | 'MC'
  /** Moldova */
  | 'MD'
  /** Montenegro */
  | 'ME'
  /** Saint Martin (French part) */
  | 'MF'
  /** Madagascar */
  | 'MG'
  /** Marshall Islands */
  | 'MH'
  /** North Macedonia */
  | 'MK'
  /** Mali */
  | 'ML'
  /** Myanmar */
  | 'MM'
  /** Mongolia */
  | 'MN'
  /** Macao */
  | 'MO'
  /** Northern Mariana Islands */
  | 'MP'
  /** Martinique */
  | 'MQ'
  /** Mauritania */
  | 'MR'
  /** Montserrat */
  | 'MS'
  /** Malta */
  | 'MT'
  /** Mauritius */
  | 'MU'
  /** Maldives */
  | 'MV'
  /** Malawi */
  | 'MW'
  /** Mexico */
  | 'MX'
  /** Malaysia */
  | 'MY'
  /** Mozambique */
  | 'MZ'
  /** Namibia */
  | 'NA'
  /** New Caledonia */
  | 'NC'
  /** Niger */
  | 'NE'
  /** Norfolk Island */
  | 'NF'
  /** Nigeria */
  | 'NG'
  /** Nicaragua */
  | 'NI'
  /** Netherlands */
  | 'NL'
  /** Norway */
  | 'NO'
  /** Nepal */
  | 'NP'
  /** Nauru */
  | 'NR'
  /** Niue */
  | 'NU'
  /** New Zealand */
  | 'NZ'
  /** Oman */
  | 'OM'
  /** Panama */
  | 'PA'
  /** Peru */
  | 'PE'
  /** French Polynesia */
  | 'PF'
  /** Papua New Guinea */
  | 'PG'
  /** Philippines */
  | 'PH'
  /** Pakistan */
  | 'PK'
  /** Poland */
  | 'PL'
  /** Saint Pierre and Miquelon */
  | 'PM'
  /** Pitcairn */
  | 'PN'
  /** Puerto Rico */
  | 'PR'
  /** Palestine, State of */
  | 'PS'
  /** Portugal */
  | 'PT'
  /** Palau */
  | 'PW'
  /** Paraguay */
  | 'PY'
  /** Qatar */
  | 'QA'
  /** Réunion */
  | 'RE'
  /** Romania */
  | 'RO'
  /** Serbia */
  | 'RS'
  /** Russia */
  | 'RU'
  /** Rwanda */
  | 'RW'
  /** Saudi Arabia */
  | 'SA'
  /** Solomon Islands */
  | 'SB'
  /** Seychelles */
  | 'SC'
  /** Sudan */
  | 'SD'
  /** Sweden */
  | 'SE'
  /** Singapore */
  | 'SG'
  /** Saint Helena, Ascension and Tristan da Cunha */
  | 'SH'
  /** Slovenia */
  | 'SI'
  /** Svalbard and Jan Mayen */
  | 'SJ'
  /** Slovakia */
  | 'SK'
  /** Sierra Leone */
  | 'SL'
  /** San Marino */
  | 'SM'
  /** Senegal */
  | 'SN'
  /** Somalia */
  | 'SO'
  /** Suriname */
  | 'SR'
  /** South Sudan */
  | 'SS'
  /** Sao Tome and Principe */
  | 'ST'
  /** El Salvador */
  | 'SV'
  /** Sint Maarten (Dutch part) */
  | 'SX'
  /** Syria */
  | 'SY'
  /** Eswatini */
  | 'SZ'
  /** Turks and Caicos Islands */
  | 'TC'
  /** Chad */
  | 'TD'
  /** French Southern Territories */
  | 'TF'
  /** Togo */
  | 'TG'
  /** Thailand */
  | 'TH'
  /** Tajikistan */
  | 'TJ'
  /** Tokelau */
  | 'TK'
  /** Timor-Leste */
  | 'TL'
  /** Turkmenistan */
  | 'TM'
  /** Tunisia */
  | 'TN'
  /** Tonga */
  | 'TO'
  /** Türkiye */
  | 'TR'
  /** Trinidad and Tobago */
  | 'TT'
  /** Tuvalu */
  | 'TV'
  /** Taiwan */
  | 'TW'
  /** Tanzania */
  | 'TZ'
  /** Ukraine */
  | 'UA'
  /** Uganda */
  | 'UG'
  /** United States Minor Outlying Islands */
  | 'UM'
  /** United States of America */
  | 'US'
  /** Uruguay */
  | 'UY'
  /** Uzbekistan */
  | 'UZ'
  /** Holy See */
  | 'VA'
  /** Saint Vincent and the Grenadines */
  | 'VC'
  /** Venezuela */
  | 'VE'
  /** Virgin Islands (British) */
  | 'VG'
  /** Virgin Islands (U.S.) */
  | 'VI'
  /** Vietnam */
  | 'VN'
  /** Vanuatu */
  | 'VU'
  /** Wallis and Futuna */
  | 'WF'
  /** Samoa */
  | 'WS'
  /** Kosovo */
  | 'XK'
  /** Yemen */
  | 'YE'
  /** Mayotte */
  | 'YT'
  /** South Africa */
  | 'ZA'
  /** Zambia */
  | 'ZM'
  /** Zimbabwe */
  | 'ZW';

/** Filter by country code. */
export type SaleorCountryCodeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorCountryCode>;
  /** The value not included in. */
  notOneOf?: InputMaybe<Array<SaleorCountryCode>>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorCountryCode>>;
};

export type SaleorCountryDisplay = {
  __typename?: 'CountryDisplay';
  /** Country code. */
  code: Scalars['String']['output'];
  /** Country name. */
  country: Scalars['String']['output'];
  /**
   * Country tax.
   * @deprecated Always returns `null`. Use `TaxClassCountryRate` type to manage tax rates per country.
   */
  vat: Maybe<SaleorVat>;
};

export type SaleorCountryFilterInput = {
  /** Boolean for filtering countries by having shipping zone assigned.If 'true', return countries with shipping zone assigned.If 'false', return countries without any shipping zone assigned.If the argument is not provided (null), return all countries. */
  attachedToShippingZones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorCountryRateInput = {
  /** Country in which this rate applies. */
  countryCode: SaleorCountryCode;
  /** Tax rate value provided as percentage. Example: provide `23` to represent `23%` tax rate. */
  rate: Scalars['Float']['input'];
};

export type SaleorCountryRateUpdateInput = {
  /** Country in which this rate applies. */
  countryCode: SaleorCountryCode;
  /** Tax rate value provided as percentage. Example: provide `23` to represent `23%` tax rate. Provide `null` to remove the particular rate. */
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** Create JWT token. */
export type SaleorCreateToken = {
  __typename?: 'CreateToken';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate access token. */
  csrfToken: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** JWT refresh token, required to re-generate access token. */
  refreshToken: Maybe<Scalars['String']['output']>;
  /** JWT token, required to authenticate. */
  token: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user: Maybe<SaleorUser>;
};

export type SaleorCreditCard = {
  __typename?: 'CreditCard';
  /** Card brand. */
  brand: Scalars['String']['output'];
  /** Two-digit number representing the card’s expiration month. */
  expMonth: Maybe<Scalars['Int']['output']>;
  /** Four-digit number representing the card’s expiration year. */
  expYear: Maybe<Scalars['Int']['output']>;
  /** First 4 digits of the card number. */
  firstDigits: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the card number. */
  lastDigits: Scalars['String']['output'];
};

/**
 * Deletes customers.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_DELETED (async): A customer account was deleted.
 */
export type SaleorCustomerBulkDelete = {
  __typename?: 'CustomerBulkDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAccountError>;
};

export type SaleorCustomerBulkResult = {
  __typename?: 'CustomerBulkResult';
  /** Customer data. */
  customer: Maybe<SaleorUser>;
  /** List of errors that occurred during the update attempt. */
  errors: Maybe<Array<SaleorCustomerBulkUpdateError>>;
};

/**
 * Updates customers.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 */
export type SaleorCustomerBulkUpdate = {
  __typename?: 'CustomerBulkUpdate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorCustomerBulkUpdateError>;
  /** List of the updated customers. */
  results: Array<SaleorCustomerBulkResult>;
};

export type SaleorCustomerBulkUpdateError = {
  __typename?: 'CustomerBulkUpdateError';
  /** The error code. */
  code: SaleorCustomerBulkUpdateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorCustomerBulkUpdateErrorCode =
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorCustomerBulkUpdateInput = {
  /** External ID of a customer to update. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of a customer to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Fields required to update a customer. */
  input: SaleorCustomerInput;
};

/**
 * Creates a new customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_CREATED (async): A new customer account was created.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 * - NOTIFY_USER (async): A notification for setting the password.
 * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
 */
export type SaleorCustomerCreate = {
  __typename?: 'CustomerCreate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user: Maybe<SaleorUser>;
};

/** Event sent when new customer user is created. */
export type SaleorCustomerCreated = SaleorEvent & {
  __typename?: 'CustomerCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_DELETED (async): A customer account was deleted.
 */
export type SaleorCustomerDelete = {
  __typename?: 'CustomerDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user: Maybe<SaleorUser>;
};

/** History log of the customer. */
export type SaleorCustomerEvent = SaleorNode & {
  __typename?: 'CustomerEvent';
  /** App that performed the action. */
  app: Maybe<SaleorApp>;
  /** Number of objects concerned by the event. */
  count: Maybe<Scalars['Int']['output']>;
  /** Date when event happened at in ISO 8601 format. */
  date: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the customer event. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message: Maybe<Scalars['String']['output']>;
  /** The concerned order. */
  order: Maybe<SaleorOrder>;
  /** The concerned order line. */
  orderLine: Maybe<SaleorOrderLine>;
  /** Customer event type. */
  type: Maybe<SaleorCustomerEventsEnum>;
  /** User who performed the action. */
  user: Maybe<SaleorUser>;
};

export type SaleorCustomerEventsEnum =
  | 'ACCOUNT_ACTIVATED'
  | 'ACCOUNT_CREATED'
  | 'ACCOUNT_DEACTIVATED'
  | 'CUSTOMER_DELETED'
  | 'DIGITAL_LINK_DOWNLOADED'
  | 'EMAIL_ASSIGNED'
  | 'EMAIL_CHANGED'
  | 'EMAIL_CHANGED_REQUEST'
  | 'NAME_ASSIGNED'
  | 'NOTE_ADDED'
  | 'NOTE_ADDED_TO_ORDER'
  | 'PASSWORD_CHANGED'
  | 'PASSWORD_RESET'
  | 'PASSWORD_RESET_LINK_SENT'
  | 'PLACED_ORDER';

export type SaleorCustomerFilterInput = {
  dateJoined?: InputMaybe<SaleorDateRangeInput>;
  /** Filter by ids. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  numberOfOrders?: InputMaybe<SaleorIntRangeInput>;
  placedOrders?: InputMaybe<SaleorDateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorCustomerInput = {
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<SaleorAddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<SaleorAddressInput>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the customer. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** User account is confirmed. */
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
};

/** Event sent when customer user metadata is updated. */
export type SaleorCustomerMetadataUpdated = SaleorEvent & {
  __typename?: 'CustomerMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorCustomerOrderWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorCustomerOrderWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorCustomerOrderWhereInput>>;
  /** Filter by authorize status. */
  authorizeStatus?: InputMaybe<SaleorOrderAuthorizeStatusEnumFilterInput>;
  /** Filter by billing address of the order. */
  billingAddress?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by channel. */
  channelId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by charge status. */
  chargeStatus?: InputMaybe<SaleorOrderChargeStatusEnumFilterInput>;
  /** Filter by checkout id. */
  checkoutId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by checkout token. */
  checkoutToken?: InputMaybe<SaleorUuidFilterInput>;
  /** Filter order by created at date. */
  createdAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by whether the order has any fulfillments. */
  hasFulfillments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the order has any invoices. */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by invoice data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  invoices?: InputMaybe<Array<SaleorInvoiceFilterInput>>;
  /** Filter by whether the order uses the click and collect delivery method. */
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether the order includes a gift card purchase. */
  isGiftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether a gift card was used in the order. */
  isGiftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by number of lines in the order. */
  linesCount?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by order number. */
  number?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by the product type of related order lines. */
  productTypeId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by shipping address of the order. */
  shippingAddress?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by order status. */
  status?: InputMaybe<SaleorOrderStatusEnumFilterInput>;
  /** Filter by total gross amount of the order. */
  totalGross?: InputMaybe<SaleorPriceFilterInput>;
  /** Filter by total net amount of the order. */
  totalNet?: InputMaybe<SaleorPriceFilterInput>;
  /** Filter order by updated at date. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by user email. */
  userEmail?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by voucher code used in the order. */
  voucherCode?: InputMaybe<SaleorStringFilterInput>;
};

/**
 * Updates an existing customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A new customer account was updated.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 */
export type SaleorCustomerUpdate = {
  __typename?: 'CustomerUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user: Maybe<SaleorUser>;
};

/** Event sent when customer user is updated. */
export type SaleorCustomerUpdated = SaleorEvent & {
  __typename?: 'CustomerUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorCustomerWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorCustomerWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorCustomerWhereInput>>;
  /** Filter by addresses data associated with user. */
  addresses?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by date joined. */
  dateJoined?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by email address. */
  email?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by first name. */
  firstName?: InputMaybe<SaleorStringFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether the user is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by last name. */
  lastName?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by number of orders placed by the user. */
  numberOfOrders?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by date when orders were placed. */
  placedOrdersAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by last updated date. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorDateRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** End date. */
  lte?: InputMaybe<Scalars['Date']['input']>;
};

/** Define the filtering options for date time fields. */
export type SaleorDateTimeFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** The value in range. */
  range?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorDateTimeRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Deactivate all JWT tokens of the currently authenticated user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorDeactivateAllUserTokens = {
  __typename?: 'DeactivateAllUserTokens';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
};

/** Define the filtering options for decimal fields. */
export type SaleorDecimalFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  /** The value in range. */
  range?: InputMaybe<SaleorDecimalRangeInput>;
};

export type SaleorDecimalRangeInput = {
  /** Decimal value greater than or equal to. */
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  /** Decimal value less than or equal to. */
  lte?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Delete metadata of an object. To use it, you need to have access to the modified object. */
export type SaleorDeleteMetadata = {
  __typename?: 'DeleteMetadata';
  errors: Array<SaleorMetadataError>;
  item: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

/** Delete object's private metadata. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
export type SaleorDeletePrivateMetadata = {
  __typename?: 'DeletePrivateMetadata';
  errors: Array<SaleorMetadataError>;
  item: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

/** Represents a delivery method chosen for the checkout. `Warehouse` type is used when checkout is marked as "click and collect" and `ShippingMethod` otherwise. */
export type SaleorDeliveryMethod = SaleorShippingMethod | SaleorWarehouse;

/** Represents digital content associated with a product variant. */
export type SaleorDigitalContent = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'DigitalContent';
  /** Indicator for automatic fulfillment of digital content. */
  automaticFulfillment: Scalars['Boolean']['output'];
  /** File associated with digital content. */
  contentFile: Scalars['String']['output'];
  /** The ID of the digital content. */
  id: Scalars['ID']['output'];
  /** Maximum number of allowed downloads for the digital content. */
  maxDownloads: Maybe<Scalars['Int']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Product variant assigned to digital content. */
  productVariant: SaleorProductVariant;
  /** Number of days the URL for the digital content remains valid. */
  urlValidDays: Maybe<Scalars['Int']['output']>;
  /** List of URLs for the digital variant. */
  urls: Maybe<Array<SaleorDigitalContentUrl>>;
  /** Default settings indicator for digital content. */
  useDefaultSettings: Scalars['Boolean']['output'];
};


/** Represents digital content associated with a product variant. */
export type SaleorDigitalContentMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents digital content associated with a product variant. */
export type SaleorDigitalContentMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents digital content associated with a product variant. */
export type SaleorDigitalContentPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents digital content associated with a product variant. */
export type SaleorDigitalContentPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A connection to a list of digital content items. */
export type SaleorDigitalContentCountableConnection = {
  __typename?: 'DigitalContentCountableConnection';
  edges: Array<SaleorDigitalContentCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorDigitalContentCountableEdge = {
  __typename?: 'DigitalContentCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorDigitalContent;
};

/**
 * Create new digital content. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentCreate = {
  __typename?: 'DigitalContentCreate';
  content: Maybe<SaleorDigitalContent>;
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  variant: Maybe<SaleorProductVariant>;
};

/**
 * Remove digital content assigned to given variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentDelete = {
  __typename?: 'DigitalContentDelete';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  variant: Maybe<SaleorProductVariant>;
};

export type SaleorDigitalContentInput = {
  /** Overwrite default automatic_fulfillment setting for variant. */
  automaticFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines how many times a download link can be accessed by a customer. */
  maxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Fields required to update the digital content metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Fields required to update the digital content private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines for how many days a download link is active since it was generated. */
  urlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Use default digital content settings for this product. */
  useDefaultSettings: Scalars['Boolean']['input'];
};

/**
 * Updates digital content.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentUpdate = {
  __typename?: 'DigitalContentUpdate';
  content: Maybe<SaleorDigitalContent>;
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  variant: Maybe<SaleorProductVariant>;
};

export type SaleorDigitalContentUploadInput = {
  /** Overwrite default automatic_fulfillment setting for variant. */
  automaticFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents an file in a multipart request. */
  contentFile: Scalars['Upload']['input'];
  /** Determines how many times a download link can be accessed by a customer. */
  maxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Fields required to update the digital content metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Fields required to update the digital content private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines for how many days a download link is active since it was generated. */
  urlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Use default digital content settings for this product. */
  useDefaultSettings: Scalars['Boolean']['input'];
};

/** Represents a URL for digital content. */
export type SaleorDigitalContentUrl = SaleorNode & {
  __typename?: 'DigitalContentUrl';
  /** Digital content associated with the URL. */
  content: SaleorDigitalContent;
  /** Date and time when the digital content URL was created. */
  created: Scalars['DateTime']['output'];
  /** Number of times digital content has been downloaded. */
  downloadNum: Scalars['Int']['output'];
  /** The ID of the digital content URL. */
  id: Scalars['ID']['output'];
  /** UUID of digital content. */
  token: Scalars['UUID']['output'];
  /** URL for digital content. */
  url: Maybe<Scalars['String']['output']>;
};

/**
 * Generate new URL to digital content.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentUrlCreate = {
  __typename?: 'DigitalContentUrlCreate';
  digitalContentUrl: Maybe<SaleorDigitalContentUrl>;
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorDigitalContentUrlCreateInput = {
  /** Digital content ID which URL will belong to. */
  content: Scalars['ID']['input'];
};

export type SaleorDiscountError = {
  __typename?: 'DiscountError';
  /** List of channels IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorDiscountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of products IDs which causes the error. */
  products: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * List of voucher codes which causes the error.
   *
   * Added in Saleor 3.18.
   */
  voucherCodes: Maybe<Array<Scalars['String']['output']>>;
};

export type SaleorDiscountErrorCode =
  | 'ALREADY_EXISTS'
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'VOUCHER_ALREADY_USED';

export type SaleorDiscountStatusEnum =
  | 'ACTIVE'
  | 'EXPIRED'
  | 'SCHEDULED';

export type SaleorDiscountValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

export type SaleorDiscountedObjectWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorDiscountedObjectWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorDiscountedObjectWhereInput>>;
  /** Filter by the base subtotal price. */
  baseSubtotalPrice?: InputMaybe<SaleorDecimalFilterInput>;
  /** Filter by the base total price. */
  baseTotalPrice?: InputMaybe<SaleorDecimalFilterInput>;
};

export type SaleorDistanceUnitsEnum =
  | 'CM'
  | 'DM'
  | 'FT'
  | 'INCH'
  | 'KM'
  | 'M'
  | 'MM'
  | 'YD';

/** Represents API domain. */
export type SaleorDomain = {
  __typename?: 'Domain';
  /** The host name of the domain. */
  host: Scalars['String']['output'];
  /** Inform if SSL is enabled. */
  sslEnabled: Scalars['Boolean']['output'];
  /** The absolute URL of the API. */
  url: Scalars['String']['output'];
};

/**
 * Deletes draft orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderBulkDelete = {
  __typename?: 'DraftOrderBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderError>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Completes creating an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderComplete = {
  __typename?: 'DraftOrderComplete';
  errors: Array<SaleorOrderError>;
  /** Completed order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Creates a new draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderCreate = {
  __typename?: 'DraftOrderCreate';
  errors: Array<SaleorOrderError>;
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorDraftOrderCreateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of the channel associated with the order. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A note from a customer. Visible by customers in the order summary. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Discount amount for the order.
   *
   * DEPRECATED: this field will be removed. Providing a value for the field has no effect. Use `orderDiscountAdd` mutation instead.
   */
  discount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** External ID of this order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Order language code.
   *
   * Added in Saleor 3.21.
   */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Variant line input consisting of variant ID and quantity of products. */
  lines?: InputMaybe<Array<SaleorOrderLineCreateInput>>;
  /**
   * Order public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Order private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a view where users should be redirected to see the order details. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates whether the billing address should be saved to the user’s address book upon draft order completion. Can only be set when a billing address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the shipping address should be saved to the user’s address book upon draft order completion.Can only be set when a shipping address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of a selected shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
  /** Customer associated with the draft order. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of the voucher associated with the order. */
  voucher?: InputMaybe<Scalars['ID']['input']>;
  /**
   * A code of the voucher associated with the order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new draft order is created. */
export type SaleorDraftOrderCreated = SaleorEvent & {
  __typename?: 'DraftOrderCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderDelete = {
  __typename?: 'DraftOrderDelete';
  errors: Array<SaleorOrderError>;
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** Event sent when draft order is deleted. */
export type SaleorDraftOrderDeleted = SaleorEvent & {
  __typename?: 'DraftOrderDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorDraftOrderInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of the channel associated with the order. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A note from a customer. Visible by customers in the order summary. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Discount amount for the order.
   *
   * DEPRECATED: this field will be removed. Providing a value for the field has no effect. Use `orderDiscountAdd` mutation instead.
   */
  discount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** External ID of this order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Order language code.
   *
   * Added in Saleor 3.21.
   */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /**
   * Order public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Order private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a view where users should be redirected to see the order details. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates whether the billing address should be saved to the user’s address book upon draft order completion. Can only be set when a billing address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the shipping address should be saved to the user’s address book upon draft order completion.Can only be set when a shipping address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of a selected shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
  /** Customer associated with the draft order. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of the voucher associated with the order. */
  voucher?: InputMaybe<Scalars['ID']['input']>;
  /**
   * A code of the voucher associated with the order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes order lines.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderLinesBulkDelete = {
  __typename?: 'DraftOrderLinesBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderError>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Updates a draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderUpdate = {
  __typename?: 'DraftOrderUpdate';
  errors: Array<SaleorOrderError>;
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** Event sent when draft order is updated. */
export type SaleorDraftOrderUpdated = SaleorEvent & {
  __typename?: 'DraftOrderUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorDraftOrderWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorDraftOrderWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorDraftOrderWhereInput>>;
  /** Filter by authorize status. */
  authorizeStatus?: InputMaybe<SaleorOrderAuthorizeStatusEnumFilterInput>;
  /** Filter by billing address of the order. */
  billingAddress?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by channel. */
  channelId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by charge status. */
  chargeStatus?: InputMaybe<SaleorOrderChargeStatusEnumFilterInput>;
  /** Filter order by created at date. */
  createdAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by order events. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  events?: InputMaybe<Array<SaleorOrderEventFilterInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether the order uses the click and collect delivery method. */
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by line items associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  lines?: InputMaybe<Array<SaleorLinesFilterInput>>;
  /** Filter by number of lines in the order. */
  linesCount?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by order number. */
  number?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by the product type of related order lines. */
  productTypeId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by shipping address of the order. */
  shippingAddress?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by total gross amount of the order. */
  totalGross?: InputMaybe<SaleorPriceFilterInput>;
  /** Filter by total net amount of the order. */
  totalNet?: InputMaybe<SaleorPriceFilterInput>;
  /** Filter by transaction data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  transactions?: InputMaybe<Array<SaleorTransactionFilterInput>>;
  /** Filter order by updated at date. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by user. */
  user?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by user email. */
  userEmail?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by voucher code used in the order. */
  voucherCode?: InputMaybe<SaleorStringFilterInput>;
};

export type SaleorErrorPolicyEnum =
  /** Save what is possible within a single row. If there are errors in an input data row, try to save it partially and skip the invalid part. */
  | 'IGNORE_FAILED'
  /** Reject all rows if there is at least one error in any of them. */
  | 'REJECT_EVERYTHING'
  /** Reject rows with errors. */
  | 'REJECT_FAILED_ROWS';

export type SaleorEvent = {
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event delivery. */
export type SaleorEventDelivery = SaleorNode & {
  __typename?: 'EventDelivery';
  /** Event delivery attempts. */
  attempts: Maybe<SaleorEventDeliveryAttemptCountableConnection>;
  /** Creation time of an event delivery. */
  createdAt: Scalars['DateTime']['output'];
  /** Webhook event type. */
  eventType: SaleorWebhookEventTypeEnum;
  /** The ID of an event delivery. */
  id: Scalars['ID']['output'];
  /** Event payload. */
  payload: Maybe<Scalars['String']['output']>;
  /** Event delivery status. */
  status: SaleorEventDeliveryStatusEnum;
};


/** Event delivery. */
export type SaleorEventDeliveryAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorEventDeliveryAttemptSortingInput>;
};

/** Event delivery attempts. */
export type SaleorEventDeliveryAttempt = SaleorNode & {
  __typename?: 'EventDeliveryAttempt';
  /** Event delivery creation date and time. */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery attempt duration. */
  duration: Maybe<Scalars['Float']['output']>;
  /** The ID of Event Delivery Attempt. */
  id: Scalars['ID']['output'];
  /** Request headers for delivery attempt. */
  requestHeaders: Maybe<Scalars['String']['output']>;
  /** Delivery attempt response content. */
  response: Maybe<Scalars['String']['output']>;
  /** Response headers for delivery attempt. */
  responseHeaders: Maybe<Scalars['String']['output']>;
  /** Delivery attempt response status code. */
  responseStatusCode: Maybe<Scalars['Int']['output']>;
  /** Event delivery status. */
  status: SaleorEventDeliveryStatusEnum;
  /** Task id for delivery attempt. */
  taskId: Maybe<Scalars['String']['output']>;
};

export type SaleorEventDeliveryAttemptCountableConnection = {
  __typename?: 'EventDeliveryAttemptCountableConnection';
  edges: Array<SaleorEventDeliveryAttemptCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorEventDeliveryAttemptCountableEdge = {
  __typename?: 'EventDeliveryAttemptCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorEventDeliveryAttempt;
};

export type SaleorEventDeliveryAttemptSortField =
  /** Sort event delivery attempts by created at. */
  | 'CREATED_AT';

export type SaleorEventDeliveryAttemptSortingInput = {
  /** Specifies the direction in which to sort attempts. */
  direction: SaleorOrderDirection;
  /** Sort attempts by the selected field. */
  field: SaleorEventDeliveryAttemptSortField;
};

export type SaleorEventDeliveryCountableConnection = {
  __typename?: 'EventDeliveryCountableConnection';
  edges: Array<SaleorEventDeliveryCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorEventDeliveryCountableEdge = {
  __typename?: 'EventDeliveryCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorEventDelivery;
};

export type SaleorEventDeliveryFilterInput = {
  eventType?: InputMaybe<SaleorWebhookEventTypeEnum>;
  status?: InputMaybe<SaleorEventDeliveryStatusEnum>;
};

/**
 * Retries event delivery.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorEventDeliveryRetry = {
  __typename?: 'EventDeliveryRetry';
  /** Event delivery. */
  delivery: Maybe<SaleorEventDelivery>;
  errors: Array<SaleorWebhookError>;
};

export type SaleorEventDeliverySortField =
  /** Sort event deliveries by created at. */
  | 'CREATED_AT';

export type SaleorEventDeliverySortingInput = {
  /** Specifies the direction in which to sort deliveries. */
  direction: SaleorOrderDirection;
  /** Sort deliveries by the selected field. */
  field: SaleorEventDeliverySortField;
};

export type SaleorEventDeliveryStatusEnum =
  | 'FAILED'
  | 'PENDING'
  | 'SUCCESS';

export type SaleorExportError = {
  __typename?: 'ExportError';
  /** The error code. */
  code: SaleorExportErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorExportErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** History log of export file. */
export type SaleorExportEvent = SaleorNode & {
  __typename?: 'ExportEvent';
  /** App which performed the action. Requires one of the following permissions: OWNER, MANAGE_APPS. */
  app: Maybe<SaleorApp>;
  /** Date when event happened at in ISO 8601 format. */
  date: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message: Scalars['String']['output'];
  /** Export event type. */
  type: SaleorExportEventsEnum;
  /** User who performed the action. Requires one of the following permissions: OWNER, MANAGE_STAFF. */
  user: Maybe<SaleorUser>;
};

export type SaleorExportEventsEnum =
  | 'EXPORTED_FILE_SENT'
  | 'EXPORT_DELETED'
  | 'EXPORT_FAILED'
  | 'EXPORT_FAILED_INFO_SENT'
  | 'EXPORT_PENDING'
  | 'EXPORT_SUCCESS';

/** Represents a job data of exported file. */
export type SaleorExportFile = SaleorJob & SaleorNode & {
  __typename?: 'ExportFile';
  /** The app which requests file export. */
  app: Maybe<SaleorApp>;
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /** List of events associated with the export. */
  events: Maybe<Array<SaleorExportEvent>>;
  /** The ID of the export file. */
  id: Scalars['ID']['output'];
  /** Job message. */
  message: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL of field to download. */
  url: Maybe<Scalars['String']['output']>;
  /** The user who requests file export. */
  user: Maybe<SaleorUser>;
};

export type SaleorExportFileCountableConnection = {
  __typename?: 'ExportFileCountableConnection';
  edges: Array<SaleorExportFileCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorExportFileCountableEdge = {
  __typename?: 'ExportFileCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorExportFile;
};

export type SaleorExportFileFilterInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<SaleorDateTimeRangeInput>;
  status?: InputMaybe<SaleorJobStatusEnum>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorExportFileSortField =
  | 'CREATED_AT'
  | 'LAST_MODIFIED_AT'
  | 'STATUS'
  | 'UPDATED_AT';

export type SaleorExportFileSortingInput = {
  /** Specifies the direction in which to sort export file. */
  direction: SaleorOrderDirection;
  /** Sort export file by the selected field. */
  field: SaleorExportFileSortField;
};

/**
 * Export gift cards to csv file.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for the exported file.
 * - GIFT_CARD_EXPORT_COMPLETED (async): A notification for the exported file.
 */
export type SaleorExportGiftCards = {
  __typename?: 'ExportGiftCards';
  errors: Array<SaleorExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile: Maybe<SaleorExportFile>;
};

export type SaleorExportGiftCardsInput = {
  /** Type of exported file. */
  fileType: SaleorFileTypesEnum;
  /** Filtering options for gift cards. */
  filter?: InputMaybe<SaleorGiftCardFilterInput>;
  /** List of gift cards IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine which gift cards should be exported. */
  scope: SaleorExportScope;
};

export type SaleorExportInfoInput = {
  /** List of attribute ids witch should be exported. */
  attributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channels ids which should be exported. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of product fields witch should be exported. */
  fields?: InputMaybe<Array<SaleorProductFieldEnum>>;
  /** List of warehouse ids witch should be exported. */
  warehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Export products to csv file.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for the exported file.
 * - PRODUCT_EXPORT_COMPLETED (async): A notification for the exported file.
 */
export type SaleorExportProducts = {
  __typename?: 'ExportProducts';
  errors: Array<SaleorExportError>;
  /** @deprecated Use `errors` field instead. */
  exportErrors: Array<SaleorExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile: Maybe<SaleorExportFile>;
};

export type SaleorExportProductsInput = {
  /** Input with info about fields which should be exported. */
  exportInfo?: InputMaybe<SaleorExportInfoInput>;
  /** Type of exported file. */
  fileType: SaleorFileTypesEnum;
  /** Filtering options for products. */
  filter?: InputMaybe<SaleorProductFilterInput>;
  /** List of products IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine which products should be exported. */
  scope: SaleorExportScope;
};

export type SaleorExportScope =
  /** Export all products. */
  | 'ALL'
  /** Export the filtered products. */
  | 'FILTER'
  /** Export products with given ids. */
  | 'IDS';

/**
 * Export voucher codes to csv/xlsx file.
 *
 * Added in Saleor 3.18.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_CODE_EXPORT_COMPLETED (async): A notification for the exported file.
 */
export type SaleorExportVoucherCodes = {
  __typename?: 'ExportVoucherCodes';
  errors: Array<SaleorExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile: Maybe<SaleorExportFile>;
};

export type SaleorExportVoucherCodesInput = {
  /** Type of exported file. */
  fileType: SaleorFileTypesEnum;
  /** List of voucher code IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the voucher. If provided, exports all codes belonging to the voucher. */
  voucherId?: InputMaybe<Scalars['ID']['input']>;
};

/** External authentication plugin. */
export type SaleorExternalAuthentication = {
  __typename?: 'ExternalAuthentication';
  /** ID of external authentication plugin. */
  id: Scalars['String']['output'];
  /** Name of external authentication plugin. */
  name: Maybe<Scalars['String']['output']>;
};

/** Prepare external authentication URL for user by custom plugin. */
export type SaleorExternalAuthenticationUrl = {
  __typename?: 'ExternalAuthenticationUrl';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** The data returned by authentication plugin. */
  authenticationData: Maybe<Scalars['JSONString']['output']>;
  errors: Array<SaleorAccountError>;
};

/** Logout user by custom plugin. */
export type SaleorExternalLogout = {
  __typename?: 'ExternalLogout';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** The data returned by authentication plugin. */
  logoutData: Maybe<Scalars['JSONString']['output']>;
};

export type SaleorExternalNotificationError = {
  __typename?: 'ExternalNotificationError';
  /** The error code. */
  code: SaleorExternalNotificationErrorCodes;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorExternalNotificationErrorCodes =
  | 'CHANNEL_INACTIVE'
  | 'INVALID_MODEL_TYPE'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Trigger sending a notification with the notify plugin method. Serializes nodes provided as ids parameter and includes this data in the notification payload. */
export type SaleorExternalNotificationTrigger = {
  __typename?: 'ExternalNotificationTrigger';
  errors: Array<SaleorExternalNotificationError>;
};

export type SaleorExternalNotificationTriggerInput = {
  /** External event type. This field is passed to a plugin as an event type. */
  externalEventType: Scalars['String']['input'];
  /** Additional payload that will be merged with the one based on the business object ID. */
  extraPayload?: InputMaybe<Scalars['JSONString']['input']>;
  /** The list of customers or orders node IDs that will be serialized and included in the notification payload. */
  ids: Array<Scalars['ID']['input']>;
};

/** Obtain external access tokens for user by custom plugin. */
export type SaleorExternalObtainAccessTokens = {
  __typename?: 'ExternalObtainAccessTokens';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate external access token. */
  csrfToken: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** The refresh token, required to re-generate external access token. */
  refreshToken: Maybe<Scalars['String']['output']>;
  /** The token, required to authenticate. */
  token: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user: Maybe<SaleorUser>;
};

/** Refresh user's access by custom plugin. */
export type SaleorExternalRefresh = {
  __typename?: 'ExternalRefresh';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate external access token. */
  csrfToken: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** The refresh token, required to re-generate external access token. */
  refreshToken: Maybe<Scalars['String']['output']>;
  /** The token, required to authenticate. */
  token: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user: Maybe<SaleorUser>;
};

/** Verify external authentication data by plugin. */
export type SaleorExternalVerify = {
  __typename?: 'ExternalVerify';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** Determine if authentication data is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** User assigned to data. */
  user: Maybe<SaleorUser>;
  /** External data. */
  verifyData: Maybe<Scalars['JSONString']['output']>;
};

export type SaleorFile = {
  __typename?: 'File';
  /** Content type of the file. */
  contentType: Maybe<Scalars['String']['output']>;
  /** The URL of the file. */
  url: Scalars['String']['output'];
};

export type SaleorFileTypesEnum =
  | 'CSV'
  | 'XLSX';

/**
 * Upload a file. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
 */
export type SaleorFileUpload = {
  __typename?: 'FileUpload';
  errors: Array<SaleorUploadError>;
  /** @deprecated Use `errors` field instead. */
  uploadErrors: Array<SaleorUploadError>;
  uploadedFile: Maybe<SaleorFile>;
};

/** Represents order fulfillment. */
export type SaleorFulfillment = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Fulfillment';
  /** Date and time when fulfillment was created. */
  created: Scalars['DateTime']['output'];
  /** Sequence in which the fulfillments were created for an order. */
  fulfillmentOrder: Scalars['Int']['output'];
  /** ID of the fulfillment. */
  id: Scalars['ID']['output'];
  /** List of lines for the fulfillment. */
  lines: Maybe<Array<SaleorFulfillmentLine>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Amount of refunded shipping price. */
  shippingRefundedAmount: Maybe<SaleorMoney>;
  /** Status of fulfillment. */
  status: SaleorFulfillmentStatus;
  /** User-friendly fulfillment status. */
  statusDisplay: Maybe<Scalars['String']['output']>;
  /** Total refunded amount assigned to this fulfillment. */
  totalRefundedAmount: Maybe<SaleorMoney>;
  /** Fulfillment tracking number. */
  trackingNumber: Scalars['String']['output'];
  /** Warehouse from fulfillment was fulfilled. */
  warehouse: Maybe<SaleorWarehouse>;
};


/** Represents order fulfillment. */
export type SaleorFulfillmentMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order fulfillment. */
export type SaleorFulfillmentMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order fulfillment. */
export type SaleorFulfillmentPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order fulfillment. */
export type SaleorFulfillmentPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Approve existing fulfillment.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - FULFILLMENT_APPROVED (async): Fulfillment is approved.
 */
export type SaleorFulfillmentApprove = {
  __typename?: 'FulfillmentApprove';
  errors: Array<SaleorOrderError>;
  /** An approved fulfillment. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Order which fulfillment was approved. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** Event sent when fulfillment is approved. */
export type SaleorFulfillmentApproved = SaleorEvent & {
  __typename?: 'FulfillmentApproved';
  /** The fulfillment the event relates to. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** If true, send a notification to the customer. */
  notifyCustomer: Scalars['Boolean']['output'];
  /** The order the fulfillment belongs to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Cancels existing fulfillment and optionally restocks items.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentCancel = {
  __typename?: 'FulfillmentCancel';
  errors: Array<SaleorOrderError>;
  /** A canceled fulfillment. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Order which fulfillment was cancelled. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorFulfillmentCancelInput = {
  /** ID of a warehouse where items will be restocked. Optional when fulfillment is in WAITING_FOR_APPROVAL state. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Event sent when fulfillment is canceled. */
export type SaleorFulfillmentCanceled = SaleorEvent & {
  __typename?: 'FulfillmentCanceled';
  /** The fulfillment the event relates to. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when new fulfillment is created. */
export type SaleorFulfillmentCreated = SaleorEvent & {
  __typename?: 'FulfillmentCreated';
  /** The fulfillment the event relates to. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** If true, the app should send a notification to the customer. */
  notifyCustomer: Scalars['Boolean']['output'];
  /** The order the fulfillment belongs to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Filter input for order fulfillments data. */
export type SaleorFulfillmentFilterInput = {
  /** Filter by metadata fields. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by fulfillment status. */
  status?: InputMaybe<SaleorFulfillmentStatusEnumFilterInput>;
  /** Filter by fulfillment warehouse. */
  warehouse?: InputMaybe<SaleorFulfillmentWarehouseFilterInput>;
};

/** Represents line of the fulfillment. */
export type SaleorFulfillmentLine = SaleorNode & {
  __typename?: 'FulfillmentLine';
  /** ID of the fulfillment line. */
  id: Scalars['ID']['output'];
  /** The order line to which the fulfillment line is related. */
  orderLine: Maybe<SaleorOrderLine>;
  /** The number of items included in the fulfillment line. */
  quantity: Scalars['Int']['output'];
};

/** Event sent when fulfillment metadata is updated. */
export type SaleorFulfillmentMetadataUpdated = SaleorEvent & {
  __typename?: 'FulfillmentMetadataUpdated';
  /** The fulfillment the event relates to. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Refund products.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentRefundProducts = {
  __typename?: 'FulfillmentRefundProducts';
  errors: Array<SaleorOrderError>;
  /** A refunded fulfillment. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Order which fulfillment was refunded. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Return products.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentReturnProducts = {
  __typename?: 'FulfillmentReturnProducts';
  errors: Array<SaleorOrderError>;
  /** Order which fulfillment was returned. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** A replace fulfillment. */
  replaceFulfillment: Maybe<SaleorFulfillment>;
  /** A draft order which was created for products with replace flag. */
  replaceOrder: Maybe<SaleorOrder>;
  /** A return fulfillment. */
  returnFulfillment: Maybe<SaleorFulfillment>;
};

export type SaleorFulfillmentStatus =
  | 'CANCELED'
  | 'FULFILLED'
  | 'REFUNDED'
  | 'REFUNDED_AND_RETURNED'
  | 'REPLACED'
  | 'RETURNED'
  | 'WAITING_FOR_APPROVAL';

/** Filter by fulfillment status. */
export type SaleorFulfillmentStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorFulfillmentStatus>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorFulfillmentStatus>>;
};

/** Event sent when the tracking number is updated. */
export type SaleorFulfillmentTrackingNumberUpdated = SaleorEvent & {
  __typename?: 'FulfillmentTrackingNumberUpdated';
  /** The fulfillment the event relates to. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Updates a fulfillment for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Fulfillment tracking number is updated.
 */
export type SaleorFulfillmentUpdateTracking = {
  __typename?: 'FulfillmentUpdateTracking';
  errors: Array<SaleorOrderError>;
  /** A fulfillment with updated tracking. */
  fulfillment: Maybe<SaleorFulfillment>;
  /** Order for which fulfillment was updated. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorFulfillmentUpdateTrackingInput = {
  /** If true, send an email notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fulfillment tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Filter input for fulfillment warehouses. */
export type SaleorFulfillmentWarehouseFilterInput = {
  /** Filter fulfillments by warehouse external reference. */
  externalReference?: InputMaybe<SaleorStringFilterInput>;
  /** Filter fulfillments by warehouse ID. */
  id?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter fulfillments by warehouse slug. */
  slug?: InputMaybe<SaleorStringFilterInput>;
};

/** Payment gateway client configuration key and value pair. */
export type SaleorGatewayConfigLine = {
  __typename?: 'GatewayConfigLine';
  /** Gateway config key. */
  field: Scalars['String']['output'];
  /** Gateway config value for key. */
  value: Maybe<Scalars['String']['output']>;
};

/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCard = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'GiftCard';
  /**
   * App which created the gift card.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  app: Maybe<SaleorApp>;
  /** Slug of the channel where the gift card was bought. */
  boughtInChannel: Maybe<Scalars['String']['output']>;
  /**
   * Gift card code. It can be fetched both by a staff member with 'MANAGE_GIFT_CARD' when gift card hasn't been used yet or a user who bought or issued the gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD, OWNER.
   */
  code: Scalars['String']['output'];
  /** Date and time when gift card was created. */
  created: Scalars['DateTime']['output'];
  /** The user who bought or issued a gift card. */
  createdBy: Maybe<SaleorUser>;
  /**
   * Email address of the user who bought or issued gift card.
   *
   * Requires one of the following permissions: MANAGE_USERS, OWNER.
   */
  createdByEmail: Maybe<Scalars['String']['output']>;
  currentBalance: SaleorMoney;
  /** Code in format which allows displaying in a user interface. */
  displayCode: Scalars['String']['output'];
  /**
   * End date of gift card.
   * @deprecated Use `expiryDate` field instead.
   */
  endDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * List of events associated with the gift card. Requires MANAGE_GIFT_CARD permission to access all events. Users with MANAGE_ORDERS permission can access only USED_IN_ORDER events.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD, MANAGE_ORDERS.
   */
  events: Array<SaleorGiftCardEvent>;
  /** Expiry date of the gift card. */
  expiryDate: Maybe<Scalars['Date']['output']>;
  /** ID of the gift card. */
  id: Scalars['ID']['output'];
  initialBalance: SaleorMoney;
  isActive: Scalars['Boolean']['output'];
  /** Last 4 characters of gift card code. */
  last4CodeChars: Scalars['String']['output'];
  /** Date and time when gift card was last used. */
  lastUsedOn: Maybe<Scalars['DateTime']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Related gift card product. */
  product: Maybe<SaleorProduct>;
  /**
   * Start date of gift card.
   * @deprecated Field no longer supported
   */
  startDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * The gift card tag.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  tags: Array<SaleorGiftCardTag>;
  /**
   * The customer who used a gift card.
   * @deprecated Field no longer supported
   */
  usedBy: Maybe<SaleorUser>;
  /**
   * Email address of the customer who used a gift card.
   * @deprecated Field no longer supported
   */
  usedByEmail: Maybe<Scalars['String']['output']>;
  /**
   * The customer who bought a gift card.
   * @deprecated Use `createdBy` field instead.
   */
  user: Maybe<SaleorUser>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardEventsArgs = {
  filter?: InputMaybe<SaleorGiftCardEventFilterInput>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Activate a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
 */
export type SaleorGiftCardActivate = {
  __typename?: 'GiftCardActivate';
  errors: Array<SaleorGiftCardError>;
  /** Activated gift card. */
  giftCard: Maybe<SaleorGiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

/**
 * Adds note to the gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_UPDATED (async): A gift card was updated.
 */
export type SaleorGiftCardAddNote = {
  __typename?: 'GiftCardAddNote';
  errors: Array<SaleorGiftCardError>;
  /** Gift card note created. */
  event: Maybe<SaleorGiftCardEvent>;
  /** Gift card with the note added. */
  giftCard: Maybe<SaleorGiftCard>;
};

export type SaleorGiftCardAddNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Activate gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
 */
export type SaleorGiftCardBulkActivate = {
  __typename?: 'GiftCardBulkActivate';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
};

/**
 * Creates gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_CREATED (async): A gift card was created.
 * - NOTIFY_USER (async): A notification for created gift card.
 */
export type SaleorGiftCardBulkCreate = {
  __typename?: 'GiftCardBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
  /** List of created gift cards. */
  giftCards: Array<SaleorGiftCard>;
};

export type SaleorGiftCardBulkCreateInput = {
  /** Balance of the gift card. */
  balance: SaleorPriceInput;
  /** The number of cards to issue. */
  count: Scalars['Int']['input'];
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  /** Determine if gift card is active. */
  isActive: Scalars['Boolean']['input'];
  /** The gift card tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deactivate gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
 */
export type SaleorGiftCardBulkDeactivate = {
  __typename?: 'GiftCardBulkDeactivate';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
};

/**
 * Deletes gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_DELETED (async): A gift card was deleted.
 */
export type SaleorGiftCardBulkDelete = {
  __typename?: 'GiftCardBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
};

export type SaleorGiftCardCountableConnection = {
  __typename?: 'GiftCardCountableConnection';
  edges: Array<SaleorGiftCardCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorGiftCardCountableEdge = {
  __typename?: 'GiftCardCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorGiftCard;
};

/**
 * Creates a new gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_CREATED (async): A gift card was created.
 * - NOTIFY_USER (async): A notification for created gift card.
 */
export type SaleorGiftCardCreate = {
  __typename?: 'GiftCardCreate';
  errors: Array<SaleorGiftCardError>;
  giftCard: Maybe<SaleorGiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

export type SaleorGiftCardCreateInput = {
  /** The gift card tags to add. */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Balance of the gift card. */
  balance: SaleorPriceInput;
  /** Slug of a channel from which the email should be sent. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Code to use the gift card.
   *
   * DEPRECATED: this field will be removed. The code is now auto generated.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * End date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed. Use `expiryDate` from `expirySettings` instead.
   */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  /** Determine if gift card is active. */
  isActive: Scalars['Boolean']['input'];
  /**
   * Gift Card public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** The gift card note from the staff member. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gift Card private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Start date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed.
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Email of the customer to whom gift card will be sent. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new gift card is created. */
export type SaleorGiftCardCreated = SaleorEvent & {
  __typename?: 'GiftCardCreated';
  /** The gift card the event relates to. */
  giftCard: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deactivate a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
 */
export type SaleorGiftCardDeactivate = {
  __typename?: 'GiftCardDeactivate';
  errors: Array<SaleorGiftCardError>;
  /** Deactivated gift card. */
  giftCard: Maybe<SaleorGiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

/**
 * Deletes gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_DELETED (async): A gift card was deleted.
 */
export type SaleorGiftCardDelete = {
  __typename?: 'GiftCardDelete';
  errors: Array<SaleorGiftCardError>;
  giftCard: Maybe<SaleorGiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

/** Event sent when gift card is deleted. */
export type SaleorGiftCardDeleted = SaleorEvent & {
  __typename?: 'GiftCardDeleted';
  /** The gift card the event relates to. */
  giftCard: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorGiftCardError = {
  __typename?: 'GiftCardError';
  /** The error code. */
  code: SaleorGiftCardErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of tag values that cause the error. */
  tags: Maybe<Array<Scalars['String']['output']>>;
};

export type SaleorGiftCardErrorCode =
  | 'ALREADY_EXISTS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'EXPIRED_GIFT_CARD'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/** History log of the gift card. */
export type SaleorGiftCardEvent = SaleorNode & {
  __typename?: 'GiftCardEvent';
  /** App that performed the action. Requires one of the following permissions: MANAGE_APPS, OWNER. */
  app: Maybe<SaleorApp>;
  /** The gift card balance. */
  balance: Maybe<SaleorGiftCardEventBalance>;
  /** Date when event happened at in ISO 8601 format. */
  date: Maybe<Scalars['DateTime']['output']>;
  /** Email of the customer. */
  email: Maybe<Scalars['String']['output']>;
  /** The gift card expiry date. */
  expiryDate: Maybe<Scalars['Date']['output']>;
  /** ID of the event associated with a gift card. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message: Maybe<Scalars['String']['output']>;
  /** Previous gift card expiry date. */
  oldExpiryDate: Maybe<Scalars['Date']['output']>;
  /** The list of old gift card tags. */
  oldTags: Maybe<Array<Scalars['String']['output']>>;
  /** The order ID where gift card was used or bought. */
  orderId: Maybe<Scalars['ID']['output']>;
  /** User-friendly number of an order where gift card was used or bought. */
  orderNumber: Maybe<Scalars['String']['output']>;
  /** The list of gift card tags. */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** Gift card event type. */
  type: Maybe<SaleorGiftCardEventsEnum>;
  /** User who performed the action. Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF, OWNER. */
  user: Maybe<SaleorUser>;
};

export type SaleorGiftCardEventBalance = {
  __typename?: 'GiftCardEventBalance';
  /** Current balance of the gift card. */
  currentBalance: SaleorMoney;
  /** Initial balance of the gift card. */
  initialBalance: Maybe<SaleorMoney>;
  /** Previous current balance of the gift card. */
  oldCurrentBalance: Maybe<SaleorMoney>;
  /** Previous initial balance of the gift card. */
  oldInitialBalance: Maybe<SaleorMoney>;
};

export type SaleorGiftCardEventFilterInput = {
  orders?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<SaleorGiftCardEventsEnum>;
};

export type SaleorGiftCardEventsEnum =
  | 'ACTIVATED'
  | 'BALANCE_RESET'
  | 'BOUGHT'
  | 'DEACTIVATED'
  | 'EXPIRY_DATE_UPDATED'
  | 'ISSUED'
  | 'NOTE_ADDED'
  | 'RESENT'
  | 'SENT_TO_CUSTOMER'
  | 'TAGS_UPDATED'
  | 'UPDATED'
  | 'USED_IN_ORDER';

/** Event sent when gift card export is completed. */
export type SaleorGiftCardExportCompleted = SaleorEvent & {
  __typename?: 'GiftCardExportCompleted';
  /** The export file for gift cards. */
  export: Maybe<SaleorExportFile>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorGiftCardFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currentBalance?: InputMaybe<SaleorPriceRangeInput>;
  initialBalance?: InputMaybe<SaleorPriceRangeInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  usedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when gift card metadata is updated. */
export type SaleorGiftCardMetadataUpdated = SaleorEvent & {
  __typename?: 'GiftCardMetadataUpdated';
  /** The gift card the event relates to. */
  giftCard: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Resend a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for gift card resend.
 */
export type SaleorGiftCardResend = {
  __typename?: 'GiftCardResend';
  errors: Array<SaleorGiftCardError>;
  /** Gift card which has been sent. */
  giftCard: Maybe<SaleorGiftCard>;
};

export type SaleorGiftCardResendInput = {
  /** Slug of a channel from which the email should be sent. */
  channel: Scalars['String']['input'];
  /** Email to which gift card should be send. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of a gift card to resend. */
  id: Scalars['ID']['input'];
};

/** Event sent when gift card is e-mailed. */
export type SaleorGiftCardSent = SaleorEvent & {
  __typename?: 'GiftCardSent';
  /** Slug of a channel for which this gift card email was sent. */
  channel: Maybe<Scalars['String']['output']>;
  /** The gift card the event relates to. */
  giftCard: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** E-mail address to which gift card was sent. */
  sentToEmail: Maybe<Scalars['String']['output']>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Gift card related settings from site settings. */
export type SaleorGiftCardSettings = {
  __typename?: 'GiftCardSettings';
  /** The gift card expiry period settings. */
  expiryPeriod: Maybe<SaleorTimePeriod>;
  /** The gift card expiry type settings. */
  expiryType: SaleorGiftCardSettingsExpiryTypeEnum;
};

export type SaleorGiftCardSettingsError = {
  __typename?: 'GiftCardSettingsError';
  /** The error code. */
  code: SaleorGiftCardSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorGiftCardSettingsErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'REQUIRED';

export type SaleorGiftCardSettingsExpiryTypeEnum =
  | 'EXPIRY_PERIOD'
  | 'NEVER_EXPIRE';

/**
 * Update gift card settings.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardSettingsUpdate = {
  __typename?: 'GiftCardSettingsUpdate';
  errors: Array<SaleorGiftCardSettingsError>;
  /** Gift card settings. */
  giftCardSettings: Maybe<SaleorGiftCardSettings>;
};

export type SaleorGiftCardSettingsUpdateInput = {
  /** Defines gift card expiry period. */
  expiryPeriod?: InputMaybe<SaleorTimePeriodInputType>;
  /** Defines gift card default expiry settings. */
  expiryType?: InputMaybe<SaleorGiftCardSettingsExpiryTypeEnum>;
};

export type SaleorGiftCardSortField =
  /** Sort gift cards by created at. */
  | 'CREATED_AT'
  /** Sort gift cards by current balance. */
  | 'CURRENT_BALANCE'
  /** Sort gift cards by product. */
  | 'PRODUCT'
  /** Sort gift cards by used by. */
  | 'USED_BY';

export type SaleorGiftCardSortingInput = {
  /** Specifies the direction in which to sort gift cards. */
  direction: SaleorOrderDirection;
  /** Sort gift cards by the selected field. */
  field: SaleorGiftCardSortField;
};

/** Event sent when gift card status has changed. */
export type SaleorGiftCardStatusChanged = SaleorEvent & {
  __typename?: 'GiftCardStatusChanged';
  /** The gift card the event relates to. */
  giftCard: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** The gift card tag. */
export type SaleorGiftCardTag = SaleorNode & {
  __typename?: 'GiftCardTag';
  /** ID of the tag associated with a gift card. */
  id: Scalars['ID']['output'];
  /** Name of the tag associated with a gift card. */
  name: Scalars['String']['output'];
};

export type SaleorGiftCardTagCountableConnection = {
  __typename?: 'GiftCardTagCountableConnection';
  edges: Array<SaleorGiftCardTagCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorGiftCardTagCountableEdge = {
  __typename?: 'GiftCardTagCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorGiftCardTag;
};

export type SaleorGiftCardTagFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_UPDATED (async): A gift card was updated.
 */
export type SaleorGiftCardUpdate = {
  __typename?: 'GiftCardUpdate';
  errors: Array<SaleorGiftCardError>;
  giftCard: Maybe<SaleorGiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

export type SaleorGiftCardUpdateInput = {
  /** The gift card tags to add. */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The gift card balance amount. */
  balanceAmount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /**
   * End date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed. Use `expiryDate` from `expirySettings` instead.
   */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Gift Card public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Gift Card private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** The gift card tags to remove. */
  removeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Start date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed.
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Event sent when gift card is updated. */
export type SaleorGiftCardUpdated = SaleorEvent & {
  __typename?: 'GiftCardUpdated';
  /** The gift card the event relates to. */
  giftCard: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Define the filtering options for foreign key fields. */
export type SaleorGlobalIdFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['ID']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents permission group data. */
export type SaleorGroup = SaleorNode & {
  __typename?: 'Group';
  /** List of channels the group has access to. */
  accessibleChannels: Maybe<Array<SaleorChannel>>;
  /** The ID of the group. */
  id: Scalars['ID']['output'];
  /** The name of the group. */
  name: Scalars['String']['output'];
  /** List of group permissions */
  permissions: Maybe<Array<SaleorPermission>>;
  /** Determine if the group have restricted access to channels. */
  restrictedAccessToChannels: Scalars['Boolean']['output'];
  /** True, if the currently authenticated user has rights to manage a group. */
  userCanManage: Scalars['Boolean']['output'];
  /**
   * List of group users
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  users: Maybe<Array<SaleorUser>>;
};

export type SaleorGroupCountableConnection = {
  __typename?: 'GroupCountableConnection';
  edges: Array<SaleorGroupCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorGroupCountableEdge = {
  __typename?: 'GroupCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorGroup;
};

export type SaleorHttpMethod =
  | 'GET'
  | 'POST';

/** Thumbnail formats for icon images. */
export type SaleorIconThumbnailFormatEnum =
  | 'ORIGINAL'
  | 'WEBP';

/** Represents an image. */
export type SaleorImage = {
  __typename?: 'Image';
  /** Alt text for an image. */
  alt: Maybe<Scalars['String']['output']>;
  /** The URL of the image. */
  url: Scalars['String']['output'];
};

/** Define the filtering options for integer fields. */
export type SaleorIntFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The value in range. */
  range?: InputMaybe<SaleorIntRangeInput>;
};

export type SaleorIntRangeInput = {
  /** Value greater than or equal to. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Value less than or equal to. */
  lte?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Invoice. */
export type SaleorInvoice = SaleorJob & SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Invoice';
  /** Date and time at which invoice was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * URL to view an invoice.
   * @deprecated Use `url` field.
   */
  externalUrl: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Message associated with an invoice. */
  message: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Invoice number. */
  number: Maybe<Scalars['String']['output']>;
  /** Order related to the invoice. */
  order: Maybe<SaleorOrder>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date and time at which invoice was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** URL to view/download an invoice. */
  url: Maybe<Scalars['String']['output']>;
};


/** Represents an Invoice. */
export type SaleorInvoiceMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an Invoice. */
export type SaleorInvoiceMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an Invoice. */
export type SaleorInvoicePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an Invoice. */
export type SaleorInvoicePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Creates a ready to send invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceCreate = {
  __typename?: 'InvoiceCreate';
  errors: Array<SaleorInvoiceError>;
  invoice: Maybe<SaleorInvoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

export type SaleorInvoiceCreateInput = {
  /**
   * Fields required to update the invoice metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Invoice number. */
  number: Scalars['String']['input'];
  /**
   * Fields required to update the invoice private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of an invoice to download. */
  url: Scalars['String']['input'];
};

/**
 * Deletes an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceDelete = {
  __typename?: 'InvoiceDelete';
  errors: Array<SaleorInvoiceError>;
  invoice: Maybe<SaleorInvoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

/** Event sent when invoice is deleted. */
export type SaleorInvoiceDeleted = SaleorEvent & {
  __typename?: 'InvoiceDeleted';
  /** The invoice the event relates to. */
  invoice: Maybe<SaleorInvoice>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** Order related to the invoice. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorInvoiceError = {
  __typename?: 'InvoiceError';
  /** The error code. */
  code: SaleorInvoiceErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorInvoiceErrorCode =
  | 'EMAIL_NOT_SET'
  | 'INVALID_STATUS'
  | 'NOT_FOUND'
  | 'NOT_READY'
  | 'NO_INVOICE_PLUGIN'
  | 'NUMBER_NOT_SET'
  | 'REQUIRED'
  | 'URL_NOT_SET';

/** Filter input for invoices. */
export type SaleorInvoiceFilterInput = {
  /** Filter invoices by creation date. */
  createdAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

/**
 * Request an invoice for the order using plugin.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - INVOICE_REQUESTED (async): An invoice was requested.
 */
export type SaleorInvoiceRequest = {
  __typename?: 'InvoiceRequest';
  errors: Array<SaleorInvoiceError>;
  invoice: Maybe<SaleorInvoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
  /** Order related to an invoice. */
  order: Maybe<SaleorOrder>;
};

/**
 * Requests deletion of an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - INVOICE_DELETED (async): An invoice was requested to delete.
 */
export type SaleorInvoiceRequestDelete = {
  __typename?: 'InvoiceRequestDelete';
  errors: Array<SaleorInvoiceError>;
  invoice: Maybe<SaleorInvoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

/** Event sent when invoice is requested. */
export type SaleorInvoiceRequested = SaleorEvent & {
  __typename?: 'InvoiceRequested';
  /** The invoice the event relates to. */
  invoice: Maybe<SaleorInvoice>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** Order related to the invoice. */
  order: SaleorOrder;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Send an invoice notification to the customer.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - INVOICE_SENT (async): A notification for invoice send
 * - NOTIFY_USER (async): A notification for invoice send
 */
export type SaleorInvoiceSendNotification = {
  __typename?: 'InvoiceSendNotification';
  errors: Array<SaleorInvoiceError>;
  invoice: Maybe<SaleorInvoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

/** Event sent when invoice is sent. */
export type SaleorInvoiceSent = SaleorEvent & {
  __typename?: 'InvoiceSent';
  /** The invoice the event relates to. */
  invoice: Maybe<SaleorInvoice>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** Order related to the invoice. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceUpdate = {
  __typename?: 'InvoiceUpdate';
  errors: Array<SaleorInvoiceError>;
  invoice: Maybe<SaleorInvoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

export type SaleorIssuingPrincipal = SaleorApp | SaleorUser;

export type SaleorJob = {
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /** Job message. */
  message: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleorJobStatusEnum =
  | 'DELETED'
  | 'FAILED'
  | 'PENDING'
  | 'SUCCESS';

/** Language code enum. It contains all the languages supported by Saleor. */
export type SaleorLanguageCodeEnum =
  /** Afrikaans */
  | 'AF'
  /** Afrikaans (Namibia) */
  | 'AF_NA'
  /** Afrikaans (South Africa) */
  | 'AF_ZA'
  /** Aghem */
  | 'AGQ'
  /** Aghem (Cameroon) */
  | 'AGQ_CM'
  /** Akan */
  | 'AK'
  /** Akan (Ghana) */
  | 'AK_GH'
  /** Amharic */
  | 'AM'
  /** Amharic (Ethiopia) */
  | 'AM_ET'
  /** Arabic */
  | 'AR'
  /** Arabic (United Arab Emirates) */
  | 'AR_AE'
  /** Arabic (Bahrain) */
  | 'AR_BH'
  /** Arabic (Djibouti) */
  | 'AR_DJ'
  /** Arabic (Algeria) */
  | 'AR_DZ'
  /** Arabic (Egypt) */
  | 'AR_EG'
  /** Arabic (Western Sahara) */
  | 'AR_EH'
  /** Arabic (Eritrea) */
  | 'AR_ER'
  /** Arabic (Israel) */
  | 'AR_IL'
  /** Arabic (Iraq) */
  | 'AR_IQ'
  /** Arabic (Jordan) */
  | 'AR_JO'
  /** Arabic (Comoros) */
  | 'AR_KM'
  /** Arabic (Kuwait) */
  | 'AR_KW'
  /** Arabic (Lebanon) */
  | 'AR_LB'
  /** Arabic (Libya) */
  | 'AR_LY'
  /** Arabic (Morocco) */
  | 'AR_MA'
  /** Arabic (Mauritania) */
  | 'AR_MR'
  /** Arabic (Oman) */
  | 'AR_OM'
  /** Arabic (Palestinian Territories) */
  | 'AR_PS'
  /** Arabic (Qatar) */
  | 'AR_QA'
  /** Arabic (Saudi Arabia) */
  | 'AR_SA'
  /** Arabic (Sudan) */
  | 'AR_SD'
  /** Arabic (Somalia) */
  | 'AR_SO'
  /** Arabic (South Sudan) */
  | 'AR_SS'
  /** Arabic (Syria) */
  | 'AR_SY'
  /** Arabic (Chad) */
  | 'AR_TD'
  /** Arabic (Tunisia) */
  | 'AR_TN'
  /** Arabic (Yemen) */
  | 'AR_YE'
  /** Assamese */
  | 'AS'
  /** Asu */
  | 'ASA'
  /** Asu (Tanzania) */
  | 'ASA_TZ'
  /** Asturian */
  | 'AST'
  /** Asturian (Spain) */
  | 'AST_ES'
  /** Assamese (India) */
  | 'AS_IN'
  /** Azerbaijani */
  | 'AZ'
  /** Azerbaijani (Cyrillic) */
  | 'AZ_CYRL'
  /** Azerbaijani (Cyrillic, Azerbaijan) */
  | 'AZ_CYRL_AZ'
  /** Azerbaijani (Latin) */
  | 'AZ_LATN'
  /** Azerbaijani (Latin, Azerbaijan) */
  | 'AZ_LATN_AZ'
  /** Basaa */
  | 'BAS'
  /** Basaa (Cameroon) */
  | 'BAS_CM'
  /** Belarusian */
  | 'BE'
  /** Bemba */
  | 'BEM'
  /** Bemba (Zambia) */
  | 'BEM_ZM'
  /** Bena */
  | 'BEZ'
  /** Bena (Tanzania) */
  | 'BEZ_TZ'
  /** Belarusian (Belarus) */
  | 'BE_BY'
  /** Bulgarian */
  | 'BG'
  /** Bulgarian (Bulgaria) */
  | 'BG_BG'
  /** Bambara */
  | 'BM'
  /** Bambara (Mali) */
  | 'BM_ML'
  /** Bangla */
  | 'BN'
  /** Bangla (Bangladesh) */
  | 'BN_BD'
  /** Bangla (India) */
  | 'BN_IN'
  /** Tibetan */
  | 'BO'
  /** Tibetan (China) */
  | 'BO_CN'
  /** Tibetan (India) */
  | 'BO_IN'
  /** Breton */
  | 'BR'
  /** Bodo */
  | 'BRX'
  /** Bodo (India) */
  | 'BRX_IN'
  /** Breton (France) */
  | 'BR_FR'
  /** Bosnian */
  | 'BS'
  /** Bosnian (Cyrillic) */
  | 'BS_CYRL'
  /** Bosnian (Cyrillic, Bosnia & Herzegovina) */
  | 'BS_CYRL_BA'
  /** Bosnian (Latin) */
  | 'BS_LATN'
  /** Bosnian (Latin, Bosnia & Herzegovina) */
  | 'BS_LATN_BA'
  /** Catalan */
  | 'CA'
  /** Catalan (Andorra) */
  | 'CA_AD'
  /** Catalan (Spain) */
  | 'CA_ES'
  /** Catalan (Spain, Valencian) */
  | 'CA_ES_VALENCIA'
  /** Catalan (France) */
  | 'CA_FR'
  /** Catalan (Italy) */
  | 'CA_IT'
  /** Chakma */
  | 'CCP'
  /** Chakma (Bangladesh) */
  | 'CCP_BD'
  /** Chakma (India) */
  | 'CCP_IN'
  /** Chechen */
  | 'CE'
  /** Cebuano */
  | 'CEB'
  /** Cebuano (Philippines) */
  | 'CEB_PH'
  /** Chechen (Russia) */
  | 'CE_RU'
  /** Chiga */
  | 'CGG'
  /** Chiga (Uganda) */
  | 'CGG_UG'
  /** Cherokee */
  | 'CHR'
  /** Cherokee (United States) */
  | 'CHR_US'
  /** Central Kurdish */
  | 'CKB'
  /** Central Kurdish (Iraq) */
  | 'CKB_IQ'
  /** Central Kurdish (Iran) */
  | 'CKB_IR'
  /** Czech */
  | 'CS'
  /** Czech (Czechia) */
  | 'CS_CZ'
  /** Church Slavic */
  | 'CU'
  /** Church Slavic (Russia) */
  | 'CU_RU'
  /** Welsh */
  | 'CY'
  /** Welsh (United Kingdom) */
  | 'CY_GB'
  /** Danish */
  | 'DA'
  /** Taita */
  | 'DAV'
  /** Taita (Kenya) */
  | 'DAV_KE'
  /** Danish (Denmark) */
  | 'DA_DK'
  /** Danish (Greenland) */
  | 'DA_GL'
  /** German */
  | 'DE'
  /** German (Austria) */
  | 'DE_AT'
  /** German (Belgium) */
  | 'DE_BE'
  /** German (Switzerland) */
  | 'DE_CH'
  /** German (Germany) */
  | 'DE_DE'
  /** German (Italy) */
  | 'DE_IT'
  /** German (Liechtenstein) */
  | 'DE_LI'
  /** German (Luxembourg) */
  | 'DE_LU'
  /** Zarma */
  | 'DJE'
  /** Zarma (Niger) */
  | 'DJE_NE'
  /** Lower Sorbian */
  | 'DSB'
  /** Lower Sorbian (Germany) */
  | 'DSB_DE'
  /** Duala */
  | 'DUA'
  /** Duala (Cameroon) */
  | 'DUA_CM'
  /** Jola-Fonyi */
  | 'DYO'
  /** Jola-Fonyi (Senegal) */
  | 'DYO_SN'
  /** Dzongkha */
  | 'DZ'
  /** Dzongkha (Bhutan) */
  | 'DZ_BT'
  /** Embu */
  | 'EBU'
  /** Embu (Kenya) */
  | 'EBU_KE'
  /** Ewe */
  | 'EE'
  /** Ewe (Ghana) */
  | 'EE_GH'
  /** Ewe (Togo) */
  | 'EE_TG'
  /** Greek */
  | 'EL'
  /** Greek (Cyprus) */
  | 'EL_CY'
  /** Greek (Greece) */
  | 'EL_GR'
  /** English */
  | 'EN'
  /** English (United Arab Emirates) */
  | 'EN_AE'
  /** English (Antigua & Barbuda) */
  | 'EN_AG'
  /** English (Anguilla) */
  | 'EN_AI'
  /** English (American Samoa) */
  | 'EN_AS'
  /** English (Austria) */
  | 'EN_AT'
  /** English (Australia) */
  | 'EN_AU'
  /** English (Barbados) */
  | 'EN_BB'
  /** English (Belgium) */
  | 'EN_BE'
  /** English (Burundi) */
  | 'EN_BI'
  /** English (Bermuda) */
  | 'EN_BM'
  /** English (Bahamas) */
  | 'EN_BS'
  /** English (Botswana) */
  | 'EN_BW'
  /** English (Belize) */
  | 'EN_BZ'
  /** English (Canada) */
  | 'EN_CA'
  /** English (Cocos (Keeling) Islands) */
  | 'EN_CC'
  /** English (Switzerland) */
  | 'EN_CH'
  /** English (Cook Islands) */
  | 'EN_CK'
  /** English (Cameroon) */
  | 'EN_CM'
  /** English (Christmas Island) */
  | 'EN_CX'
  /** English (Cyprus) */
  | 'EN_CY'
  /** English (Germany) */
  | 'EN_DE'
  /** English (Diego Garcia) */
  | 'EN_DG'
  /** English (Denmark) */
  | 'EN_DK'
  /** English (Dominica) */
  | 'EN_DM'
  /** English (Eritrea) */
  | 'EN_ER'
  /** English (Finland) */
  | 'EN_FI'
  /** English (Fiji) */
  | 'EN_FJ'
  /** English (Falkland Islands) */
  | 'EN_FK'
  /** English (Micronesia) */
  | 'EN_FM'
  /** English (United Kingdom) */
  | 'EN_GB'
  /** English (Grenada) */
  | 'EN_GD'
  /** English (Guernsey) */
  | 'EN_GG'
  /** English (Ghana) */
  | 'EN_GH'
  /** English (Gibraltar) */
  | 'EN_GI'
  /** English (Gambia) */
  | 'EN_GM'
  /** English (Guam) */
  | 'EN_GU'
  /** English (Guyana) */
  | 'EN_GY'
  /** English (Hong Kong SAR China) */
  | 'EN_HK'
  /** English (Ireland) */
  | 'EN_IE'
  /** English (Israel) */
  | 'EN_IL'
  /** English (Isle of Man) */
  | 'EN_IM'
  /** English (India) */
  | 'EN_IN'
  /** English (British Indian Ocean Territory) */
  | 'EN_IO'
  /** English (Jersey) */
  | 'EN_JE'
  /** English (Jamaica) */
  | 'EN_JM'
  /** English (Kenya) */
  | 'EN_KE'
  /** English (Kiribati) */
  | 'EN_KI'
  /** English (St. Kitts & Nevis) */
  | 'EN_KN'
  /** English (Cayman Islands) */
  | 'EN_KY'
  /** English (St. Lucia) */
  | 'EN_LC'
  /** English (Liberia) */
  | 'EN_LR'
  /** English (Lesotho) */
  | 'EN_LS'
  /** English (Madagascar) */
  | 'EN_MG'
  /** English (Marshall Islands) */
  | 'EN_MH'
  /** English (Macao SAR China) */
  | 'EN_MO'
  /** English (Northern Mariana Islands) */
  | 'EN_MP'
  /** English (Montserrat) */
  | 'EN_MS'
  /** English (Malta) */
  | 'EN_MT'
  /** English (Mauritius) */
  | 'EN_MU'
  /** English (Malawi) */
  | 'EN_MW'
  /** English (Malaysia) */
  | 'EN_MY'
  /** English (Namibia) */
  | 'EN_NA'
  /** English (Norfolk Island) */
  | 'EN_NF'
  /** English (Nigeria) */
  | 'EN_NG'
  /** English (Netherlands) */
  | 'EN_NL'
  /** English (Nauru) */
  | 'EN_NR'
  /** English (Niue) */
  | 'EN_NU'
  /** English (New Zealand) */
  | 'EN_NZ'
  /** English (Papua New Guinea) */
  | 'EN_PG'
  /** English (Philippines) */
  | 'EN_PH'
  /** English (Pakistan) */
  | 'EN_PK'
  /** English (Pitcairn Islands) */
  | 'EN_PN'
  /** English (Puerto Rico) */
  | 'EN_PR'
  /** English (Palau) */
  | 'EN_PW'
  /** English (Rwanda) */
  | 'EN_RW'
  /** English (Solomon Islands) */
  | 'EN_SB'
  /** English (Seychelles) */
  | 'EN_SC'
  /** English (Sudan) */
  | 'EN_SD'
  /** English (Sweden) */
  | 'EN_SE'
  /** English (Singapore) */
  | 'EN_SG'
  /** English (St. Helena) */
  | 'EN_SH'
  /** English (Slovenia) */
  | 'EN_SI'
  /** English (Sierra Leone) */
  | 'EN_SL'
  /** English (South Sudan) */
  | 'EN_SS'
  /** English (Sint Maarten) */
  | 'EN_SX'
  /** English (Eswatini) */
  | 'EN_SZ'
  /** English (Turks & Caicos Islands) */
  | 'EN_TC'
  /** English (Tokelau) */
  | 'EN_TK'
  /** English (Tonga) */
  | 'EN_TO'
  /** English (Trinidad & Tobago) */
  | 'EN_TT'
  /** English (Tuvalu) */
  | 'EN_TV'
  /** English (Tanzania) */
  | 'EN_TZ'
  /** English (Uganda) */
  | 'EN_UG'
  /** English (U.S. Outlying Islands) */
  | 'EN_UM'
  /** English (United States) */
  | 'EN_US'
  /** English (St. Vincent & Grenadines) */
  | 'EN_VC'
  /** English (British Virgin Islands) */
  | 'EN_VG'
  /** English (U.S. Virgin Islands) */
  | 'EN_VI'
  /** English (Vanuatu) */
  | 'EN_VU'
  /** English (Samoa) */
  | 'EN_WS'
  /** English (South Africa) */
  | 'EN_ZA'
  /** English (Zambia) */
  | 'EN_ZM'
  /** English (Zimbabwe) */
  | 'EN_ZW'
  /** Esperanto */
  | 'EO'
  /** Spanish */
  | 'ES'
  /** Spanish (Argentina) */
  | 'ES_AR'
  /** Spanish (Bolivia) */
  | 'ES_BO'
  /** Spanish (Brazil) */
  | 'ES_BR'
  /** Spanish (Belize) */
  | 'ES_BZ'
  /** Spanish (Chile) */
  | 'ES_CL'
  /** Spanish (Colombia) */
  | 'ES_CO'
  /** Spanish (Costa Rica) */
  | 'ES_CR'
  /** Spanish (Cuba) */
  | 'ES_CU'
  /** Spanish (Dominican Republic) */
  | 'ES_DO'
  /** Spanish (Ceuta & Melilla) */
  | 'ES_EA'
  /** Spanish (Ecuador) */
  | 'ES_EC'
  /** Spanish (Spain) */
  | 'ES_ES'
  /** Spanish (Equatorial Guinea) */
  | 'ES_GQ'
  /** Spanish (Guatemala) */
  | 'ES_GT'
  /** Spanish (Honduras) */
  | 'ES_HN'
  /** Spanish (Canary Islands) */
  | 'ES_IC'
  /** Spanish (Mexico) */
  | 'ES_MX'
  /** Spanish (Nicaragua) */
  | 'ES_NI'
  /** Spanish (Panama) */
  | 'ES_PA'
  /** Spanish (Peru) */
  | 'ES_PE'
  /** Spanish (Philippines) */
  | 'ES_PH'
  /** Spanish (Puerto Rico) */
  | 'ES_PR'
  /** Spanish (Paraguay) */
  | 'ES_PY'
  /** Spanish (El Salvador) */
  | 'ES_SV'
  /** Spanish (United States) */
  | 'ES_US'
  /** Spanish (Uruguay) */
  | 'ES_UY'
  /** Spanish (Venezuela) */
  | 'ES_VE'
  /** Estonian */
  | 'ET'
  /** Estonian (Estonia) */
  | 'ET_EE'
  /** Basque */
  | 'EU'
  /** Basque (Spain) */
  | 'EU_ES'
  /** Ewondo */
  | 'EWO'
  /** Ewondo (Cameroon) */
  | 'EWO_CM'
  /** Persian */
  | 'FA'
  /** Persian (Afghanistan) */
  | 'FA_AF'
  /** Persian (Iran) */
  | 'FA_IR'
  /** Fulah */
  | 'FF'
  /** Fulah (Adlam) */
  | 'FF_ADLM'
  /** Fulah (Adlam, Burkina Faso) */
  | 'FF_ADLM_BF'
  /** Fulah (Adlam, Cameroon) */
  | 'FF_ADLM_CM'
  /** Fulah (Adlam, Ghana) */
  | 'FF_ADLM_GH'
  /** Fulah (Adlam, Gambia) */
  | 'FF_ADLM_GM'
  /** Fulah (Adlam, Guinea) */
  | 'FF_ADLM_GN'
  /** Fulah (Adlam, Guinea-Bissau) */
  | 'FF_ADLM_GW'
  /** Fulah (Adlam, Liberia) */
  | 'FF_ADLM_LR'
  /** Fulah (Adlam, Mauritania) */
  | 'FF_ADLM_MR'
  /** Fulah (Adlam, Niger) */
  | 'FF_ADLM_NE'
  /** Fulah (Adlam, Nigeria) */
  | 'FF_ADLM_NG'
  /** Fulah (Adlam, Sierra Leone) */
  | 'FF_ADLM_SL'
  /** Fulah (Adlam, Senegal) */
  | 'FF_ADLM_SN'
  /** Fulah (Latin) */
  | 'FF_LATN'
  /** Fulah (Latin, Burkina Faso) */
  | 'FF_LATN_BF'
  /** Fulah (Latin, Cameroon) */
  | 'FF_LATN_CM'
  /** Fulah (Latin, Ghana) */
  | 'FF_LATN_GH'
  /** Fulah (Latin, Gambia) */
  | 'FF_LATN_GM'
  /** Fulah (Latin, Guinea) */
  | 'FF_LATN_GN'
  /** Fulah (Latin, Guinea-Bissau) */
  | 'FF_LATN_GW'
  /** Fulah (Latin, Liberia) */
  | 'FF_LATN_LR'
  /** Fulah (Latin, Mauritania) */
  | 'FF_LATN_MR'
  /** Fulah (Latin, Niger) */
  | 'FF_LATN_NE'
  /** Fulah (Latin, Nigeria) */
  | 'FF_LATN_NG'
  /** Fulah (Latin, Sierra Leone) */
  | 'FF_LATN_SL'
  /** Fulah (Latin, Senegal) */
  | 'FF_LATN_SN'
  /** Finnish */
  | 'FI'
  /** Filipino */
  | 'FIL'
  /** Filipino (Philippines) */
  | 'FIL_PH'
  /** Finnish (Finland) */
  | 'FI_FI'
  /** Faroese */
  | 'FO'
  /** Faroese (Denmark) */
  | 'FO_DK'
  /** Faroese (Faroe Islands) */
  | 'FO_FO'
  /** French */
  | 'FR'
  /** French (Belgium) */
  | 'FR_BE'
  /** French (Burkina Faso) */
  | 'FR_BF'
  /** French (Burundi) */
  | 'FR_BI'
  /** French (Benin) */
  | 'FR_BJ'
  /** French (St. Barthélemy) */
  | 'FR_BL'
  /** French (Canada) */
  | 'FR_CA'
  /** French (Congo - Kinshasa) */
  | 'FR_CD'
  /** French (Central African Republic) */
  | 'FR_CF'
  /** French (Congo - Brazzaville) */
  | 'FR_CG'
  /** French (Switzerland) */
  | 'FR_CH'
  /** French (Côte d’Ivoire) */
  | 'FR_CI'
  /** French (Cameroon) */
  | 'FR_CM'
  /** French (Djibouti) */
  | 'FR_DJ'
  /** French (Algeria) */
  | 'FR_DZ'
  /** French (France) */
  | 'FR_FR'
  /** French (Gabon) */
  | 'FR_GA'
  /** French (French Guiana) */
  | 'FR_GF'
  /** French (Guinea) */
  | 'FR_GN'
  /** French (Guadeloupe) */
  | 'FR_GP'
  /** French (Equatorial Guinea) */
  | 'FR_GQ'
  /** French (Haiti) */
  | 'FR_HT'
  /** French (Comoros) */
  | 'FR_KM'
  /** French (Luxembourg) */
  | 'FR_LU'
  /** French (Morocco) */
  | 'FR_MA'
  /** French (Monaco) */
  | 'FR_MC'
  /** French (St. Martin) */
  | 'FR_MF'
  /** French (Madagascar) */
  | 'FR_MG'
  /** French (Mali) */
  | 'FR_ML'
  /** French (Martinique) */
  | 'FR_MQ'
  /** French (Mauritania) */
  | 'FR_MR'
  /** French (Mauritius) */
  | 'FR_MU'
  /** French (New Caledonia) */
  | 'FR_NC'
  /** French (Niger) */
  | 'FR_NE'
  /** French (French Polynesia) */
  | 'FR_PF'
  /** French (St. Pierre & Miquelon) */
  | 'FR_PM'
  /** French (Réunion) */
  | 'FR_RE'
  /** French (Rwanda) */
  | 'FR_RW'
  /** French (Seychelles) */
  | 'FR_SC'
  /** French (Senegal) */
  | 'FR_SN'
  /** French (Syria) */
  | 'FR_SY'
  /** French (Chad) */
  | 'FR_TD'
  /** French (Togo) */
  | 'FR_TG'
  /** French (Tunisia) */
  | 'FR_TN'
  /** French (Vanuatu) */
  | 'FR_VU'
  /** French (Wallis & Futuna) */
  | 'FR_WF'
  /** French (Mayotte) */
  | 'FR_YT'
  /** Friulian */
  | 'FUR'
  /** Friulian (Italy) */
  | 'FUR_IT'
  /** Western Frisian */
  | 'FY'
  /** Western Frisian (Netherlands) */
  | 'FY_NL'
  /** Irish */
  | 'GA'
  /** Irish (United Kingdom) */
  | 'GA_GB'
  /** Irish (Ireland) */
  | 'GA_IE'
  /** Scottish Gaelic */
  | 'GD'
  /** Scottish Gaelic (United Kingdom) */
  | 'GD_GB'
  /** Galician */
  | 'GL'
  /** Galician (Spain) */
  | 'GL_ES'
  /** Swiss German */
  | 'GSW'
  /** Swiss German (Switzerland) */
  | 'GSW_CH'
  /** Swiss German (France) */
  | 'GSW_FR'
  /** Swiss German (Liechtenstein) */
  | 'GSW_LI'
  /** Gujarati */
  | 'GU'
  /** Gusii */
  | 'GUZ'
  /** Gusii (Kenya) */
  | 'GUZ_KE'
  /** Gujarati (India) */
  | 'GU_IN'
  /** Manx */
  | 'GV'
  /** Manx (Isle of Man) */
  | 'GV_IM'
  /** Hausa */
  | 'HA'
  /** Hawaiian */
  | 'HAW'
  /** Hawaiian (United States) */
  | 'HAW_US'
  /** Hausa (Ghana) */
  | 'HA_GH'
  /** Hausa (Niger) */
  | 'HA_NE'
  /** Hausa (Nigeria) */
  | 'HA_NG'
  /** Hebrew */
  | 'HE'
  /** Hebrew (Israel) */
  | 'HE_IL'
  /** Hindi */
  | 'HI'
  /** Hindi (India) */
  | 'HI_IN'
  /** Croatian */
  | 'HR'
  /** Croatian (Bosnia & Herzegovina) */
  | 'HR_BA'
  /** Croatian (Croatia) */
  | 'HR_HR'
  /** Upper Sorbian */
  | 'HSB'
  /** Upper Sorbian (Germany) */
  | 'HSB_DE'
  /** Hungarian */
  | 'HU'
  /** Hungarian (Hungary) */
  | 'HU_HU'
  /** Armenian */
  | 'HY'
  /** Armenian (Armenia) */
  | 'HY_AM'
  /** Interlingua */
  | 'IA'
  /** Indonesian */
  | 'ID'
  /** Indonesian (Indonesia) */
  | 'ID_ID'
  /** Igbo */
  | 'IG'
  /** Igbo (Nigeria) */
  | 'IG_NG'
  /** Sichuan Yi */
  | 'II'
  /** Sichuan Yi (China) */
  | 'II_CN'
  /** Icelandic */
  | 'IS'
  /** Icelandic (Iceland) */
  | 'IS_IS'
  /** Italian */
  | 'IT'
  /** Italian (Switzerland) */
  | 'IT_CH'
  /** Italian (Italy) */
  | 'IT_IT'
  /** Italian (San Marino) */
  | 'IT_SM'
  /** Italian (Vatican City) */
  | 'IT_VA'
  /** Japanese */
  | 'JA'
  /** Japanese (Japan) */
  | 'JA_JP'
  /** Ngomba */
  | 'JGO'
  /** Ngomba (Cameroon) */
  | 'JGO_CM'
  /** Machame */
  | 'JMC'
  /** Machame (Tanzania) */
  | 'JMC_TZ'
  /** Javanese */
  | 'JV'
  /** Javanese (Indonesia) */
  | 'JV_ID'
  /** Georgian */
  | 'KA'
  /** Kabyle */
  | 'KAB'
  /** Kabyle (Algeria) */
  | 'KAB_DZ'
  /** Kamba */
  | 'KAM'
  /** Kamba (Kenya) */
  | 'KAM_KE'
  /** Georgian (Georgia) */
  | 'KA_GE'
  /** Makonde */
  | 'KDE'
  /** Makonde (Tanzania) */
  | 'KDE_TZ'
  /** Kabuverdianu */
  | 'KEA'
  /** Kabuverdianu (Cape Verde) */
  | 'KEA_CV'
  /** Koyra Chiini */
  | 'KHQ'
  /** Koyra Chiini (Mali) */
  | 'KHQ_ML'
  /** Kikuyu */
  | 'KI'
  /** Kikuyu (Kenya) */
  | 'KI_KE'
  /** Kazakh */
  | 'KK'
  /** Kako */
  | 'KKJ'
  /** Kako (Cameroon) */
  | 'KKJ_CM'
  /** Kazakh (Kazakhstan) */
  | 'KK_KZ'
  /** Kalaallisut */
  | 'KL'
  /** Kalenjin */
  | 'KLN'
  /** Kalenjin (Kenya) */
  | 'KLN_KE'
  /** Kalaallisut (Greenland) */
  | 'KL_GL'
  /** Khmer */
  | 'KM'
  /** Khmer (Cambodia) */
  | 'KM_KH'
  /** Kannada */
  | 'KN'
  /** Kannada (India) */
  | 'KN_IN'
  /** Korean */
  | 'KO'
  /** Konkani */
  | 'KOK'
  /** Konkani (India) */
  | 'KOK_IN'
  /** Korean (North Korea) */
  | 'KO_KP'
  /** Korean (South Korea) */
  | 'KO_KR'
  /** Kashmiri */
  | 'KS'
  /** Shambala */
  | 'KSB'
  /** Shambala (Tanzania) */
  | 'KSB_TZ'
  /** Bafia */
  | 'KSF'
  /** Bafia (Cameroon) */
  | 'KSF_CM'
  /** Colognian */
  | 'KSH'
  /** Colognian (Germany) */
  | 'KSH_DE'
  /** Kashmiri (Arabic) */
  | 'KS_ARAB'
  /** Kashmiri (Arabic, India) */
  | 'KS_ARAB_IN'
  /** Kurdish */
  | 'KU'
  /** Kurdish (Turkey) */
  | 'KU_TR'
  /** Cornish */
  | 'KW'
  /** Cornish (United Kingdom) */
  | 'KW_GB'
  /** Kyrgyz */
  | 'KY'
  /** Kyrgyz (Kyrgyzstan) */
  | 'KY_KG'
  /** Langi */
  | 'LAG'
  /** Langi (Tanzania) */
  | 'LAG_TZ'
  /** Luxembourgish */
  | 'LB'
  /** Luxembourgish (Luxembourg) */
  | 'LB_LU'
  /** Ganda */
  | 'LG'
  /** Ganda (Uganda) */
  | 'LG_UG'
  /** Lakota */
  | 'LKT'
  /** Lakota (United States) */
  | 'LKT_US'
  /** Lingala */
  | 'LN'
  /** Lingala (Angola) */
  | 'LN_AO'
  /** Lingala (Congo - Kinshasa) */
  | 'LN_CD'
  /** Lingala (Central African Republic) */
  | 'LN_CF'
  /** Lingala (Congo - Brazzaville) */
  | 'LN_CG'
  /** Lao */
  | 'LO'
  /** Lao (Laos) */
  | 'LO_LA'
  /** Northern Luri */
  | 'LRC'
  /** Northern Luri (Iraq) */
  | 'LRC_IQ'
  /** Northern Luri (Iran) */
  | 'LRC_IR'
  /** Lithuanian */
  | 'LT'
  /** Lithuanian (Lithuania) */
  | 'LT_LT'
  /** Luba-Katanga */
  | 'LU'
  /** Luo */
  | 'LUO'
  /** Luo (Kenya) */
  | 'LUO_KE'
  /** Luyia */
  | 'LUY'
  /** Luyia (Kenya) */
  | 'LUY_KE'
  /** Luba-Katanga (Congo - Kinshasa) */
  | 'LU_CD'
  /** Latvian */
  | 'LV'
  /** Latvian (Latvia) */
  | 'LV_LV'
  /** Maithili */
  | 'MAI'
  /** Maithili (India) */
  | 'MAI_IN'
  /** Masai */
  | 'MAS'
  /** Masai (Kenya) */
  | 'MAS_KE'
  /** Masai (Tanzania) */
  | 'MAS_TZ'
  /** Meru */
  | 'MER'
  /** Meru (Kenya) */
  | 'MER_KE'
  /** Morisyen */
  | 'MFE'
  /** Morisyen (Mauritius) */
  | 'MFE_MU'
  /** Malagasy */
  | 'MG'
  /** Makhuwa-Meetto */
  | 'MGH'
  /** Makhuwa-Meetto (Mozambique) */
  | 'MGH_MZ'
  /** Metaʼ */
  | 'MGO'
  /** Metaʼ (Cameroon) */
  | 'MGO_CM'
  /** Malagasy (Madagascar) */
  | 'MG_MG'
  /** Maori */
  | 'MI'
  /** Maori (New Zealand) */
  | 'MI_NZ'
  /** Macedonian */
  | 'MK'
  /** Macedonian (North Macedonia) */
  | 'MK_MK'
  /** Malayalam */
  | 'ML'
  /** Malayalam (India) */
  | 'ML_IN'
  /** Mongolian */
  | 'MN'
  /** Manipuri */
  | 'MNI'
  /** Manipuri (Bangla) */
  | 'MNI_BENG'
  /** Manipuri (Bangla, India) */
  | 'MNI_BENG_IN'
  /** Mongolian (Mongolia) */
  | 'MN_MN'
  /** Marathi */
  | 'MR'
  /** Marathi (India) */
  | 'MR_IN'
  /** Malay */
  | 'MS'
  /** Malay (Brunei) */
  | 'MS_BN'
  /** Malay (Indonesia) */
  | 'MS_ID'
  /** Malay (Malaysia) */
  | 'MS_MY'
  /** Malay (Singapore) */
  | 'MS_SG'
  /** Maltese */
  | 'MT'
  /** Maltese (Malta) */
  | 'MT_MT'
  /** Mundang */
  | 'MUA'
  /** Mundang (Cameroon) */
  | 'MUA_CM'
  /** Burmese */
  | 'MY'
  /** Burmese (Myanmar (Burma)) */
  | 'MY_MM'
  /** Mazanderani */
  | 'MZN'
  /** Mazanderani (Iran) */
  | 'MZN_IR'
  /** Nama */
  | 'NAQ'
  /** Nama (Namibia) */
  | 'NAQ_NA'
  /** Norwegian Bokmål */
  | 'NB'
  /** Norwegian Bokmål (Norway) */
  | 'NB_NO'
  /** Norwegian Bokmål (Svalbard & Jan Mayen) */
  | 'NB_SJ'
  /** North Ndebele */
  | 'ND'
  /** Low German */
  | 'NDS'
  /** Low German (Germany) */
  | 'NDS_DE'
  /** Low German (Netherlands) */
  | 'NDS_NL'
  /** North Ndebele (Zimbabwe) */
  | 'ND_ZW'
  /** Nepali */
  | 'NE'
  /** Nepali (India) */
  | 'NE_IN'
  /** Nepali (Nepal) */
  | 'NE_NP'
  /** Dutch */
  | 'NL'
  /** Dutch (Aruba) */
  | 'NL_AW'
  /** Dutch (Belgium) */
  | 'NL_BE'
  /** Dutch (Caribbean Netherlands) */
  | 'NL_BQ'
  /** Dutch (Curaçao) */
  | 'NL_CW'
  /** Dutch (Netherlands) */
  | 'NL_NL'
  /** Dutch (Suriname) */
  | 'NL_SR'
  /** Dutch (Sint Maarten) */
  | 'NL_SX'
  /** Kwasio */
  | 'NMG'
  /** Kwasio (Cameroon) */
  | 'NMG_CM'
  /** Norwegian Nynorsk */
  | 'NN'
  /** Ngiemboon */
  | 'NNH'
  /** Ngiemboon (Cameroon) */
  | 'NNH_CM'
  /** Norwegian Nynorsk (Norway) */
  | 'NN_NO'
  /** Nuer */
  | 'NUS'
  /** Nuer (South Sudan) */
  | 'NUS_SS'
  /** Nyankole */
  | 'NYN'
  /** Nyankole (Uganda) */
  | 'NYN_UG'
  /** Oromo */
  | 'OM'
  /** Oromo (Ethiopia) */
  | 'OM_ET'
  /** Oromo (Kenya) */
  | 'OM_KE'
  /** Odia */
  | 'OR'
  /** Odia (India) */
  | 'OR_IN'
  /** Ossetic */
  | 'OS'
  /** Ossetic (Georgia) */
  | 'OS_GE'
  /** Ossetic (Russia) */
  | 'OS_RU'
  /** Punjabi */
  | 'PA'
  /** Punjabi (Arabic) */
  | 'PA_ARAB'
  /** Punjabi (Arabic, Pakistan) */
  | 'PA_ARAB_PK'
  /** Punjabi (Gurmukhi) */
  | 'PA_GURU'
  /** Punjabi (Gurmukhi, India) */
  | 'PA_GURU_IN'
  /** Nigerian Pidgin */
  | 'PCM'
  /** Nigerian Pidgin (Nigeria) */
  | 'PCM_NG'
  /** Polish */
  | 'PL'
  /** Polish (Poland) */
  | 'PL_PL'
  /** Prussian */
  | 'PRG'
  /** Pashto */
  | 'PS'
  /** Pashto (Afghanistan) */
  | 'PS_AF'
  /** Pashto (Pakistan) */
  | 'PS_PK'
  /** Portuguese */
  | 'PT'
  /** Portuguese (Angola) */
  | 'PT_AO'
  /** Portuguese (Brazil) */
  | 'PT_BR'
  /** Portuguese (Switzerland) */
  | 'PT_CH'
  /** Portuguese (Cape Verde) */
  | 'PT_CV'
  /** Portuguese (Equatorial Guinea) */
  | 'PT_GQ'
  /** Portuguese (Guinea-Bissau) */
  | 'PT_GW'
  /** Portuguese (Luxembourg) */
  | 'PT_LU'
  /** Portuguese (Macao SAR China) */
  | 'PT_MO'
  /** Portuguese (Mozambique) */
  | 'PT_MZ'
  /** Portuguese (Portugal) */
  | 'PT_PT'
  /** Portuguese (São Tomé & Príncipe) */
  | 'PT_ST'
  /** Portuguese (Timor-Leste) */
  | 'PT_TL'
  /** Quechua */
  | 'QU'
  /** Quechua (Bolivia) */
  | 'QU_BO'
  /** Quechua (Ecuador) */
  | 'QU_EC'
  /** Quechua (Peru) */
  | 'QU_PE'
  /** Romansh */
  | 'RM'
  /** Romansh (Switzerland) */
  | 'RM_CH'
  /** Rundi */
  | 'RN'
  /** Rundi (Burundi) */
  | 'RN_BI'
  /** Romanian */
  | 'RO'
  /** Rombo */
  | 'ROF'
  /** Rombo (Tanzania) */
  | 'ROF_TZ'
  /** Romanian (Moldova) */
  | 'RO_MD'
  /** Romanian (Romania) */
  | 'RO_RO'
  /** Russian */
  | 'RU'
  /** Russian (Belarus) */
  | 'RU_BY'
  /** Russian (Kyrgyzstan) */
  | 'RU_KG'
  /** Russian (Kazakhstan) */
  | 'RU_KZ'
  /** Russian (Moldova) */
  | 'RU_MD'
  /** Russian (Russia) */
  | 'RU_RU'
  /** Russian (Ukraine) */
  | 'RU_UA'
  /** Kinyarwanda */
  | 'RW'
  /** Rwa */
  | 'RWK'
  /** Rwa (Tanzania) */
  | 'RWK_TZ'
  /** Kinyarwanda (Rwanda) */
  | 'RW_RW'
  /** Sakha */
  | 'SAH'
  /** Sakha (Russia) */
  | 'SAH_RU'
  /** Samburu */
  | 'SAQ'
  /** Samburu (Kenya) */
  | 'SAQ_KE'
  /** Santali */
  | 'SAT'
  /** Santali (Ol Chiki) */
  | 'SAT_OLCK'
  /** Santali (Ol Chiki, India) */
  | 'SAT_OLCK_IN'
  /** Sangu */
  | 'SBP'
  /** Sangu (Tanzania) */
  | 'SBP_TZ'
  /** Sindhi */
  | 'SD'
  /** Sindhi (Arabic) */
  | 'SD_ARAB'
  /** Sindhi (Arabic, Pakistan) */
  | 'SD_ARAB_PK'
  /** Sindhi (Devanagari) */
  | 'SD_DEVA'
  /** Sindhi (Devanagari, India) */
  | 'SD_DEVA_IN'
  /** Northern Sami */
  | 'SE'
  /** Sena */
  | 'SEH'
  /** Sena (Mozambique) */
  | 'SEH_MZ'
  /** Koyraboro Senni */
  | 'SES'
  /** Koyraboro Senni (Mali) */
  | 'SES_ML'
  /** Northern Sami (Finland) */
  | 'SE_FI'
  /** Northern Sami (Norway) */
  | 'SE_NO'
  /** Northern Sami (Sweden) */
  | 'SE_SE'
  /** Sango */
  | 'SG'
  /** Sango (Central African Republic) */
  | 'SG_CF'
  /** Tachelhit */
  | 'SHI'
  /** Tachelhit (Latin) */
  | 'SHI_LATN'
  /** Tachelhit (Latin, Morocco) */
  | 'SHI_LATN_MA'
  /** Tachelhit (Tifinagh) */
  | 'SHI_TFNG'
  /** Tachelhit (Tifinagh, Morocco) */
  | 'SHI_TFNG_MA'
  /** Sinhala */
  | 'SI'
  /** Sinhala (Sri Lanka) */
  | 'SI_LK'
  /** Slovak */
  | 'SK'
  /** Slovak (Slovakia) */
  | 'SK_SK'
  /** Slovenian */
  | 'SL'
  /** Slovenian (Slovenia) */
  | 'SL_SI'
  /** Inari Sami */
  | 'SMN'
  /** Inari Sami (Finland) */
  | 'SMN_FI'
  /** Shona */
  | 'SN'
  /** Shona (Zimbabwe) */
  | 'SN_ZW'
  /** Somali */
  | 'SO'
  /** Somali (Djibouti) */
  | 'SO_DJ'
  /** Somali (Ethiopia) */
  | 'SO_ET'
  /** Somali (Kenya) */
  | 'SO_KE'
  /** Somali (Somalia) */
  | 'SO_SO'
  /** Albanian */
  | 'SQ'
  /** Albanian (Albania) */
  | 'SQ_AL'
  /** Albanian (North Macedonia) */
  | 'SQ_MK'
  /** Albanian (Kosovo) */
  | 'SQ_XK'
  /** Serbian */
  | 'SR'
  /** Serbian (Cyrillic) */
  | 'SR_CYRL'
  /** Serbian (Cyrillic, Bosnia & Herzegovina) */
  | 'SR_CYRL_BA'
  /** Serbian (Cyrillic, Montenegro) */
  | 'SR_CYRL_ME'
  /** Serbian (Cyrillic, Serbia) */
  | 'SR_CYRL_RS'
  /** Serbian (Cyrillic, Kosovo) */
  | 'SR_CYRL_XK'
  /** Serbian (Latin) */
  | 'SR_LATN'
  /** Serbian (Latin, Bosnia & Herzegovina) */
  | 'SR_LATN_BA'
  /** Serbian (Latin, Montenegro) */
  | 'SR_LATN_ME'
  /** Serbian (Latin, Serbia) */
  | 'SR_LATN_RS'
  /** Serbian (Latin, Kosovo) */
  | 'SR_LATN_XK'
  /** Sundanese */
  | 'SU'
  /** Sundanese (Latin) */
  | 'SU_LATN'
  /** Sundanese (Latin, Indonesia) */
  | 'SU_LATN_ID'
  /** Swedish */
  | 'SV'
  /** Swedish (Åland Islands) */
  | 'SV_AX'
  /** Swedish (Finland) */
  | 'SV_FI'
  /** Swedish (Sweden) */
  | 'SV_SE'
  /** Swahili */
  | 'SW'
  /** Swahili (Congo - Kinshasa) */
  | 'SW_CD'
  /** Swahili (Kenya) */
  | 'SW_KE'
  /** Swahili (Tanzania) */
  | 'SW_TZ'
  /** Swahili (Uganda) */
  | 'SW_UG'
  /** Tamil */
  | 'TA'
  /** Tamil (India) */
  | 'TA_IN'
  /** Tamil (Sri Lanka) */
  | 'TA_LK'
  /** Tamil (Malaysia) */
  | 'TA_MY'
  /** Tamil (Singapore) */
  | 'TA_SG'
  /** Telugu */
  | 'TE'
  /** Teso */
  | 'TEO'
  /** Teso (Kenya) */
  | 'TEO_KE'
  /** Teso (Uganda) */
  | 'TEO_UG'
  /** Telugu (India) */
  | 'TE_IN'
  /** Tajik */
  | 'TG'
  /** Tajik (Tajikistan) */
  | 'TG_TJ'
  /** Thai */
  | 'TH'
  /** Thai (Thailand) */
  | 'TH_TH'
  /** Tigrinya */
  | 'TI'
  /** Tigrinya (Eritrea) */
  | 'TI_ER'
  /** Tigrinya (Ethiopia) */
  | 'TI_ET'
  /** Turkmen */
  | 'TK'
  /** Turkmen (Turkmenistan) */
  | 'TK_TM'
  /** Tongan */
  | 'TO'
  /** Tongan (Tonga) */
  | 'TO_TO'
  /** Turkish */
  | 'TR'
  /** Turkish (Cyprus) */
  | 'TR_CY'
  /** Turkish (Turkey) */
  | 'TR_TR'
  /** Tatar */
  | 'TT'
  /** Tatar (Russia) */
  | 'TT_RU'
  /** Tasawaq */
  | 'TWQ'
  /** Tasawaq (Niger) */
  | 'TWQ_NE'
  /** Central Atlas Tamazight */
  | 'TZM'
  /** Central Atlas Tamazight (Morocco) */
  | 'TZM_MA'
  /** Uyghur */
  | 'UG'
  /** Uyghur (China) */
  | 'UG_CN'
  /** Ukrainian */
  | 'UK'
  /** Ukrainian (Ukraine) */
  | 'UK_UA'
  /** Urdu */
  | 'UR'
  /** Urdu (India) */
  | 'UR_IN'
  /** Urdu (Pakistan) */
  | 'UR_PK'
  /** Uzbek */
  | 'UZ'
  /** Uzbek (Arabic) */
  | 'UZ_ARAB'
  /** Uzbek (Arabic, Afghanistan) */
  | 'UZ_ARAB_AF'
  /** Uzbek (Cyrillic) */
  | 'UZ_CYRL'
  /** Uzbek (Cyrillic, Uzbekistan) */
  | 'UZ_CYRL_UZ'
  /** Uzbek (Latin) */
  | 'UZ_LATN'
  /** Uzbek (Latin, Uzbekistan) */
  | 'UZ_LATN_UZ'
  /** Vai */
  | 'VAI'
  /** Vai (Latin) */
  | 'VAI_LATN'
  /** Vai (Latin, Liberia) */
  | 'VAI_LATN_LR'
  /** Vai (Vai) */
  | 'VAI_VAII'
  /** Vai (Vai, Liberia) */
  | 'VAI_VAII_LR'
  /** Vietnamese */
  | 'VI'
  /** Vietnamese (Vietnam) */
  | 'VI_VN'
  /** Volapük */
  | 'VO'
  /** Vunjo */
  | 'VUN'
  /** Vunjo (Tanzania) */
  | 'VUN_TZ'
  /** Walser */
  | 'WAE'
  /** Walser (Switzerland) */
  | 'WAE_CH'
  /** Wolof */
  | 'WO'
  /** Wolof (Senegal) */
  | 'WO_SN'
  /** Xhosa */
  | 'XH'
  /** Xhosa (South Africa) */
  | 'XH_ZA'
  /** Soga */
  | 'XOG'
  /** Soga (Uganda) */
  | 'XOG_UG'
  /** Yangben */
  | 'YAV'
  /** Yangben (Cameroon) */
  | 'YAV_CM'
  /** Yiddish */
  | 'YI'
  /** Yoruba */
  | 'YO'
  /** Yoruba (Benin) */
  | 'YO_BJ'
  /** Yoruba (Nigeria) */
  | 'YO_NG'
  /** Cantonese */
  | 'YUE'
  /** Cantonese (Simplified) */
  | 'YUE_HANS'
  /** Cantonese (Simplified, China) */
  | 'YUE_HANS_CN'
  /** Cantonese (Traditional) */
  | 'YUE_HANT'
  /** Cantonese (Traditional, Hong Kong SAR China) */
  | 'YUE_HANT_HK'
  /** Standard Moroccan Tamazight */
  | 'ZGH'
  /** Standard Moroccan Tamazight (Morocco) */
  | 'ZGH_MA'
  /** Chinese */
  | 'ZH'
  /** Chinese (Simplified) */
  | 'ZH_HANS'
  /** Chinese (Simplified, China) */
  | 'ZH_HANS_CN'
  /** Chinese (Simplified, Hong Kong SAR China) */
  | 'ZH_HANS_HK'
  /** Chinese (Simplified, Macao SAR China) */
  | 'ZH_HANS_MO'
  /** Chinese (Simplified, Singapore) */
  | 'ZH_HANS_SG'
  /** Chinese (Traditional) */
  | 'ZH_HANT'
  /** Chinese (Traditional, Hong Kong SAR China) */
  | 'ZH_HANT_HK'
  /** Chinese (Traditional, Macao SAR China) */
  | 'ZH_HANT_MO'
  /** Chinese (Traditional, Taiwan) */
  | 'ZH_HANT_TW'
  /** Zulu */
  | 'ZU'
  /** Zulu (South Africa) */
  | 'ZU_ZA';

export type SaleorLanguageDisplay = {
  __typename?: 'LanguageDisplay';
  /** ISO 639 representation of the language name. */
  code: SaleorLanguageCodeEnum;
  /** Full name of the language. */
  language: Scalars['String']['output'];
};

/** Store the current and allowed usage. */
export type SaleorLimitInfo = {
  __typename?: 'LimitInfo';
  /** Defines the allowed maximum resource usage, null means unlimited. */
  allowedUsage: SaleorLimits;
  /** Defines the current resource usage. */
  currentUsage: SaleorLimits;
};

export type SaleorLimits = {
  __typename?: 'Limits';
  /** Defines the number of channels. */
  channels: Maybe<Scalars['Int']['output']>;
  /** Defines the number of order. */
  orders: Maybe<Scalars['Int']['output']>;
  /** Defines the number of product variants. */
  productVariants: Maybe<Scalars['Int']['output']>;
  /** Defines the number of staff users. */
  staffUsers: Maybe<Scalars['Int']['output']>;
  /** Defines the number of warehouses. */
  warehouses: Maybe<Scalars['Int']['output']>;
};

/** Filter input for order lines data. */
export type SaleorLinesFilterInput = {
  /** Filter by metadata fields of order lines. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
};

/**
 * List payment methods stored for the user by payment gateway.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorListStoredPaymentMethods = SaleorEvent & {
  __typename?: 'ListStoredPaymentMethods';
  /** Channel in context which was used to fetch the list of payment methods. */
  channel: SaleorChannel;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user for which the app should return a list of payment methods. */
  user: SaleorUser;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** The manifest definition. */
export type SaleorManifest = {
  __typename?: 'Manifest';
  /** Description of the app displayed in the dashboard. */
  about: Maybe<Scalars['String']['output']>;
  /** App website rendered in the dashboard. */
  appUrl: Maybe<Scalars['String']['output']>;
  /** The audience that will be included in all JWT tokens for the app. */
  audience: Maybe<Scalars['String']['output']>;
  /** The App's author name. */
  author: Maybe<Scalars['String']['output']>;
  /** App's brand data. */
  brand: Maybe<SaleorAppManifestBrand>;
  /**
   * URL to iframe with the configuration for the app.
   * @deprecated Use `appUrl` instead.
   */
  configurationUrl: Maybe<Scalars['String']['output']>;
  /**
   * Description of the data privacy defined for this app.
   * @deprecated Use `dataPrivacyUrl` instead.
   */
  dataPrivacy: Maybe<Scalars['String']['output']>;
  /** URL to the full privacy policy. */
  dataPrivacyUrl: Maybe<Scalars['String']['output']>;
  /** List of extensions that will be mounted in Saleor's dashboard. For details, please [see the extension section.](https://docs.saleor.io/developer/extending/apps/extending-dashboard-with-apps#key-concepts) */
  extensions: Array<SaleorAppManifestExtension>;
  /** External URL to the app homepage. */
  homepageUrl: Maybe<Scalars['String']['output']>;
  /** The identifier of the manifest for the app. */
  identifier: Scalars['String']['output'];
  /** The name of the manifest for the app . */
  name: Scalars['String']['output'];
  /** The array permissions required for the app. */
  permissions: Maybe<Array<SaleorPermission>>;
  /** Determines the app's required Saleor version as semver range. */
  requiredSaleorVersion: Maybe<SaleorAppManifestRequiredSaleorVersion>;
  /** External URL to the page where app users can find support. */
  supportUrl: Maybe<Scalars['String']['output']>;
  /** Endpoint used during process of app installation, [see installing an app.](https://docs.saleor.io/developer/extending/apps/installing-apps#installing-an-app) */
  tokenTargetUrl: Maybe<Scalars['String']['output']>;
  /** The version of the manifest for the app. */
  version: Scalars['String']['output'];
  /** List of the app's webhooks. */
  webhooks: Array<SaleorAppManifestWebhook>;
};

/** Metadata for the Margin class. */
export type SaleorMargin = {
  __typename?: 'Margin';
  /** The starting value of the margin. */
  start: Maybe<Scalars['Int']['output']>;
  /** The ending value of the margin. */
  stop: Maybe<Scalars['Int']['output']>;
};

/**
 * Determine the mark as paid strategy for the channel.
 *
 *     TRANSACTION_FLOW - new orders marked as paid will receive a
 *     `TransactionItem` object, that will cover the `order.total`.
 *
 *     PAYMENT_FLOW - new orders marked as paid will receive a
 *     `Payment` object, that will cover the `order.total`.
 *
 *
 */
export type SaleorMarkAsPaidStrategyEnum =
  | 'PAYMENT_FLOW'
  | 'TRANSACTION_FLOW';

export type SaleorMeasurementUnitsEnum =
  | 'ACRE_FT'
  | 'ACRE_IN'
  | 'CM'
  | 'CUBIC_CENTIMETER'
  | 'CUBIC_DECIMETER'
  | 'CUBIC_FOOT'
  | 'CUBIC_INCH'
  | 'CUBIC_METER'
  | 'CUBIC_MILLIMETER'
  | 'CUBIC_YARD'
  | 'DM'
  | 'FL_OZ'
  | 'FT'
  | 'G'
  | 'INCH'
  | 'KG'
  | 'KM'
  | 'LB'
  | 'LITER'
  | 'M'
  | 'MM'
  | 'OZ'
  | 'PINT'
  | 'QT'
  | 'SQ_CM'
  | 'SQ_DM'
  | 'SQ_FT'
  | 'SQ_INCH'
  | 'SQ_KM'
  | 'SQ_M'
  | 'SQ_MM'
  | 'SQ_YD'
  | 'TONNE'
  | 'YD';

export type SaleorMeasurementUnitsEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorMeasurementUnitsEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorMeasurementUnitsEnum>>;
};

export type SaleorMediaChoicesSortField =
  /** Sort media by ID. */
  | 'ID';

export type SaleorMediaInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Represents an image file in a multipart request. */
  image?: InputMaybe<Scalars['Upload']['input']>;
  /** Represents an URL to an external media. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMediaSortingInput = {
  /** Specifies the direction in which to sort media. */
  direction: SaleorOrderDirection;
  /** Sort media by the selected field. */
  field: SaleorMediaChoicesSortField;
};

/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenu = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Menu';
  /** The ID of the menu. */
  id: Scalars['ID']['output'];
  /** Menu items associated with this menu. */
  items: Maybe<Array<SaleorMenuItem>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** The name of the menu. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Slug of the menu. */
  slug: Scalars['String']['output'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenuMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenuMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenuPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenuPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_DELETED (async): A menu was deleted.
 */
export type SaleorMenuBulkDelete = {
  __typename?: 'MenuBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorMenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuCountableConnection = {
  __typename?: 'MenuCountableConnection';
  edges: Array<SaleorMenuCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorMenuCountableEdge = {
  __typename?: 'MenuCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorMenu;
};

/**
 * Creates a new Menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_CREATED (async): A menu was created.
 */
export type SaleorMenuCreate = {
  __typename?: 'MenuCreate';
  errors: Array<SaleorMenuError>;
  menu: Maybe<SaleorMenu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuCreateInput = {
  /** List of menu items. */
  items?: InputMaybe<Array<SaleorMenuItemInput>>;
  /** Name of the menu. */
  name: Scalars['String']['input'];
  /** Slug of the menu. Will be generated if not provided. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new menu is created. */
export type SaleorMenuCreated = SaleorEvent & {
  __typename?: 'MenuCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The menu the event relates to. */
  menu: Maybe<SaleorMenu>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new menu is created. */
export type SaleorMenuCreatedMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_DELETED (async): A menu was deleted.
 */
export type SaleorMenuDelete = {
  __typename?: 'MenuDelete';
  errors: Array<SaleorMenuError>;
  menu: Maybe<SaleorMenu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

/** Event sent when menu is deleted. */
export type SaleorMenuDeleted = SaleorEvent & {
  __typename?: 'MenuDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The menu the event relates to. */
  menu: Maybe<SaleorMenu>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu is deleted. */
export type SaleorMenuDeletedMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuError = {
  __typename?: 'MenuError';
  /** The error code. */
  code: SaleorMenuErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorMenuErrorCode =
  | 'CANNOT_ASSIGN_NODE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_MENU_ITEM'
  | 'NOT_FOUND'
  | 'NO_MENU_ITEM_PROVIDED'
  | 'REQUIRED'
  | 'TOO_MANY_MENU_ITEMS'
  | 'UNIQUE';

export type SaleorMenuFilterInput = {
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorMenuInput = {
  /** Name of the menu. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the menu. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItem = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'MenuItem';
  /** Category associated with the menu item. */
  category: Maybe<SaleorCategory>;
  /** Represents the child items of the current menu item. */
  children: Maybe<Array<SaleorMenuItem>>;
  /** A collection associated with this menu item. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collection: Maybe<SaleorCollection>;
  /** The ID of the menu item. */
  id: Scalars['ID']['output'];
  /** Indicates the position of the menu item within the menu structure. */
  level: Scalars['Int']['output'];
  /** Represents the menu to which the menu item belongs. */
  menu: SaleorMenu;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** The name of the menu item. */
  name: Scalars['String']['output'];
  /** A page associated with this menu item. Requires one of the following permissions to include unpublished items: MANAGE_PAGES. */
  page: Maybe<SaleorPage>;
  /** ID of parent menu item. If empty, menu will be top level menu. */
  parent: Maybe<SaleorMenuItem>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Returns translated menu item fields for the given language code. */
  translation: Maybe<SaleorMenuItemTranslation>;
  /** URL to the menu item. */
  url: Maybe<Scalars['String']['output']>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes menu items.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_DELETED (async): A menu item was deleted.
 */
export type SaleorMenuItemBulkDelete = {
  __typename?: 'MenuItemBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorMenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuItemCountableConnection = {
  __typename?: 'MenuItemCountableConnection';
  edges: Array<SaleorMenuItemCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorMenuItemCountableEdge = {
  __typename?: 'MenuItemCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorMenuItem;
};

/**
 * Creates a new menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_CREATED (async): A menu item was created.
 */
export type SaleorMenuItemCreate = {
  __typename?: 'MenuItemCreate';
  errors: Array<SaleorMenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
  menuItem: Maybe<SaleorMenuItem>;
};

export type SaleorMenuItemCreateInput = {
  /** Category to which item points. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Collection to which item points. */
  collection?: InputMaybe<Scalars['ID']['input']>;
  /** Menu to which item belongs. */
  menu: Scalars['ID']['input'];
  /** Name of the menu item. */
  name: Scalars['String']['input'];
  /** Page to which item points. */
  page?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the parent menu. If empty, menu will be top level menu. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** URL of the pointed item. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new menu item is created. */
export type SaleorMenuItemCreated = SaleorEvent & {
  __typename?: 'MenuItemCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem: Maybe<SaleorMenuItem>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new menu item is created. */
export type SaleorMenuItemCreatedMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_DELETED (async): A menu item was deleted.
 */
export type SaleorMenuItemDelete = {
  __typename?: 'MenuItemDelete';
  errors: Array<SaleorMenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
  menuItem: Maybe<SaleorMenuItem>;
};

/** Event sent when menu item is deleted. */
export type SaleorMenuItemDeleted = SaleorEvent & {
  __typename?: 'MenuItemDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem: Maybe<SaleorMenuItem>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu item is deleted. */
export type SaleorMenuItemDeletedMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuItemFilterInput = {
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuItemInput = {
  /** Category to which item points. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Collection to which item points. */
  collection?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the menu item. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page to which item points. */
  page?: InputMaybe<Scalars['ID']['input']>;
  /** URL of the pointed item. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Moves items of menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_UPDATED (async): Optionally triggered when sort order or parent changed for menu item.
 */
export type SaleorMenuItemMove = {
  __typename?: 'MenuItemMove';
  errors: Array<SaleorMenuError>;
  /** Assigned menu to move within. */
  menu: Maybe<SaleorMenu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuItemMoveInput = {
  /** The menu item ID to move. */
  itemId: Scalars['ID']['input'];
  /** ID of the parent menu. If empty, menu will be top level menu. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorMenuItemSortingInput = {
  /** Specifies the direction in which to sort menu items. */
  direction: SaleorOrderDirection;
  /** Sort menu items by the selected field. */
  field: SaleorMenuItemsSortField;
};

/** Represents menu item's original translatable fields and related translations. */
export type SaleorMenuItemTranslatableContent = SaleorNode & {
  __typename?: 'MenuItemTranslatableContent';
  /** The ID of the menu item translatable content. */
  id: Scalars['ID']['output'];
  /**
   * Represents a single item of the related menu. Can store categories, collection or pages.
   * @deprecated Get model fields from the root level queries.
   */
  menuItem: Maybe<SaleorMenuItem>;
  /** The ID of the menu item to translate. */
  menuItemId: Scalars['ID']['output'];
  /** Name of the menu item to translate. */
  name: Scalars['String']['output'];
  /** Returns translated menu item fields for the given language code. */
  translation: Maybe<SaleorMenuItemTranslation>;
};


/** Represents menu item's original translatable fields and related translations. */
export type SaleorMenuItemTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a menu item.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorMenuItemTranslate = {
  __typename?: 'MenuItemTranslate';
  errors: Array<SaleorTranslationError>;
  menuItem: Maybe<SaleorMenuItem>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

/** Represents menu item translations. */
export type SaleorMenuItemTranslation = SaleorNode & {
  __typename?: 'MenuItemTranslation';
  /** The ID of the menu item translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated menu item name. */
  name: Scalars['String']['output'];
  /** Represents the menu item fields to translate. */
  translatableContent: Maybe<SaleorMenuItemTranslatableContent>;
};

/**
 * Updates a menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_UPDATED (async): A menu item was updated.
 */
export type SaleorMenuItemUpdate = {
  __typename?: 'MenuItemUpdate';
  errors: Array<SaleorMenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
  menuItem: Maybe<SaleorMenuItem>;
};

/** Event sent when menu item is updated. */
export type SaleorMenuItemUpdated = SaleorEvent & {
  __typename?: 'MenuItemUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem: Maybe<SaleorMenuItem>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu item is updated. */
export type SaleorMenuItemUpdatedMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuItemsSortField =
  /** Sort menu items by name. */
  | 'NAME';

export type SaleorMenuSortField =
  /** Sort menus by items count. */
  | 'ITEMS_COUNT'
  /** Sort menus by name. */
  | 'NAME';

export type SaleorMenuSortingInput = {
  /** Specifies the direction in which to sort menus. */
  direction: SaleorOrderDirection;
  /** Sort menus by the selected field. */
  field: SaleorMenuSortField;
};

/**
 * Updates a menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_UPDATED (async): A menu was updated.
 */
export type SaleorMenuUpdate = {
  __typename?: 'MenuUpdate';
  errors: Array<SaleorMenuError>;
  menu: Maybe<SaleorMenu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

/** Event sent when menu is updated. */
export type SaleorMenuUpdated = SaleorEvent & {
  __typename?: 'MenuUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The menu the event relates to. */
  menu: Maybe<SaleorMenu>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu is updated. */
export type SaleorMenuUpdatedMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMetadataError = {
  __typename?: 'MetadataError';
  /** The error code. */
  code: SaleorMetadataErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorMetadataErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'NOT_UPDATED'
  | 'REQUIRED';

export type SaleorMetadataFilter = {
  /** Key of a metadata item. */
  key: Scalars['String']['input'];
  /** Value of a metadata item. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Allows filtering based on metadata key/value pairs.
 *
 *         Examples:
 *         - `{key: "size"}`
 *           Matches objects where the metadata key "size" exists, regardless of its value.
 *         - `{key: "color", value: {oneOf: ["blue", "green"]}}`
 *           Matches objects where the metadata key "color" is set to either "blue" or "green".
 *         - `{key: "status", value: {eq: "active"}}`
 *           Matches objects where the metadata key "status" is set to "active".
 *
 */
export type SaleorMetadataFilterInput = {
  /** Key to filter by. If not other fields provided - checking the existence of the key in metadata. */
  key: Scalars['String']['input'];
  /** Value to filter by. */
  value?: InputMaybe<SaleorMetadataValueFilterInput>;
};

export type SaleorMetadataInput = {
  /** Key of a metadata item. */
  key: Scalars['String']['input'];
  /** Value of a metadata item. */
  value: Scalars['String']['input'];
};

export type SaleorMetadataItem = {
  __typename?: 'MetadataItem';
  /** Key of a metadata item. */
  key: Scalars['String']['output'];
  /** Value of a metadata item. */
  value: Scalars['String']['output'];
};

/** Define the filtering options for metadata value fields. */
export type SaleorMetadataValueFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents amount of money in specific currency. */
export type SaleorMoney = {
  __typename?: 'Money';
  /** Amount of money. */
  amount: Scalars['Float']['output'];
  /** Currency code. */
  currency: Scalars['String']['output'];
  /** Number of digits after the decimal point in the currency. */
  fractionDigits: Scalars['Int']['output'];
  /** Amount of money represented as an integer in the smallest currency unit. */
  fractionalAmount: Scalars['Int']['output'];
};

export type SaleorMoneyInput = {
  /** Amount of money. */
  amount: Scalars['PositiveDecimal']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
};

/** Represents a range of amounts of money. */
export type SaleorMoneyRange = {
  __typename?: 'MoneyRange';
  /** Lower bound of a price range. */
  start: Maybe<SaleorMoney>;
  /** Upper bound of a price range. */
  stop: Maybe<SaleorMoney>;
};

export type SaleorMoveProductInput = {
  /** The ID of the product to move. */
  productId: Scalars['ID']['input'];
  /** The relative sorting position of the product (from -inf to +inf) starting from the first given product's actual position.1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorMutation = {
  __typename?: 'Mutation';
  /**
   * Create a new address for the customer.
   *
   * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - ADDRESS_CREATED (async): An address was created.
   */
  accountAddressCreate: Maybe<SaleorAccountAddressCreate>;
  /**
   * Deletes an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
   *
   * Triggers the following webhook events:
   * - ADDRESS_DELETED (async): An address was deleted.
   */
  accountAddressDelete: Maybe<SaleorAccountAddressDelete>;
  /**
   * Updates an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
   *
   * Triggers the following webhook events:
   * - ADDRESS_UPDATED (async): An address was updated.
   */
  accountAddressUpdate: Maybe<SaleorAccountAddressUpdate>;
  /**
   * Remove user account.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - ACCOUNT_DELETED (async): Account was deleted.
   */
  accountDelete: Maybe<SaleorAccountDelete>;
  /**
   * Register a new user.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_CREATED (async): A new customer account was created.
   * - NOTIFY_USER (async): A notification for account confirmation.
   * - ACCOUNT_CONFIRMATION_REQUESTED (async): An user confirmation was requested. This event is always sent regardless of settings.
   */
  accountRegister: Maybe<SaleorAccountRegister>;
  /**
   * Sends an email with the account removal link for the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for account delete request.
   * - ACCOUNT_DELETE_REQUESTED (async): An account delete requested.
   */
  accountRequestDeletion: Maybe<SaleorAccountRequestDeletion>;
  /**
   * Sets a default address for the authenticated user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer's address was updated.
   */
  accountSetDefaultAddress: Maybe<SaleorAccountSetDefaultAddress>;
  /**
   * Updates the account of the logged-in user.
   *
   * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   */
  accountUpdate: Maybe<SaleorAccountUpdate>;
  /**
   * Creates user address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - ADDRESS_CREATED (async): A new address was created.
   */
  addressCreate: Maybe<SaleorAddressCreate>;
  /**
   * Deletes an address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - ADDRESS_DELETED (async): An address was deleted.
   */
  addressDelete: Maybe<SaleorAddressDelete>;
  /**
   * Sets a default address for the given user.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer was updated.
   */
  addressSetDefault: Maybe<SaleorAddressSetDefault>;
  /**
   * Updates an address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - ADDRESS_UPDATED (async): An address was updated.
   */
  addressUpdate: Maybe<SaleorAddressUpdate>;
  /**
   * Activate the app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_STATUS_CHANGED (async): An app was activated.
   */
  appActivate: Maybe<SaleorAppActivate>;
  /**
   * Creates a new app. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_INSTALLED (async): An app was installed.
   */
  appCreate: Maybe<SaleorAppCreate>;
  /**
   * Deactivate the app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_STATUS_CHANGED (async): An app was deactivated.
   */
  appDeactivate: Maybe<SaleorAppDeactivate>;
  /**
   * Deletes an app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_DELETED (async): An app was deleted.
   */
  appDelete: Maybe<SaleorAppDelete>;
  /**
   * Deletes failed installation.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appDeleteFailedInstallation: Maybe<SaleorAppDeleteFailedInstallation>;
  /**
   * Fetch and validate manifest.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appFetchManifest: Maybe<SaleorAppFetchManifest>;
  /** Install new app by using app manifest. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
  appInstall: Maybe<SaleorAppInstall>;
  /**
   * Add a problem to the calling app.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP.
   */
  appProblemCreate: Maybe<SaleorAppProblemCreate>;
  /**
   * Dismiss problems for an app.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  appProblemDismiss: Maybe<SaleorAppProblemDismiss>;
  /**
   * Re-enable sync webhooks for provided app. Can be used to manually re-enable sync webhooks for the app before the cooldown period ends.
   *
   * Added in Saleor 3.21.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appReenableSyncWebhooks: Maybe<SaleorAppReenableSyncWebhooks>;
  /**
   * Retry failed installation of new app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_INSTALLED (async): An app was installed.
   */
  appRetryInstall: Maybe<SaleorAppRetryInstall>;
  /**
   * Creates a new token.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appTokenCreate: Maybe<SaleorAppTokenCreate>;
  /**
   * Deletes an authentication token assigned to app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appTokenDelete: Maybe<SaleorAppTokenDelete>;
  /** Verify provided app token. */
  appTokenVerify: Maybe<SaleorAppTokenVerify>;
  /**
   * Updates an existing app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_UPDATED (async): An app was updated.
   */
  appUpdate: Maybe<SaleorAppUpdate>;
  /**
   * Assigns storefront's navigation menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS, MANAGE_SETTINGS.
   */
  assignNavigation: Maybe<SaleorAssignNavigation>;
  /**
   * Add shipping zone to given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  assignWarehouseShippingZone: Maybe<SaleorWarehouseShippingZoneAssign>;
  /**
   * Creates attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_CREATED (async): An attribute was created.
   */
  attributeBulkCreate: Maybe<SaleorAttributeBulkCreate>;
  /**
   * Deletes attributes.
   *
   * Requires one of the following permissions, depending on the type of each attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_DELETED (async): An attribute was deleted.
   */
  attributeBulkDelete: Maybe<SaleorAttributeBulkDelete>;
  /**
   * Creates/updates translations for attributes.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeBulkTranslate: Maybe<SaleorAttributeBulkTranslate>;
  /**
   * Updates attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_UPDATED (async): An attribute was updated. Optionally called when new attribute value was created or deleted.
   * - ATTRIBUTE_VALUE_CREATED (async): Called optionally when an attribute value was created.
   * - ATTRIBUTE_VALUE_DELETED (async): Called optionally when an attribute value was deleted.
   */
  attributeBulkUpdate: Maybe<SaleorAttributeBulkUpdate>;
  /**
   * Creates an attribute.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_CREATED (async): An attribute was created.
   */
  attributeCreate: Maybe<SaleorAttributeCreate>;
  /**
   * Deletes an attribute.
   *
   * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_DELETED (async): An attribute was deleted.
   */
  attributeDelete: Maybe<SaleorAttributeDelete>;
  /**
   * Reorder the values of an attribute.
   *
   * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeReorderValues: Maybe<SaleorAttributeReorderValues>;
  /**
   * Creates/updates translations for an attribute.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeTranslate: Maybe<SaleorAttributeTranslate>;
  /**
   * Updates attribute.
   *
   * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeUpdate: Maybe<SaleorAttributeUpdate>;
  /**
   * Deletes values of attributes.
   *
   * Requires one of the following permissions, depending on the type of each value's attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueBulkDelete: Maybe<SaleorAttributeValueBulkDelete>;
  /**
   * Creates/updates translations for attribute values.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeValueBulkTranslate: Maybe<SaleorAttributeValueBulkTranslate>;
  /**
   * Creates a value for an attribute.
   *
   * Requires one of the following permissions, depending on the attribute type: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_CREATED (async): An attribute value was created.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueCreate: Maybe<SaleorAttributeValueCreate>;
  /**
   * Deletes a value of an attribute.
   *
   * Requires one of the following permissions, depending on the type of the value's attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueDelete: Maybe<SaleorAttributeValueDelete>;
  /**
   * Creates/updates translations for an attribute value.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeValueTranslate: Maybe<SaleorAttributeValueTranslate>;
  /**
   * Updates value of an attribute.
   *
   * Requires one of the following permissions, depending on the type of the value's attribute: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES for `PRODUCT_TYPE` attributes, MANAGE_PAGE_TYPES_AND_ATTRIBUTES for `PAGE_TYPE` attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueUpdate: Maybe<SaleorAttributeValueUpdate>;
  /**
   * Deletes categories.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryBulkDelete: Maybe<SaleorCategoryBulkDelete>;
  /**
   * Creates a new category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryCreate: Maybe<SaleorCategoryCreate>;
  /**
   * Deletes a category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryDelete: Maybe<SaleorCategoryDelete>;
  /**
   * Creates/updates translations for a category.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  categoryTranslate: Maybe<SaleorCategoryTranslate>;
  /**
   * Updates a category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryUpdate: Maybe<SaleorCategoryUpdate>;
  /**
   * Activate a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_STATUS_CHANGED (async): A channel was activated.
   */
  channelActivate: Maybe<SaleorChannelActivate>;
  /**
   * Creates a new channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_CREATED (async): A channel was created.
   */
  channelCreate: Maybe<SaleorChannelCreate>;
  /**
   * Deactivate a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_STATUS_CHANGED (async): A channel was deactivated.
   */
  channelDeactivate: Maybe<SaleorChannelDeactivate>;
  /**
   * Deletes a channel. Orders associated with the deleted channel will be moved to the target channel. Checkouts, product availability, and pricing will be removed.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_DELETED (async): A channel was deleted.
   */
  channelDelete: Maybe<SaleorChannelDelete>;
  /**
   * Reorder the warehouses of a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  channelReorderWarehouses: Maybe<SaleorChannelReorderWarehouses>;
  /**
   * Update a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   * Requires one of the following permissions when updating only `orderSettings` field: `MANAGE_CHANNELS`, `MANAGE_ORDERS`.
   * Requires one of the following permissions when updating only `checkoutSettings` field: `MANAGE_CHANNELS`, `MANAGE_CHECKOUTS`.
   * Requires one of the following permissions when updating only `paymentSettings` field: `MANAGE_CHANNELS`, `HANDLE_PAYMENTS`.
   *
   * Triggers the following webhook events:
   * - CHANNEL_UPDATED (async): A channel was updated.
   * - CHANNEL_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
   */
  channelUpdate: Maybe<SaleorChannelUpdate>;
  /**
   * Adds a gift card or a voucher to a checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutAddPromoCode: Maybe<SaleorCheckoutAddPromoCode>;
  /**
   * Updates billing address in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutBillingAddressUpdate: Maybe<SaleorCheckoutBillingAddressUpdate>;
  /**
   * Completes the checkout. As a result a new order is created. The mutation allows to create the unpaid order when setting `orderSettings.allowUnpaidOrders` for given `Channel` is set to `true`. When `orderSettings.allowUnpaidOrders` is set to `false`, checkout can be completed only when attached `Payment`/`TransactionItem`s fully cover the checkout's total. When processing the checkout with `Payment`, in case of required additional confirmation step like 3D secure, the `confirmationNeeded` flag will be set to True and no order will be created until payment is confirmed with second call of this mutation.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   * - ORDER_CREATED (async): Triggered when order is created.
   * - NOTIFY_USER (async): A notification for order placement.
   * - NOTIFY_USER (async): A staff notification for order placement.
   * - ORDER_UPDATED (async): Triggered when order received the update after placement.
   * - ORDER_PAID (async): Triggered when newly created order is paid.
   * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
   * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
   */
  checkoutComplete: Maybe<SaleorCheckoutComplete>;
  /**
   * Create a new checkout.
   *
   * `skipValidation` field requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CREATED (async): A checkout was created.
   */
  checkoutCreate: Maybe<SaleorCheckoutCreate>;
  /** Creates a new checkout from existing order. */
  checkoutCreateFromOrder: Maybe<SaleorCheckoutCreateFromOrder>;
  /**
   * Sets the customer as the owner of the checkout.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutCustomerAttach: Maybe<SaleorCheckoutCustomerAttach>;
  /**
   * Removes the user assigned as the owner of the checkout.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutCustomerDetach: Maybe<SaleorCheckoutCustomerDetach>;
  /**
   * Updates customer note in the existing checkout object.
   *
   * Added in Saleor 3.21.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutCustomerNoteUpdate: Maybe<SaleorCheckoutCustomerNoteUpdate>;
  /**
   * Updates the delivery method (shipping method or pick up point) of the checkout. Updates the checkout shipping_address for click and collect delivery for a warehouse address.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout delivery method with the external one.
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutDeliveryMethodUpdate: Maybe<SaleorCheckoutDeliveryMethodUpdate>;
  /**
   * Updates email address in the existing checkout object.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutEmailUpdate: Maybe<SaleorCheckoutEmailUpdate>;
  /**
   * Updates language code in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLanguageCodeUpdate: Maybe<SaleorCheckoutLanguageCodeUpdate>;
  /**
   * Deletes a CheckoutLine.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   * @deprecated Use `checkoutLinesDelete` instead.
   */
  checkoutLineDelete: Maybe<SaleorCheckoutLineDelete>;
  /**
   * Adds a checkout line to the existing checkout.If line was already in checkout, its quantity will be increased.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLinesAdd: Maybe<SaleorCheckoutLinesAdd>;
  /**
   * Deletes checkout lines.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLinesDelete: Maybe<SaleorCheckoutLinesDelete>;
  /**
   * Updates checkout line in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLinesUpdate: Maybe<SaleorCheckoutLinesUpdate>;
  /**
   * Creates a new payment for given checkout.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  checkoutPaymentCreate: Maybe<SaleorCheckoutPaymentCreate>;
  /**
   * Remove a gift card or a voucher from a checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutRemovePromoCode: Maybe<SaleorCheckoutRemovePromoCode>;
  /**
   * Updates shipping address in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutShippingAddressUpdate: Maybe<SaleorCheckoutShippingAddressUpdate>;
  /**
   * Updates the shipping method of the checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout shipping method with the external one.
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   * @deprecated Use `checkoutDeliveryMethodUpdate` instead.
   */
  checkoutShippingMethodUpdate: Maybe<SaleorCheckoutShippingMethodUpdate>;
  /**
   * Adds products to a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionAddProducts: Maybe<SaleorCollectionAddProducts>;
  /**
   * Deletes collections.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionBulkDelete: Maybe<SaleorCollectionBulkDelete>;
  /**
   * Manage collection's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionChannelListingUpdate: Maybe<SaleorCollectionChannelListingUpdate>;
  /**
   * Creates a new collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionCreate: Maybe<SaleorCollectionCreate>;
  /**
   * Deletes a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionDelete: Maybe<SaleorCollectionDelete>;
  /**
   * Remove products from a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionRemoveProducts: Maybe<SaleorCollectionRemoveProducts>;
  /**
   * Reorder the products of a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionReorderProducts: Maybe<SaleorCollectionReorderProducts>;
  /**
   * Creates/updates translations for a collection.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  collectionTranslate: Maybe<SaleorCollectionTranslate>;
  /**
   * Updates a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionUpdate: Maybe<SaleorCollectionUpdate>;
  /**
   * Confirm user account with token sent by email during registration.
   *
   * Triggers the following webhook events:
   * - ACCOUNT_CONFIRMED (async): Account was confirmed.
   */
  confirmAccount: Maybe<SaleorConfirmAccount>;
  /**
   * Confirm the email change of the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - NOTIFY_USER (async): A notification that account email change was confirmed.
   * - ACCOUNT_EMAIL_CHANGED (async): An account email was changed.
   */
  confirmEmailChange: Maybe<SaleorConfirmEmailChange>;
  /**
   * Creates a new warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  createWarehouse: Maybe<SaleorWarehouseCreate>;
  /**
   * Deletes customers.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_DELETED (async): A customer account was deleted.
   */
  customerBulkDelete: Maybe<SaleorCustomerBulkDelete>;
  /**
   * Updates customers.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   */
  customerBulkUpdate: Maybe<SaleorCustomerBulkUpdate>;
  /**
   * Creates a new customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_CREATED (async): A new customer account was created.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   * - NOTIFY_USER (async): A notification for setting the password.
   * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
   */
  customerCreate: Maybe<SaleorCustomerCreate>;
  /**
   * Deletes a customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_DELETED (async): A customer account was deleted.
   */
  customerDelete: Maybe<SaleorCustomerDelete>;
  /**
   * Updates an existing customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A new customer account was updated.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   */
  customerUpdate: Maybe<SaleorCustomerUpdate>;
  /** Delete metadata of an object. To use it, you need to have access to the modified object. */
  deleteMetadata: Maybe<SaleorDeleteMetadata>;
  /** Delete object's private metadata. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
  deletePrivateMetadata: Maybe<SaleorDeletePrivateMetadata>;
  /**
   * Deletes selected warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  deleteWarehouse: Maybe<SaleorWarehouseDelete>;
  /**
   * Create new digital content. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentCreate: Maybe<SaleorDigitalContentCreate>;
  /**
   * Remove digital content assigned to given variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentDelete: Maybe<SaleorDigitalContentDelete>;
  /**
   * Updates digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentUpdate: Maybe<SaleorDigitalContentUpdate>;
  /**
   * Generate new URL to digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentUrlCreate: Maybe<SaleorDigitalContentUrlCreate>;
  /**
   * Deletes draft orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderBulkDelete: Maybe<SaleorDraftOrderBulkDelete>;
  /**
   * Completes creating an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderComplete: Maybe<SaleorDraftOrderComplete>;
  /**
   * Creates a new draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderCreate: Maybe<SaleorDraftOrderCreate>;
  /**
   * Deletes a draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderDelete: Maybe<SaleorDraftOrderDelete>;
  /**
   * Deletes order lines.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Field no longer supported
   */
  draftOrderLinesBulkDelete: Maybe<SaleorDraftOrderLinesBulkDelete>;
  /**
   * Updates a draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderUpdate: Maybe<SaleorDraftOrderUpdate>;
  /**
   * Retries event delivery.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  eventDeliveryRetry: Maybe<SaleorEventDeliveryRetry>;
  /**
   * Export gift cards to csv file.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for the exported file.
   * - GIFT_CARD_EXPORT_COMPLETED (async): A notification for the exported file.
   */
  exportGiftCards: Maybe<SaleorExportGiftCards>;
  /**
   * Export products to csv file.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for the exported file.
   * - PRODUCT_EXPORT_COMPLETED (async): A notification for the exported file.
   */
  exportProducts: Maybe<SaleorExportProducts>;
  /**
   * Export voucher codes to csv/xlsx file.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_CODE_EXPORT_COMPLETED (async): A notification for the exported file.
   */
  exportVoucherCodes: Maybe<SaleorExportVoucherCodes>;
  /** Prepare external authentication URL for user by custom plugin. */
  externalAuthenticationUrl: Maybe<SaleorExternalAuthenticationUrl>;
  /** Logout user by custom plugin. */
  externalLogout: Maybe<SaleorExternalLogout>;
  /**
   * Trigger sending a notification with the notify plugin method. Serializes nodes provided as ids parameter and includes this data in the notification payload.
   * @deprecated Field no longer supported
   */
  externalNotificationTrigger: Maybe<SaleorExternalNotificationTrigger>;
  /** Obtain external access tokens for user by custom plugin. */
  externalObtainAccessTokens: Maybe<SaleorExternalObtainAccessTokens>;
  /** Refresh user's access by custom plugin. */
  externalRefresh: Maybe<SaleorExternalRefresh>;
  /** Verify external authentication data by plugin. */
  externalVerify: Maybe<SaleorExternalVerify>;
  /**
   * Upload a file. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  fileUpload: Maybe<SaleorFileUpload>;
  /**
   * Activate a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
   */
  giftCardActivate: Maybe<SaleorGiftCardActivate>;
  /**
   * Adds note to the gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_UPDATED (async): A gift card was updated.
   */
  giftCardAddNote: Maybe<SaleorGiftCardAddNote>;
  /**
   * Activate gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
   */
  giftCardBulkActivate: Maybe<SaleorGiftCardBulkActivate>;
  /**
   * Creates gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_CREATED (async): A gift card was created.
   * - NOTIFY_USER (async): A notification for created gift card.
   */
  giftCardBulkCreate: Maybe<SaleorGiftCardBulkCreate>;
  /**
   * Deactivate gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
   */
  giftCardBulkDeactivate: Maybe<SaleorGiftCardBulkDeactivate>;
  /**
   * Deletes gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_DELETED (async): A gift card was deleted.
   */
  giftCardBulkDelete: Maybe<SaleorGiftCardBulkDelete>;
  /**
   * Creates a new gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_CREATED (async): A gift card was created.
   * - NOTIFY_USER (async): A notification for created gift card.
   */
  giftCardCreate: Maybe<SaleorGiftCardCreate>;
  /**
   * Deactivate a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
   */
  giftCardDeactivate: Maybe<SaleorGiftCardDeactivate>;
  /**
   * Deletes gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_DELETED (async): A gift card was deleted.
   */
  giftCardDelete: Maybe<SaleorGiftCardDelete>;
  /**
   * Resend a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for gift card resend.
   */
  giftCardResend: Maybe<SaleorGiftCardResend>;
  /**
   * Update gift card settings.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardSettingsUpdate: Maybe<SaleorGiftCardSettingsUpdate>;
  /**
   * Update a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_UPDATED (async): A gift card was updated.
   */
  giftCardUpdate: Maybe<SaleorGiftCardUpdate>;
  /**
   * Creates a ready to send invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  invoiceCreate: Maybe<SaleorInvoiceCreate>;
  /**
   * Deletes an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  invoiceDelete: Maybe<SaleorInvoiceDelete>;
  /**
   * Request an invoice for the order using plugin.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - INVOICE_REQUESTED (async): An invoice was requested.
   */
  invoiceRequest: Maybe<SaleorInvoiceRequest>;
  /**
   * Requests deletion of an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - INVOICE_DELETED (async): An invoice was requested to delete.
   */
  invoiceRequestDelete: Maybe<SaleorInvoiceRequestDelete>;
  /**
   * Send an invoice notification to the customer.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - INVOICE_SENT (async): A notification for invoice send
   * - NOTIFY_USER (async): A notification for invoice send
   */
  invoiceSendNotification: Maybe<SaleorInvoiceSendNotification>;
  /**
   * Updates an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  invoiceUpdate: Maybe<SaleorInvoiceUpdate>;
  /**
   * Deletes menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_DELETED (async): A menu was deleted.
   */
  menuBulkDelete: Maybe<SaleorMenuBulkDelete>;
  /**
   * Creates a new Menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_CREATED (async): A menu was created.
   */
  menuCreate: Maybe<SaleorMenuCreate>;
  /**
   * Deletes a menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_DELETED (async): A menu was deleted.
   */
  menuDelete: Maybe<SaleorMenuDelete>;
  /**
   * Deletes menu items.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_DELETED (async): A menu item was deleted.
   */
  menuItemBulkDelete: Maybe<SaleorMenuItemBulkDelete>;
  /**
   * Creates a new menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_CREATED (async): A menu item was created.
   */
  menuItemCreate: Maybe<SaleorMenuItemCreate>;
  /**
   * Deletes a menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_DELETED (async): A menu item was deleted.
   */
  menuItemDelete: Maybe<SaleorMenuItemDelete>;
  /**
   * Moves items of menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_UPDATED (async): Optionally triggered when sort order or parent changed for menu item.
   */
  menuItemMove: Maybe<SaleorMenuItemMove>;
  /**
   * Creates/updates translations for a menu item.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  menuItemTranslate: Maybe<SaleorMenuItemTranslate>;
  /**
   * Updates a menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_UPDATED (async): A menu item was updated.
   */
  menuItemUpdate: Maybe<SaleorMenuItemUpdate>;
  /**
   * Updates a menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_UPDATED (async): A menu was updated.
   */
  menuUpdate: Maybe<SaleorMenuUpdate>;
  /**
   * Adds note to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Use `orderNoteAdd` instead.
   */
  orderAddNote: Maybe<SaleorOrderAddNote>;
  /**
   * Cancels orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderBulkCancel: Maybe<SaleorOrderBulkCancel>;
  /**
   * Creates multiple orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS_IMPORT.
   */
  orderBulkCreate: Maybe<SaleorOrderBulkCreate>;
  /**
   * Cancel an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderCancel: Maybe<SaleorOrderCancel>;
  /**
   * Capture an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  orderCapture: Maybe<SaleorOrderCapture>;
  /**
   * Confirms an unconfirmed order by changing status to unfulfilled.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderConfirm: Maybe<SaleorOrderConfirm>;
  /**
   * Create new order from existing checkout. Requires the following permissions: AUTHENTICATED_APP and HANDLE_CHECKOUTS.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   * - ORDER_CREATED (async): Triggered when order is created.
   * - NOTIFY_USER (async): A notification for order placement.
   * - NOTIFY_USER (async): A staff notification for order placement.
   * - ORDER_UPDATED (async): Triggered when order received the update after placement.
   * - ORDER_PAID (async): Triggered when newly created order is paid.
   * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
   * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
   */
  orderCreateFromCheckout: Maybe<SaleorOrderCreateFromCheckout>;
  /**
   * Adds discount to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderDiscountAdd: Maybe<SaleorOrderDiscountAdd>;
  /**
   * Remove discount from the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderDiscountDelete: Maybe<SaleorOrderDiscountDelete>;
  /**
   * Update discount for the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderDiscountUpdate: Maybe<SaleorOrderDiscountUpdate>;
  /**
   * Creates new fulfillments for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - FULFILLMENT_CREATED (async): A new fulfillment is created.
   * - ORDER_FULFILLED (async): Order is fulfilled.
   * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Sent when fulfillment tracking number is updated.
   * - FULFILLMENT_APPROVED (async): A fulfillment is approved.
   */
  orderFulfill: Maybe<SaleorOrderFulfill>;
  /**
   * Approve existing fulfillment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - FULFILLMENT_APPROVED (async): Fulfillment is approved.
   */
  orderFulfillmentApprove: Maybe<SaleorFulfillmentApprove>;
  /**
   * Cancels existing fulfillment and optionally restocks items.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderFulfillmentCancel: Maybe<SaleorFulfillmentCancel>;
  /**
   * Refund products.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderFulfillmentRefundProducts: Maybe<SaleorFulfillmentRefundProducts>;
  /**
   * Return products.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderFulfillmentReturnProducts: Maybe<SaleorFulfillmentReturnProducts>;
  /**
   * Updates a fulfillment for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Fulfillment tracking number is updated.
   */
  orderFulfillmentUpdateTracking: Maybe<SaleorFulfillmentUpdateTracking>;
  /**
   * Adds granted refund to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderGrantRefundCreate: Maybe<SaleorOrderGrantRefundCreate>;
  /**
   * Updates granted refund.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderGrantRefundUpdate: Maybe<SaleorOrderGrantRefundUpdate>;
  /**
   * Deletes an order line from an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineDelete: Maybe<SaleorOrderLineDelete>;
  /**
   * Remove discount applied to the order line.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineDiscountRemove: Maybe<SaleorOrderLineDiscountRemove>;
  /**
   * Update discount for the order line.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineDiscountUpdate: Maybe<SaleorOrderLineDiscountUpdate>;
  /**
   * Updates an order line of an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineUpdate: Maybe<SaleorOrderLineUpdate>;
  /**
   * Creates order lines for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLinesCreate: Maybe<SaleorOrderLinesCreate>;
  /**
   * Mark order as manually paid.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderMarkAsPaid: Maybe<SaleorOrderMarkAsPaid>;
  /**
   * Adds note to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderNoteAdd: Maybe<SaleorOrderNoteAdd>;
  /**
   * Updates note of an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderNoteUpdate: Maybe<SaleorOrderNoteUpdate>;
  /**
   * Refund an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  orderRefund: Maybe<SaleorOrderRefund>;
  /**
   * Update shop order settings across all channels. Returns `orderSettings` for the first `channel` in alphabetical order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Use `channelUpdate` mutation instead.
   */
  orderSettingsUpdate: Maybe<SaleorOrderSettingsUpdate>;
  /**
   * Updates an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderUpdate: Maybe<SaleorOrderUpdate>;
  /**
   * Updates a shipping method of the order. Requires shipping method ID to update, when null is passed then currently assigned shipping method is removed.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderUpdateShipping: Maybe<SaleorOrderUpdateShipping>;
  /**
   * Void an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  orderVoid: Maybe<SaleorOrderVoid>;
  /**
   * Assign attributes to a given page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageAttributeAssign: Maybe<SaleorPageAttributeAssign>;
  /**
   * Unassign attributes from a given page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageAttributeUnassign: Maybe<SaleorPageAttributeUnassign>;
  /**
   * Deletes pages.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageBulkDelete: Maybe<SaleorPageBulkDelete>;
  /**
   * Publish pages.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageBulkPublish: Maybe<SaleorPageBulkPublish>;
  /**
   * Creates a new page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageCreate: Maybe<SaleorPageCreate>;
  /**
   * Deletes a page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageDelete: Maybe<SaleorPageDelete>;
  /**
   * Reorder page attribute values.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageReorderAttributeValues: Maybe<SaleorPageReorderAttributeValues>;
  /**
   * Creates/updates translations for a page.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  pageTranslate: Maybe<SaleorPageTranslate>;
  /**
   * Deletes page types.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeBulkDelete: Maybe<SaleorPageTypeBulkDelete>;
  /**
   * Creates a new page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeCreate: Maybe<SaleorPageTypeCreate>;
  /**
   * Deletes a page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeDelete: Maybe<SaleorPageTypeDelete>;
  /**
   * Reorder the attributes of a page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeReorderAttributes: Maybe<SaleorPageTypeReorderAttributes>;
  /**
   * Updates page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeUpdate: Maybe<SaleorPageTypeUpdate>;
  /**
   * Updates an existing page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageUpdate: Maybe<SaleorPageUpdate>;
  /**
   * Change the password of the logged in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  passwordChange: Maybe<SaleorPasswordChange>;
  /**
   * Captures the authorized payment amount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  paymentCapture: Maybe<SaleorPaymentCapture>;
  /**
   * Check payment balance.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  paymentCheckBalance: Maybe<SaleorPaymentCheckBalance>;
  /** Initializes a payment gateway session. It triggers the webhook `PAYMENT_GATEWAY_INITIALIZE_SESSION`, to the requested `paymentGateways`. If `paymentGateways` is not provided, the webhook will be send to all subscribed payment gateways. There is a limit of 100 transaction items per checkout / order. */
  paymentGatewayInitialize: Maybe<SaleorPaymentGatewayInitialize>;
  /**
   * Initializes payment gateway for tokenizing payment method session.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to initialize payment gateway for tokenization.
   */
  paymentGatewayInitializeTokenization: Maybe<SaleorPaymentGatewayInitializeTokenization>;
  /**
   * Initializes payment process when it is required by gateway.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  paymentInitialize: Maybe<SaleorPaymentInitialize>;
  /**
   * Tokenize payment method.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to tokenize payment method.
   */
  paymentMethodInitializeTokenization: Maybe<SaleorPaymentMethodInitializeTokenization>;
  /**
   * Tokenize payment method.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION (sync): The customer continues payment method tokenization.
   */
  paymentMethodProcessTokenization: Maybe<SaleorPaymentMethodProcessTokenization>;
  /**
   * Refunds the captured payment amount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  paymentRefund: Maybe<SaleorPaymentRefund>;
  /**
   * Voids the authorized payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  paymentVoid: Maybe<SaleorPaymentVoid>;
  /**
   * Create new permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - PERMISSION_GROUP_CREATED (async)
   */
  permissionGroupCreate: Maybe<SaleorPermissionGroupCreate>;
  /**
   * Delete permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - PERMISSION_GROUP_DELETED (async)
   */
  permissionGroupDelete: Maybe<SaleorPermissionGroupDelete>;
  /**
   * Update permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - PERMISSION_GROUP_UPDATED (async)
   */
  permissionGroupUpdate: Maybe<SaleorPermissionGroupUpdate>;
  /**
   * Update plugin configuration.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  pluginUpdate: Maybe<SaleorPluginUpdate>;
  /**
   * Assign attributes to a given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productAttributeAssign: Maybe<SaleorProductAttributeAssign>;
  /**
   * Update attributes assigned to product variant for given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productAttributeAssignmentUpdate: Maybe<SaleorProductAttributeAssignmentUpdate>;
  /**
   * Un-assign attributes from a given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productAttributeUnassign: Maybe<SaleorProductAttributeUnassign>;
  /**
   * Creates products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productBulkCreate: Maybe<SaleorProductBulkCreate>;
  /**
   * Deletes products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productBulkDelete: Maybe<SaleorProductBulkDelete>;
  /**
   * Creates/updates translations for products.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   *
   * Triggers the following webhook events:
   * - TRANSLATION_CREATED (async): Called when a translation was created.
   * - TRANSLATION_UPDATED (async): Called when a translation was updated.
   */
  productBulkTranslate: Maybe<SaleorProductBulkTranslate>;
  /**
   * Manage product's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productChannelListingUpdate: Maybe<SaleorProductChannelListingUpdate>;
  /**
   * Creates a new product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productCreate: Maybe<SaleorProductCreate>;
  /**
   * Deletes a product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productDelete: Maybe<SaleorProductDelete>;
  /**
   * Deletes product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaBulkDelete: Maybe<SaleorProductMediaBulkDelete>;
  /**
   * Create a media object (image or video URL) associated with product. For image, this mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaCreate: Maybe<SaleorProductMediaCreate>;
  /**
   * Deletes a product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaDelete: Maybe<SaleorProductMediaDelete>;
  /**
   * Changes ordering of the product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaReorder: Maybe<SaleorProductMediaReorder>;
  /**
   * Updates a product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaUpdate: Maybe<SaleorProductMediaUpdate>;
  /**
   * Reorder product attribute values.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productReorderAttributeValues: Maybe<SaleorProductReorderAttributeValues>;
  /**
   * Creates/updates translations for a product.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  productTranslate: Maybe<SaleorProductTranslate>;
  /**
   * Deletes product types.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeBulkDelete: Maybe<SaleorProductTypeBulkDelete>;
  /**
   * Creates a new product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeCreate: Maybe<SaleorProductTypeCreate>;
  /**
   * Deletes a product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeDelete: Maybe<SaleorProductTypeDelete>;
  /**
   * Reorder the attributes of a product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeReorderAttributes: Maybe<SaleorProductTypeReorderAttributes>;
  /**
   * Updates an existing product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeUpdate: Maybe<SaleorProductTypeUpdate>;
  /**
   * Updates an existing product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productUpdate: Maybe<SaleorProductUpdate>;
  /**
   * Creates product variants for a given product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantBulkCreate: Maybe<SaleorProductVariantBulkCreate>;
  /**
   * Deletes product variants.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantBulkDelete: Maybe<SaleorProductVariantBulkDelete>;
  /**
   * Creates/updates translations for product variants.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   *
   * Triggers the following webhook events:
   * - TRANSLATION_CREATED (async): A translation was created.
   * - TRANSLATION_UPDATED (async): A translation was updated.
   */
  productVariantBulkTranslate: Maybe<SaleorProductVariantBulkTranslate>;
  /**
   * Updates multiple product variants.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantBulkUpdate: Maybe<SaleorProductVariantBulkUpdate>;
  /**
   * Manage product variant prices in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantChannelListingUpdate: Maybe<SaleorProductVariantChannelListingUpdate>;
  /**
   * Creates a new variant for a product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantCreate: Maybe<SaleorProductVariantCreate>;
  /**
   * Deletes a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantDelete: Maybe<SaleorProductVariantDelete>;
  /**
   * Deactivates product variant preorder. It changes all preorder allocation into regular allocation.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantPreorderDeactivate: Maybe<SaleorProductVariantPreorderDeactivate>;
  /**
   * Reorder the variants of a product. Mutation updates updated_at on product and triggers PRODUCT_UPDATED webhook.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantReorder: Maybe<SaleorProductVariantReorder>;
  /**
   * Reorder product variant attribute values.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantReorderAttributeValues: Maybe<SaleorProductVariantReorderAttributeValues>;
  /**
   * Set default variant for a product. Mutation triggers PRODUCT_UPDATED webhook.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantSetDefault: Maybe<SaleorProductVariantSetDefault>;
  /**
   * Creates stocks for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantStocksCreate: Maybe<SaleorProductVariantStocksCreate>;
  /**
   * Deletes stocks from product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantStocksDelete: Maybe<SaleorProductVariantStocksDelete>;
  /**
   * Updates stocks for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantStocksUpdate: Maybe<SaleorProductVariantStocksUpdate>;
  /**
   * Creates/updates translations for a product variant.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  productVariantTranslate: Maybe<SaleorProductVariantTranslate>;
  /**
   * Updates an existing variant for product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantUpdate: Maybe<SaleorProductVariantUpdate>;
  /**
   * Deletes promotions.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_DELETED (async): A promotion was deleted.
   */
  promotionBulkDelete: Maybe<SaleorPromotionBulkDelete>;
  /**
   * Creates a new promotion.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_CREATED (async): A promotion was created.
   * - PROMOTION_STARTED (async): Optionally called if promotion was started.
   */
  promotionCreate: Maybe<SaleorPromotionCreate>;
  /**
   * Deletes a promotion.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_DELETED (async): A promotion was deleted.
   */
  promotionDelete: Maybe<SaleorPromotionDelete>;
  /**
   * Creates a new promotion rule.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_RULE_CREATED (async): A promotion rule was created.
   */
  promotionRuleCreate: Maybe<SaleorPromotionRuleCreate>;
  /**
   * Deletes a promotion rule.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_RULE_DELETED (async): A promotion rule was deleted.
   */
  promotionRuleDelete: Maybe<SaleorPromotionRuleDelete>;
  /**
   * Creates/updates translations for a promotion rule.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  promotionRuleTranslate: Maybe<SaleorPromotionRuleTranslate>;
  /**
   * Updates an existing promotion rule.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_RULE_UPDATED (async): A promotion rule was updated.
   */
  promotionRuleUpdate: Maybe<SaleorPromotionRuleUpdate>;
  /**
   * Creates/updates translations for a promotion.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  promotionTranslate: Maybe<SaleorPromotionTranslate>;
  /**
   * Updates an existing promotion.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_UPDATED (async): A promotion was updated.
   * - PROMOTION_STARTED (async): Optionally called if promotion was started.
   * - PROMOTION_ENDED (async): Optionally called if promotion was ended.
   */
  promotionUpdate: Maybe<SaleorPromotionUpdate>;
  /**
   * Updates RefundSettings. The `Page` (Model) Type will be cleared from `reasonReferenceType`. When it's cleared, passing reason reference to refund mutations is no longer accepted and will raise error.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  refundReasonReferenceClear: Maybe<SaleorRefundReasonReferenceTypeClear>;
  /**
   * Update refund settings across all channels.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  refundSettingsUpdate: Maybe<SaleorRefundSettingsUpdate>;
  /**
   * Request email change of the logged in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for account email change.
   * - ACCOUNT_CHANGE_EMAIL_REQUESTED (async): An account email change was requested.
   */
  requestEmailChange: Maybe<SaleorRequestEmailChange>;
  /**
   * Sends an email with the account password modification link.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for password reset.
   * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
   * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
   */
  requestPasswordReset: Maybe<SaleorRequestPasswordReset>;
  /**
   * Deletes sales.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_DELETED (async): A sale was deleted.
   */
  saleBulkDelete: Maybe<SaleorSaleBulkDelete>;
  /**
   * Adds products, categories, collections to a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_UPDATED (async): A sale was updated.
   * @deprecated Use `promotionRuleCreate` and `promotionRuleUpdate` mutations instead.
   */
  saleCataloguesAdd: Maybe<SaleorSaleAddCatalogues>;
  /**
   * Removes products, categories, collections from a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_UPDATED (async): A sale was updated.
   * @deprecated Use `promotionRuleUpdate` and `promotionRuleDelete` mutations instead.
   */
  saleCataloguesRemove: Maybe<SaleorSaleRemoveCatalogues>;
  /**
   * Manage sale's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Use `promotionRuleUpdate` mutation instead.
   */
  saleChannelListingUpdate: Maybe<SaleorSaleChannelListingUpdate>;
  /**
   * Creates a new sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_CREATED (async): A sale was created.
   * @deprecated Use `promotionCreate` mutation instead.
   */
  saleCreate: Maybe<SaleorSaleCreate>;
  /**
   * Deletes a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_DELETED (async): A sale was deleted.
   * @deprecated Use `promotionDelete` mutation instead.
   */
  saleDelete: Maybe<SaleorSaleDelete>;
  /**
   * Creates/updates translations for a sale.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   * @deprecated Use `promotionTranslate` mutation instead.
   */
  saleTranslate: Maybe<SaleorSaleTranslate>;
  /**
   * Updates a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_UPDATED (async): A sale was updated.
   * - SALE_TOGGLE (async): Optionally triggered when a sale is started or stopped.
   * @deprecated Use `promotionUpdate` mutation instead.
   */
  saleUpdate: Maybe<SaleorSaleUpdate>;
  /**
   * Sends a notification confirmation.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for account confirmation.
   * - ACCOUNT_CONFIRMATION_REQUESTED (async): An account confirmation was requested. This event is always sent regardless of settings.
   */
  sendConfirmationEmail: Maybe<SaleorSendConfirmationEmail>;
  /** Sets the user's password from the token sent by email using the RequestPasswordReset mutation. */
  setPassword: Maybe<SaleorSetPassword>;
  /**
   * Manage shipping method's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingMethodChannelListingUpdate: Maybe<SaleorShippingMethodChannelListingUpdate>;
  /**
   * Deletes shipping prices.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceBulkDelete: Maybe<SaleorShippingPriceBulkDelete>;
  /**
   * Creates a new shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceCreate: Maybe<SaleorShippingPriceCreate>;
  /**
   * Deletes a shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceDelete: Maybe<SaleorShippingPriceDelete>;
  /**
   * Exclude products from shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceExcludeProducts: Maybe<SaleorShippingPriceExcludeProducts>;
  /**
   * Remove product from excluded list for shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceRemoveProductFromExclude: Maybe<SaleorShippingPriceRemoveProductFromExclude>;
  /**
   * Creates/updates translations for a shipping method.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  shippingPriceTranslate: Maybe<SaleorShippingPriceTranslate>;
  /**
   * Updates a new shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceUpdate: Maybe<SaleorShippingPriceUpdate>;
  /**
   * Deletes shipping zones.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneBulkDelete: Maybe<SaleorShippingZoneBulkDelete>;
  /**
   * Creates a new shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneCreate: Maybe<SaleorShippingZoneCreate>;
  /**
   * Deletes a shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneDelete: Maybe<SaleorShippingZoneDelete>;
  /**
   * Updates a new shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneUpdate: Maybe<SaleorShippingZoneUpdate>;
  /**
   * Update the shop's address. If the `null` value is passed, the currently selected address will be deleted.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  shopAddressUpdate: Maybe<SaleorShopAddressUpdate>;
  /**
   * Updates site domain of the shop.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   * @deprecated Use `PUBLIC_URL` environment variable instead.
   */
  shopDomainUpdate: Maybe<SaleorShopDomainUpdate>;
  /**
   * Fetch tax rates.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   * @deprecated Field no longer supported
   */
  shopFetchTaxRates: Maybe<SaleorShopFetchTaxRates>;
  /**
   * Creates/updates translations for shop settings.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  shopSettingsTranslate: Maybe<SaleorShopSettingsTranslate>;
  /**
   * Updates shop settings.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   *
   * Triggers the following webhook events:
   * - SHOP_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
   */
  shopSettingsUpdate: Maybe<SaleorShopSettingsUpdate>;
  /**
   * Deletes staff users. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_DELETED (async): A staff account was deleted.
   */
  staffBulkDelete: Maybe<SaleorStaffBulkDelete>;
  /**
   * Creates a new staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_CREATED (async): A new staff account was created.
   * - NOTIFY_USER (async): A notification for setting the password.
   * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
   */
  staffCreate: Maybe<SaleorStaffCreate>;
  /**
   * Deletes a staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_DELETED (async): A staff account was deleted.
   */
  staffDelete: Maybe<SaleorStaffDelete>;
  /**
   * Creates a new staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipientCreate: Maybe<SaleorStaffNotificationRecipientCreate>;
  /**
   * Deletes staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipientDelete: Maybe<SaleorStaffNotificationRecipientDelete>;
  /**
   * Updates a staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipientUpdate: Maybe<SaleorStaffNotificationRecipientUpdate>;
  /**
   * Updates an existing staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_UPDATED (async): A staff account was updated.
   */
  staffUpdate: Maybe<SaleorStaffUpdate>;
  /**
   * Updates stocks for a given variant and warehouse. Variant and warehouse selectors have to be the same for all stock inputs. Is not allowed to use 'variantId' in one input and 'variantExternalReference' in another.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   *
   * Triggers the following webhook events:
   * - PRODUCT_VARIANT_STOCK_UPDATED (async): A product variant stock details were updated.
   */
  stockBulkUpdate: Maybe<SaleorStockBulkUpdate>;
  /**
   * Request to delete a stored payment method on payment provider side.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - STORED_PAYMENT_METHOD_DELETE_REQUESTED (sync): The customer requested to delete a payment method.
   */
  storedPaymentMethodRequestDelete: Maybe<SaleorStoredPaymentMethodRequestDelete>;
  /**
   * Creates a tax class.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxClassCreate: Maybe<SaleorTaxClassCreate>;
  /**
   * Deletes a tax class. After deleting the tax class any products, product types or shipping methods using it are updated to use the default tax class.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxClassDelete: Maybe<SaleorTaxClassDelete>;
  /**
   * Updates a tax class.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxClassUpdate: Maybe<SaleorTaxClassUpdate>;
  /**
   * Updates tax configuration for a channel.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxConfigurationUpdate: Maybe<SaleorTaxConfigurationUpdate>;
  /**
   * Remove all tax class rates for a specific country.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxCountryConfigurationDelete: Maybe<SaleorTaxCountryConfigurationDelete>;
  /**
   * Updates tax class rates for a specific country.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxCountryConfigurationUpdate: Maybe<SaleorTaxCountryConfigurationUpdate>;
  /**
   * Exempt checkout or order from charging the taxes. When tax exemption is enabled, taxes won't be charged for the checkout or order. Taxes may still be calculated in cases when product prices are entered with the tax included and the net price needs to be known.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxExemptionManage: Maybe<SaleorTaxExemptionManage>;
  /** Create JWT token. */
  tokenCreate: Maybe<SaleorCreateToken>;
  /** Refresh JWT token. Mutation tries to take refreshToken from the input. If it fails it will try to take `refreshToken` from the http-only cookie `refreshToken`. `csrfToken` is required when `refreshToken` is provided as a cookie. */
  tokenRefresh: Maybe<SaleorRefreshToken>;
  /** Verify JWT token. */
  tokenVerify: Maybe<SaleorVerifyToken>;
  /**
   * Deactivate all JWT tokens of the currently authenticated user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  tokensDeactivateAll: Maybe<SaleorDeactivateAllUserTokens>;
  /**
   * Creates transaction for checkout or order.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  transactionCreate: Maybe<SaleorTransactionCreate>;
  /**
   * Report the event for the transaction.
   *
   * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
   *
   * Triggers the following webhook events:
   * - TRANSACTION_ITEM_METADATA_UPDATED (async): Optionally called when transaction's metadata was updated.
   * - CHECKOUT_FULLY_PAID (async): Optionally called when the checkout charge status changed to `FULL` or `OVERCHARGED`.
   * - ORDER_UPDATED (async): Optionally called when the transaction is related to the order and the order was updated.
   */
  transactionEventReport: Maybe<SaleorTransactionEventReport>;
  /** Initializes a transaction session. It triggers the webhook `TRANSACTION_INITIALIZE_SESSION`, to the requested `paymentGateways`. There is a limit of 100 transaction items per checkout / order. */
  transactionInitialize: Maybe<SaleorTransactionInitialize>;
  /** Processes a transaction session. It triggers the webhook `TRANSACTION_PROCESS_SESSION`, to the assigned `paymentGateways`.  */
  transactionProcess: Maybe<SaleorTransactionProcess>;
  /**
   * Request an action for payment transaction.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  transactionRequestAction: Maybe<SaleorTransactionRequestAction>;
  /**
   * Request a refund for payment transaction based on granted refund.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  transactionRequestRefundForGrantedRefund: Maybe<SaleorTransactionRequestRefundForGrantedRefund>;
  /**
   * Update transaction.
   *
   * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
   */
  transactionUpdate: Maybe<SaleorTransactionUpdate>;
  /**
   * Remove shipping zone from given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  unassignWarehouseShippingZone: Maybe<SaleorWarehouseShippingZoneUnassign>;
  /**
   * Updates metadata of an object.Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  updateMetadata: Maybe<SaleorUpdateMetadata>;
  /**
   * Updates private metadata of an object. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  updatePrivateMetadata: Maybe<SaleorUpdatePrivateMetadata>;
  /**
   * Updates given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  updateWarehouse: Maybe<SaleorWarehouseUpdate>;
  /**
   * Deletes a user avatar. Only for staff members.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  userAvatarDelete: Maybe<SaleorUserAvatarDelete>;
  /**
   * Create a user avatar. Only for staff members. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  userAvatarUpdate: Maybe<SaleorUserAvatarUpdate>;
  /**
   * Activate or deactivate users.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  userBulkSetActive: Maybe<SaleorUserBulkSetActive>;
  /**
   * Assign an media to a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  variantMediaAssign: Maybe<SaleorVariantMediaAssign>;
  /**
   * Unassign an media from a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  variantMediaUnassign: Maybe<SaleorVariantMediaUnassign>;
  /**
   * Deletes vouchers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_DELETED (async): A voucher was deleted.
   */
  voucherBulkDelete: Maybe<SaleorVoucherBulkDelete>;
  /**
   * Adds products, categories, collections to a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   */
  voucherCataloguesAdd: Maybe<SaleorVoucherAddCatalogues>;
  /**
   * Removes products, categories, collections from a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   */
  voucherCataloguesRemove: Maybe<SaleorVoucherRemoveCatalogues>;
  /**
   * Manage voucher's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   */
  voucherChannelListingUpdate: Maybe<SaleorVoucherChannelListingUpdate>;
  /**
   * Deletes voucher codes.
   *
   * Added in Saleor 3.18.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_CODES_DELETED (async): A voucher codes were deleted.
   */
  voucherCodeBulkDelete: Maybe<SaleorVoucherCodeBulkDelete>;
  /**
   * Creates a new voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_CREATED (async): A voucher was created.
   * - VOUCHER_CODES_CREATED (async): A voucher codes were created.
   */
  voucherCreate: Maybe<SaleorVoucherCreate>;
  /**
   * Deletes a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_DELETED (async): A voucher was deleted.
   */
  voucherDelete: Maybe<SaleorVoucherDelete>;
  /**
   * Creates/updates translations for a voucher.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  voucherTranslate: Maybe<SaleorVoucherTranslate>;
  /**
   * Updates a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   * - VOUCHER_CODES_CREATED (async): A voucher code was created.
   */
  voucherUpdate: Maybe<SaleorVoucherUpdate>;
  /**
   * Creates a new webhook subscription.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  webhookCreate: Maybe<SaleorWebhookCreate>;
  /**
   * Deletes a webhook. Before the deletion, the webhook is deactivated to pause any deliveries that are already scheduled. The deletion might fail if delivery is in progress. In such a case, the webhook is not deleted but remains deactivated.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  webhookDelete: Maybe<SaleorWebhookDelete>;
  /**
   * Performs a dry run of a webhook event. Supports a single event (the first, if multiple provided in the `query`). Requires permission relevant to processed event.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  webhookDryRun: Maybe<SaleorWebhookDryRun>;
  /**
   * Trigger a webhook event. Supports a single event (the first, if multiple provided in the `webhook.subscription_query`). Requires permission relevant to processed event. Successfully delivered webhook returns `delivery` with status='PENDING' and empty payload.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  webhookTrigger: Maybe<SaleorWebhookTrigger>;
  /**
   * Updates a webhook subscription.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  webhookUpdate: Maybe<SaleorWebhookUpdate>;
};


export type SaleorMutationAccountAddressCreateArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorAddressInput;
  type?: InputMaybe<SaleorAddressTypeEnum>;
};


export type SaleorMutationAccountAddressDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAccountAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAddressInput;
};


export type SaleorMutationAccountDeleteArgs = {
  token: Scalars['String']['input'];
};


export type SaleorMutationAccountRegisterArgs = {
  input: SaleorAccountRegisterInput;
};


export type SaleorMutationAccountRequestDeletionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type SaleorMutationAccountSetDefaultAddressArgs = {
  id: Scalars['ID']['input'];
  type: SaleorAddressTypeEnum;
};


export type SaleorMutationAccountUpdateArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorAccountInput;
};


export type SaleorMutationAddressCreateArgs = {
  input: SaleorAddressInput;
  userId: Scalars['ID']['input'];
};


export type SaleorMutationAddressDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAddressSetDefaultArgs = {
  addressId: Scalars['ID']['input'];
  type: SaleorAddressTypeEnum;
  userId: Scalars['ID']['input'];
};


export type SaleorMutationAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAddressInput;
};


export type SaleorMutationAppActivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAppCreateArgs = {
  input: SaleorAppInput;
};


export type SaleorMutationAppDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAppDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAppDeleteFailedInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAppFetchManifestArgs = {
  manifestUrl: Scalars['String']['input'];
};


export type SaleorMutationAppInstallArgs = {
  input: SaleorAppInstallInput;
};


export type SaleorMutationAppProblemCreateArgs = {
  input: SaleorAppProblemCreateInput;
};


export type SaleorMutationAppProblemDismissArgs = {
  input: SaleorAppProblemDismissInput;
};


export type SaleorMutationAppReenableSyncWebhooksArgs = {
  appId: Scalars['ID']['input'];
};


export type SaleorMutationAppRetryInstallArgs = {
  activateAfterInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type SaleorMutationAppTokenCreateArgs = {
  input: SaleorAppTokenInput;
};


export type SaleorMutationAppTokenDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationAppTokenVerifyArgs = {
  token: Scalars['String']['input'];
};


export type SaleorMutationAppUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAppInput;
};


export type SaleorMutationAssignNavigationArgs = {
  menu?: InputMaybe<Scalars['ID']['input']>;
  navigationType: SaleorNavigationType;
};


export type SaleorMutationAssignWarehouseShippingZoneArgs = {
  id: Scalars['ID']['input'];
  shippingZoneIds: Array<Scalars['ID']['input']>;
};


export type SaleorMutationAttributeBulkCreateArgs = {
  attributes: Array<SaleorAttributeCreateInput>;
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
};


export type SaleorMutationAttributeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationAttributeBulkTranslateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  translations: Array<SaleorAttributeBulkTranslateInput>;
};


export type SaleorMutationAttributeBulkUpdateArgs = {
  attributes: Array<SaleorAttributeBulkUpdateInput>;
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
};


export type SaleorMutationAttributeCreateArgs = {
  input: SaleorAttributeCreateInput;
};


export type SaleorMutationAttributeDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationAttributeReorderValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
};


export type SaleorMutationAttributeTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationAttributeUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorAttributeUpdateInput;
};


export type SaleorMutationAttributeValueBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationAttributeValueBulkTranslateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  translations: Array<SaleorAttributeValueBulkTranslateInput>;
};


export type SaleorMutationAttributeValueCreateArgs = {
  attribute: Scalars['ID']['input'];
  input: SaleorAttributeValueCreateInput;
};


export type SaleorMutationAttributeValueDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationAttributeValueTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAttributeValueTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationAttributeValueUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorAttributeValueUpdateInput;
};


export type SaleorMutationCategoryBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationCategoryCreateArgs = {
  input: SaleorCategoryInput;
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationCategoryTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCategoryInput;
};


export type SaleorMutationChannelActivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationChannelCreateArgs = {
  input: SaleorChannelCreateInput;
};


export type SaleorMutationChannelDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationChannelDeleteArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SaleorChannelDeleteInput>;
};


export type SaleorMutationChannelReorderWarehousesArgs = {
  channelId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
};


export type SaleorMutationChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorChannelUpdateInput;
};


export type SaleorMutationCheckoutAddPromoCodeArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode: Scalars['String']['input'];
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutBillingAddressUpdateArgs = {
  billingAddress: SaleorAddressInput;
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  saveAddress?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  validationRules?: InputMaybe<SaleorCheckoutAddressValidationRules>;
};


export type SaleorMutationCheckoutCompleteArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  paymentData?: InputMaybe<Scalars['JSONString']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  storeSource?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutCreateArgs = {
  input: SaleorCheckoutCreateInput;
};


export type SaleorMutationCheckoutCreateFromOrderArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationCheckoutCustomerAttachArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutCustomerDetachArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutCustomerNoteUpdateArgs = {
  customerNote: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type SaleorMutationCheckoutDeliveryMethodUpdateArgs = {
  deliveryMethodId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutEmailUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutLanguageCodeUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutLineDeleteArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutLinesAddArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SaleorCheckoutLineInput>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutLinesDeleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linesIds: Array<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutLinesUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SaleorCheckoutLineUpdateInput>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutPaymentCreateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorPaymentInput;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutRemovePromoCodeArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCheckoutShippingAddressUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  saveAddress?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress: SaleorAddressInput;
  token?: InputMaybe<Scalars['UUID']['input']>;
  validationRules?: InputMaybe<SaleorCheckoutAddressValidationRules>;
};


export type SaleorMutationCheckoutShippingMethodUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shippingMethodId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationCollectionAddProductsArgs = {
  collectionId: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type SaleorMutationCollectionBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationCollectionChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCollectionChannelListingUpdateInput;
};


export type SaleorMutationCollectionCreateArgs = {
  input: SaleorCollectionCreateInput;
};


export type SaleorMutationCollectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationCollectionRemoveProductsArgs = {
  collectionId: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type SaleorMutationCollectionReorderProductsArgs = {
  collectionId: Scalars['ID']['input'];
  moves: Array<SaleorMoveProductInput>;
};


export type SaleorMutationCollectionTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationCollectionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCollectionInput;
};


export type SaleorMutationConfirmAccountArgs = {
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type SaleorMutationConfirmEmailChangeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type SaleorMutationCreateWarehouseArgs = {
  input: SaleorWarehouseCreateInput;
};


export type SaleorMutationCustomerBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationCustomerBulkUpdateArgs = {
  customers: Array<SaleorCustomerBulkUpdateInput>;
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
};


export type SaleorMutationCustomerCreateArgs = {
  input: SaleorUserCreateInput;
};


export type SaleorMutationCustomerDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationCustomerUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorCustomerInput;
};


export type SaleorMutationDeleteMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type SaleorMutationDeletePrivateMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type SaleorMutationDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationDigitalContentCreateArgs = {
  input: SaleorDigitalContentUploadInput;
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationDigitalContentDeleteArgs = {
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationDigitalContentUpdateArgs = {
  input: SaleorDigitalContentInput;
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationDigitalContentUrlCreateArgs = {
  input: SaleorDigitalContentUrlCreateInput;
};


export type SaleorMutationDraftOrderBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationDraftOrderCreateArgs = {
  input: SaleorDraftOrderCreateInput;
};


export type SaleorMutationDraftOrderDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationDraftOrderLinesBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationDraftOrderUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorDraftOrderInput;
};


export type SaleorMutationEventDeliveryRetryArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationExportGiftCardsArgs = {
  input: SaleorExportGiftCardsInput;
};


export type SaleorMutationExportProductsArgs = {
  input: SaleorExportProductsInput;
};


export type SaleorMutationExportVoucherCodesArgs = {
  input: SaleorExportVoucherCodesInput;
};


export type SaleorMutationExternalAuthenticationUrlArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type SaleorMutationExternalLogoutArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type SaleorMutationExternalNotificationTriggerArgs = {
  channel: Scalars['String']['input'];
  input: SaleorExternalNotificationTriggerInput;
  pluginId?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationExternalObtainAccessTokensArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type SaleorMutationExternalRefreshArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type SaleorMutationExternalVerifyArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type SaleorMutationFileUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type SaleorMutationGiftCardActivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationGiftCardAddNoteArgs = {
  id: Scalars['ID']['input'];
  input: SaleorGiftCardAddNoteInput;
};


export type SaleorMutationGiftCardBulkActivateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationGiftCardBulkCreateArgs = {
  input: SaleorGiftCardBulkCreateInput;
};


export type SaleorMutationGiftCardBulkDeactivateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationGiftCardBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationGiftCardCreateArgs = {
  input: SaleorGiftCardCreateInput;
};


export type SaleorMutationGiftCardDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationGiftCardDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationGiftCardResendArgs = {
  input: SaleorGiftCardResendInput;
};


export type SaleorMutationGiftCardSettingsUpdateArgs = {
  input: SaleorGiftCardSettingsUpdateInput;
};


export type SaleorMutationGiftCardUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorGiftCardUpdateInput;
};


export type SaleorMutationInvoiceCreateArgs = {
  input: SaleorInvoiceCreateInput;
  orderId: Scalars['ID']['input'];
};


export type SaleorMutationInvoiceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationInvoiceRequestArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type SaleorMutationInvoiceRequestDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationInvoiceSendNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationInvoiceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorUpdateInvoiceInput;
};


export type SaleorMutationMenuBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationMenuCreateArgs = {
  input: SaleorMenuCreateInput;
};


export type SaleorMutationMenuDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationMenuItemBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationMenuItemCreateArgs = {
  input: SaleorMenuItemCreateInput;
};


export type SaleorMutationMenuItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationMenuItemMoveArgs = {
  menu: Scalars['ID']['input'];
  moves: Array<SaleorMenuItemMoveInput>;
};


export type SaleorMutationMenuItemTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationMenuItemUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorMenuItemInput;
};


export type SaleorMutationMenuUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorMenuInput;
};


export type SaleorMutationOrderAddNoteArgs = {
  input: SaleorOrderAddNoteInput;
  order: Scalars['ID']['input'];
};


export type SaleorMutationOrderBulkCancelArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationOrderBulkCreateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  orders: Array<SaleorOrderBulkCreateInput>;
  stockUpdatePolicy?: InputMaybe<SaleorStockUpdatePolicyEnum>;
};


export type SaleorMutationOrderCancelArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationOrderCaptureArgs = {
  amount: Scalars['PositiveDecimal']['input'];
  id: Scalars['ID']['input'];
};


export type SaleorMutationOrderConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationOrderCreateFromCheckoutArgs = {
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  removeCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SaleorMutationOrderDiscountAddArgs = {
  input: SaleorOrderDiscountCommonInput;
  orderId: Scalars['ID']['input'];
};


export type SaleorMutationOrderDiscountDeleteArgs = {
  discountId: Scalars['ID']['input'];
};


export type SaleorMutationOrderDiscountUpdateArgs = {
  discountId: Scalars['ID']['input'];
  input: SaleorOrderDiscountCommonInput;
};


export type SaleorMutationOrderFulfillArgs = {
  input: SaleorOrderFulfillInput;
  order?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationOrderFulfillmentApproveArgs = {
  allowStockToBeExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notifyCustomer: Scalars['Boolean']['input'];
};


export type SaleorMutationOrderFulfillmentCancelArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SaleorFulfillmentCancelInput>;
};


export type SaleorMutationOrderFulfillmentRefundProductsArgs = {
  input: SaleorOrderRefundProductsInput;
  order: Scalars['ID']['input'];
};


export type SaleorMutationOrderFulfillmentReturnProductsArgs = {
  input: SaleorOrderReturnProductsInput;
  order: Scalars['ID']['input'];
};


export type SaleorMutationOrderFulfillmentUpdateTrackingArgs = {
  id: Scalars['ID']['input'];
  input: SaleorFulfillmentUpdateTrackingInput;
};


export type SaleorMutationOrderGrantRefundCreateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorOrderGrantRefundCreateInput;
};


export type SaleorMutationOrderGrantRefundUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorOrderGrantRefundUpdateInput;
};


export type SaleorMutationOrderLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationOrderLineDiscountRemoveArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type SaleorMutationOrderLineDiscountUpdateArgs = {
  input: SaleorOrderDiscountCommonInput;
  orderLineId: Scalars['ID']['input'];
};


export type SaleorMutationOrderLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorOrderLineInput;
};


export type SaleorMutationOrderLinesCreateArgs = {
  id: Scalars['ID']['input'];
  input: Array<SaleorOrderLineCreateInput>;
};


export type SaleorMutationOrderMarkAsPaidArgs = {
  id: Scalars['ID']['input'];
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationOrderNoteAddArgs = {
  input: SaleorOrderNoteInput;
  order: Scalars['ID']['input'];
};


export type SaleorMutationOrderNoteUpdateArgs = {
  input: SaleorOrderNoteInput;
  note: Scalars['ID']['input'];
};


export type SaleorMutationOrderRefundArgs = {
  amount: Scalars['PositiveDecimal']['input'];
  id: Scalars['ID']['input'];
};


export type SaleorMutationOrderSettingsUpdateArgs = {
  input: SaleorOrderSettingsUpdateInput;
};


export type SaleorMutationOrderUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorOrderUpdateInput;
};


export type SaleorMutationOrderUpdateShippingArgs = {
  input: SaleorOrderUpdateShippingInput;
  order: Scalars['ID']['input'];
};


export type SaleorMutationOrderVoidArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationPageAttributeAssignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  pageTypeId: Scalars['ID']['input'];
};


export type SaleorMutationPageAttributeUnassignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  pageTypeId: Scalars['ID']['input'];
};


export type SaleorMutationPageBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationPageBulkPublishArgs = {
  ids: Array<Scalars['ID']['input']>;
  isPublished: Scalars['Boolean']['input'];
};


export type SaleorMutationPageCreateArgs = {
  input: SaleorPageCreateInput;
};


export type SaleorMutationPageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationPageReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
  pageId: Scalars['ID']['input'];
};


export type SaleorMutationPageTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPageTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationPageTypeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationPageTypeCreateArgs = {
  input: SaleorPageTypeCreateInput;
};


export type SaleorMutationPageTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationPageTypeReorderAttributesArgs = {
  moves: Array<SaleorReorderInput>;
  pageTypeId: Scalars['ID']['input'];
};


export type SaleorMutationPageTypeUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorPageTypeUpdateInput;
};


export type SaleorMutationPageUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPageInput;
};


export type SaleorMutationPasswordChangeArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationPaymentCaptureArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type SaleorMutationPaymentCheckBalanceArgs = {
  input: SaleorPaymentCheckBalanceInput;
};


export type SaleorMutationPaymentGatewayInitializeArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  id: Scalars['ID']['input'];
  paymentGateways?: InputMaybe<Array<SaleorPaymentGatewayToInitialize>>;
};


export type SaleorMutationPaymentGatewayInitializeTokenizationArgs = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
};


export type SaleorMutationPaymentInitializeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  gateway: Scalars['String']['input'];
  paymentData?: InputMaybe<Scalars['JSONString']['input']>;
};


export type SaleorMutationPaymentMethodInitializeTokenizationArgs = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  paymentFlowToSupport: SaleorTokenizedPaymentFlowEnum;
};


export type SaleorMutationPaymentMethodProcessTokenizationArgs = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
};


export type SaleorMutationPaymentRefundArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type SaleorMutationPaymentVoidArgs = {
  paymentId: Scalars['ID']['input'];
};


export type SaleorMutationPermissionGroupCreateArgs = {
  input: SaleorPermissionGroupCreateInput;
};


export type SaleorMutationPermissionGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationPermissionGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPermissionGroupUpdateInput;
};


export type SaleorMutationPluginUpdateArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input: SaleorPluginUpdateInput;
};


export type SaleorMutationProductAttributeAssignArgs = {
  operations: Array<SaleorProductAttributeAssignInput>;
  productTypeId: Scalars['ID']['input'];
};


export type SaleorMutationProductAttributeAssignmentUpdateArgs = {
  operations: Array<SaleorProductAttributeAssignmentUpdateInput>;
  productTypeId: Scalars['ID']['input'];
};


export type SaleorMutationProductAttributeUnassignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  productTypeId: Scalars['ID']['input'];
};


export type SaleorMutationProductBulkCreateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  products: Array<SaleorProductBulkCreateInput>;
};


export type SaleorMutationProductBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationProductBulkTranslateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  translations: Array<SaleorProductBulkTranslateInput>;
};


export type SaleorMutationProductChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorProductChannelListingUpdateInput;
};


export type SaleorMutationProductCreateArgs = {
  input: SaleorProductCreateInput;
};


export type SaleorMutationProductDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationProductMediaBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationProductMediaCreateArgs = {
  input: SaleorProductMediaCreateInput;
};


export type SaleorMutationProductMediaDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationProductMediaReorderArgs = {
  mediaIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type SaleorMutationProductMediaUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorProductMediaUpdateInput;
};


export type SaleorMutationProductReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
  productId: Scalars['ID']['input'];
};


export type SaleorMutationProductTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationProductTypeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationProductTypeCreateArgs = {
  input: SaleorProductTypeInput;
};


export type SaleorMutationProductTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationProductTypeReorderAttributesArgs = {
  moves: Array<SaleorReorderInput>;
  productTypeId: Scalars['ID']['input'];
  type: SaleorProductAttributeType;
};


export type SaleorMutationProductTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorProductTypeInput;
};


export type SaleorMutationProductUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorProductInput;
};


export type SaleorMutationProductVariantBulkCreateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  product: Scalars['ID']['input'];
  variants: Array<SaleorProductVariantBulkCreateInput>;
};


export type SaleorMutationProductVariantBulkDeleteArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorMutationProductVariantBulkTranslateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  translations: Array<SaleorProductVariantBulkTranslateInput>;
};


export type SaleorMutationProductVariantBulkUpdateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  product: Scalars['ID']['input'];
  variants: Array<SaleorProductVariantBulkUpdateInput>;
};


export type SaleorMutationProductVariantChannelListingUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: Array<SaleorProductVariantChannelListingAddInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationProductVariantCreateArgs = {
  input: SaleorProductVariantCreateInput;
};


export type SaleorMutationProductVariantDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationProductVariantPreorderDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationProductVariantReorderArgs = {
  moves: Array<SaleorReorderInput>;
  productId: Scalars['ID']['input'];
};


export type SaleorMutationProductVariantReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationProductVariantSetDefaultArgs = {
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationProductVariantStocksCreateArgs = {
  stocks: Array<SaleorStockInput>;
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationProductVariantStocksDeleteArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type SaleorMutationProductVariantStocksUpdateArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  stocks: Array<SaleorStockInput>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorMutationProductVariantTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationProductVariantUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorProductVariantInput;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationPromotionBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationPromotionCreateArgs = {
  input: SaleorPromotionCreateInput;
};


export type SaleorMutationPromotionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationPromotionRuleCreateArgs = {
  input: SaleorPromotionRuleCreateInput;
};


export type SaleorMutationPromotionRuleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationPromotionRuleTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPromotionRuleTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationPromotionRuleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPromotionRuleUpdateInput;
};


export type SaleorMutationPromotionTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPromotionTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationPromotionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPromotionUpdateInput;
};


export type SaleorMutationRefundSettingsUpdateArgs = {
  input: SaleorRefundSettingsUpdateInput;
};


export type SaleorMutationRequestEmailChangeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  newEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type SaleorMutationRequestPasswordResetArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type SaleorMutationSaleBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationSaleCataloguesAddArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type SaleorMutationSaleCataloguesRemoveArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type SaleorMutationSaleChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorSaleChannelListingInput;
};


export type SaleorMutationSaleCreateArgs = {
  input: SaleorSaleInput;
};


export type SaleorMutationSaleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationSaleTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationSaleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorSaleInput;
};


export type SaleorMutationSendConfirmationEmailArgs = {
  channel: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type SaleorMutationSetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type SaleorMutationShippingMethodChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingMethodChannelListingInput;
};


export type SaleorMutationShippingPriceBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationShippingPriceCreateArgs = {
  input: SaleorShippingPriceInput;
};


export type SaleorMutationShippingPriceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationShippingPriceExcludeProductsArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingPriceExcludeProductsInput;
};


export type SaleorMutationShippingPriceRemoveProductFromExcludeArgs = {
  id: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type SaleorMutationShippingPriceTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingPriceTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationShippingPriceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingPriceInput;
};


export type SaleorMutationShippingZoneBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationShippingZoneCreateArgs = {
  input: SaleorShippingZoneCreateInput;
};


export type SaleorMutationShippingZoneDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationShippingZoneUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingZoneUpdateInput;
};


export type SaleorMutationShopAddressUpdateArgs = {
  input?: InputMaybe<SaleorAddressInput>;
};


export type SaleorMutationShopDomainUpdateArgs = {
  input?: InputMaybe<SaleorSiteDomainInput>;
};


export type SaleorMutationShopSettingsTranslateArgs = {
  input: SaleorShopSettingsTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationShopSettingsUpdateArgs = {
  input: SaleorShopSettingsInput;
};


export type SaleorMutationStaffBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationStaffCreateArgs = {
  input: SaleorStaffCreateInput;
};


export type SaleorMutationStaffDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationStaffNotificationRecipientCreateArgs = {
  input: SaleorStaffNotificationRecipientInput;
};


export type SaleorMutationStaffNotificationRecipientDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationStaffNotificationRecipientUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorStaffNotificationRecipientInput;
};


export type SaleorMutationStaffUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorStaffUpdateInput;
};


export type SaleorMutationStockBulkUpdateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  stocks: Array<SaleorStockBulkUpdateInput>;
};


export type SaleorMutationStoredPaymentMethodRequestDeleteArgs = {
  channel: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type SaleorMutationTaxClassCreateArgs = {
  input: SaleorTaxClassCreateInput;
};


export type SaleorMutationTaxClassDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationTaxClassUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTaxClassUpdateInput;
};


export type SaleorMutationTaxConfigurationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTaxConfigurationUpdateInput;
};


export type SaleorMutationTaxCountryConfigurationDeleteArgs = {
  countryCode: SaleorCountryCode;
};


export type SaleorMutationTaxCountryConfigurationUpdateArgs = {
  countryCode: SaleorCountryCode;
  updateTaxClassRates: Array<SaleorTaxClassRateInput>;
};


export type SaleorMutationTaxExemptionManageArgs = {
  id: Scalars['ID']['input'];
  taxExemption: Scalars['Boolean']['input'];
};


export type SaleorMutationTokenCreateArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type SaleorMutationTokenRefreshArgs = {
  csrfToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorMutationTokenVerifyArgs = {
  token: Scalars['String']['input'];
};


export type SaleorMutationTransactionCreateArgs = {
  id: Scalars['ID']['input'];
  transaction: SaleorTransactionCreateInput;
  transactionEvent?: InputMaybe<SaleorTransactionEventInput>;
};


export type SaleorMutationTransactionEventReportArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  availableActions?: InputMaybe<Array<SaleorTransactionActionEnum>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  paymentMethodDetails?: InputMaybe<SaleorPaymentMethodDetailsInput>;
  pspReference: Scalars['String']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  transactionMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  transactionPrivateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  type: SaleorTransactionEventTypeEnum;
};


export type SaleorMutationTransactionInitializeArgs = {
  action?: InputMaybe<SaleorTransactionFlowStrategyEnum>;
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  customerIpAddress?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: SaleorPaymentGatewayToInitialize;
};


export type SaleorMutationTransactionProcessArgs = {
  customerIpAddress?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationTransactionRequestActionArgs = {
  actionType: SaleorTransactionActionEnum;
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  refundReason?: InputMaybe<Scalars['String']['input']>;
  refundReasonReference?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationTransactionRequestRefundForGrantedRefundArgs = {
  grantedRefundId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorMutationTransactionUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  transaction?: InputMaybe<SaleorTransactionUpdateInput>;
  transactionEvent?: InputMaybe<SaleorTransactionEventInput>;
};


export type SaleorMutationUnassignWarehouseShippingZoneArgs = {
  id: Scalars['ID']['input'];
  shippingZoneIds: Array<Scalars['ID']['input']>;
};


export type SaleorMutationUpdateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<SaleorMetadataInput>;
};


export type SaleorMutationUpdatePrivateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<SaleorMetadataInput>;
};


export type SaleorMutationUpdateWarehouseArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorWarehouseUpdateInput;
};


export type SaleorMutationUserAvatarUpdateArgs = {
  image: Scalars['Upload']['input'];
};


export type SaleorMutationUserBulkSetActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};


export type SaleorMutationVariantMediaAssignArgs = {
  mediaId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationVariantMediaUnassignArgs = {
  mediaId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type SaleorMutationVoucherBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationVoucherCataloguesAddArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type SaleorMutationVoucherCataloguesRemoveArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type SaleorMutationVoucherChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorVoucherChannelListingInput;
};


export type SaleorMutationVoucherCodeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SaleorMutationVoucherCreateArgs = {
  input: SaleorVoucherInput;
};


export type SaleorMutationVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationVoucherTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type SaleorMutationVoucherUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorVoucherInput;
};


export type SaleorMutationWebhookCreateArgs = {
  input: SaleorWebhookCreateInput;
};


export type SaleorMutationWebhookDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorMutationWebhookDryRunArgs = {
  objectId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type SaleorMutationWebhookTriggerArgs = {
  objectId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
};


export type SaleorMutationWebhookUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorWebhookUpdateInput;
};

export type SaleorNameTranslationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorNavigationType =
  /** Main storefront navigation. */
  | 'MAIN'
  /** Secondary storefront navigation. */
  | 'SECONDARY';

/** Represents the NEW_TAB target options for an app extension. */
export type SaleorNewTabTargetOptions = {
  __typename?: 'NewTabTargetOptions';
  /**
   * HTTP method for New Tab target (GET or POST)
   * @deprecated Use `settings` field directly.
   */
  method: SaleorHttpMethod;
};

/** An object with an ID */
export type SaleorNode = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

/**
 * An object with attributes.
 *
 * Added in Saleor 3.22.
 */
export type SaleorObjectWithAttributes = {
  /**
   * Get a single attribute attached to the object by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute: Maybe<SaleorAssignedAttribute>;
  /**
   * List of attributes assigned to the object.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<SaleorAssignedAttribute>;
};


/**
 * An object with attributes.
 *
 * Added in Saleor 3.22.
 */
export type SaleorObjectWithAttributesAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/**
 * An object with attributes.
 *
 * Added in Saleor 3.22.
 */
export type SaleorObjectWithAttributesAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type SaleorObjectWithMetadata = {
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
};


export type SaleorObjectWithMetadataMetafieldArgs = {
  key: Scalars['String']['input'];
};


export type SaleorObjectWithMetadataMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorObjectWithMetadataPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


export type SaleorObjectWithMetadataPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents an order in the shop. */
export type SaleorOrder = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Order';
  /** List of actions that can be performed in the current state of an order. */
  actions: Array<SaleorOrderAction>;
  /** The authorize status of the order. */
  authorizeStatus: SaleorOrderAuthorizeStatusEnum;
  /** Collection points that can be used for this order. */
  availableCollectionPoints: Array<SaleorWarehouse>;
  /**
   * Shipping methods that can be used with this order.
   * @deprecated Use `shippingMethods`, this field will be removed in 4.0
   */
  availableShippingMethods: Maybe<Array<SaleorShippingMethod>>;
  /** Billing address. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  billingAddress: Maybe<SaleorAddress>;
  /** Informs whether a draft order can be finalized(turned into a regular order). */
  canFinalize: Scalars['Boolean']['output'];
  /** Channel through which the order was placed. */
  channel: SaleorChannel;
  /** The charge status of the order. */
  chargeStatus: SaleorOrderChargeStatusEnum;
  /** ID of the checkout that the order was created from. */
  checkoutId: Maybe<Scalars['ID']['output']>;
  /** Name of the collection point where the order should be picked up by the customer. */
  collectionPointName: Maybe<Scalars['String']['output']>;
  /** Date and time when the order was created. */
  created: Scalars['DateTime']['output'];
  /** Additional information provided by the customer about the order. */
  customerNote: Scalars['String']['output'];
  /** The delivery method selected for this order. */
  deliveryMethod: Maybe<SaleorDeliveryMethod>;
  /**
   * Returns applied discount.
   * @deprecated Use the `discounts` field instead.
   */
  discount: Maybe<SaleorMoney>;
  /**
   * Discount name.
   * @deprecated Use the `discounts` field instead.
   */
  discountName: Maybe<Scalars['String']['output']>;
  /** List of all discounts assigned to the order. */
  discounts: Array<SaleorOrderDiscount>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** List of errors that occurred during order validation. */
  errors: Array<SaleorOrderError>;
  /**
   * List of events associated with the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  events: Array<SaleorOrderEvent>;
  /** External ID of this order. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** List of shipments for the order. */
  fulfillments: Array<SaleorFulfillment>;
  /** List of user gift cards. */
  giftCards: Array<SaleorGiftCard>;
  /**
   * List of granted refunds.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  grantedRefunds: Array<SaleorOrderGrantedRefund>;
  /** ID of the order. */
  id: Scalars['ID']['output'];
  /** List of order invoices. Can be fetched for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  invoices: Array<SaleorInvoice>;
  /** Informs if an order is fully paid. */
  isPaid: Scalars['Boolean']['output'];
  /** Returns True, if order requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** @deprecated Use the `languageCodeEnum` field to fetch the language code. */
  languageCode: Scalars['String']['output'];
  /** Order language code. */
  languageCodeEnum: SaleorLanguageCodeEnum;
  /** List of order lines. */
  lines: Array<SaleorOrderLine>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** User-friendly number of an order. */
  number: Scalars['String']['output'];
  /** The order origin. */
  origin: SaleorOrderOriginEnum;
  /** The ID of the order that was the base for this order. */
  original: Maybe<Scalars['ID']['output']>;
  /** Internal payment status. */
  paymentStatus: SaleorPaymentChargeStatusEnum;
  /** User-friendly payment status. */
  paymentStatusDisplay: Scalars['String']['output'];
  /**
   * List of payments for the order.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payments: Array<SaleorPayment>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** URL to which user should be redirected after order is placed. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shipping address. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  shippingAddress: Maybe<SaleorAddress>;
  /**
   * Shipping method for this order.
   * @deprecated Use `deliveryMethod` instead.
   */
  shippingMethod: Maybe<SaleorShippingMethod>;
  /** Method used for shipping. */
  shippingMethodName: Maybe<Scalars['String']['output']>;
  /** Shipping methods related to this order. */
  shippingMethods: Array<SaleorShippingMethod>;
  /** Total price of shipping. */
  shippingPrice: SaleorTaxedMoney;
  /**
   * Denormalized tax class assigned to the shipping method.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  shippingTaxClass: Maybe<SaleorTaxClass>;
  /** Denormalized public metadata of the shipping method's tax class. */
  shippingTaxClassMetadata: Array<SaleorMetadataItem>;
  /** Denormalized name of the tax class assigned to the shipping method. */
  shippingTaxClassName: Maybe<Scalars['String']['output']>;
  /** Denormalized private metadata of the shipping method's tax class. Requires staff permissions to access. */
  shippingTaxClassPrivateMetadata: Array<SaleorMetadataItem>;
  /** The shipping tax rate value. */
  shippingTaxRate: Scalars['Float']['output'];
  /** Status of the order. */
  status: SaleorOrderStatus;
  /** User-friendly order status. */
  statusDisplay: Scalars['String']['output'];
  /** The sum of line prices not including shipping. */
  subtotal: SaleorTaxedMoney;
  /** Returns True if order has to be exempt from taxes. */
  taxExemption: Scalars['Boolean']['output'];
  /** @deprecated Use `id` instead. */
  token: Scalars['String']['output'];
  /** Total amount of the order. */
  total: SaleorTaxedMoney;
  /**
   * Total amount of ongoing authorize requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalAuthorizePending: SaleorMoney;
  /** Amount authorized for the order. */
  totalAuthorized: SaleorMoney;
  /** The difference between the paid and the order total amount. */
  totalBalance: SaleorMoney;
  /**
   * Total amount of ongoing cancel requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalCancelPending: SaleorMoney;
  /** Amount canceled for the order. */
  totalCanceled: SaleorMoney;
  /**
   * Amount captured for the order.
   * @deprecated Use `totalCharged` instead.
   */
  totalCaptured: SaleorMoney;
  /**
   * Total amount of ongoing charge requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalChargePending: SaleorMoney;
  /** Amount charged for the order. */
  totalCharged: SaleorMoney;
  /**
   * Total amount of granted refund.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalGrantedRefund: SaleorMoney;
  /**
   * Total amount of ongoing refund requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalRefundPending: SaleorMoney;
  /** Total refund amount for the order. */
  totalRefunded: SaleorMoney;
  /**
   * The difference amount between granted refund and the amounts that are pending and refunded.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalRemainingGrant: SaleorMoney;
  /**
   * Google Analytics tracking client ID.
   *
   * DEPRECATED: this field will be removed.
   */
  trackingClientId: Scalars['String']['output'];
  /** List of transactions for the order. Requires one of the following permissions: MANAGE_ORDERS, HANDLE_PAYMENTS. */
  transactions: Array<SaleorTransactionItem>;
  /**
   * Translated discount name.
   * @deprecated Use the `discounts` field instead.
   */
  translatedDiscountName: Maybe<Scalars['String']['output']>;
  /**
   * Undiscounted total price of shipping.
   *
   * Added in Saleor 3.19.
   */
  undiscountedShippingPrice: SaleorMoney;
  /** Undiscounted total amount of the order. */
  undiscountedTotal: SaleorTaxedMoney;
  /** Date and time when the order was created. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who placed the order. This field is set only for orders placed by authenticated users. Can be fetched for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_USERS, MANAGE_ORDERS, HANDLE_PAYMENTS, OWNER. */
  user: Maybe<SaleorUser>;
  /** Email address of the customer. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  userEmail: Maybe<Scalars['String']['output']>;
  /** Voucher linked to the order. */
  voucher: Maybe<SaleorVoucher>;
  /**
   * Voucher code that was used for Order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode: Maybe<Scalars['String']['output']>;
  /** Weight of the order. */
  weight: SaleorWeight;
};


/** Represents an order in the shop. */
export type SaleorOrderMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an order in the shop. */
export type SaleorOrderMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an order in the shop. */
export type SaleorOrderPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an order in the shop. */
export type SaleorOrderPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorOrderAction =
  /** Represents the capture action. */
  | 'CAPTURE'
  /** Represents a mark-as-paid action. */
  | 'MARK_AS_PAID'
  /** Represents a refund action. */
  | 'REFUND'
  /** Represents a void action. */
  | 'VOID';

/**
 * Adds note to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderAddNote = {
  __typename?: 'OrderAddNote';
  errors: Array<SaleorOrderError>;
  /** Order note created. */
  event: Maybe<SaleorOrderEvent>;
  /** Order with the note added. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderAddNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Determine a current authorize status for order.
 *
 *     We treat the order as fully authorized when the sum of authorized and charged funds
 *     cover the `order.total`-`order.totalGrantedRefund`.
 *     We treat the order as partially authorized when the sum of authorized and charged
 *     funds covers only part of the `order.total`-`order.totalGrantedRefund`.
 *     We treat the order as not authorized when the sum of authorized and charged funds is
 *     0.
 *
 *     NONE - the funds are not authorized
 *     PARTIAL - the funds that are authorized and charged don't cover fully the
 *     `order.total`-`order.totalGrantedRefund`
 *     FULL - the funds that are authorized and charged fully cover the
 *     `order.total`-`order.totalGrantedRefund`
 *
 */
export type SaleorOrderAuthorizeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'PARTIAL';

/** Filter by authorize status. */
export type SaleorOrderAuthorizeStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorOrderAuthorizeStatusEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorOrderAuthorizeStatusEnum>>;
};

/**
 * Cancels orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderBulkCancel = {
  __typename?: 'OrderBulkCancel';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderError>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Creates multiple orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS_IMPORT.
 */
export type SaleorOrderBulkCreate = {
  __typename?: 'OrderBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderBulkCreateError>;
  /** List of the created orders. */
  results: Array<SaleorOrderBulkCreateResult>;
};

export type SaleorOrderBulkCreateDeliveryMethodInput = {
  /** The ID of the shipping method. */
  shippingMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the shipping method. */
  shippingMethodName?: InputMaybe<Scalars['String']['input']>;
  /** The price of the shipping. */
  shippingPrice?: InputMaybe<SaleorTaxedMoneyInput>;
  /** The ID of the tax class. */
  shippingTaxClassId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Metadata of the tax class. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  shippingTaxClassMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** The name of the tax class. */
  shippingTaxClassName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Private metadata of the tax class. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  shippingTaxClassPrivateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Tax rate of the shipping. */
  shippingTaxRate?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The ID of the warehouse. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the warehouse. */
  warehouseName?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderBulkCreateError = {
  __typename?: 'OrderBulkCreateError';
  /** The error code. */
  code: Maybe<SaleorOrderBulkCreateErrorCode>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderBulkCreateErrorCode =
  | 'BULK_LIMIT'
  | 'FUTURE_DATE'
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_QUANTITY'
  | 'METADATA_KEY_REQUIRED'
  | 'NEGATIVE_INDEX'
  | 'NON_EXISTING_STOCK'
  | 'NOTE_LENGTH'
  | 'NOT_FOUND'
  | 'NO_RELATED_ORDER_LINE'
  | 'ORDER_LINE_FULFILLMENT_LINE_MISMATCH'
  | 'PRICE_ERROR'
  | 'REQUIRED'
  | 'TOO_MANY_IDENTIFIERS'
  | 'UNIQUE';

export type SaleorOrderBulkCreateFulfillmentInput = {
  /** List of items informing how to fulfill the order. */
  lines?: InputMaybe<Array<SaleorOrderBulkCreateFulfillmentLineInput>>;
  /** Fulfillment's tracking code. */
  trackingCode?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderBulkCreateFulfillmentLineInput = {
  /** 0-based index of order line, which the fulfillment line refers to. */
  orderLineIndex: Scalars['Int']['input'];
  /** The number of line items to be fulfilled from given warehouse. */
  quantity: Scalars['Int']['input'];
  /** The external ID of the product variant. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** The SKU of the product variant. */
  variantSku?: InputMaybe<Scalars['String']['input']>;
  /** ID of the warehouse from which the item will be fulfilled. */
  warehouse: Scalars['ID']['input'];
};

export type SaleorOrderBulkCreateInput = {
  /** Billing address of the customer. */
  billingAddress: SaleorAddressInput;
  /** Slug of the channel associated with the order. */
  channel: Scalars['String']['input'];
  /** The date, when the order was inserted to Saleor database. */
  createdAt: Scalars['DateTime']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
  /** Note about customer. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /** The delivery method selected for this order. */
  deliveryMethod?: InputMaybe<SaleorOrderBulkCreateDeliveryMethodInput>;
  /** List of discounts. */
  discounts?: InputMaybe<Array<SaleorOrderDiscountCommonInput>>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** External ID of the order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Fulfillments of the order. */
  fulfillments?: InputMaybe<Array<SaleorOrderBulkCreateFulfillmentInput>>;
  /** List of gift card codes associated with the order. */
  giftCards?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Invoices related to the order. */
  invoices?: InputMaybe<Array<SaleorOrderBulkCreateInvoiceInput>>;
  /** Order language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** List of order lines. */
  lines: Array<SaleorOrderBulkCreateOrderLineInput>;
  /**
   * Metadata of the order. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Notes related to the order. */
  notes?: InputMaybe<Array<SaleorOrderBulkCreateNoteInput>>;
  /**
   * Private metadata of the order. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a view, where users should be redirected to see the order details. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** Status of the order. */
  status?: InputMaybe<SaleorOrderStatus>;
  /** Transactions related to the order. */
  transactions?: InputMaybe<Array<SaleorTransactionCreateInput>>;
  /** Customer associated with the order. */
  user: SaleorOrderBulkCreateUserInput;
  /**
   * Code of a voucher associated with the order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the order in kg. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

export type SaleorOrderBulkCreateInvoiceInput = {
  /** The date, when the invoice was created. */
  createdAt: Scalars['DateTime']['input'];
  /**
   * Metadata of the invoice. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Invoice number. */
  number?: InputMaybe<Scalars['String']['input']>;
  /**
   * Private metadata of the invoice. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of the invoice to download. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderBulkCreateNoteInput = {
  /** The app ID associated with the message. */
  appId?: InputMaybe<Scalars['ID']['input']>;
  /** The date associated with the message. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Note message. Max characters: 255. */
  message: Scalars['String']['input'];
  /** The user email associated with the message. */
  userEmail?: InputMaybe<Scalars['ID']['input']>;
  /** The user external ID associated with the message. */
  userExternalReference?: InputMaybe<Scalars['ID']['input']>;
  /** The user ID associated with the message. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorOrderBulkCreateOrderLineInput = {
  /** The date, when the order line was created. */
  createdAt: Scalars['DateTime']['input'];
  /** Gift card flag. */
  isGiftCard: Scalars['Boolean']['input'];
  /** Determines whether shipping of the order line items is required. */
  isShippingRequired: Scalars['Boolean']['input'];
  /**
   * Metadata of the order line. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Private metadata of the order line. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** The name of the product. */
  productName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The SKU of the product.
   *
   * Added in Saleor 3.18.
   */
  productSku?: InputMaybe<Scalars['String']['input']>;
  /** Number of items in the order line */
  quantity: Scalars['Int']['input'];
  /** The ID of the tax class. */
  taxClassId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Metadata of the tax class. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  taxClassMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** The name of the tax class. */
  taxClassName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Private metadata of the tax class. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  taxClassPrivateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Tax rate of the order line. */
  taxRate?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Price of the order line. */
  totalPrice: SaleorTaxedMoneyInput;
  /** Translation of the product name. */
  translatedProductName?: InputMaybe<Scalars['String']['input']>;
  /** Translation of the product variant name. */
  translatedVariantName?: InputMaybe<Scalars['String']['input']>;
  /** Price of the order line excluding applied discount. */
  undiscountedTotalPrice: SaleorTaxedMoneyInput;
  /**
   * Reason of the discount on order line.
   *
   * Added in Saleor 3.19.
   */
  unitDiscountReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type of the discount: fixed or percent
   *
   * Added in Saleor 3.19.
   */
  unitDiscountType?: InputMaybe<SaleorDiscountValueTypeEnum>;
  /**
   * Value of the discount. Can store fixed value or percent value
   *
   * Added in Saleor 3.19.
   */
  unitDiscountValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The external ID of the product variant. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the product variant. */
  variantName?: InputMaybe<Scalars['String']['input']>;
  /** The SKU of the product variant. */
  variantSku?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the warehouse, where the line will be allocated. */
  warehouse: Scalars['ID']['input'];
};

export type SaleorOrderBulkCreateResult = {
  __typename?: 'OrderBulkCreateResult';
  /** List of errors occurred on create attempt. */
  errors: Maybe<Array<SaleorOrderBulkCreateError>>;
  /** Order data. */
  order: Maybe<SaleorOrder>;
};

export type SaleorOrderBulkCreateUserInput = {
  /** Customer email associated with the order. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Customer external ID associated with the order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Customer ID associated with the order. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Event sent when orders are imported. */
export type SaleorOrderBulkCreated = SaleorEvent & {
  __typename?: 'OrderBulkCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The orders the event relates to. */
  orders: Maybe<Array<SaleorOrder>>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Cancel an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderCancel = {
  __typename?: 'OrderCancel';
  errors: Array<SaleorOrderError>;
  /** Canceled order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** Event sent when order is canceled. */
export type SaleorOrderCancelled = SaleorEvent & {
  __typename?: 'OrderCancelled';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Capture an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderCapture = {
  __typename?: 'OrderCapture';
  errors: Array<SaleorOrderError>;
  /** Captured order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Determine the current charge status for the order.
 *
 *     An order is considered overcharged when the sum of the
 *     transactionItem's charge amounts exceeds the value of
 *     `order.total` - `order.totalGrantedRefund`.
 *     If the sum of the transactionItem's charge amounts equals
 *     `order.total` - `order.totalGrantedRefund`, we consider the order to be fully
 *     charged.
 *     If the sum of the transactionItem's charge amounts covers a part of the
 *     `order.total` - `order.totalGrantedRefund`, we treat the order as partially charged.
 *
 *     NONE - the funds are not charged.
 *     PARTIAL - the funds that are charged don't cover the
 *     `order.total`-`order.totalGrantedRefund`
 *     FULL - the funds that are charged fully cover the
 *     `order.total`-`order.totalGrantedRefund`
 *     OVERCHARGED - the charged funds are bigger than the
 *     `order.total`-`order.totalGrantedRefund`
 *
 */
export type SaleorOrderChargeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'OVERCHARGED'
  | 'PARTIAL';

/** Filter by charge status. */
export type SaleorOrderChargeStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorOrderChargeStatusEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorOrderChargeStatusEnum>>;
};

/**
 * Confirms an unconfirmed order by changing status to unfulfilled.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderConfirm = {
  __typename?: 'OrderConfirm';
  errors: Array<SaleorOrderError>;
  /** Order which has been confirmed. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** Event sent when order is confirmed. */
export type SaleorOrderConfirmed = SaleorEvent & {
  __typename?: 'OrderConfirmed';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderCountableConnection = {
  __typename?: 'OrderCountableConnection';
  edges: Array<SaleorOrderCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorOrderCountableEdge = {
  __typename?: 'OrderCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorOrder;
};

/**
 * Create new order from existing checkout. Requires the following permissions: AUTHENTICATED_APP and HANDLE_CHECKOUTS.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
 * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
 * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
 * - ORDER_CREATED (async): Triggered when order is created.
 * - NOTIFY_USER (async): A notification for order placement.
 * - NOTIFY_USER (async): A staff notification for order placement.
 * - ORDER_UPDATED (async): Triggered when order received the update after placement.
 * - ORDER_PAID (async): Triggered when newly created order is paid.
 * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
 * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
 */
export type SaleorOrderCreateFromCheckout = {
  __typename?: 'OrderCreateFromCheckout';
  errors: Array<SaleorOrderCreateFromCheckoutError>;
  /** Placed order. */
  order: Maybe<SaleorOrder>;
};

export type SaleorOrderCreateFromCheckoutError = {
  __typename?: 'OrderCreateFromCheckoutError';
  /** The error code. */
  code: SaleorOrderCreateFromCheckoutErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** List of line Ids which cause the error. */
  lines: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorOrderCreateFromCheckoutErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_NOT_FOUND'
  | 'EMAIL_NOT_SET'
  | 'GIFT_CARD_NOT_APPLICABLE'
  | 'GRAPHQL_ERROR'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID_SHIPPING_METHOD'
  | 'NO_LINES'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'TAX_ERROR'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'VOUCHER_NOT_APPLICABLE';

/** Event sent when new order is created. */
export type SaleorOrderCreated = SaleorEvent & {
  __typename?: 'OrderCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderDirection =
  /** Specifies an ascending sort order. */
  | 'ASC'
  /** Specifies a descending sort order. */
  | 'DESC';

/** Contains all details related to the applied discount to the order. */
export type SaleorOrderDiscount = SaleorNode & {
  __typename?: 'OrderDiscount';
  /**
   * Returns amount of discount.
   * @deprecated Use `total` instead.
   */
  amount: SaleorMoney;
  /** The ID of discount applied. */
  id: Scalars['ID']['output'];
  /** The name of applied discount. */
  name: Maybe<Scalars['String']['output']>;
  /**
   * Explanation for the applied discount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  reason: Maybe<Scalars['String']['output']>;
  /**
   * The amount of discount applied to the order.
   *
   * Added in Saleor 3.21.
   */
  total: SaleorMoney;
  /** Translated name of the applied discount. */
  translatedName: Maybe<Scalars['String']['output']>;
  /** The type of applied discount: Sale, Voucher or Manual. */
  type: SaleorOrderDiscountType;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['PositiveDecimal']['output'];
  /** Type of the discount: fixed or percent */
  valueType: SaleorDiscountValueTypeEnum;
};

/**
 * Adds discount to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderDiscountAdd = {
  __typename?: 'OrderDiscountAdd';
  errors: Array<SaleorOrderError>;
  /** Order which has been discounted. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderDiscountCommonInput = {
  /** Explanation for the applied discount. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['PositiveDecimal']['input'];
  /** Type of the discount: fixed or percent */
  valueType: SaleorDiscountValueTypeEnum;
};

/**
 * Remove discount from the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderDiscountDelete = {
  __typename?: 'OrderDiscountDelete';
  errors: Array<SaleorOrderError>;
  /** Order which has removed discount. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderDiscountType =
  | 'MANUAL'
  | 'ORDER_PROMOTION'
  | 'PROMOTION'
  | 'SALE'
  | 'VOUCHER';

/**
 * Update discount for the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderDiscountUpdate = {
  __typename?: 'OrderDiscountUpdate';
  errors: Array<SaleorOrderError>;
  /** Order which has been discounted. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderDraftFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  created?: InputMaybe<SaleorDateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderError = {
  __typename?: 'OrderError';
  /** A type of address that causes the error. */
  addressType: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorOrderErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of order line IDs that cause the error. */
  orderLines: Maybe<Array<Scalars['ID']['output']>>;
  /** List of product variants that are associated with the error */
  variants: Maybe<Array<Scalars['ID']['output']>>;
  /** Warehouse ID which causes the error. */
  warehouse: Maybe<Scalars['ID']['output']>;
};

export type SaleorOrderErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CANNOT_CANCEL_FULFILLMENT'
  | 'CANNOT_CANCEL_ORDER'
  | 'CANNOT_DELETE'
  | 'CANNOT_DISCOUNT'
  | 'CANNOT_FULFILL_UNPAID_ORDER'
  | 'CANNOT_REFUND'
  | 'CAPTURE_INACTIVE_PAYMENT'
  | 'CHANNEL_INACTIVE'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FULFILL_ORDER_LINE'
  | 'GIFT_CARD_LINE'
  | 'GRAPHQL_ERROR'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_QUANTITY'
  | 'INVALID_VOUCHER'
  | 'INVALID_VOUCHER_CODE'
  | 'MISSING_ADDRESS_DATA'
  | 'NON_EDITABLE_GIFT_LINE'
  | 'NON_REMOVABLE_GIFT_LINE'
  | 'NOT_AVAILABLE_IN_CHANNEL'
  | 'NOT_EDITABLE'
  | 'NOT_FOUND'
  | 'ORDER_NO_SHIPPING_ADDRESS'
  | 'PAYMENT_ERROR'
  | 'PAYMENT_MISSING'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'REQUIRED'
  | 'SHIPPING_METHOD_NOT_APPLICABLE'
  | 'SHIPPING_METHOD_REQUIRED'
  | 'TAX_ERROR'
  | 'TRANSACTION_ERROR'
  | 'UNIQUE'
  | 'VOID_INACTIVE_PAYMENT'
  | 'ZERO_QUANTITY';

/** History log of the order. */
export type SaleorOrderEvent = SaleorNode & {
  __typename?: 'OrderEvent';
  /** Amount of money. */
  amount: Maybe<Scalars['Float']['output']>;
  /** App that performed the action. Requires of of the following permissions: MANAGE_APPS, MANAGE_ORDERS, OWNER. */
  app: Maybe<SaleorApp>;
  /** Composed ID of the Fulfillment. */
  composedId: Maybe<Scalars['String']['output']>;
  /** Date when event happened at in ISO 8601 format. */
  date: Maybe<Scalars['DateTime']['output']>;
  /** The discount applied to the order. */
  discount: Maybe<SaleorOrderEventDiscountObject>;
  /** Email of the customer. */
  email: Maybe<Scalars['String']['output']>;
  /** Type of an email sent to the customer. */
  emailType: Maybe<SaleorOrderEventsEmailsEnum>;
  /** The lines fulfilled. */
  fulfilledItems: Maybe<Array<SaleorFulfillmentLine>>;
  /** ID of the event associated with an order. */
  id: Scalars['ID']['output'];
  /** Number of an invoice related to the order. */
  invoiceNumber: Maybe<Scalars['String']['output']>;
  /** The concerned lines. */
  lines: Maybe<Array<SaleorOrderEventOrderLineObject>>;
  /** Content of the event. */
  message: Maybe<Scalars['String']['output']>;
  /** User-friendly number of an order. */
  orderNumber: Maybe<Scalars['String']['output']>;
  /** List of oversold lines names. */
  oversoldItems: Maybe<Array<Scalars['String']['output']>>;
  /** The payment gateway of the payment. */
  paymentGateway: Maybe<Scalars['String']['output']>;
  /** The payment reference from the payment provider. */
  paymentId: Maybe<Scalars['String']['output']>;
  /** Number of items. */
  quantity: Maybe<Scalars['Int']['output']>;
  /** The reference of payment's transaction. */
  reference: Maybe<Scalars['String']['output']>;
  /** The order event which is related to this event. */
  related: Maybe<SaleorOrderEvent>;
  /** The order which is related to this order. */
  relatedOrder: Maybe<SaleorOrder>;
  /** Define if shipping costs were included to the refund. */
  shippingCostsIncluded: Maybe<Scalars['Boolean']['output']>;
  /** The transaction reference of captured payment. */
  transactionReference: Maybe<Scalars['String']['output']>;
  /** Order event type. */
  type: Maybe<SaleorOrderEventsEnum>;
  /** User who performed the action. */
  user: Maybe<SaleorUser>;
  /** The warehouse were items were restocked. */
  warehouse: Maybe<SaleorWarehouse>;
};

export type SaleorOrderEventCountableConnection = {
  __typename?: 'OrderEventCountableConnection';
  edges: Array<SaleorOrderEventCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorOrderEventCountableEdge = {
  __typename?: 'OrderEventCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorOrderEvent;
};

export type SaleorOrderEventDiscountObject = {
  __typename?: 'OrderEventDiscountObject';
  /** Returns amount of discount. */
  amount: Maybe<SaleorMoney>;
  /** Returns amount of discount. */
  oldAmount: Maybe<SaleorMoney>;
  /** Value of the discount. Can store fixed value or percent value. */
  oldValue: Maybe<Scalars['PositiveDecimal']['output']>;
  /** Type of the discount: fixed or percent. */
  oldValueType: Maybe<SaleorDiscountValueTypeEnum>;
  /** Explanation for the applied discount. */
  reason: Maybe<Scalars['String']['output']>;
  /** Value of the discount. Can store fixed value or percent value. */
  value: Scalars['PositiveDecimal']['output'];
  /** Type of the discount: fixed or percent. */
  valueType: SaleorDiscountValueTypeEnum;
};

/** Filter input for order events data. */
export type SaleorOrderEventFilterInput = {
  /** Filter order events by date. */
  date?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter order events by type. */
  type?: InputMaybe<SaleorOrderEventTypeEnumFilterInput>;
};

export type SaleorOrderEventOrderLineObject = {
  __typename?: 'OrderEventOrderLineObject';
  /** The discount applied to the order line. */
  discount: Maybe<SaleorOrderEventDiscountObject>;
  /** The variant name. */
  itemName: Maybe<Scalars['String']['output']>;
  /** The order line. */
  orderLine: Maybe<SaleorOrderLine>;
  /** The variant quantity. */
  quantity: Maybe<Scalars['Int']['output']>;
};

export type SaleorOrderEventTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorOrderEventsEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorOrderEventsEnum>>;
};

export type SaleorOrderEventsEmailsEnum =
  | 'CONFIRMED'
  | 'DIGITAL_LINKS'
  | 'FULFILLMENT_CONFIRMATION'
  | 'ORDER_CANCEL'
  | 'ORDER_CONFIRMATION'
  | 'ORDER_REFUND'
  | 'PAYMENT_CONFIRMATION'
  | 'SHIPPING_CONFIRMATION'
  | 'TRACKING_UPDATED';

/** The different order event types.  */
export type SaleorOrderEventsEnum =
  | 'ADDED_PRODUCTS'
  | 'CANCELED'
  | 'CONFIRMED'
  | 'DRAFT_CREATED'
  | 'DRAFT_CREATED_FROM_REPLACE'
  | 'EMAIL_SENT'
  | 'EXPIRED'
  | 'EXTERNAL_SERVICE_NOTIFICATION'
  | 'FULFILLMENT_AWAITS_APPROVAL'
  | 'FULFILLMENT_CANCELED'
  | 'FULFILLMENT_FULFILLED_ITEMS'
  | 'FULFILLMENT_REFUNDED'
  | 'FULFILLMENT_REPLACED'
  | 'FULFILLMENT_RESTOCKED_ITEMS'
  | 'FULFILLMENT_RETURNED'
  | 'INVOICE_GENERATED'
  | 'INVOICE_REQUESTED'
  | 'INVOICE_SENT'
  | 'INVOICE_UPDATED'
  | 'NOTE_ADDED'
  | 'NOTE_UPDATED'
  | 'ORDER_DISCOUNT_ADDED'
  | 'ORDER_DISCOUNT_AUTOMATICALLY_UPDATED'
  | 'ORDER_DISCOUNT_DELETED'
  | 'ORDER_DISCOUNT_UPDATED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_LINE_DISCOUNT_REMOVED'
  | 'ORDER_LINE_DISCOUNT_UPDATED'
  | 'ORDER_LINE_PRODUCT_DELETED'
  | 'ORDER_LINE_VARIANT_DELETED'
  | 'ORDER_MARKED_AS_PAID'
  | 'ORDER_REPLACEMENT_CREATED'
  | 'OTHER'
  | 'OVERSOLD_ITEMS'
  | 'PAYMENT_AUTHORIZED'
  | 'PAYMENT_CAPTURED'
  | 'PAYMENT_FAILED'
  | 'PAYMENT_REFUNDED'
  | 'PAYMENT_VOIDED'
  | 'PLACED'
  | 'PLACED_AUTOMATICALLY_FROM_PAID_CHECKOUT'
  | 'PLACED_FROM_DRAFT'
  | 'REMOVED_PRODUCTS'
  | 'TRACKING_UPDATED'
  | 'TRANSACTION_CANCEL_REQUESTED'
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_EVENT'
  | 'TRANSACTION_MARK_AS_PAID_FAILED'
  | 'TRANSACTION_REFUND_REQUESTED'
  | 'UPDATED_ADDRESS';

/** Event sent when order becomes expired. */
export type SaleorOrderExpired = SaleorEvent & {
  __typename?: 'OrderExpired';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderFilterInput = {
  authorizeStatus?: InputMaybe<Array<SaleorOrderAuthorizeStatusEnum>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  chargeStatus?: InputMaybe<Array<SaleorOrderChargeStatusEnum>>;
  checkoutIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkoutTokens?: InputMaybe<Array<Scalars['UUID']['input']>>;
  created?: InputMaybe<SaleorDateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  giftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  giftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter orders by payment charge status.
   *
   * DEPRECATED: this field will be removed. The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  paymentStatus?: InputMaybe<Array<SaleorPaymentChargeStatusEnum>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<SaleorOrderStatusFilter>>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

/** Filter shipping methods for order. */
export type SaleorOrderFilterShippingMethods = SaleorEvent & {
  __typename?: 'OrderFilterShippingMethods';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods: Maybe<Array<SaleorShippingMethod>>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Creates new fulfillments for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - FULFILLMENT_CREATED (async): A new fulfillment is created.
 * - ORDER_FULFILLED (async): Order is fulfilled.
 * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Sent when fulfillment tracking number is updated.
 * - FULFILLMENT_APPROVED (async): A fulfillment is approved.
 */
export type SaleorOrderFulfill = {
  __typename?: 'OrderFulfill';
  errors: Array<SaleorOrderError>;
  /** List of created fulfillments. */
  fulfillments: Maybe<Array<SaleorFulfillment>>;
  /** Fulfilled order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderFulfillInput = {
  /** If true, then allow proceed fulfillment when stock is exceeded. */
  allowStockToBeExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of items informing how to fulfill the order. */
  lines: Array<SaleorOrderFulfillLineInput>;
  /** If true, send an email notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fulfillment tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderFulfillLineInput = {
  /** The ID of the order line. */
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  /** List of stock items to create. */
  stocks: Array<SaleorOrderFulfillStockInput>;
};

export type SaleorOrderFulfillStockInput = {
  /** The number of line items to be fulfilled from given warehouse. */
  quantity: Scalars['Int']['input'];
  /** ID of the warehouse from which the item will be fulfilled. */
  warehouse: Scalars['ID']['input'];
};

/** Event sent when order is fulfilled. */
export type SaleorOrderFulfilled = SaleorEvent & {
  __typename?: 'OrderFulfilled';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when order is fully paid. */
export type SaleorOrderFullyPaid = SaleorEvent & {
  __typename?: 'OrderFullyPaid';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** The order is fully refunded. */
export type SaleorOrderFullyRefunded = SaleorEvent & {
  __typename?: 'OrderFullyRefunded';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Adds granted refund to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderGrantRefundCreate = {
  __typename?: 'OrderGrantRefundCreate';
  errors: Array<SaleorOrderGrantRefundCreateError>;
  /** Created granted refund. */
  grantedRefund: Maybe<SaleorOrderGrantedRefund>;
  /** Order which has assigned new grant refund. */
  order: Maybe<SaleorOrder>;
};

export type SaleorOrderGrantRefundCreateError = {
  __typename?: 'OrderGrantRefundCreateError';
  /** The error code. */
  code: SaleorOrderGrantRefundCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** List of lines which cause the error. */
  lines: Maybe<Array<SaleorOrderGrantRefundCreateLineError>>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderGrantRefundCreateErrorCode =
  | 'AMOUNT_GREATER_THAN_AVAILABLE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SHIPPING_COSTS_ALREADY_GRANTED';

export type SaleorOrderGrantRefundCreateInput = {
  /** Amount of the granted refund. If not provided, the amount will be calculated automatically based on provided `lines` and `grantRefundForShipping`. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** Determine if granted refund should include shipping costs. */
  grantRefundForShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lines to assign to granted refund. */
  lines?: InputMaybe<Array<SaleorOrderGrantRefundCreateLineInput>>;
  /** Reason of the granted refund. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of a `Page` (Model) to reference in reason.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The ID of the transaction item related to the granted refund. If `amount` provided in the input, the transaction.chargedAmount needs to be equal or greater than provided `amount`.If `amount` is not provided in the input and calculated automatically by Saleor, the `min(calculatedAmount, transaction.chargedAmount)` will be used. Field required starting from Saleor 3.21.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  transactionId: Scalars['ID']['input'];
};

export type SaleorOrderGrantRefundCreateLineError = {
  __typename?: 'OrderGrantRefundCreateLineError';
  /** The error code. */
  code: SaleorOrderGrantRefundCreateLineErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The ID of the line related to the error. */
  lineId: Scalars['ID']['output'];
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderGrantRefundCreateLineErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'QUANTITY_GREATER_THAN_AVAILABLE';

export type SaleorOrderGrantRefundCreateLineInput = {
  /** The ID of the order line. */
  id: Scalars['ID']['input'];
  /** The quantity of line items to be marked to refund. */
  quantity: Scalars['Int']['input'];
  /** Reason of the granted refund for the line. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates granted refund.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderGrantRefundUpdate = {
  __typename?: 'OrderGrantRefundUpdate';
  errors: Array<SaleorOrderGrantRefundUpdateError>;
  /** Created granted refund. */
  grantedRefund: Maybe<SaleorOrderGrantedRefund>;
  /** Order which has assigned updated grant refund. */
  order: Maybe<SaleorOrder>;
};

export type SaleorOrderGrantRefundUpdateError = {
  __typename?: 'OrderGrantRefundUpdateError';
  /** List of lines to add which cause the error. */
  addLines: Maybe<Array<SaleorOrderGrantRefundUpdateLineError>>;
  /** The error code. */
  code: SaleorOrderGrantRefundUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of lines to remove which cause the error. */
  removeLines: Maybe<Array<SaleorOrderGrantRefundUpdateLineError>>;
};

export type SaleorOrderGrantRefundUpdateErrorCode =
  | 'AMOUNT_GREATER_THAN_AVAILABLE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SHIPPING_COSTS_ALREADY_GRANTED';

export type SaleorOrderGrantRefundUpdateInput = {
  /** Lines to assign to granted refund. */
  addLines?: InputMaybe<Array<SaleorOrderGrantRefundUpdateLineAddInput>>;
  /** Amount of the granted refund. if not provided and `addLines` or `removeLines` or `grantRefundForShipping` is provided, amount will be calculated automatically. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** Determine if granted refund should include shipping costs. */
  grantRefundForShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason of the granted refund. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of a `Page` (Model) to reference in reason.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: InputMaybe<Scalars['ID']['input']>;
  /** Lines to remove from granted refund. */
  removeLines?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The ID of the transaction item related to the granted refund. If `amount` provided in the input, the transaction.chargedAmount needs to be equal or greater than provided `amount`.If `amount` is not provided in the input and calculated automatically by Saleor, the `min(calculatedAmount, transaction.chargedAmount)` will be used.Field will be required starting from Saleor 3.21.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorOrderGrantRefundUpdateLineAddInput = {
  /** The ID of the order line. */
  id: Scalars['ID']['input'];
  /** The quantity of line items to be marked to refund. */
  quantity: Scalars['Int']['input'];
  /** Reason of the granted refund for the line. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderGrantRefundUpdateLineError = {
  __typename?: 'OrderGrantRefundUpdateLineError';
  /** The error code. */
  code: SaleorOrderGrantRefundUpdateLineErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The ID of the line related to the error. */
  lineId: Scalars['ID']['output'];
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderGrantRefundUpdateLineErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'QUANTITY_GREATER_THAN_AVAILABLE';

/** The details of granted refund. */
export type SaleorOrderGrantedRefund = {
  __typename?: 'OrderGrantedRefund';
  /** Refund amount. */
  amount: SaleorMoney;
  /** App that performed the action. */
  app: Maybe<SaleorApp>;
  /** Time of creation. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Lines assigned to the granted refund. */
  lines: Maybe<Array<SaleorOrderGrantedRefundLine>>;
  /**
   * Reason of the refund.
   *
   * Added in Saleor 3.22.
   */
  reason: Maybe<Scalars['String']['output']>;
  /**
   * Reason Model (Page) reference for refund.
   *
   * Added in Saleor 3.22.
   */
  reasonReference: Maybe<SaleorPage>;
  /** If true, the refunded amount includes the shipping price.If false, the refunded amount does not include the shipping price. */
  shippingCostsIncluded: Scalars['Boolean']['output'];
  /**
   * Status of the granted refund calculated based on transactionItem assigned to granted refund.
   *
   * Added in Saleor 3.20.
   */
  status: SaleorOrderGrantedRefundStatusEnum;
  /**
   * The transaction assigned to the granted refund.
   *
   * Added in Saleor 3.20.
   */
  transaction: Maybe<SaleorTransactionItem>;
  /**
   * List of refund events associated with the granted refund.
   *
   * Added in Saleor 3.20.
   */
  transactionEvents: Maybe<Array<SaleorTransactionEvent>>;
  /** Time of last update. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who performed the action. Requires of of the following permissions: MANAGE_USERS, MANAGE_STAFF, OWNER. */
  user: Maybe<SaleorUser>;
};

/** Represents granted refund line. */
export type SaleorOrderGrantedRefundLine = {
  __typename?: 'OrderGrantedRefundLine';
  id: Scalars['ID']['output'];
  /** Line of the order associated with this granted refund. */
  orderLine: SaleorOrderLine;
  /** Number of items to refund. */
  quantity: Scalars['Int']['output'];
  /** Reason for refunding the line. */
  reason: Maybe<Scalars['String']['output']>;
};

/**
 * Represents the status of a granted refund.
 *
 *     NONE - the refund on related transactionItem is not processed
 *     PENDING - the refund on related transactionItem is pending
 *     FULL - the refund on related transactionItem is fully processed
 *     FAIL - the refund on related transactionItem failed
 *
 */
export type SaleorOrderGrantedRefundStatusEnum =
  | 'FAILURE'
  | 'NONE'
  | 'PENDING'
  | 'SUCCESS';

/** Represents order line of particular order. */
export type SaleorOrderLine = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'OrderLine';
  /**
   * List of allocations across warehouses.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  allocations: Maybe<Array<SaleorAllocation>>;
  digitalContentUrl: Maybe<SaleorDigitalContentUrl>;
  /**
   * List of applied discounts
   *
   * Added in Saleor 3.21.
   */
  discounts: Maybe<Array<SaleorOrderLineDiscount>>;
  /** ID of the order line. */
  id: Scalars['ID']['output'];
  /**
   * Determine if the line is a gift.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  isGift: Maybe<Scalars['Boolean']['output']>;
  /** Returns True, if the line unit price was overridden. */
  isPriceOverridden: Maybe<Scalars['Boolean']['output']>;
  /** Whether the product variant requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the product in order line. */
  productName: Scalars['String']['output'];
  /** SKU of the product variant. */
  productSku: Maybe<Scalars['String']['output']>;
  /** The ID of the product variant. */
  productVariantId: Maybe<Scalars['String']['output']>;
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['output'];
  /** Number of variant items fulfilled. */
  quantityFulfilled: Scalars['Int']['output'];
  /** A quantity of items remaining to be fulfilled. */
  quantityToFulfill: Scalars['Int']['output'];
  /** Denormalized sale ID, set when order line is created for a product variant that is on sale. */
  saleId: Maybe<Scalars['ID']['output']>;
  /**
   * Denormalized tax class of the product in this order line.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass: Maybe<SaleorTaxClass>;
  /** Denormalized public metadata of the tax class. */
  taxClassMetadata: Array<SaleorMetadataItem>;
  /** Denormalized name of the tax class. */
  taxClassName: Maybe<Scalars['String']['output']>;
  /** Denormalized private metadata of the tax class. Requires staff permissions to access. */
  taxClassPrivateMetadata: Array<SaleorMetadataItem>;
  /** Rate of tax applied on product variant. */
  taxRate: Scalars['Float']['output'];
  thumbnail: Maybe<SaleorImage>;
  /** Price of the order line. */
  totalPrice: SaleorTaxedMoney;
  /** Product name in the customer's language */
  translatedProductName: Scalars['String']['output'];
  /** Variant name in the customer's language */
  translatedVariantName: Scalars['String']['output'];
  /** Price of the order line without discounts. */
  undiscountedTotalPrice: SaleorTaxedMoney;
  /** Price of the single item in the order line without any discount applied. */
  undiscountedUnitPrice: SaleorTaxedMoney;
  /** Sum of the line-level discounts applied to the order line. Order-level discounts which affect the line are not visible in this field. For order-level discount portion (if any), please query `order.discounts` field. */
  unitDiscount: SaleorMoney;
  /** Reason for line-level discounts applied on the order line. Order-level discounts which affect the line are not visible in this field. For order-level discount reason (if any), please query `order.discounts` field. */
  unitDiscountReason: Maybe<Scalars['String']['output']>;
  /** Type of the discount: `fixed` or `percent`. This field shouldn't be used when multiple discounts affect the line. There is a limitation, that after running `checkoutComplete` mutation the field is always set to `fixed`. */
  unitDiscountType: Maybe<SaleorDiscountValueTypeEnum>;
  /** Value of the discount. Can store fixed value or percent value. This field shouldn't be used when multiple discounts affect the line. There is a limitation, that after running `checkoutComplete` mutation the field always stores fixed value. */
  unitDiscountValue: Scalars['PositiveDecimal']['output'];
  /** Price of the single item in the order line with all the line-level discounts and order-level discount portions applied. */
  unitPrice: SaleorTaxedMoney;
  /** A purchased product variant. Note: this field may be null if the variant has been removed from stock at all. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  variant: Maybe<SaleorProductVariant>;
  /** Name of the variant of product in order line. */
  variantName: Scalars['String']['output'];
  /** Voucher code that was used for this order line. */
  voucherCode: Maybe<Scalars['String']['output']>;
};


/** Represents order line of particular order. */
export type SaleorOrderLineMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order line of particular order. */
export type SaleorOrderLineMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order line of particular order. */
export type SaleorOrderLinePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order line of particular order. */
export type SaleorOrderLinePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order line of particular order. */
export type SaleorOrderLineThumbnailArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorOrderLineCreateInput = {
  /** Flag that allow force splitting the same variant into multiple lines by skipping the matching logic.  */
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom price of the item.When the line with the same variant will be provided multiple times, the last price will be used. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['input'];
  /** Product variant ID. */
  variantId: Scalars['ID']['input'];
};

/**
 * Deletes an order line from an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineDelete = {
  __typename?: 'OrderLineDelete';
  errors: Array<SaleorOrderError>;
  /** A related order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** An order line that was deleted. */
  orderLine: Maybe<SaleorOrderLine>;
};

/** Represent the discount applied to order line. */
export type SaleorOrderLineDiscount = {
  __typename?: 'OrderLineDiscount';
  /** The ID of discount applied. */
  id: Scalars['ID']['output'];
  /** The name of applied discount. */
  name: Maybe<Scalars['String']['output']>;
  /**
   * Explanation for the applied discount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  reason: Maybe<Scalars['String']['output']>;
  /** The discount amount applied to the line item. */
  total: SaleorMoney;
  /** Translated name of the applied discount. */
  translatedName: Maybe<Scalars['String']['output']>;
  /** The type of applied discount: Sale, Voucher or Manual. */
  type: SaleorOrderDiscountType;
  /** The discount amount applied to the single line unit. */
  unit: SaleorMoney;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['PositiveDecimal']['output'];
  /** Type of the discount: fixed or percent */
  valueType: SaleorDiscountValueTypeEnum;
};

/**
 * Remove discount applied to the order line.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineDiscountRemove = {
  __typename?: 'OrderLineDiscountRemove';
  errors: Array<SaleorOrderError>;
  /** Order which is related to line which has removed discount. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** Order line which has removed discount. */
  orderLine: Maybe<SaleorOrderLine>;
};

/**
 * Update discount for the order line.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineDiscountUpdate = {
  __typename?: 'OrderLineDiscountUpdate';
  errors: Array<SaleorOrderError>;
  /** Order which is related to the discounted line. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** Order line which has been discounted. */
  orderLine: Maybe<SaleorOrderLine>;
};

export type SaleorOrderLineInput = {
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['input'];
};

/**
 * Updates an order line of an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineUpdate = {
  __typename?: 'OrderLineUpdate';
  errors: Array<SaleorOrderError>;
  /** Related order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  orderLine: Maybe<SaleorOrderLine>;
};

/**
 * Creates order lines for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLinesCreate = {
  __typename?: 'OrderLinesCreate';
  errors: Array<SaleorOrderError>;
  /** Related order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** List of added order lines. */
  orderLines: Maybe<Array<SaleorOrderLine>>;
};

/**
 * Mark order as manually paid.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderMarkAsPaid = {
  __typename?: 'OrderMarkAsPaid';
  errors: Array<SaleorOrderError>;
  /** Order marked as paid. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** Event sent when order metadata is updated. */
export type SaleorOrderMetadataUpdated = SaleorEvent & {
  __typename?: 'OrderMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Adds note to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderNoteAdd = {
  __typename?: 'OrderNoteAdd';
  errors: Array<SaleorOrderNoteAddError>;
  /** Order note created. */
  event: Maybe<SaleorOrderEvent>;
  /** Order with the note added. */
  order: Maybe<SaleorOrder>;
};

export type SaleorOrderNoteAddError = {
  __typename?: 'OrderNoteAddError';
  /** The error code. */
  code: Maybe<SaleorOrderNoteAddErrorCode>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderNoteAddErrorCode =
  | 'GRAPHQL_ERROR'
  | 'REQUIRED';

export type SaleorOrderNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Updates note of an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderNoteUpdate = {
  __typename?: 'OrderNoteUpdate';
  errors: Array<SaleorOrderNoteUpdateError>;
  /** Order note updated. */
  event: Maybe<SaleorOrderEvent>;
  /** Order with the note updated. */
  order: Maybe<SaleorOrder>;
};

export type SaleorOrderNoteUpdateError = {
  __typename?: 'OrderNoteUpdateError';
  /** The error code. */
  code: Maybe<SaleorOrderNoteUpdateErrorCode>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderNoteUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorOrderOrCheckout = SaleorCheckout | SaleorOrder;

export type SaleorOrderOriginEnum =
  | 'BULK_CREATE'
  | 'CHECKOUT'
  | 'DRAFT'
  | 'REISSUE';

/** Payment has been made. The order may be partially or fully paid. */
export type SaleorOrderPaid = SaleorEvent & {
  __typename?: 'OrderPaid';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderPredicateInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorOrderPredicateInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorOrderPredicateInput>>;
  /** Defines the conditions related to checkout and order objects. */
  discountedObjectPredicate?: InputMaybe<SaleorDiscountedObjectWhereInput>;
};

/**
 * Refund an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderRefund = {
  __typename?: 'OrderRefund';
  errors: Array<SaleorOrderError>;
  /** A refunded order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderRefundFulfillmentLineInput = {
  /** The ID of the fulfillment line to refund. */
  fulfillmentLineId: Scalars['ID']['input'];
  /** The number of items to be refunded. */
  quantity: Scalars['Int']['input'];
};

export type SaleorOrderRefundLineInput = {
  /** The ID of the order line to refund. */
  orderLineId: Scalars['ID']['input'];
  /** The number of items to be refunded. */
  quantity: Scalars['Int']['input'];
};

export type SaleorOrderRefundProductsInput = {
  /** The total amount of refund when the value is provided manually. */
  amountToRefund?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** List of fulfilled lines to refund. */
  fulfillmentLines?: InputMaybe<Array<SaleorOrderRefundFulfillmentLineInput>>;
  /** If true, Saleor will refund shipping costs. If amountToRefund is providedincludeShippingCosts will be ignored. */
  includeShippingCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of unfulfilled lines to refund. */
  orderLines?: InputMaybe<Array<SaleorOrderRefundLineInput>>;
};

/** The order received a refund. The order may be partially or fully refunded. */
export type SaleorOrderRefunded = SaleorEvent & {
  __typename?: 'OrderRefunded';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderReturnFulfillmentLineInput = {
  /** The ID of the fulfillment line to return. */
  fulfillmentLineId: Scalars['ID']['input'];
  /** The number of items to be returned. */
  quantity: Scalars['Int']['input'];
  /** Determines, if the line should be added to replace order. */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorOrderReturnLineInput = {
  /** The ID of the order line to return. */
  orderLineId: Scalars['ID']['input'];
  /** The number of items to be returned. */
  quantity: Scalars['Int']['input'];
  /** Determines, if the line should be added to replace order. */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorOrderReturnProductsInput = {
  /** The total amount of refund when the value is provided manually. */
  amountToRefund?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** List of fulfilled lines to return. */
  fulfillmentLines?: InputMaybe<Array<SaleorOrderReturnFulfillmentLineInput>>;
  /** If true, Saleor will refund shipping costs. If amountToRefund is providedincludeShippingCosts will be ignored. */
  includeShippingCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of unfulfilled lines to return. */
  orderLines?: InputMaybe<Array<SaleorOrderReturnLineInput>>;
  /** If true, Saleor will call refund action for all lines. */
  refund?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the channel-specific order settings. */
export type SaleorOrderSettings = {
  __typename?: 'OrderSettings';
  /** Determine if it is possible to place unpaid order by calling `checkoutComplete` mutation. */
  allowUnpaidOrders: Scalars['Boolean']['output'];
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. */
  automaticallyConfirmAllNewOrders: Scalars['Boolean']['output'];
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. */
  automaticallyFulfillNonShippableGiftCard: Scalars['Boolean']['output'];
  /** The time in days after expired orders will be deleted. */
  deleteExpiredOrdersAfter: Scalars['Day']['output'];
  /**
   * Time in hours after which the draft order line price will be refreshed.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderLinePriceFreezePeriod: Maybe<Scalars['Hour']['output']>;
  /** Expiration time in minutes. Default null - means do not expire any orders. */
  expireOrdersAfter: Maybe<Scalars['Minute']['output']>;
  /**
   * Determine if voucher applied on draft order should be count toward voucher usage.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  includeDraftOrderInVoucherUsage: Scalars['Boolean']['output'];
  /**
   * Determine what strategy will be used to mark the order as paid. Based on the chosen option, the proper object will be created and attached to the order when it's manually marked as paid.
   * `PAYMENT_FLOW` - [default option] creates the `Payment` object.
   * `TRANSACTION_FLOW` - creates the `TransactionItem` object.
   */
  markAsPaidStrategy: SaleorMarkAsPaidStrategyEnum;
  /**
   * This flag only affects orders created from checkout and applies specifically to vouchers of the types: `SPECIFIC_PRODUCT` and `ENTIRE_ORDER` with `applyOncePerOrder` enabled.
   * - When legacy propagation is enabled, discounts from these vouchers are represented as `OrderDiscount` objects, attached to the order and returned in the `Order.discounts` field. Additionally, percentage-based vouchers are converted to fixed-value discounts.
   * - When legacy propagation is disabled, discounts are represented as `OrderLineDiscount` objects, attached to individual lines and returned in the `OrderLine.discounts` field. In this case, percentage-based vouchers retain their original type.
   * In future releases, `OrderLineDiscount` will become the default behavior, and this flag will be deprecated and removed.
   *
   * Added in Saleor 3.21.
   */
  useLegacyLineDiscountPropagation: Scalars['Boolean']['output'];
};

export type SaleorOrderSettingsError = {
  __typename?: 'OrderSettingsError';
  /** The error code. */
  code: SaleorOrderSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderSettingsErrorCode =
  | 'INVALID';

export type SaleorOrderSettingsInput = {
  /** Determine if it is possible to place unpaid order by calling `checkoutComplete` mutation. */
  allowUnpaidOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. By default set to True */
  automaticallyConfirmAllNewOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. By default set to True. */
  automaticallyFulfillNonShippableGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The time in days after expired orders will be deleted.Allowed range is from 1 to 120. */
  deleteExpiredOrdersAfter?: InputMaybe<Scalars['Day']['input']>;
  /**
   * Time in hours after which the draft order line price will be refreshed. Default value is 24 hours. Enter 0 or null to disable.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderLinePriceFreezePeriod?: InputMaybe<Scalars['Hour']['input']>;
  /** Expiration time in minutes. Default null - means do not expire any orders. Enter 0 or null to disable. */
  expireOrdersAfter?: InputMaybe<Scalars['Minute']['input']>;
  /**
   * Specify whether a coupon applied to draft orders will count toward voucher usage.
   *
   * Warning:  when switching this setting from `false` to `true`, the vouchers will be disconnected from all draft orders.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  includeDraftOrderInVoucherUsage?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Determine what strategy will be used to mark the order as paid. Based on the chosen option, the proper object will be created and attached to the order when it's manually marked as paid.
   * `PAYMENT_FLOW` - [default option] creates the `Payment` object.
   * `TRANSACTION_FLOW` - creates the `TransactionItem` object.
   */
  markAsPaidStrategy?: InputMaybe<SaleorMarkAsPaidStrategyEnum>;
  /**
   * This flag only affects orders created from checkout and applies specifically to vouchers of the types: `SPECIFIC_PRODUCT` and `ENTIRE_ORDER` with `applyOncePerOrder` enabled.
   * - When legacy propagation is enabled, discounts from these vouchers are represented as `OrderDiscount` objects, attached to the order and returned in the `Order.discounts` field. Additionally, percentage-based vouchers are converted to fixed-value discounts.
   * - When legacy propagation is disabled, discounts are represented as `OrderLineDiscount` objects, attached to individual lines and returned in the `OrderLine.discounts` field. In this case, percentage-based vouchers retain their original type.
   * In future releases, `OrderLineDiscount` will become the default behavior, and this flag will be deprecated and removed.
   *
   * Added in Saleor 3.21.
   */
  useLegacyLineDiscountPropagation?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Update shop order settings across all channels. Returns `orderSettings` for the first `channel` in alphabetical order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderSettingsUpdate = {
  __typename?: 'OrderSettingsUpdate';
  errors: Array<SaleorOrderSettingsError>;
  /** Order settings. */
  orderSettings: Maybe<SaleorOrderSettings>;
  /** @deprecated Use `errors` field instead. */
  orderSettingsErrors: Array<SaleorOrderSettingsError>;
};

export type SaleorOrderSettingsUpdateInput = {
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. By default set to True */
  automaticallyConfirmAllNewOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. By default set to True. */
  automaticallyFulfillNonShippableGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorOrderSortField =
  /** Sort orders by creation date. */
  | 'CREATED_AT'
  /** Sort orders by creation date */
  | 'CREATION_DATE'
  /** Sort orders by customer. */
  | 'CUSTOMER'
  /** Sort orders by fulfillment status. */
  | 'FULFILLMENT_STATUS'
  /** Sort orders by last modified date. */
  | 'LAST_MODIFIED_AT'
  /** Sort orders by number. */
  | 'NUMBER'
  /** Sort orders by payment status. */
  | 'PAYMENT'
  /** Sort orders by rank. Note: This option is available only with the `search` filter. */
  | 'RANK'
  /**
   * Sort orders by order status.
   *
   * Added in Saleor 3.22.
   */
  | 'STATUS';

export type SaleorOrderSortingInput = {
  /** Specifies the direction in which to sort orders. */
  direction: SaleorOrderDirection;
  /** Sort orders by the selected field. */
  field: SaleorOrderSortField;
};

export type SaleorOrderStatus =
  | 'CANCELED'
  | 'DRAFT'
  | 'EXPIRED'
  | 'FULFILLED'
  | 'PARTIALLY_FULFILLED'
  | 'PARTIALLY_RETURNED'
  | 'RETURNED'
  | 'UNCONFIRMED'
  | 'UNFULFILLED';

/** Filter by order status. */
export type SaleorOrderStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorOrderStatus>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorOrderStatus>>;
};

export type SaleorOrderStatusFilter =
  | 'CANCELED'
  | 'FULFILLED'
  | 'PARTIALLY_FULFILLED'
  | 'READY_TO_CAPTURE'
  | 'READY_TO_FULFILL'
  | 'UNCONFIRMED'
  | 'UNFULFILLED';

/**
 * Updates an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderUpdate = {
  __typename?: 'OrderUpdate';
  errors: Array<SaleorOrderError>;
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderUpdateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** External ID of this order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Order language code.
   *
   * Added in Saleor 3.21.
   */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /**
   * Order public metadata.
   *
   * Added in Saleor 3.21.Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Order private metadata.
   *
   * Added in Saleor 3.21.Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a shipping method of the order. Requires shipping method ID to update, when null is passed then currently assigned shipping method is removed.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderUpdateShipping = {
  __typename?: 'OrderUpdateShipping';
  errors: Array<SaleorOrderError>;
  /** Order with updated shipping method. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderUpdateShippingInput = {
  /** ID of the selected shipping method, pass null to remove currently assigned shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
};

/** Event sent when order is updated. */
export type SaleorOrderUpdated = SaleorEvent & {
  __typename?: 'OrderUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Void an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderVoid = {
  __typename?: 'OrderVoid';
  errors: Array<SaleorOrderError>;
  /** A voided order. */
  order: Maybe<SaleorOrder>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorOrderWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorOrderWhereInput>>;
  /** Filter by authorize status. */
  authorizeStatus?: InputMaybe<SaleorOrderAuthorizeStatusEnumFilterInput>;
  /** Filter by billing address of the order. */
  billingAddress?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by channel. */
  channelId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by charge status. */
  chargeStatus?: InputMaybe<SaleorOrderChargeStatusEnumFilterInput>;
  /** Filter by checkout id. */
  checkoutId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by checkout token. */
  checkoutToken?: InputMaybe<SaleorUuidFilterInput>;
  /** Filter order by created at date. */
  createdAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by order events. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  events?: InputMaybe<Array<SaleorOrderEventFilterInput>>;
  /** Filter by fulfillment data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  fulfillments?: InputMaybe<Array<SaleorFulfillmentFilterInput>>;
  /** Filter by whether the order has any fulfillments. */
  hasFulfillments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the order has any invoices. */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by invoice data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  invoices?: InputMaybe<Array<SaleorInvoiceFilterInput>>;
  /** Filter by whether the order uses the click and collect delivery method. */
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether the order includes a gift card purchase. */
  isGiftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether a gift card was used in the order. */
  isGiftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by line items associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  lines?: InputMaybe<Array<SaleorLinesFilterInput>>;
  /** Filter by number of lines in the order. */
  linesCount?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by order number. */
  number?: InputMaybe<SaleorIntFilterInput>;
  /** Filter by the product type of related order lines. */
  productTypeId?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by shipping address of the order. */
  shippingAddress?: InputMaybe<SaleorAddressFilterInput>;
  /** Filter by order status. */
  status?: InputMaybe<SaleorOrderStatusEnumFilterInput>;
  /** Filter by total gross amount of the order. */
  totalGross?: InputMaybe<SaleorPriceFilterInput>;
  /** Filter by total net amount of the order. */
  totalNet?: InputMaybe<SaleorPriceFilterInput>;
  /** Filter by transaction data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  transactions?: InputMaybe<Array<SaleorTransactionFilterInput>>;
  /** Filter order by updated at date. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Filter by user. */
  user?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by user email. */
  userEmail?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by voucher code used in the order. */
  voucherCode?: InputMaybe<SaleorStringFilterInput>;
};

/**
 * Represents a payment method used for a transaction.
 *
 * Added in Saleor 3.22.
 */
export type SaleorOtherPaymentMethodDetails = SaleorPaymentMethodDetails & {
  __typename?: 'OtherPaymentMethodDetails';
  /** Name of the payment method. */
  name: Scalars['String']['output'];
};

export type SaleorOtherPaymentMethodDetailsInput = {
  /** Name of the payment method used for the transaction. */
  name: Scalars['String']['input'];
};

/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPage = SaleorNode & SaleorObjectWithAttributes & SaleorObjectWithMetadata & {
  __typename?: 'Page';
  /**
   * Get a single attribute attached to page by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute: Maybe<SaleorAssignedAttribute>;
  /**
   * List of attributes assigned to this page.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<SaleorAssignedAttribute>;
  /**
   * Get a single attribute attached to page by attribute slug.
   * @deprecated Use `assignedAttribute` field instead.
   */
  attribute: Maybe<SaleorSelectedAttribute>;
  /**
   * List of attributes assigned to this page.
   * @deprecated Use `assignedAttributes` field instead.
   */
  attributes: Array<SaleorSelectedAttribute>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content: Maybe<Scalars['JSONString']['output']>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `content` field instead.
   */
  contentJson: Scalars['JSONString']['output'];
  /** Date and time at which page was created. */
  created: Scalars['DateTime']['output'];
  /** ID of the page. */
  id: Scalars['ID']['output'];
  /** Determines if the page is published. */
  isPublished: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Determines the type of page */
  pageType: SaleorPageType;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** @deprecated Use the `publishedAt` field to fetch the publication date. */
  publicationDate: Maybe<Scalars['Date']['output']>;
  /** The page publication date. */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** Description of the page for SEO. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** Title of the page for SEO. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /** Slug of the page. */
  slug: Scalars['String']['output'];
  /** Title of the page. */
  title: Scalars['String']['output'];
  /** Returns translated page fields for the given language code. */
  translation: Maybe<SaleorPageTranslation>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPagePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPagePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Assign attributes to a given page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageAttributeAssign = {
  __typename?: 'PageAttributeAssign';
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  /** The updated page type. */
  pageType: Maybe<SaleorPageType>;
};

/**
 * Unassign attributes from a given page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageAttributeUnassign = {
  __typename?: 'PageAttributeUnassign';
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  /** The updated page type. */
  pageType: Maybe<SaleorPageType>;
};

/**
 * Deletes pages.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageBulkDelete = {
  __typename?: 'PageBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

/**
 * Publish pages.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageBulkPublish = {
  __typename?: 'PageBulkPublish';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageCountableConnection = {
  __typename?: 'PageCountableConnection';
  edges: Array<SaleorPageCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorPageCountableEdge = {
  __typename?: 'PageCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPage;
};

/**
 * Creates a new page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageCreate = {
  __typename?: 'PageCreate';
  errors: Array<SaleorPageError>;
  page: Maybe<SaleorPage>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /**
   * Page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['JSONString']['input']>;
  /** Determines if page is visible in the storefront. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the page type that page belongs to. */
  pageType: Scalars['ID']['input'];
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Page internal name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Page title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new page is created. */
export type SaleorPageCreated = SaleorEvent & {
  __typename?: 'PageCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The page the event relates to. */
  page: Maybe<SaleorPage>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageDelete = {
  __typename?: 'PageDelete';
  errors: Array<SaleorPageError>;
  page: Maybe<SaleorPage>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

/** Event sent when page is deleted. */
export type SaleorPageDeleted = SaleorEvent & {
  __typename?: 'PageDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The page the event relates to. */
  page: Maybe<SaleorPage>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPageError = {
  __typename?: 'PageError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorPageErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorPageErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorPageFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  pageTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type SaleorPageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type SaleorPageInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /**
   * Page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['JSONString']['input']>;
  /** Determines if page is visible in the storefront. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Page internal name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Page title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Reorder page attribute values.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageReorderAttributeValues = {
  __typename?: 'PageReorderAttributeValues';
  errors: Array<SaleorPageError>;
  /** Page from which attribute values are reordered. */
  page: Maybe<SaleorPage>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageSortField =
  /** Sort pages by creation date. */
  | 'CREATED_AT'
  /** Sort pages by creation date. */
  | 'CREATION_DATE'
  /** Sort pages by publication date. */
  | 'PUBLICATION_DATE'
  /** Sort pages by publication date. */
  | 'PUBLISHED_AT'
  /** Sort pages by slug. */
  | 'SLUG'
  /** Sort pages by title. */
  | 'TITLE'
  /** Sort pages by visibility. */
  | 'VISIBILITY';

export type SaleorPageSortingInput = {
  /** Specifies the direction in which to sort pages. */
  direction: SaleorOrderDirection;
  /** Sort pages by the selected field. */
  field: SaleorPageSortField;
};

/** Represents page's original translatable fields and related translations. */
export type SaleorPageTranslatableContent = SaleorNode & {
  __typename?: 'PageTranslatableContent';
  /** List of page content attribute values that can be translated. */
  attributeValues: Array<SaleorAttributeValueTranslatableContent>;
  /**
   * Content of the page to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content: Maybe<Scalars['JSONString']['output']>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `content` field instead.
   */
  contentJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the page translatable content. */
  id: Scalars['ID']['output'];
  /**
   * A static page that can be manually added by a shop operator through the dashboard.
   * @deprecated Get model fields from the root level queries.
   */
  page: Maybe<SaleorPage>;
  /** The ID of the page to translate. */
  pageId: Scalars['ID']['output'];
  /** SEO description to translate. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Page title to translate. */
  title: Scalars['String']['output'];
  /** Returns translated page fields for the given language code. */
  translation: Maybe<SaleorPageTranslation>;
};


/** Represents page's original translatable fields and related translations. */
export type SaleorPageTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a page.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorPageTranslate = {
  __typename?: 'PageTranslate';
  errors: Array<SaleorTranslationError>;
  page: Maybe<SaleorPageTranslatableContent>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

/** Represents page translations. */
export type SaleorPageTranslation = SaleorNode & {
  __typename?: 'PageTranslation';
  /**
   * Translated content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `content` field instead.
   */
  contentJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the page translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated SEO description. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Translated page slug.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Translated page title. */
  title: Maybe<Scalars['String']['output']>;
  /** Represents the page fields to translate. */
  translatableContent: Maybe<SaleorPageTranslatableContent>;
};

export type SaleorPageTranslationInput = {
  /**
   * Translated page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['JSONString']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageType = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'PageType';
  /** Page attributes of that page type. */
  attributes: Maybe<Array<SaleorAttribute>>;
  /**
   * Attributes that can be assigned to the page type.
   *
   * Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  availableAttributes: Maybe<SaleorAttributeCountableConnection>;
  /**
   * Whether page type has pages assigned.
   *
   * Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  hasPages: Maybe<Scalars['Boolean']['output']>;
  /** ID of the page type. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the page type. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Slug of the page type. */
  slug: Scalars['String']['output'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypeAvailableAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SaleorAttributeWhereInput>;
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes page types.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeBulkDelete = {
  __typename?: 'PageTypeBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageTypeCountableConnection = {
  __typename?: 'PageTypeCountableConnection';
  edges: Array<SaleorPageTypeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorPageTypeCountableEdge = {
  __typename?: 'PageTypeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPageType;
};

/**
 * Creates a new page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeCreate = {
  __typename?: 'PageTypeCreate';
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  pageType: Maybe<SaleorPageType>;
};

export type SaleorPageTypeCreateInput = {
  /** List of attribute IDs to be assigned to the page type. */
  addAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the page type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new page type is created. */
export type SaleorPageTypeCreated = SaleorEvent & {
  __typename?: 'PageTypeCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The page type the event relates to. */
  pageType: Maybe<SaleorPageType>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeDelete = {
  __typename?: 'PageTypeDelete';
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  pageType: Maybe<SaleorPageType>;
};

/** Event sent when page type is deleted. */
export type SaleorPageTypeDeleted = SaleorEvent & {
  __typename?: 'PageTypeDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The page type the event relates to. */
  pageType: Maybe<SaleorPageType>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPageTypeFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Reorder the attributes of a page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeReorderAttributes = {
  __typename?: 'PageTypeReorderAttributes';
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  /** Page type from which attributes are reordered. */
  pageType: Maybe<SaleorPageType>;
};

export type SaleorPageTypeSortField =
  /** Sort page types by name. */
  | 'NAME'
  /** Sort page types by slug. */
  | 'SLUG';

export type SaleorPageTypeSortingInput = {
  /** Specifies the direction in which to sort page types. */
  direction: SaleorOrderDirection;
  /** Sort page types by the selected field. */
  field: SaleorPageTypeSortField;
};

/**
 * Updates page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeUpdate = {
  __typename?: 'PageTypeUpdate';
  errors: Array<SaleorPageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  pageType: Maybe<SaleorPageType>;
};

export type SaleorPageTypeUpdateInput = {
  /** List of attribute IDs to be assigned to the page type. */
  addAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the page type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of attribute IDs to be assigned to the page type. */
  removeAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Page type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when page type is updated. */
export type SaleorPageTypeUpdated = SaleorEvent & {
  __typename?: 'PageTypeUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The page type the event relates to. */
  pageType: Maybe<SaleorPageType>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an existing page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageUpdate = {
  __typename?: 'PageUpdate';
  errors: Array<SaleorPageError>;
  page: Maybe<SaleorPage>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

/** Event sent when page is updated. */
export type SaleorPageUpdated = SaleorEvent & {
  __typename?: 'PageUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The page the event relates to. */
  page: Maybe<SaleorPage>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPageWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorPageWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorPageWhereInput>>;
  /** Filter by attributes associated with the page. */
  attributes?: InputMaybe<Array<SaleorAssignedAttributeWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by page type. */
  pageType?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by page slug. */
  slug?: InputMaybe<SaleorStringFilterInput>;
};

/**
 * Change the password of the logged in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorPasswordChange = {
  __typename?: 'PasswordChange';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** A user instance with a new password. */
  user: Maybe<SaleorUser>;
};

/**
 * Represents a payment of a given type.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPayment = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Payment';
  /**
   * List of actions that can be performed in the current state of a payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  actions: Array<SaleorOrderAction>;
  /**
   * Maximum amount of money that can be captured.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  availableCaptureAmount: Maybe<SaleorMoney>;
  /**
   * Maximum amount of money that can be refunded.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  availableRefundAmount: Maybe<SaleorMoney>;
  /** Total amount captured for this payment. */
  capturedAmount: Maybe<SaleorMoney>;
  /** Internal payment status. */
  chargeStatus: SaleorPaymentChargeStatusEnum;
  /** Checkout associated with a payment. */
  checkout: Maybe<SaleorCheckout>;
  /** Date and time at which payment was created. */
  created: Scalars['DateTime']['output'];
  /** The details of the card used for this payment. */
  creditCard: Maybe<SaleorCreditCard>;
  /**
   * IP address of the user who created the payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  customerIpAddress: Maybe<Scalars['String']['output']>;
  /** Payment gateway used for payment. */
  gateway: Scalars['String']['output'];
  /** ID of the payment. */
  id: Scalars['ID']['output'];
  /** Determines if the payment is active or not. */
  isActive: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Date and time at which payment was modified. */
  modified: Scalars['DateTime']['output'];
  /** Order associated with a payment. */
  order: Maybe<SaleorOrder>;
  /**
   * Informs whether this is a partial payment.
   * @deprecated This field is reserved for the Adyen Gateway plugin. For other gateways, its value is always `false`. This field will be removed in 3.23 along with the plugin.
   */
  partial: Scalars['Boolean']['output'];
  /** Type of method used for payment. */
  paymentMethodType: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** PSP reference of the payment. */
  pspReference: Maybe<Scalars['String']['output']>;
  /** Unique token associated with a payment. */
  token: Scalars['String']['output'];
  /** Total amount of the payment. */
  total: Maybe<SaleorMoney>;
  /**
   * List of all transactions within this payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  transactions: Maybe<Array<SaleorTransaction>>;
};


/**
 * Represents a payment of a given type.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Represents a payment of a given type.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Represents a payment of a given type.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Represents a payment of a given type.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Authorize payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentAuthorize = SaleorEvent & {
  __typename?: 'PaymentAuthorize';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /**
   * Look up a payment.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Captures the authorized payment amount.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorPaymentCapture = {
  __typename?: 'PaymentCapture';
  errors: Array<SaleorPaymentError>;
  /** Updated payment. */
  payment: Maybe<SaleorPayment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Capture payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentCaptureEvent = SaleorEvent & {
  __typename?: 'PaymentCaptureEvent';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /**
   * Look up a payment.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentChargeStatusEnum =
  | 'CANCELLED'
  | 'FULLY_CHARGED'
  | 'FULLY_REFUNDED'
  | 'NOT_CHARGED'
  | 'PARTIALLY_CHARGED'
  | 'PARTIALLY_REFUNDED'
  | 'PENDING'
  | 'REFUSED';

/** Check payment balance. */
export type SaleorPaymentCheckBalance = {
  __typename?: 'PaymentCheckBalance';
  /** Response from the gateway. */
  data: Maybe<Scalars['JSONString']['output']>;
  errors: Array<SaleorPaymentError>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Fields required to check a payment balance.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentCheckBalanceInput = {
  /** Information about card. */
  card: SaleorCardInput;
  /** Slug of a channel for which the data should be returned. */
  channel: Scalars['String']['input'];
  /** An ID of a payment gateway to check. */
  gatewayId: Scalars['String']['input'];
  /** Payment method name. */
  method: Scalars['String']['input'];
};

/**
 * Confirm payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentConfirmEvent = SaleorEvent & {
  __typename?: 'PaymentConfirmEvent';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /**
   * Look up a payment.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentCountableConnection = {
  __typename?: 'PaymentCountableConnection';
  edges: Array<SaleorPaymentCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorPaymentCountableEdge = {
  __typename?: 'PaymentCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPayment;
};

export type SaleorPaymentError = {
  __typename?: 'PaymentError';
  /** The error code. */
  code: SaleorPaymentErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorPaymentErrorCode =
  | 'BALANCE_CHECK_ERROR'
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_COMPLETION_IN_PROGRESS'
  | 'CHECKOUT_EMAIL_NOT_SET'
  | 'CHECKOUT_HAS_TRANSACTION'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_SHIPPING_METHOD'
  | 'NOT_FOUND'
  | 'NOT_SUPPORTED_GATEWAY'
  | 'NO_CHECKOUT_LINES'
  | 'PARTIAL_PAYMENT_NOT_ALLOWED'
  | 'PAYMENT_ERROR'
  | 'REQUIRED'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'UNIQUE';

/**
 * Filtering options for payments.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentFilterInput = {
  checkouts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by ids. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Available payment gateway backend with configuration necessary to setup client. */
export type SaleorPaymentGateway = {
  __typename?: 'PaymentGateway';
  /** Payment gateway client configuration. */
  config: Array<SaleorGatewayConfigLine>;
  /** Payment gateway supported currencies. */
  currencies: Array<Scalars['String']['output']>;
  /** Payment gateway ID. */
  id: Scalars['ID']['output'];
  /** Payment gateway name. */
  name: Scalars['String']['output'];
};

export type SaleorPaymentGatewayConfig = {
  __typename?: 'PaymentGatewayConfig';
  /** The JSON data required to initialize the payment gateway. */
  data: Maybe<Scalars['JSON']['output']>;
  errors: Maybe<Array<SaleorPaymentGatewayConfigError>>;
  /** The app identifier. */
  id: Scalars['String']['output'];
};

export type SaleorPaymentGatewayConfigError = {
  __typename?: 'PaymentGatewayConfigError';
  /** The error code. */
  code: SaleorPaymentGatewayConfigErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentGatewayConfigErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Initializes a payment gateway session. It triggers the webhook `PAYMENT_GATEWAY_INITIALIZE_SESSION`, to the requested `paymentGateways`. If `paymentGateways` is not provided, the webhook will be send to all subscribed payment gateways. There is a limit of 100 transaction items per checkout / order. */
export type SaleorPaymentGatewayInitialize = {
  __typename?: 'PaymentGatewayInitialize';
  errors: Array<SaleorPaymentGatewayInitializeError>;
  /** List of payment gateway configurations. */
  gatewayConfigs: Maybe<Array<SaleorPaymentGatewayConfig>>;
};

export type SaleorPaymentGatewayInitializeError = {
  __typename?: 'PaymentGatewayInitializeError';
  /** The error code. */
  code: SaleorPaymentGatewayInitializeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentGatewayInitializeErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Event sent when user wants to initialize the payment gateway. */
export type SaleorPaymentGatewayInitializeSession = SaleorEvent & {
  __typename?: 'PaymentGatewayInitializeSession';
  /** Amount requested for initializing the payment gateway. */
  amount: Maybe<Scalars['PositiveDecimal']['output']>;
  /** Payment gateway data in JSON format, received from storefront. */
  data: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Checkout or order */
  sourceObject: SaleorOrderOrCheckout;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Initializes payment gateway for tokenizing payment method session.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to initialize payment gateway for tokenization.
 */
export type SaleorPaymentGatewayInitializeTokenization = {
  __typename?: 'PaymentGatewayInitializeTokenization';
  /** A data returned by payment app. */
  data: Maybe<Scalars['JSON']['output']>;
  errors: Array<SaleorPaymentGatewayInitializeTokenizationError>;
  /** A status of the payment gateway initialization. */
  result: SaleorPaymentGatewayInitializeTokenizationResult;
};

export type SaleorPaymentGatewayInitializeTokenizationError = {
  __typename?: 'PaymentGatewayInitializeTokenizationError';
  /** The error code. */
  code: SaleorPaymentGatewayInitializeTokenizationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentGatewayInitializeTokenizationErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Result of initialize payment gateway for tokenization of payment method.
 *
 *     The result of initialize payment gateway for tokenization of payment method.
 *     SUCCESSFULLY_INITIALIZED - The payment gateway was successfully initialized.
 *     FAILED_TO_INITIALIZE - The payment gateway was not initialized.
 *     FAILED_TO_DELIVER - The request to initialize payment gateway was not delivered.
 *
 */
export type SaleorPaymentGatewayInitializeTokenizationResult =
  | 'FAILED_TO_DELIVER'
  | 'FAILED_TO_INITIALIZE'
  | 'SUCCESSFULLY_INITIALIZED';

/** Event sent to initialize a new session in payment gateway to store the payment method.  */
export type SaleorPaymentGatewayInitializeTokenizationSession = SaleorEvent & {
  __typename?: 'PaymentGatewayInitializeTokenizationSession';
  /** Channel related to the requested action. */
  channel: SaleorChannel;
  /** Payment gateway data in JSON format, received from storefront. */
  data: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user related to the requested action. */
  user: SaleorUser;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentGatewayToInitialize = {
  /** The data that will be passed to the payment gateway. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** The identifier of the payment gateway app to initialize. */
  id: Scalars['String']['input'];
};

/** Initializes payment process when it is required by gateway. */
export type SaleorPaymentInitialize = {
  __typename?: 'PaymentInitialize';
  errors: Array<SaleorPaymentError>;
  /** Payment that was initialized. */
  initializedPayment: Maybe<SaleorPaymentInitialized>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Server-side data generated by a payment gateway. Optional step when the payment provider requires an additional action to initialize payment session.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentInitialized = {
  __typename?: 'PaymentInitialized';
  /** Initialized data by gateway. */
  data: Maybe<Scalars['JSONString']['output']>;
  /** ID of a payment gateway. */
  gateway: Scalars['String']['output'];
  /** Payment gateway name. */
  name: Scalars['String']['output'];
};

/**
 * Fields required to create a payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentInput = {
  /** Total amount of the transaction, including all taxes and discounts. If no amount is provided, the checkout total will be used. */
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** A gateway to use with that payment. */
  gateway: Scalars['String']['input'];
  /**
   * User public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a storefront view where user should be redirected after requiring additional actions. Payment with additional actions will not be finished if this field is not provided. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** Payment store type. */
  storePaymentMethod?: InputMaybe<SaleorStorePaymentMethodEnum>;
  /** Client-side generated payment token, representing customer's billing data in a secure manner. */
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * List payment gateways.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentListGateways = SaleorEvent & {
  __typename?: 'PaymentListGateways';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a payment method used for a transaction.
 *
 * Added in Saleor 3.22.
 */
export type SaleorPaymentMethodDetails = {
  /** Name of the payment method. */
  name: Scalars['String']['output'];
};

export type SaleorPaymentMethodDetailsCardFilterInput = {
  /** Filter by payment method brand used to pay for the order. */
  brand?: InputMaybe<SaleorStringFilterInput>;
};

export type SaleorPaymentMethodDetailsFilterInput = {
  /** Filter by card details used to pay for the order. Skips `type` filter if provided. */
  card?: InputMaybe<SaleorPaymentMethodDetailsCardFilterInput>;
  /** Filter by payment method type used to pay for the order. */
  type?: InputMaybe<SaleorPaymentMethodTypeEnumFilterInput>;
};

/**
 * Details of the payment method used for the transaction. One of `card` or `other` is required.
 *
 * Added in Saleor 3.22.
 */
export type SaleorPaymentMethodDetailsInput = {
  /** Details of the card payment method used for the transaction. */
  card?: InputMaybe<SaleorCardPaymentMethodDetailsInput>;
  /** Details of the non-card payment method used for this transaction. */
  other?: InputMaybe<SaleorOtherPaymentMethodDetailsInput>;
};

/**
 * Tokenize payment method.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to tokenize payment method.
 */
export type SaleorPaymentMethodInitializeTokenization = {
  __typename?: 'PaymentMethodInitializeTokenization';
  /** A data returned by the payment app. */
  data: Maybe<Scalars['JSON']['output']>;
  errors: Array<SaleorPaymentMethodInitializeTokenizationError>;
  /** The identifier of the payment method. */
  id: Maybe<Scalars['String']['output']>;
  /** A status of the payment method tokenization. */
  result: SaleorPaymentMethodTokenizationResult;
};

export type SaleorPaymentMethodInitializeTokenizationError = {
  __typename?: 'PaymentMethodInitializeTokenizationError';
  /** The error code. */
  code: SaleorPaymentMethodInitializeTokenizationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentMethodInitializeTokenizationErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Event sent when user requests a tokenization of payment method. */
export type SaleorPaymentMethodInitializeTokenizationSession = SaleorEvent & {
  __typename?: 'PaymentMethodInitializeTokenizationSession';
  /** Channel related to the requested action. */
  channel: SaleorChannel;
  /** Payment gateway data in JSON format, received from storefront. */
  data: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The payment flow that the tokenized payment method should support. */
  paymentFlowToSupport: SaleorTokenizedPaymentFlowEnum;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user related to the requested action. */
  user: SaleorUser;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Tokenize payment method.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION (sync): The customer continues payment method tokenization.
 */
export type SaleorPaymentMethodProcessTokenization = {
  __typename?: 'PaymentMethodProcessTokenization';
  /** A data returned by the payment app. */
  data: Maybe<Scalars['JSON']['output']>;
  errors: Array<SaleorPaymentMethodProcessTokenizationError>;
  /** The identifier of the payment method. */
  id: Maybe<Scalars['String']['output']>;
  /** A status of the payment method tokenization. */
  result: SaleorPaymentMethodTokenizationResult;
};

export type SaleorPaymentMethodProcessTokenizationError = {
  __typename?: 'PaymentMethodProcessTokenizationError';
  /** The error code. */
  code: SaleorPaymentMethodProcessTokenizationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentMethodProcessTokenizationErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Event sent when user continues a tokenization of payment method. */
export type SaleorPaymentMethodProcessTokenizationSession = SaleorEvent & {
  __typename?: 'PaymentMethodProcessTokenizationSession';
  /** Channel related to the requested action. */
  channel: SaleorChannel;
  /** Payment gateway data in JSON format, received from storefront. */
  data: Maybe<Scalars['JSON']['output']>;
  /** The ID returned by app from `PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION` webhook. */
  id: Scalars['String']['output'];
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user related to the requested action. */
  user: SaleorUser;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentMethodRequestDeleteError = {
  __typename?: 'PaymentMethodRequestDeleteError';
  /** The error code. */
  code: SaleorStoredPaymentMethodRequestDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

/**
 * Result of tokenization of payment method.
 *
 *     SUCCESSFULLY_TOKENIZED - The payment method was successfully tokenized.
 *     ADDITIONAL_ACTION_REQUIRED - The additional action is required to tokenize payment
 *     method.
 *     PENDING - The payment method is pending tokenization.
 *     FAILED_TO_TOKENIZE - The payment method was not tokenized.
 *     FAILED_TO_DELIVER - The request to tokenize payment method was not delivered.
 *
 */
export type SaleorPaymentMethodTokenizationResult =
  | 'ADDITIONAL_ACTION_REQUIRED'
  | 'FAILED_TO_DELIVER'
  | 'FAILED_TO_TOKENIZE'
  | 'PENDING'
  | 'SUCCESSFULLY_TOKENIZED';

/**
 * Represents possible payment method types.
 *
 *     The following types are possible:
 *     CARD - represents a card payment method.
 *     OTHER - represents any payment method that is not a card payment.
 *
 *
 */
export type SaleorPaymentMethodTypeEnum =
  | 'CARD'
  | 'OTHER';

export type SaleorPaymentMethodTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorPaymentMethodTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorPaymentMethodTypeEnum>>;
};

/**
 * Process payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentProcessEvent = SaleorEvent & {
  __typename?: 'PaymentProcessEvent';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /**
   * Look up a payment.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Refunds the captured payment amount.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorPaymentRefund = {
  __typename?: 'PaymentRefund';
  errors: Array<SaleorPaymentError>;
  /** Updated payment. */
  payment: Maybe<SaleorPayment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Refund payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentRefundEvent = SaleorEvent & {
  __typename?: 'PaymentRefundEvent';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /**
   * Look up a payment.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents the channel-specific payment settings. */
export type SaleorPaymentSettings = {
  __typename?: 'PaymentSettings';
  /**
   * Specifies the earliest date on which funds for expired checkouts can begin to be released. Expired checkouts dated before this cut-off will not have their funds released. Additionally, no funds will be released for checkouts that are more than one year old, regardless of the cut-off date.
   *
   * Added in Saleor 3.20.
   */
  checkoutReleaseFundsCutOffDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time in hours after which funds for expired checkouts will be released.
   *
   * Added in Saleor 3.20.
   */
  checkoutTtlBeforeReleasingFunds: Maybe<Scalars['Hour']['output']>;
  /** Determine the transaction flow strategy to be used. Include the selected option in the payload sent to the payment app, as a requested action for the transaction. */
  defaultTransactionFlowStrategy: SaleorTransactionFlowStrategyEnum;
  /**
   * Determine if the funds for expired checkouts should be released automatically.
   *
   * Added in Saleor 3.20.
   */
  releaseFundsForExpiredCheckouts: Maybe<Scalars['Boolean']['output']>;
};

export type SaleorPaymentSettingsInput = {
  /**
   * Specifies the earliest date on which funds for expired checkouts can begin to be released. Expired checkouts dated before this cut-off will not have their funds released. Additionally, no funds will be released for checkouts that are more than one year old, regardless of the cut-off date.
   *
   * Added in Saleor 3.20.
   */
  checkoutReleaseFundsCutOffDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The time in hours after which funds for expired checkouts will be released.
   *
   * Added in Saleor 3.20.
   */
  checkoutTtlBeforeReleasingFunds?: InputMaybe<Scalars['Hour']['input']>;
  /** Determine the transaction flow strategy to be used. Include the selected option in the payload sent to the payment app, as a requested action for the transaction. */
  defaultTransactionFlowStrategy?: InputMaybe<SaleorTransactionFlowStrategyEnum>;
  /**
   * Determine if the funds for expired checkouts should be released automatically.
   *
   * Added in Saleor 3.20.
   */
  releaseFundsForExpiredCheckouts?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a payment source stored for user in payment gateway, such as credit card.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentSource = {
  __typename?: 'PaymentSource';
  /** Stored credit card details if available. */
  creditCardInfo: Maybe<SaleorCreditCard>;
  /** Payment gateway name. */
  gateway: Scalars['String']['output'];
  /**
   * List of public metadata items.
   *
   * Can be accessed without permissions.
   */
  metadata: Array<SaleorMetadataItem>;
  /** ID of stored payment method. */
  paymentMethodId: Maybe<Scalars['String']['output']>;
};

/**
 * Voids the authorized payment.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorPaymentVoid = {
  __typename?: 'PaymentVoid';
  errors: Array<SaleorPaymentError>;
  /** Updated payment. */
  payment: Maybe<SaleorPayment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Void payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorPaymentVoidEvent = SaleorEvent & {
  __typename?: 'PaymentVoidEvent';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /**
   * Look up a payment.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents a permission object in a friendly form. */
export type SaleorPermission = {
  __typename?: 'Permission';
  /** Internal code for permission. */
  code: SaleorPermissionEnum;
  /** Describe action(s) allowed to do by permission. */
  name: Scalars['String']['output'];
};

export type SaleorPermissionEnum =
  | 'HANDLE_CHECKOUTS'
  | 'HANDLE_PAYMENTS'
  | 'HANDLE_TAXES'
  | 'IMPERSONATE_USER'
  | 'MANAGE_APPS'
  | 'MANAGE_CHANNELS'
  | 'MANAGE_CHECKOUTS'
  | 'MANAGE_DISCOUNTS'
  | 'MANAGE_GIFT_CARD'
  | 'MANAGE_MENUS'
  | 'MANAGE_OBSERVABILITY'
  | 'MANAGE_ORDERS'
  | 'MANAGE_ORDERS_IMPORT'
  | 'MANAGE_PAGES'
  | 'MANAGE_PAGE_TYPES_AND_ATTRIBUTES'
  | 'MANAGE_PLUGINS'
  | 'MANAGE_PRODUCTS'
  | 'MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES'
  | 'MANAGE_SETTINGS'
  | 'MANAGE_SHIPPING'
  | 'MANAGE_STAFF'
  | 'MANAGE_TAXES'
  | 'MANAGE_TRANSLATIONS'
  | 'MANAGE_USERS';

/**
 * Create new permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - PERMISSION_GROUP_CREATED (async)
 */
export type SaleorPermissionGroupCreate = {
  __typename?: 'PermissionGroupCreate';
  errors: Array<SaleorPermissionGroupError>;
  group: Maybe<SaleorGroup>;
  /** @deprecated Use `errors` field instead. */
  permissionGroupErrors: Array<SaleorPermissionGroupError>;
};

export type SaleorPermissionGroupCreateInput = {
  /** List of channels to assign to this group. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of permission code names to assign to this group. */
  addPermissions?: InputMaybe<Array<SaleorPermissionEnum>>;
  /** List of users to assign to this group. */
  addUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group name. */
  name: Scalars['String']['input'];
  /** Determine if the group has restricted access to channels.  DEFAULT: False */
  restrictedAccessToChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when new permission group is created. */
export type SaleorPermissionGroupCreated = SaleorEvent & {
  __typename?: 'PermissionGroupCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup: Maybe<SaleorGroup>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Delete permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - PERMISSION_GROUP_DELETED (async)
 */
export type SaleorPermissionGroupDelete = {
  __typename?: 'PermissionGroupDelete';
  errors: Array<SaleorPermissionGroupError>;
  group: Maybe<SaleorGroup>;
  /** @deprecated Use `errors` field instead. */
  permissionGroupErrors: Array<SaleorPermissionGroupError>;
};

/** Event sent when permission group is deleted. */
export type SaleorPermissionGroupDeleted = SaleorEvent & {
  __typename?: 'PermissionGroupDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup: Maybe<SaleorGroup>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorPermissionGroupError = {
  __typename?: 'PermissionGroupError';
  /** List of channels IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorPermissionGroupErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions: Maybe<Array<SaleorPermissionEnum>>;
  /** List of user IDs which causes the error. */
  users: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorPermissionGroupErrorCode =
  | 'ASSIGN_NON_STAFF_MEMBER'
  | 'CANNOT_REMOVE_FROM_LAST_GROUP'
  | 'DUPLICATED_INPUT_ITEM'
  | 'LEFT_NOT_MANAGEABLE_PERMISSION'
  | 'OUT_OF_SCOPE_CHANNEL'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'OUT_OF_SCOPE_USER'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorPermissionGroupFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Sorting options for permission groups. */
export type SaleorPermissionGroupSortField =
  /** Sort permission group accounts by name. */
  | 'NAME';

export type SaleorPermissionGroupSortingInput = {
  /** Specifies the direction in which to sort permission group. */
  direction: SaleorOrderDirection;
  /** Sort permission group by the selected field. */
  field: SaleorPermissionGroupSortField;
};

/**
 * Update permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - PERMISSION_GROUP_UPDATED (async)
 */
export type SaleorPermissionGroupUpdate = {
  __typename?: 'PermissionGroupUpdate';
  errors: Array<SaleorPermissionGroupError>;
  group: Maybe<SaleorGroup>;
  /** @deprecated Use `errors` field instead. */
  permissionGroupErrors: Array<SaleorPermissionGroupError>;
};

export type SaleorPermissionGroupUpdateInput = {
  /** List of channels to assign to this group. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of permission code names to assign to this group. */
  addPermissions?: InputMaybe<Array<SaleorPermissionEnum>>;
  /** List of users to assign to this group. */
  addUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of channels to unassign from this group. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of permission code names to unassign from this group. */
  removePermissions?: InputMaybe<Array<SaleorPermissionEnum>>;
  /** List of users to unassign from this group. */
  removeUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine if the group has restricted access to channels. */
  restrictedAccessToChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when permission group is updated. */
export type SaleorPermissionGroupUpdated = SaleorEvent & {
  __typename?: 'PermissionGroupUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup: Maybe<SaleorGroup>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Plugin. */
export type SaleorPlugin = {
  __typename?: 'Plugin';
  /** Channel-specific plugin configuration. */
  channelConfigurations: Array<SaleorPluginConfiguration>;
  /** Description of the plugin. */
  description: Scalars['String']['output'];
  /** Global configuration of the plugin (not channel-specific). */
  globalConfiguration: Maybe<SaleorPluginConfiguration>;
  /** Identifier of the plugin. */
  id: Scalars['ID']['output'];
  /** Name of the plugin. */
  name: Scalars['String']['output'];
};

/** Stores information about a configuration of plugin. */
export type SaleorPluginConfiguration = {
  __typename?: 'PluginConfiguration';
  /** Determines if plugin is active or not. */
  active: Scalars['Boolean']['output'];
  /** The channel to which the plugin configuration is assigned to. */
  channel: Maybe<SaleorChannel>;
  /** Configuration of the plugin. */
  configuration: Maybe<Array<SaleorConfigurationItem>>;
};

export type SaleorPluginConfigurationType =
  | 'GLOBAL'
  | 'PER_CHANNEL';

export type SaleorPluginCountableConnection = {
  __typename?: 'PluginCountableConnection';
  edges: Array<SaleorPluginCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorPluginCountableEdge = {
  __typename?: 'PluginCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPlugin;
};

export type SaleorPluginError = {
  __typename?: 'PluginError';
  /** The error code. */
  code: SaleorPluginErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPluginErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'PLUGIN_MISCONFIGURED'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorPluginFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  statusInChannels?: InputMaybe<SaleorPluginStatusInChannelsInput>;
  type?: InputMaybe<SaleorPluginConfigurationType>;
};

export type SaleorPluginSortField =
  | 'IS_ACTIVE'
  | 'NAME';

export type SaleorPluginSortingInput = {
  /** Specifies the direction in which to sort plugins. */
  direction: SaleorOrderDirection;
  /** Sort plugins by the selected field. */
  field: SaleorPluginSortField;
};

export type SaleorPluginStatusInChannelsInput = {
  active: Scalars['Boolean']['input'];
  channels: Array<Scalars['ID']['input']>;
};

/**
 * Update plugin configuration.
 *
 * Requires one of the following permissions: MANAGE_PLUGINS.
 */
export type SaleorPluginUpdate = {
  __typename?: 'PluginUpdate';
  errors: Array<SaleorPluginError>;
  plugin: Maybe<SaleorPlugin>;
  /** @deprecated Use `errors` field instead. */
  pluginsErrors: Array<SaleorPluginError>;
};

export type SaleorPluginUpdateInput = {
  /** Indicates whether the plugin should be enabled. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration of the plugin. */
  configuration?: InputMaybe<Array<SaleorConfigurationItemInput>>;
};

export type SaleorPostalCodeRuleInclusionTypeEnum =
  | 'EXCLUDE'
  | 'INCLUDE';

/** Represents preorder settings for product variant. */
export type SaleorPreorderData = {
  __typename?: 'PreorderData';
  /** Preorder end date. */
  endDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * Total number of sold product variant during preorder.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  globalSoldUnits: Scalars['Int']['output'];
  /**
   * The global preorder threshold for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  globalThreshold: Maybe<Scalars['Int']['output']>;
};

export type SaleorPreorderSettingsInput = {
  /** The end date for preorder. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The global threshold for preorder variant. */
  globalThreshold?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents preorder variant data for channel. */
export type SaleorPreorderThreshold = {
  __typename?: 'PreorderThreshold';
  /** Preorder threshold for product variant in this channel. */
  quantity: Maybe<Scalars['Int']['output']>;
  /** Number of sold product variant in this channel. */
  soldUnits: Scalars['Int']['output'];
};

export type SaleorPriceFilterInput = {
  /** The amount of the price to filter by. */
  amount: SaleorDecimalFilterInput;
  /** The currency of the price to filter by. */
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorPriceInput = {
  /** Amount of money. */
  amount: Scalars['PositiveDecimal']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
};

export type SaleorPriceRangeInput = {
  /** Price greater than or equal to. */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Price less than or equal to. */
  lte?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents an individual item for sale in the storefront. */
export type SaleorProduct = SaleorNode & SaleorObjectWithAttributes & SaleorObjectWithMetadata & {
  __typename?: 'Product';
  /**
   * Get a single attribute attached to product by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute: Maybe<SaleorAssignedAttribute>;
  /**
   * List of attributes assigned to this product.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<SaleorAssignedAttribute>;
  /**
   * Get a single attribute attached to product by attribute slug.
   * @deprecated Use the `assignedAttribute` field instead.
   */
  attribute: Maybe<SaleorSelectedAttribute>;
  /**
   * List of attributes assigned to this product.
   * @deprecated Use the `assignedAttributes` field instead.
   */
  attributes: Array<SaleorSelectedAttribute>;
  /**
   * Date when product is available for purchase.
   * @deprecated Use the `availableForPurchaseAt` field to fetch the available for purchase date.
   */
  availableForPurchase: Maybe<Scalars['Date']['output']>;
  /** Date when product is available for purchase. */
  availableForPurchaseAt: Maybe<Scalars['DateTime']['output']>;
  category: Maybe<SaleorCategory>;
  /** Channel given to retrieve this product. Also used by federation gateway to resolve this object in a federated query. */
  channel: Maybe<Scalars['String']['output']>;
  /**
   * List of availability in channels for the product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  channelListings: Maybe<Array<SaleorProductChannelListing>>;
  /** @deprecated Use `Channel.taxConfiguration` field to determine whether tax collection is enabled. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** List of collections for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collections: Maybe<Array<SaleorCollection>>;
  /** The date and time when the product was created. */
  created: Scalars['DateTime']['output'];
  /** Default variant of the product. */
  defaultVariant: Maybe<SaleorProductVariant>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** External ID of this product. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** The ID of the product. */
  id: Scalars['ID']['output'];
  /**
   * Get a single product image by ID.
   * @deprecated Use the `mediaById` field instead.
   */
  imageById: Maybe<SaleorProductImage>;
  /**
   * List of images for the product.
   * @deprecated Use the `media` field instead.
   */
  images: Maybe<Array<SaleorProductImage>>;
  /** Whether the product is in stock, set as available for purchase in the given channel, and published. */
  isAvailable: Maybe<Scalars['Boolean']['output']>;
  /** Refers to a state that can be set by admins to control whether a product is available for purchase in storefronts. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase: Maybe<Scalars['Boolean']['output']>;
  /** List of media for the product. */
  media: Maybe<Array<SaleorProductMedia>>;
  /** Get a single product media by ID. */
  mediaById: Maybe<SaleorProductMedia>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** SEO description of the product. */
  name: Scalars['String']['output'];
  /** Lists the storefront product's pricing, the current price and discounts, only meant for displaying. */
  pricing: Maybe<SaleorProductPricingInfo>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Type of the product. */
  productType: SaleorProductType;
  /**
   * List of variants for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS.
   *
   * Added in Saleor 3.21.
   */
  productVariants: Maybe<SaleorProductVariantCountableConnection>;
  /** Rating of the product. */
  rating: Maybe<Scalars['Float']['output']>;
  /** SEO description of the product. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title of the product. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /** Slug of the product. */
  slug: Scalars['String']['output'];
  /**
   * Tax class assigned to this product type. All products of this product type use this tax class, unless it's overridden in the `Product` type.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass: Maybe<SaleorTaxClass>;
  /**
   * A type of tax. Assigned by enabled tax gateway
   * @deprecated Use `taxClass` field instead.
   */
  taxType: Maybe<SaleorTaxType>;
  /** Thumbnail of the product. */
  thumbnail: Maybe<SaleorImage>;
  /** Returns translated product fields for the given language code. */
  translation: Maybe<SaleorProductTranslation>;
  /** The date and time when the product was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Get a single variant by SKU or ID.
   * @deprecated Use top-level `variant` query.
   */
  variant: Maybe<SaleorProductVariant>;
  /**
   * List of variants for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS.
   * @deprecated Use `productVariants` field instead.
   */
  variants: Maybe<Array<SaleorProductVariant>>;
  /** Weight of the product. */
  weight: Maybe<SaleorWeight>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductImageByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductIsAvailableArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductMediaArgs = {
  sortBy?: InputMaybe<SaleorMediaSortingInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductMediaByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductPricingArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductVariantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductVariantSortingInput>;
  where?: InputMaybe<SaleorProductVariantWhereInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductThumbnailArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductVariantArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Assign attributes to a given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductAttributeAssign = {
  __typename?: 'ProductAttributeAssign';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** The updated product type. */
  productType: Maybe<SaleorProductType>;
};

export type SaleorProductAttributeAssignInput = {
  /** The ID of the attribute to assign. */
  id: Scalars['ID']['input'];
  /** The attribute type to be assigned as. */
  type: SaleorProductAttributeType;
  /** Whether attribute is allowed in variant selection. Allowed types are: ['dropdown', 'boolean', 'swatch', 'numeric']. */
  variantSelection?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Update attributes assigned to product variant for given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductAttributeAssignmentUpdate = {
  __typename?: 'ProductAttributeAssignmentUpdate';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** The updated product type. */
  productType: Maybe<SaleorProductType>;
};

export type SaleorProductAttributeAssignmentUpdateInput = {
  /** The ID of the attribute to assign. */
  id: Scalars['ID']['input'];
  /** Whether attribute is allowed in variant selection. Allowed types are: ['dropdown', 'boolean', 'swatch', 'numeric']. */
  variantSelection: Scalars['Boolean']['input'];
};

export type SaleorProductAttributeType =
  | 'PRODUCT'
  | 'VARIANT';

/**
 * Un-assign attributes from a given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductAttributeUnassign = {
  __typename?: 'ProductAttributeUnassign';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** The updated product type. */
  productType: Maybe<SaleorProductType>;
};

/**
 * Creates products.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductBulkCreate = {
  __typename?: 'ProductBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductBulkCreateError>;
  /** List of the created products. */
  results: Array<SaleorProductBulkResult>;
};

export type SaleorProductBulkCreateError = {
  __typename?: 'ProductBulkCreateError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductBulkCreateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorProductBulkCreateErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'PRODUCT_WITHOUT_CATEGORY'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_MEDIA_PROVIDER';

export type SaleorProductBulkCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** List of channels in which the product is available. */
  channelListings?: InputMaybe<Array<SaleorProductChannelListingCreateInput>>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** List of media inputs associated with the product. */
  media?: InputMaybe<Array<SaleorMediaInput>>;
  /**
   * Fields required to update the product metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** ID of the type that product belongs to. */
  productType: Scalars['ID']['input'];
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Input list of product variants to create. */
  variants?: InputMaybe<Array<SaleorProductVariantBulkCreateInput>>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/**
 * Deletes products.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductBulkDelete = {
  __typename?: 'ProductBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductBulkResult = {
  __typename?: 'ProductBulkResult';
  /** List of errors occurred on create attempt. */
  errors: Maybe<Array<SaleorProductBulkCreateError>>;
  /** Product data. */
  product: Maybe<SaleorProduct>;
};

/**
 * Creates/updates translations for products.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 *
 * Triggers the following webhook events:
 * - TRANSLATION_CREATED (async): Called when a translation was created.
 * - TRANSLATION_UPDATED (async): Called when a translation was updated.
 */
export type SaleorProductBulkTranslate = {
  __typename?: 'ProductBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductBulkTranslateError>;
  /** List of the translations. */
  results: Array<SaleorProductBulkTranslateResult>;
};

export type SaleorProductBulkTranslateError = {
  __typename?: 'ProductBulkTranslateError';
  /** The error code. */
  code: SaleorProductTranslateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorProductBulkTranslateInput = {
  /** External reference of an product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Product ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** Translation fields. */
  translationFields: SaleorTranslationInput;
};

export type SaleorProductBulkTranslateResult = {
  __typename?: 'ProductBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors: Maybe<Array<SaleorProductBulkTranslateError>>;
  /** Product translation data. */
  translation: Maybe<SaleorProductTranslation>;
};

/** Represents product channel listing. */
export type SaleorProductChannelListing = SaleorNode & {
  __typename?: 'ProductChannelListing';
  /** @deprecated Use the `availableForPurchaseAt` field to fetch the available for purchase date. */
  availableForPurchase: Maybe<Scalars['Date']['output']>;
  /** The product available for purchase date time. */
  availableForPurchaseAt: Maybe<Scalars['DateTime']['output']>;
  /** The channel in which the product is listed. */
  channel: SaleorChannel;
  /** The price of the cheapest variant (including discounts). */
  discountedPrice: Maybe<SaleorMoney>;
  /** The ID of the product channel listing. */
  id: Scalars['ID']['output'];
  /** Refers to a state that can be set by admins to control whether a product is available for purchase in storefronts in this channel. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the product is published in the channel. */
  isPublished: Scalars['Boolean']['output'];
  /**
   * Range of margin percentage value.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  margin: Maybe<SaleorMargin>;
  /** Lists the storefront product's pricing, the current price and discounts, only meant for displaying. */
  pricing: Maybe<SaleorProductPricingInfo>;
  /** @deprecated Use the `publishedAt` field to fetch the publication date. */
  publicationDate: Maybe<Scalars['Date']['output']>;
  /** The product publication date time. */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * Purchase cost of product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  purchaseCost: Maybe<SaleorMoneyRange>;
  /** Indicates product visibility in the channel listings. */
  visibleInListings: Scalars['Boolean']['output'];
};


/** Represents product channel listing. */
export type SaleorProductChannelListingPricingArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};

export type SaleorProductChannelListingAddInput = {
  /** List of variants to which the channel should be assigned. */
  addVariants?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A start date time from which a product will be available for purchase. When not set and `isAvailable` is set to True, the current day is assumed. */
  availableForPurchaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A start date from which a product will be available for purchase. When not set and isAvailable is set to True, the current day is assumed.
   *
   * DEPRECATED: this field will be removed. Use `availableForPurchaseAt` field instead.
   */
  availableForPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if product should be available for purchase in this channel. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of variants from which the channel should be unassigned. */
  removeVariants?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determines if product is visible in product listings (doesn't apply to product collections). */
  visibleInListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorProductChannelListingCreateInput = {
  /** A start date time from which a product will be available for purchase. When not set and `isAvailable` is set to True, the current day is assumed. */
  availableForPurchaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if product should be available for purchase in this channel. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Determines if product is visible in product listings (doesn't apply to product collections). */
  visibleInListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorProductChannelListingError = {
  __typename?: 'ProductChannelListingError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channels IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
  /** List of variants IDs which causes the error. */
  variants: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Manage product's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductChannelListingUpdate = {
  __typename?: 'ProductChannelListingUpdate';
  errors: Array<SaleorProductChannelListingError>;
  /** An updated product instance. */
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productChannelListingErrors: Array<SaleorProductChannelListingError>;
};

export type SaleorProductChannelListingUpdateInput = {
  /** List of channels from which the product should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channels to which the product should be assigned or updated. */
  updateChannels?: InputMaybe<Array<SaleorProductChannelListingAddInput>>;
};

export type SaleorProductCountableConnection = {
  __typename?: 'ProductCountableConnection';
  edges: Array<SaleorProductCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorProductCountableEdge = {
  __typename?: 'ProductCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorProduct;
};

/**
 * Creates a new product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductCreate = {
  __typename?: 'ProductCreate';
  errors: Array<SaleorProductError>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** ID of the type that product belongs to. */
  productType: Scalars['ID']['input'];
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Event sent when new product is created. */
export type SaleorProductCreated = SaleorEvent & {
  __typename?: 'ProductCreated';
  /** The category of the product. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new product is created. */
export type SaleorProductCreatedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductDelete = {
  __typename?: 'ProductDelete';
  errors: Array<SaleorProductError>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** Event sent when product is deleted. */
export type SaleorProductDeleted = SaleorEvent & {
  __typename?: 'ProductDeleted';
  /** The category of the product. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when product is deleted. */
export type SaleorProductDeletedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorProductError = {
  __typename?: 'ProductError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorProductErrorCode =
  | 'ALREADY_EXISTS'
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_FILE_TYPE'
  | 'INVALID_PRICE'
  | 'MEDIA_ALREADY_ASSIGNED'
  | 'NOT_FOUND'
  | 'NOT_PRODUCTS_IMAGE'
  | 'NOT_PRODUCTS_VARIANT'
  | 'PREORDER_VARIANT_CANNOT_BE_DEACTIVATED'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'PRODUCT_WITHOUT_CATEGORY'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_MEDIA_PROVIDER'
  | 'UNSUPPORTED_MIME_TYPE'
  | 'VARIANT_NO_DIGITAL_CONTENT';

/** Event sent when product export is completed. */
export type SaleorProductExportCompleted = SaleorEvent & {
  __typename?: 'ProductExportCompleted';
  /** The export file for products. */
  export: Maybe<SaleorExportFile>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorProductFieldEnum =
  | 'CATEGORY'
  | 'CHARGE_TAXES'
  | 'COLLECTIONS'
  | 'DESCRIPTION'
  | 'NAME'
  | 'PRODUCT_MEDIA'
  | 'PRODUCT_TYPE'
  | 'PRODUCT_WEIGHT'
  | 'VARIANT_ID'
  | 'VARIANT_MEDIA'
  | 'VARIANT_SKU'
  | 'VARIANT_WEIGHT';

export type SaleorProductFilterInput = {
  attributes?: InputMaybe<Array<SaleorAttributeInput>>;
  /** Filter by the date of availability for purchase. */
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on whether product is a gift card or not. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreorderedVariants?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by availability for purchase. */
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by visibility in product listings. */
  isVisibleInListing?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  /** Filter by the lowest variant price after discounts. */
  minimalPrice?: InputMaybe<SaleorPriceRangeInput>;
  price?: InputMaybe<SaleorPriceRangeInput>;
  productTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by the publication date. */
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by variants having specific stock status. */
  stockAvailability?: InputMaybe<SaleorStockAvailability>;
  stocks?: InputMaybe<SaleorProductStockFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

/** Represents a product image. */
export type SaleorProductImage = {
  __typename?: 'ProductImage';
  /** The alt text of the image. */
  alt: Maybe<Scalars['String']['output']>;
  /** The ID of the image. */
  id: Scalars['ID']['output'];
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder: Maybe<Scalars['Int']['output']>;
  /** The URL of the image. */
  url: Scalars['String']['output'];
};


/** Represents a product image. */
export type SaleorProductImageUrlArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorProductInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Represents a product media. */
export type SaleorProductMedia = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'ProductMedia';
  /** The alt text of the media. */
  alt: Scalars['String']['output'];
  /** The unique ID of the product media. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** The oEmbed data of the media. */
  oembedData: Scalars['JSONString']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Product id the media refers to. */
  productId: Maybe<Scalars['ID']['output']>;
  /** The sort order of the media. */
  sortOrder: Maybe<Scalars['Int']['output']>;
  /** The type of the media. */
  type: SaleorProductMediaType;
  /** The URL of the media. */
  url: Scalars['String']['output'];
};


/** Represents a product media. */
export type SaleorProductMediaMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a product media. */
export type SaleorProductMediaMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a product media. */
export type SaleorProductMediaPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a product media. */
export type SaleorProductMediaPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a product media. */
export type SaleorProductMediaUrlArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Deletes product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaBulkDelete = {
  __typename?: 'ProductMediaBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Create a media object (image or video URL) associated with product. For image, this mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaCreate = {
  __typename?: 'ProductMediaCreate';
  errors: Array<SaleorProductError>;
  media: Maybe<SaleorProductMedia>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductMediaCreateInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Represents an image file in a multipart request. */
  image?: InputMaybe<Scalars['Upload']['input']>;
  /** Represents an URL to an external media. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  /** ID of an product. */
  product: Scalars['ID']['input'];
};

/** Event sent when new product media is created. */
export type SaleorProductMediaCreated = SaleorEvent & {
  __typename?: 'ProductMediaCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia: Maybe<SaleorProductMedia>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaDelete = {
  __typename?: 'ProductMediaDelete';
  errors: Array<SaleorProductError>;
  media: Maybe<SaleorProductMedia>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** Event sent when product media is deleted. */
export type SaleorProductMediaDeleted = SaleorEvent & {
  __typename?: 'ProductMediaDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia: Maybe<SaleorProductMedia>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Changes ordering of the product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaReorder = {
  __typename?: 'ProductMediaReorder';
  errors: Array<SaleorProductError>;
  media: Maybe<Array<SaleorProductMedia>>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductMediaType =
  | 'IMAGE'
  | 'VIDEO';

/**
 * Updates a product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaUpdate = {
  __typename?: 'ProductMediaUpdate';
  errors: Array<SaleorProductError>;
  media: Maybe<SaleorProductMedia>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductMediaUpdateInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when product media is updated. */
export type SaleorProductMediaUpdated = SaleorEvent & {
  __typename?: 'ProductMediaUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia: Maybe<SaleorProductMedia>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when product metadata is updated. */
export type SaleorProductMetadataUpdated = SaleorEvent & {
  __typename?: 'ProductMetadataUpdated';
  /** The category of the product. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when product metadata is updated. */
export type SaleorProductMetadataUpdatedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorProductOrder = {
  /**
   * Sort product by the selected attribute's values.
   * Note: this doesn't take translations into account yet.
   */
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort products. */
  direction: SaleorOrderDirection;
  /** Sort products by the selected field. */
  field?: InputMaybe<SaleorProductOrderField>;
};

export type SaleorProductOrderField =
  /**
   * Sort products by collection. Note: This option is available only for the `Collection.products` query.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'COLLECTION'
  /** Sort products by creation date. */
  | 'CREATED_AT'
  /** Sort products by update date. */
  | 'DATE'
  /** Sort products by update date. */
  | 'LAST_MODIFIED'
  /** Sort products by update date. */
  | 'LAST_MODIFIED_AT'
  /**
   * Sort products by a minimal price of a product's variant.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'MINIMAL_PRICE'
  /** Sort products by name. */
  | 'NAME'
  /**
   * Sort products by price.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PRICE'
  /**
   * Sort products by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort products by publication status.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED'
  /**
   * Sort products by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED_AT'
  /** Sort products by rank. Note: This option is available only with the `search` filter. */
  | 'RANK'
  /** Sort products by rating. */
  | 'RATING'
  /** Sort products by type. */
  | 'TYPE';

/** Represents availability of a product in the storefront. */
export type SaleorProductPricingInfo = {
  __typename?: 'ProductPricingInfo';
  /** The discount amount if in sale (null otherwise). */
  discount: Maybe<SaleorTaxedMoney>;
  /**
   * The discount amount in the local currency.
   * @deprecated Always returns `null`.
   */
  discountLocalCurrency: Maybe<SaleorTaxedMoney>;
  /**
   * The discount amount compared to prior price. Null if product is not on sale or prior price was not provided in VariantChannelListing
   *
   * Added in Saleor 3.21.
   */
  discountPrior: Maybe<SaleorTaxedMoney>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Whether it is in sale or not. */
  onSale: Maybe<Scalars['Boolean']['output']>;
  /** The discounted price range of the product variants. */
  priceRange: Maybe<SaleorTaxedMoneyRange>;
  /**
   * The discounted price range of the product variants in the local currency.
   * @deprecated Always returns `null`.
   */
  priceRangeLocalCurrency: Maybe<SaleorTaxedMoneyRange>;
  /**
   * The prior price range of the product variants.
   *
   * Added in Saleor 3.21.
   */
  priceRangePrior: Maybe<SaleorTaxedMoneyRange>;
  /** The undiscounted price range of the product variants. */
  priceRangeUndiscounted: Maybe<SaleorTaxedMoneyRange>;
};

/**
 * Reorder product attribute values.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductReorderAttributeValues = {
  __typename?: 'ProductReorderAttributeValues';
  errors: Array<SaleorProductError>;
  /** Product from which attribute values are reordered. */
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductStockFilterInput = {
  quantity?: InputMaybe<SaleorIntRangeInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents product's original translatable fields and related translations. */
export type SaleorProductTranslatableContent = SaleorNode & {
  __typename?: 'ProductTranslatableContent';
  /** List of product attribute values that can be translated. */
  attributeValues: Array<SaleorAttributeValueTranslatableContent>;
  /**
   * Product's description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the product translatable content. */
  id: Scalars['ID']['output'];
  /** Product's name to translate. */
  name: Scalars['String']['output'];
  /**
   * Represents an individual item for sale in the storefront.
   * @deprecated Get model fields from the root level queries.
   */
  product: Maybe<SaleorProduct>;
  /** The ID of the product to translate. */
  productId: Scalars['ID']['output'];
  /** SEO description to translate. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Returns translated product fields for the given language code. */
  translation: Maybe<SaleorProductTranslation>;
};


/** Represents product's original translatable fields and related translations. */
export type SaleorProductTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a product.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorProductTranslate = {
  __typename?: 'ProductTranslate';
  errors: Array<SaleorTranslationError>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorProductTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents product translations. */
export type SaleorProductTranslation = SaleorNode & {
  __typename?: 'ProductTranslation';
  /**
   * Translated description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the product translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated product name. */
  name: Maybe<Scalars['String']['output']>;
  /** Translated SEO description. */
  seoDescription: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * Translated product slug.
   *
   * Added in Saleor 3.21.
   */
  slug: Maybe<Scalars['String']['output']>;
  /** Represents the product fields to translate. */
  translatableContent: Maybe<SaleorProductTranslatableContent>;
};

/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductType = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'ProductType';
  /** Variant attributes of that product type with attached variant selection. */
  assignedVariantAttributes: Maybe<Array<SaleorAssignedVariantAttribute>>;
  /**
   * List of attributes which can be assigned to this product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  availableAttributes: Maybe<SaleorAttributeCountableConnection>;
  /** Whether the product type has variants. */
  hasVariants: Scalars['Boolean']['output'];
  /** The ID of the product type. */
  id: Scalars['ID']['output'];
  /** Whether the product type is digital. */
  isDigital: Scalars['Boolean']['output'];
  /** Whether shipping is required for this product type. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** The product type kind. */
  kind: SaleorProductTypeKindEnum;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the product type. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Product attributes of that product type. */
  productAttributes: Maybe<Array<SaleorAttribute>>;
  /**
   * List of products of this type.
   * @deprecated Use the top-level `products` query with the `productTypes` filter.
   */
  products: Maybe<SaleorProductCountableConnection>;
  /** Slug of the product type. */
  slug: Scalars['String']['output'];
  /**
   * Tax class assigned to this product type. All products of this product type use this tax class, unless it's overridden in the `Product` type.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass: Maybe<SaleorTaxClass>;
  /**
   * A type of tax. Assigned by enabled tax gateway
   * @deprecated Use `taxClass` field instead.
   */
  taxType: Maybe<SaleorTaxType>;
  /**
   * Variant attributes of that product type.
   * @deprecated Use `assignedVariantAttributes` instead.
   */
  variantAttributes: Maybe<Array<SaleorAttribute>>;
  /** Weight of the product type. */
  weight: Maybe<SaleorWeight>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeAssignedVariantAttributesArgs = {
  variantSelection?: InputMaybe<SaleorVariantAttributeScope>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeAvailableAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SaleorAttributeWhereInput>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeVariantAttributesArgs = {
  variantSelection?: InputMaybe<SaleorVariantAttributeScope>;
};

/**
 * Deletes product types.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeBulkDelete = {
  __typename?: 'ProductTypeBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductTypeConfigurable =
  | 'CONFIGURABLE'
  | 'SIMPLE';

export type SaleorProductTypeCountableConnection = {
  __typename?: 'ProductTypeCountableConnection';
  edges: Array<SaleorProductTypeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorProductTypeCountableEdge = {
  __typename?: 'ProductTypeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorProductType;
};

/**
 * Creates a new product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeCreate = {
  __typename?: 'ProductTypeCreate';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productType: Maybe<SaleorProductType>;
};

/**
 * Deletes a product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeDelete = {
  __typename?: 'ProductTypeDelete';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productType: Maybe<SaleorProductType>;
};

export type SaleorProductTypeEnum =
  | 'DIGITAL'
  | 'SHIPPABLE';

export type SaleorProductTypeFilterInput = {
  configurable?: InputMaybe<SaleorProductTypeConfigurable>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<SaleorProductTypeKindEnum>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  productType?: InputMaybe<SaleorProductTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorProductTypeInput = {
  /** Determines if product of this type has multiple variants. This option mainly simplifies product management in the dashboard. There is always at least one variant created under the hood. */
  hasVariants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if products are digital. */
  isDigital?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if shipping is required for products of this variant. */
  isShippingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The product type kind. */
  kind?: InputMaybe<SaleorProductTypeKindEnum>;
  /** Name of the product type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of attributes shared among all product variants. */
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product type. All products of this product type would use this tax class, unless it's overridden in the `Product` type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product type. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** List of attributes used to distinguish between different variants of a product. */
  variantAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Weight of the ProductType items. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

export type SaleorProductTypeKindEnum =
  | 'GIFT_CARD'
  | 'NORMAL';

/**
 * Reorder the attributes of a product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeReorderAttributes = {
  __typename?: 'ProductTypeReorderAttributes';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** Product type from which attributes are reordered. */
  productType: Maybe<SaleorProductType>;
};

export type SaleorProductTypeSortField =
  /** Sort products by type. */
  | 'DIGITAL'
  /** Sort products by name. */
  | 'NAME'
  /** Sort products by shipping. */
  | 'SHIPPING_REQUIRED';

export type SaleorProductTypeSortingInput = {
  /** Specifies the direction in which to sort product types. */
  direction: SaleorOrderDirection;
  /** Sort product types by the selected field. */
  field: SaleorProductTypeSortField;
};

/**
 * Updates an existing product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeUpdate = {
  __typename?: 'ProductTypeUpdate';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productType: Maybe<SaleorProductType>;
};

/**
 * Updates an existing product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductUpdate = {
  __typename?: 'ProductUpdate';
  errors: Array<SaleorProductError>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** Event sent when product is updated. */
export type SaleorProductUpdated = SaleorEvent & {
  __typename?: 'ProductUpdated';
  /** The category of the product. */
  category: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when product is updated. */
export type SaleorProductUpdatedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a version of a product such as different size or color. */
export type SaleorProductVariant = SaleorNode & SaleorObjectWithAttributes & SaleorObjectWithMetadata & {
  __typename?: 'ProductVariant';
  /**
   * Get a single attribute attached to product by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute: Maybe<SaleorAssignedAttribute>;
  /**
   * List of attributes assigned to this variant.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<SaleorAssignedAttribute>;
  /**
   * List of attributes assigned to this variant.
   * @deprecated Use the `assignedAttributes` field instead.
   */
  attributes: Array<SaleorSelectedAttribute>;
  /** Channel given to retrieve this product variant. Also used by federation gateway to resolve this object in a federated query. */
  channel: Maybe<Scalars['String']['output']>;
  /**
   * List of price information in channels for the product.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channelListings: Maybe<Array<SaleorProductVariantChannelListing>>;
  /** The date and time when the product variant was created. */
  created: Scalars['DateTime']['output'];
  /**
   * Digital content for the product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  digitalContent: Maybe<SaleorDigitalContent>;
  /** External ID of this product. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** The ID of the product variant. */
  id: Scalars['ID']['output'];
  /**
   * List of images for the product variant.
   * @deprecated Use the `media` field instead.
   */
  images: Maybe<Array<SaleorProductImage>>;
  /** Gross margin percentage value. */
  margin: Maybe<Scalars['Int']['output']>;
  /** List of media for the product variant. */
  media: Maybe<Array<SaleorProductMedia>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** The name of the product variant. */
  name: Scalars['String']['output'];
  /** Preorder data for product variant. */
  preorder: Maybe<SaleorPreorderData>;
  /** Lists the storefront variant's pricing, the current price and discounts, only meant for displaying. */
  pricing: Maybe<SaleorVariantPricingInfo>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** The product to which the variant belongs. */
  product: SaleorProduct;
  /** Quantity of a product available for sale in one checkout. Field value will be `null` when no `limitQuantityPerCheckout` in global settings has been set, and `productVariant` stocks are not tracked. */
  quantityAvailable: Maybe<Scalars['Int']['output']>;
  /** The maximum quantity of this variant that a customer can purchase. */
  quantityLimitPerCustomer: Maybe<Scalars['Int']['output']>;
  /**
   * Total quantity ordered.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  quantityOrdered: Maybe<Scalars['Int']['output']>;
  /**
   * Total revenue generated by a variant in given period of time. Note: this field should be queried using `reportProductSales` query as it uses optimizations suitable for such calculations.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  revenue: Maybe<SaleorTaxedMoney>;
  /** The SKU (stock keeping unit) of the product variant. */
  sku: Maybe<Scalars['String']['output']>;
  /**
   * Stocks for the product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  stocks: Maybe<Array<SaleorStock>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory: Scalars['Boolean']['output'];
  /** Returns translated product variant fields for the given language code. */
  translation: Maybe<SaleorProductVariantTranslation>;
  /** The date and time when the product variant was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The weight of the product variant. */
  weight: Maybe<SaleorWeight>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantAttributesArgs = {
  variantSelection?: InputMaybe<SaleorVariantAttributeScope>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantPricingArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantQuantityAvailableArgs = {
  address?: InputMaybe<SaleorAddressInput>;
  countryCode?: InputMaybe<SaleorCountryCode>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantRevenueArgs = {
  period?: InputMaybe<SaleorReportingPeriod>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantStocksArgs = {
  address?: InputMaybe<SaleorAddressInput>;
  countryCode?: InputMaybe<SaleorCountryCode>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/** Event sent when product variant is back in stock. */
export type SaleorProductVariantBackInStock = SaleorEvent & {
  __typename?: 'ProductVariantBackInStock';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse: Maybe<SaleorWarehouse>;
};


/** Event sent when product variant is back in stock. */
export type SaleorProductVariantBackInStockProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates product variants for a given product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantBulkCreate = {
  __typename?: 'ProductVariantBulkCreate';
  /** @deprecated Use `errors` field instead. */
  bulkProductErrors: Array<SaleorBulkProductError>;
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorBulkProductError>;
  /**
   * List of the created variants.
   *
   * DEPRECATED: this field will be removed.
   */
  productVariants: Array<SaleorProductVariant>;
  /** List of the created variants. */
  results: Array<SaleorProductVariantBulkResult>;
};

export type SaleorProductVariantBulkCreateInput = {
  /** List of attributes specific to this variant. */
  attributes: Array<SaleorBulkAttributeValueInput>;
  /** List of prices assigned to channels. */
  channelListings?: InputMaybe<Array<SaleorProductVariantChannelListingAddInput>>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks of a product available for sale. */
  stocks?: InputMaybe<Array<SaleorStockInput>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/**
 * Deletes product variants.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantBulkDelete = {
  __typename?: 'ProductVariantBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductVariantBulkError = {
  __typename?: 'ProductVariantBulkError';
  /** List of attributes IDs which causes the error. */
  attributes: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel listings IDs which causes the error. */
  channelListings: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductVariantBulkErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
  /** List of stocks IDs which causes the error. */
  stocks: Maybe<Array<Scalars['ID']['output']>>;
  /** List of attribute values IDs which causes the error. */
  values: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorProductVariantBulkErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'NOT_FOUND'
  | 'NOT_PRODUCTS_VARIANT'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'REQUIRED'
  | 'STOCK_ALREADY_EXISTS'
  | 'UNIQUE';

export type SaleorProductVariantBulkResult = {
  __typename?: 'ProductVariantBulkResult';
  /** List of errors occurred on create attempt. */
  errors: Maybe<Array<SaleorProductVariantBulkError>>;
  /** Product variant data. */
  productVariant: Maybe<SaleorProductVariant>;
};

/**
 * Creates/updates translations for product variants.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 *
 * Triggers the following webhook events:
 * - TRANSLATION_CREATED (async): A translation was created.
 * - TRANSLATION_UPDATED (async): A translation was updated.
 */
export type SaleorProductVariantBulkTranslate = {
  __typename?: 'ProductVariantBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductVariantBulkTranslateError>;
  /** List of the translations. */
  results: Array<SaleorProductVariantBulkTranslateResult>;
};

export type SaleorProductVariantBulkTranslateError = {
  __typename?: 'ProductVariantBulkTranslateError';
  /** The error code. */
  code: SaleorProductVariantTranslateErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
};

export type SaleorProductVariantBulkTranslateInput = {
  /** External reference of a product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Product variant ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** Translation fields. */
  translationFields: SaleorNameTranslationInput;
};

export type SaleorProductVariantBulkTranslateResult = {
  __typename?: 'ProductVariantBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors: Maybe<Array<SaleorProductVariantBulkTranslateError>>;
  /** Product variant translation data. */
  translation: Maybe<SaleorProductVariantTranslation>;
};

/**
 * Updates multiple product variants.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantBulkUpdate = {
  __typename?: 'ProductVariantBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductVariantBulkError>;
  /** List of the updated variants. */
  results: Array<SaleorProductVariantBulkResult>;
};

/** Input fields to update product variants. */
export type SaleorProductVariantBulkUpdateInput = {
  /** List of attributes specific to this variant. */
  attributes?: InputMaybe<Array<SaleorBulkAttributeValueInput>>;
  /** Channel listings input. */
  channelListings?: InputMaybe<SaleorProductVariantChannelListingUpdateInput>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of the product variant to update. */
  id: Scalars['ID']['input'];
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks input. */
  stocks?: InputMaybe<SaleorProductVariantStocksUpdateInput>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Represents product variant channel listing. */
export type SaleorProductVariantChannelListing = SaleorNode & {
  __typename?: 'ProductVariantChannelListing';
  /** The channel to which the variant listing belongs. */
  channel: SaleorChannel;
  /** Cost price of the variant. */
  costPrice: Maybe<SaleorMoney>;
  /** The ID of the variant channel listing. */
  id: Scalars['ID']['output'];
  /**
   * Gross margin percentage value.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  margin: Maybe<Scalars['Int']['output']>;
  /** Preorder variant data. */
  preorderThreshold: Maybe<SaleorPreorderThreshold>;
  /** The price of the variant. */
  price: Maybe<SaleorMoney>;
  /**
   * Prior price of the variant used for discount calculations.
   *
   * Added in Saleor 3.21.
   */
  priorPrice: Maybe<SaleorMoney>;
};

export type SaleorProductVariantChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Cost price of the variant in channel. */
  costPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The threshold for preorder variant in channel. */
  preorderThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the particular variant in channel. */
  price: Scalars['PositiveDecimal']['input'];
  /**
   * Previous price of the variant in channel. Useful for providing promotion information required by customer protection laws such as EU Omnibus directive.
   *
   * Added in Saleor 3.21.
   */
  priorPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

/**
 * Manage product variant prices in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantChannelListingUpdate = {
  __typename?: 'ProductVariantChannelListingUpdate';
  errors: Array<SaleorProductChannelListingError>;
  /** @deprecated Use `errors` field instead. */
  productChannelListingErrors: Array<SaleorProductChannelListingError>;
  /** An updated product variant instance. */
  variant: Maybe<SaleorProductVariant>;
};

export type SaleorProductVariantChannelListingUpdateInput = {
  /** List of channels to create variant channel listings. */
  create?: InputMaybe<Array<SaleorProductVariantChannelListingAddInput>>;
  /** List of channel listings to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channel listings to update. */
  update?: InputMaybe<Array<SaleorChannelListingUpdateInput>>;
};

export type SaleorProductVariantCountableConnection = {
  __typename?: 'ProductVariantCountableConnection';
  edges: Array<SaleorProductVariantCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorProductVariantCountableEdge = {
  __typename?: 'ProductVariantCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorProductVariant;
};

/**
 * Creates a new variant for a product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantCreate = {
  __typename?: 'ProductVariantCreate';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant: Maybe<SaleorProductVariant>;
};

export type SaleorProductVariantCreateInput = {
  /** List of attributes specific to this variant. */
  attributes: Array<SaleorAttributeValueInput>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product ID of which type is the variant. */
  product: Scalars['ID']['input'];
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks of a product available for sale. */
  stocks?: InputMaybe<Array<SaleorStockInput>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Event sent when new product variant is created. */
export type SaleorProductVariantCreated = SaleorEvent & {
  __typename?: 'ProductVariantCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new product variant is created. */
export type SaleorProductVariantCreatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantDelete = {
  __typename?: 'ProductVariantDelete';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant: Maybe<SaleorProductVariant>;
};

/** Event sent when product variant is deleted. */
export type SaleorProductVariantDeleted = SaleorEvent & {
  __typename?: 'ProductVariantDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when product variant is deleted. */
export type SaleorProductVariantDeletedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when product variant discounted price is recalculated.
 *
 * Added in Saleor 3.22.
 */
export type SaleorProductVariantDiscountedPriceUpdated = SaleorEvent & {
  __typename?: 'ProductVariantDiscountedPriceUpdated';
  /** The channel where the price changed. */
  channel: SaleorChannel;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The new discounted price. */
  newPrice: SaleorMoney;
  /** The previous discounted price. */
  previousPrice: SaleorMoney;
  /** The product variant the event relates to. */
  productVariant: SaleorProductVariant;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorProductVariantFilterInput = {
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorProductVariantInput = {
  /** List of attributes specific to this variant. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Event sent when product variant metadata is updated. */
export type SaleorProductVariantMetadataUpdated = SaleorEvent & {
  __typename?: 'ProductVariantMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when product variant metadata is updated. */
export type SaleorProductVariantMetadataUpdatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when product variant is out of stock. */
export type SaleorProductVariantOutOfStock = SaleorEvent & {
  __typename?: 'ProductVariantOutOfStock';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse: Maybe<SaleorWarehouse>;
};


/** Event sent when product variant is out of stock. */
export type SaleorProductVariantOutOfStockProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deactivates product variant preorder. It changes all preorder allocation into regular allocation.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantPreorderDeactivate = {
  __typename?: 'ProductVariantPreorderDeactivate';
  errors: Array<SaleorProductError>;
  /** Product variant with ended preorder. */
  productVariant: Maybe<SaleorProductVariant>;
};

/**
 * Reorder the variants of a product. Mutation updates updated_at on product and triggers PRODUCT_UPDATED webhook.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantReorder = {
  __typename?: 'ProductVariantReorder';
  errors: Array<SaleorProductError>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Reorder product variant attribute values.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantReorderAttributeValues = {
  __typename?: 'ProductVariantReorderAttributeValues';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** Product variant from which attribute values are reordered. */
  productVariant: Maybe<SaleorProductVariant>;
};

/**
 * Set default variant for a product. Mutation triggers PRODUCT_UPDATED webhook.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantSetDefault = {
  __typename?: 'ProductVariantSetDefault';
  errors: Array<SaleorProductError>;
  product: Maybe<SaleorProduct>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductVariantSortField =
  /** Sort product variants by last modification date. */
  | 'LAST_MODIFIED_AT';

export type SaleorProductVariantSortingInput = {
  /** Specifies the direction in which to sort productVariants. */
  direction: SaleorOrderDirection;
  /** Sort productVariants by the selected field. */
  field: SaleorProductVariantSortField;
};

/** Event sent when product variant stock is updated. */
export type SaleorProductVariantStockUpdated = SaleorEvent & {
  __typename?: 'ProductVariantStockUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse: Maybe<SaleorWarehouse>;
};


/** Event sent when product variant stock is updated. */
export type SaleorProductVariantStockUpdatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates stocks for product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantStocksCreate = {
  __typename?: 'ProductVariantStocksCreate';
  /** @deprecated Use `errors` field instead. */
  bulkStockErrors: Array<SaleorBulkStockError>;
  errors: Array<SaleorBulkStockError>;
  /** Updated product variant. */
  productVariant: Maybe<SaleorProductVariant>;
};

/**
 * Deletes stocks from product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantStocksDelete = {
  __typename?: 'ProductVariantStocksDelete';
  errors: Array<SaleorStockError>;
  /** Updated product variant. */
  productVariant: Maybe<SaleorProductVariant>;
  /** @deprecated Use `errors` field instead. */
  stockErrors: Array<SaleorStockError>;
};

/**
 * Updates stocks for product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantStocksUpdate = {
  __typename?: 'ProductVariantStocksUpdate';
  /** @deprecated Use `errors` field instead. */
  bulkStockErrors: Array<SaleorBulkStockError>;
  errors: Array<SaleorBulkStockError>;
  /** Updated product variant. */
  productVariant: Maybe<SaleorProductVariant>;
};

export type SaleorProductVariantStocksUpdateInput = {
  /** List of warehouses to create stocks. */
  create?: InputMaybe<Array<SaleorStockInput>>;
  /** List of stocks to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of stocks to update. */
  update?: InputMaybe<Array<SaleorStockUpdateInput>>;
};

/** Represents product variant's original translatable fields and related translations. */
export type SaleorProductVariantTranslatableContent = SaleorNode & {
  __typename?: 'ProductVariantTranslatableContent';
  /** List of product variant attribute values that can be translated. */
  attributeValues: Array<SaleorAttributeValueTranslatableContent>;
  /** The ID of the product variant translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the product variant to translate. */
  name: Scalars['String']['output'];
  /**
   * Represents a version of a product such as different size or color.
   * @deprecated Get model fields from the root level queries.
   */
  productVariant: Maybe<SaleorProductVariant>;
  /** The ID of the product variant to translate. */
  productVariantId: Scalars['ID']['output'];
  /** Returns translated product variant fields for the given language code. */
  translation: Maybe<SaleorProductVariantTranslation>;
};


/** Represents product variant's original translatable fields and related translations. */
export type SaleorProductVariantTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a product variant.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorProductVariantTranslate = {
  __typename?: 'ProductVariantTranslate';
  errors: Array<SaleorTranslationError>;
  productVariant: Maybe<SaleorProductVariant>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorProductVariantTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents product variant translations. */
export type SaleorProductVariantTranslation = SaleorNode & {
  __typename?: 'ProductVariantTranslation';
  /** The ID of the product variant translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated product variant name. */
  name: Scalars['String']['output'];
  /** Represents the product variant fields to translate. */
  translatableContent: Maybe<SaleorProductVariantTranslatableContent>;
};

/**
 * Updates an existing variant for product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantUpdate = {
  __typename?: 'ProductVariantUpdate';
  errors: Array<SaleorProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant: Maybe<SaleorProductVariant>;
};

/** Event sent when product variant is updated. */
export type SaleorProductVariantUpdated = SaleorEvent & {
  __typename?: 'ProductVariantUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when product variant is updated. */
export type SaleorProductVariantUpdatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorProductVariantWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorProductVariantWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorProductVariantWhereInput>>;
  /**
   * Filter by attributes associated with the variant.
   *
   * Added in Saleor 3.22.
   */
  attributes?: InputMaybe<Array<SaleorAssignedAttributeWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  /** Filter by product SKU. */
  sku?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorProductWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorProductWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorProductWhereInput>>;
  /** Filter by attributes associated with the product. */
  attributes?: InputMaybe<Array<SaleorAttributeInput>>;
  /** Filter by the date of availability for purchase. */
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by product category. */
  category?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by collection. */
  collection?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter on whether product is a gift card or not. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by product with category assigned. */
  hasCategory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by product with preordered variants. */
  hasPreorderedVariants?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by availability for purchase. */
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by public visibility. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by visibility on the channel. */
  isVisibleInListing?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  /** Filter by the lowest variant price after discounts. */
  minimalPrice?: InputMaybe<SaleorDecimalFilterInput>;
  /** Filter by product name. */
  name?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by product variant price. */
  price?: InputMaybe<SaleorDecimalFilterInput>;
  /** Filter by product type. */
  productType?: InputMaybe<SaleorGlobalIdFilterInput>;
  /** Filter by the publication date. */
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by product slug. */
  slug?: InputMaybe<SaleorStringFilterInput>;
  /** Filter by variants having specific stock status. */
  stockAvailability?: InputMaybe<SaleorStockAvailability>;
  /** Filter by stock of the product variant. */
  stocks?: InputMaybe<SaleorProductStockFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<SaleorDateTimeFilterInput>;
};

/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type SaleorPromotion = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Promotion';
  /** Date time of promotion creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the promotion. */
  description: Maybe<Scalars['JSON']['output']>;
  /** End date of the promotion. */
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** The list of events associated with the promotion. */
  events: Maybe<Array<SaleorPromotionEvent>>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the promotion. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** The list of promotion rules. */
  rules: Maybe<Array<SaleorPromotionRule>>;
  /** Start date of the promotion. */
  startDate: Scalars['DateTime']['output'];
  /** Returns translated promotion fields for the given language code. */
  translation: Maybe<SaleorPromotionTranslation>;
  /**
   * The type of the promotion. Implicate if the discount is applied on catalogue or order level.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  type: Maybe<SaleorPromotionTypeEnum>;
  /** Date time of last update of promotion. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type SaleorPromotionMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type SaleorPromotionMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type SaleorPromotionPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type SaleorPromotionPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type SaleorPromotionTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes promotions.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_DELETED (async): A promotion was deleted.
 */
export type SaleorPromotionBulkDelete = {
  __typename?: 'PromotionBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorDiscountError>;
};

export type SaleorPromotionCountableConnection = {
  __typename?: 'PromotionCountableConnection';
  edges: Array<SaleorPromotionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorPromotionCountableEdge = {
  __typename?: 'PromotionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPromotion;
};

/**
 * Creates a new promotion.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_CREATED (async): A promotion was created.
 * - PROMOTION_STARTED (async): Optionally called if promotion was started.
 */
export type SaleorPromotionCreate = {
  __typename?: 'PromotionCreate';
  errors: Array<SaleorPromotionCreateError>;
  promotion: Maybe<SaleorPromotion>;
};

export type SaleorPromotionCreateError = {
  __typename?: 'PromotionCreateError';
  /** The error code. */
  code: SaleorPromotionCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** Limit of gifts assigned to promotion rule. */
  giftsLimit: Maybe<Scalars['Int']['output']>;
  /** Number of gifts defined for this promotion rule exceeding the limit. */
  giftsLimitExceedBy: Maybe<Scalars['Int']['output']>;
  /** Index of an input list item that caused the error. */
  index: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Limit of rules with orderPredicate defined. */
  rulesLimit: Maybe<Scalars['Int']['output']>;
  /** Number of rules with orderPredicate defined exceeding the limit. */
  rulesLimitExceedBy: Maybe<Scalars['Int']['output']>;
};

export type SaleorPromotionCreateErrorCode =
  | 'GIFTS_NUMBER_LIMIT'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_GIFT_TYPE'
  | 'INVALID_PRECISION'
  | 'MISSING_CHANNELS'
  | 'MULTIPLE_CURRENCIES_NOT_ALLOWED'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'RULES_NUMBER_LIMIT';

export type SaleorPromotionCreateInput = {
  /** Promotion description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /** The end date of the promotion in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Promotion name. */
  name: Scalars['String']['input'];
  /** List of promotion rules. */
  rules?: InputMaybe<Array<SaleorPromotionRuleInput>>;
  /** The start date of the promotion in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Defines the promotion type. Implicate the required promotion rules predicate type and whether the promotion rules will give the catalogue or order discount.
   *
   * Added in Saleor 3.19.
   */
  type: SaleorPromotionTypeEnum;
};

/** Event sent when new promotion is created. */
export type SaleorPromotionCreated = SaleorEvent & {
  __typename?: 'PromotionCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion: Maybe<SaleorPromotion>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion created event. */
export type SaleorPromotionCreatedEvent = SaleorNode & SaleorPromotionEventInterface & {
  __typename?: 'PromotionCreatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

/**
 * Deletes a promotion.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_DELETED (async): A promotion was deleted.
 */
export type SaleorPromotionDelete = {
  __typename?: 'PromotionDelete';
  errors: Array<SaleorPromotionDeleteError>;
  promotion: Maybe<SaleorPromotion>;
};

export type SaleorPromotionDeleteError = {
  __typename?: 'PromotionDeleteError';
  /** The error code. */
  code: SaleorPromotionDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPromotionDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND';

/** Event sent when promotion is deleted. */
export type SaleorPromotionDeleted = SaleorEvent & {
  __typename?: 'PromotionDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion: Maybe<SaleorPromotion>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** The event informs about the end of the promotion. */
export type SaleorPromotionEnded = SaleorEvent & {
  __typename?: 'PromotionEnded';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion: Maybe<SaleorPromotion>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion ended event. */
export type SaleorPromotionEndedEvent = SaleorNode & SaleorPromotionEventInterface & {
  __typename?: 'PromotionEndedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

export type SaleorPromotionEvent = SaleorPromotionCreatedEvent | SaleorPromotionEndedEvent | SaleorPromotionRuleCreatedEvent | SaleorPromotionRuleDeletedEvent | SaleorPromotionRuleUpdatedEvent | SaleorPromotionStartedEvent | SaleorPromotionUpdatedEvent;

export type SaleorPromotionEventInterface = {
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

export type SaleorPromotionEventsEnum =
  | 'PROMOTION_CREATED'
  | 'PROMOTION_ENDED'
  | 'PROMOTION_STARTED'
  | 'PROMOTION_UPDATED'
  | 'RULE_CREATED'
  | 'RULE_DELETED'
  | 'RULE_UPDATED';

/** Represents the promotion rule that specifies the conditions that must be met to apply the promotion discount. */
export type SaleorPromotionRule = SaleorNode & {
  __typename?: 'PromotionRule';
  /** The catalogue predicate that must be met to apply the rule reward. */
  cataloguePredicate: Maybe<Scalars['JSON']['output']>;
  /**
   * List of channels where the rule applies.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channels: Maybe<Array<SaleorChannel>>;
  /** Description of the promotion rule. */
  description: Maybe<Scalars['JSON']['output']>;
  /**
   * Product variant IDs available as a gift to choose.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  giftIds: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Defines the maximum number of gifts to choose from the gifts list.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  giftsLimit: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the promotion rule. */
  name: Maybe<Scalars['String']['output']>;
  /**
   * The checkout/order predicate that must be met to apply the rule reward.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate: Maybe<Scalars['JSON']['output']>;
  /**
   * The type of the predicate that must be met to apply the reward.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  predicateType: Maybe<SaleorPromotionTypeEnum>;
  /** Promotion to which the rule belongs. */
  promotion: Maybe<SaleorPromotion>;
  /**
   * The reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType: Maybe<SaleorRewardTypeEnum>;
  /**
   * The reward value of the promotion rule. Defines the discount value applied when the rule conditions are met.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardValue: Maybe<Scalars['PositiveDecimal']['output']>;
  /** The type of reward value of the promotion rule. */
  rewardValueType: Maybe<SaleorRewardValueTypeEnum>;
  /** Returns translated promotion rule fields for the given language code. */
  translation: Maybe<SaleorPromotionRuleTranslation>;
};


/** Represents the promotion rule that specifies the conditions that must be met to apply the promotion discount. */
export type SaleorPromotionRuleTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates a new promotion rule.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_RULE_CREATED (async): A promotion rule was created.
 */
export type SaleorPromotionRuleCreate = {
  __typename?: 'PromotionRuleCreate';
  errors: Array<SaleorPromotionRuleCreateError>;
  promotionRule: Maybe<SaleorPromotionRule>;
};

export type SaleorPromotionRuleCreateError = {
  __typename?: 'PromotionRuleCreateError';
  /** The error code. */
  code: SaleorPromotionRuleCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** Limit of gifts assigned to promotion rule. */
  giftsLimit: Maybe<Scalars['Int']['output']>;
  /** Number of gifts defined for this promotion rule exceeding the limit. */
  giftsLimitExceedBy: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Limit of rules with orderPredicate defined. */
  rulesLimit: Maybe<Scalars['Int']['output']>;
  /** Number of rules with orderPredicate defined exceeding the limit. */
  rulesLimitExceedBy: Maybe<Scalars['Int']['output']>;
};

export type SaleorPromotionRuleCreateErrorCode =
  | 'GIFTS_NUMBER_LIMIT'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_GIFT_TYPE'
  | 'INVALID_PRECISION'
  | 'MISSING_CHANNELS'
  | 'MULTIPLE_CURRENCIES_NOT_ALLOWED'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'RULES_NUMBER_LIMIT';

export type SaleorPromotionRuleCreateInput = {
  /** Defines the conditions on the catalogue level that must be met for the reward to be applied. */
  cataloguePredicate?: InputMaybe<SaleorCataloguePredicateInput>;
  /** List of channel ids to which the rule should apply to. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Product variant IDs available as a gift to choose.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  gifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines the conditions on the checkout/draft order level that must be met for the reward to be applied.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: InputMaybe<SaleorOrderPredicateInput>;
  /** The ID of the promotion that rule belongs to. */
  promotion: Scalars['ID']['input'];
  /**
   * Defines the reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: InputMaybe<SaleorRewardTypeEnum>;
  /** Defines the discount value. Required when catalogue predicate is provided. */
  rewardValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Defines the promotion rule reward value type. Must be provided together with reward value. */
  rewardValueType?: InputMaybe<SaleorRewardValueTypeEnum>;
};

/** Event sent when new promotion rule is created. */
export type SaleorPromotionRuleCreated = SaleorEvent & {
  __typename?: 'PromotionRuleCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion rule the event relates to. */
  promotionRule: Maybe<SaleorPromotionRule>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion rule created event. */
export type SaleorPromotionRuleCreatedEvent = SaleorNode & SaleorPromotionEventInterface & SaleorPromotionRuleEventInterface & {
  __typename?: 'PromotionRuleCreatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The rule ID associated with the promotion event. */
  ruleId: Maybe<Scalars['String']['output']>;
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

/**
 * Deletes a promotion rule.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_RULE_DELETED (async): A promotion rule was deleted.
 */
export type SaleorPromotionRuleDelete = {
  __typename?: 'PromotionRuleDelete';
  errors: Array<SaleorPromotionRuleDeleteError>;
  promotionRule: Maybe<SaleorPromotionRule>;
};

export type SaleorPromotionRuleDeleteError = {
  __typename?: 'PromotionRuleDeleteError';
  /** The error code. */
  code: SaleorPromotionRuleDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPromotionRuleDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND';

/** Event sent when new promotion rule is deleted. */
export type SaleorPromotionRuleDeleted = SaleorEvent & {
  __typename?: 'PromotionRuleDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion rule the event relates to. */
  promotionRule: Maybe<SaleorPromotionRule>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion rule created event. */
export type SaleorPromotionRuleDeletedEvent = SaleorNode & SaleorPromotionEventInterface & SaleorPromotionRuleEventInterface & {
  __typename?: 'PromotionRuleDeletedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The rule ID associated with the promotion event. */
  ruleId: Maybe<Scalars['String']['output']>;
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

/** History log of the promotion event related to rule. */
export type SaleorPromotionRuleEventInterface = {
  /** The rule ID associated with the promotion event. */
  ruleId: Maybe<Scalars['String']['output']>;
};

export type SaleorPromotionRuleInput = {
  /** Defines the conditions on the catalogue level that must be met for the reward to be applied. */
  cataloguePredicate?: InputMaybe<SaleorCataloguePredicateInput>;
  /** List of channel ids to which the rule should apply to. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Product variant IDs available as a gift to choose.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  gifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines the conditions on the checkout/draft order level that must be met for the reward to be applied.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: InputMaybe<SaleorOrderPredicateInput>;
  /**
   * Defines the reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: InputMaybe<SaleorRewardTypeEnum>;
  /** Defines the discount value. Required when catalogue predicate is provided. */
  rewardValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Defines the promotion rule reward value type. Must be provided together with reward value. */
  rewardValueType?: InputMaybe<SaleorRewardValueTypeEnum>;
};

/** Represents promotion rule's original translatable fields and related translations. */
export type SaleorPromotionRuleTranslatableContent = SaleorNode & {
  __typename?: 'PromotionRuleTranslatableContent';
  /**
   * Description of the promotion rule.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion rule translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the promotion rule. */
  name: Maybe<Scalars['String']['output']>;
  /** ID of the promotion rule to translate. */
  promotionRuleId: Scalars['ID']['output'];
  /** Returns translated promotion rule fields for the given language code. */
  translation: Maybe<SaleorPromotionRuleTranslation>;
};


/** Represents promotion rule's original translatable fields and related translations. */
export type SaleorPromotionRuleTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a promotion rule.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorPromotionRuleTranslate = {
  __typename?: 'PromotionRuleTranslate';
  errors: Array<SaleorTranslationError>;
  promotionRule: Maybe<SaleorPromotionRule>;
};

/** Represents promotion rule translations. */
export type SaleorPromotionRuleTranslation = SaleorNode & {
  __typename?: 'PromotionRuleTranslation';
  /**
   * Translated description of the promotion rule.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion rule translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated name of the promotion rule. */
  name: Maybe<Scalars['String']['output']>;
  /** Represents the promotion rule fields to translate. */
  translatableContent: Maybe<SaleorPromotionRuleTranslatableContent>;
};

export type SaleorPromotionRuleTranslationInput = {
  /**
   * Translated promotion description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates an existing promotion rule.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_RULE_UPDATED (async): A promotion rule was updated.
 */
export type SaleorPromotionRuleUpdate = {
  __typename?: 'PromotionRuleUpdate';
  errors: Array<SaleorPromotionRuleUpdateError>;
  promotionRule: Maybe<SaleorPromotionRule>;
};

export type SaleorPromotionRuleUpdateError = {
  __typename?: 'PromotionRuleUpdateError';
  /** List of channel IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorPromotionRuleUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** Limit of gifts assigned to promotion rule. */
  giftsLimit: Maybe<Scalars['Int']['output']>;
  /** Number of gifts defined for this promotion rule exceeding the limit. */
  giftsLimitExceedBy: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPromotionRuleUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GIFTS_NUMBER_LIMIT'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_GIFT_TYPE'
  | 'INVALID_PRECISION'
  | 'MISSING_CHANNELS'
  | 'MULTIPLE_CURRENCIES_NOT_ALLOWED'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorPromotionRuleUpdateInput = {
  /** List of channel ids to add. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of variant IDs available as a gift to add.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  addGifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Defines the conditions on the catalogue level that must be met for the reward to be applied. */
  cataloguePredicate?: InputMaybe<SaleorCataloguePredicateInput>;
  /** Promotion rule description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /** Promotion rule name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines the conditions on the checkout/draft order level that must be met for the reward to be applied.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: InputMaybe<SaleorOrderPredicateInput>;
  /** List of channel ids to remove. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of variant IDs available as a gift to remove.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  removeGifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Defines the reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: InputMaybe<SaleorRewardTypeEnum>;
  /** Defines the discount value. Required when catalogue predicate is provided. */
  rewardValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Defines the promotion rule reward value type. Must be provided together with reward value. */
  rewardValueType?: InputMaybe<SaleorRewardValueTypeEnum>;
};

/** Event sent when new promotion rule is updated. */
export type SaleorPromotionRuleUpdated = SaleorEvent & {
  __typename?: 'PromotionRuleUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion rule the event relates to. */
  promotionRule: Maybe<SaleorPromotionRule>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion rule created event. */
export type SaleorPromotionRuleUpdatedEvent = SaleorNode & SaleorPromotionEventInterface & SaleorPromotionRuleEventInterface & {
  __typename?: 'PromotionRuleUpdatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The rule ID associated with the promotion event. */
  ruleId: Maybe<Scalars['String']['output']>;
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

export type SaleorPromotionSortField =
  /** Sort promotions by creation date. */
  | 'CREATED_AT'
  /** Sort promotions by end date. */
  | 'END_DATE'
  /** Sort promotions by name. */
  | 'NAME'
  /** Sort promotions by start date. */
  | 'START_DATE';

export type SaleorPromotionSortingInput = {
  /** Specifies the direction in which to sort promotions. */
  direction: SaleorOrderDirection;
  /** Sort promotions by the selected field. */
  field: SaleorPromotionSortField;
};

/** The event informs about the start of the promotion. */
export type SaleorPromotionStarted = SaleorEvent & {
  __typename?: 'PromotionStarted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion: Maybe<SaleorPromotion>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion started event. */
export type SaleorPromotionStartedEvent = SaleorNode & SaleorPromotionEventInterface & {
  __typename?: 'PromotionStartedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

/** Represents promotion's original translatable fields and related translations. */
export type SaleorPromotionTranslatableContent = SaleorNode & {
  __typename?: 'PromotionTranslatableContent';
  /**
   * Description of the promotion.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the promotion. */
  name: Scalars['String']['output'];
  /** ID of the promotion to translate. */
  promotionId: Scalars['ID']['output'];
  /** Returns translated promotion fields for the given language code. */
  translation: Maybe<SaleorPromotionTranslation>;
};


/** Represents promotion's original translatable fields and related translations. */
export type SaleorPromotionTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a promotion.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorPromotionTranslate = {
  __typename?: 'PromotionTranslate';
  errors: Array<SaleorTranslationError>;
  promotion: Maybe<SaleorPromotion>;
};

/** Represents promotion translations. */
export type SaleorPromotionTranslation = SaleorNode & {
  __typename?: 'PromotionTranslation';
  /**
   * Translated description of the promotion.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated name of the promotion. */
  name: Maybe<Scalars['String']['output']>;
  /** Represents the promotion fields to translate. */
  translatableContent: Maybe<SaleorPromotionTranslatableContent>;
};

export type SaleorPromotionTranslationInput = {
  /**
   * Translated promotion description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorPromotionTypeEnum =
  | 'CATALOGUE'
  | 'ORDER';

export type SaleorPromotionTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorPromotionTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorPromotionTypeEnum>>;
};

/**
 * Updates an existing promotion.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_UPDATED (async): A promotion was updated.
 * - PROMOTION_STARTED (async): Optionally called if promotion was started.
 * - PROMOTION_ENDED (async): Optionally called if promotion was ended.
 */
export type SaleorPromotionUpdate = {
  __typename?: 'PromotionUpdate';
  errors: Array<SaleorPromotionUpdateError>;
  promotion: Maybe<SaleorPromotion>;
};

export type SaleorPromotionUpdateError = {
  __typename?: 'PromotionUpdateError';
  /** The error code. */
  code: SaleorPromotionUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorPromotionUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorPromotionUpdateInput = {
  /** Promotion description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /** The end date of the promotion in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Promotion name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the promotion in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Event sent when promotion is updated. */
export type SaleorPromotionUpdated = SaleorEvent & {
  __typename?: 'PromotionUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion: Maybe<SaleorPromotion>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion updated event. */
export type SaleorPromotionUpdatedEvent = SaleorNode & SaleorPromotionEventInterface & {
  __typename?: 'PromotionUpdatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy: Maybe<SaleorUserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: SaleorPromotionEventsEnum;
};

export type SaleorPromotionWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorPromotionWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorPromotionWhereInput>>;
  /** Filter promotions by end date. */
  endDate?: InputMaybe<SaleorDateTimeFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOldSale?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  /** Filter by promotion name. */
  name?: InputMaybe<SaleorStringFilterInput>;
  /** Filter promotions by start date. */
  startDate?: InputMaybe<SaleorDateTimeFilterInput>;
  type?: InputMaybe<SaleorPromotionTypeEnumFilterInput>;
};

export type SaleorPublishableChannelListingInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SaleorQuery = {
  __typename?: 'Query';
  _entities: Maybe<Array<Maybe<Saleor_Entity>>>;
  _service: Maybe<Saleor_Service>;
  /**
   * Look up an address by ID.
   *
   * Requires one of the following permissions: MANAGE_USERS, OWNER.
   */
  address: Maybe<SaleorAddress>;
  /** Returns address validation rules. */
  addressValidationRules: Maybe<SaleorAddressValidationData>;
  /**
   * Look up an app by ID. If ID is not provided, return the currently authenticated app.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER AUTHENTICATED_APP. The authenticated app has access to its resources. Fetching different apps requires MANAGE_APPS permission.
   */
  app: Maybe<SaleorApp>;
  /**
   * Look up an app extension by ID.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  appExtension: Maybe<SaleorAppExtension>;
  /**
   * List of all extensions.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  appExtensions: Maybe<SaleorAppExtensionCountableConnection>;
  /**
   * List of the apps.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, MANAGE_APPS.
   */
  apps: Maybe<SaleorAppCountableConnection>;
  /**
   * List of all apps installations
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appsInstallations: Array<SaleorAppInstallation>;
  /** Look up an attribute by ID, slug or external reference. */
  attribute: Maybe<SaleorAttribute>;
  /** List of the shop's attributes. */
  attributes: Maybe<SaleorAttributeCountableConnection>;
  /** List of the shop's categories. */
  categories: Maybe<SaleorCategoryCountableConnection>;
  /** Look up a category by ID or slug. */
  category: Maybe<SaleorCategory>;
  /** Look up a channel by ID or slug. */
  channel: Maybe<SaleorChannel>;
  /**
   * List of all channels.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channels: Maybe<Array<SaleorChannel>>;
  /**
   * Look up a checkout by id.
   *
   * Requires one of the following permissions to query a checkout, if a checkout is in inactive channel: MANAGE_CHECKOUTS, IMPERSONATE_USER, HANDLE_PAYMENTS.
   */
  checkout: Maybe<SaleorCheckout>;
  /**
   * List of checkout lines. The query will not initiate any external requests, including fetching external shipping methods, filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_CHECKOUTS.
   */
  checkoutLines: Maybe<SaleorCheckoutLineCountableConnection>;
  /**
   * List of checkouts. The query will not initiate any external requests, including fetching external shipping methods, filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_PAYMENTS.
   */
  checkouts: Maybe<SaleorCheckoutCountableConnection>;
  /** Look up a collection by ID or slug. If slugLanguageCode is provided, category will be fetched by slug translation. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collection: Maybe<SaleorCollection>;
  /** List of the shop's collections. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collections: Maybe<SaleorCollectionCountableConnection>;
  /**
   * List of the shop's customers. This list includes all users who registered through the accountRegister mutation. Additionally, staff users who have placed an order using their account will also appear in this list.
   *
   * Requires one of the following permissions: MANAGE_ORDERS, MANAGE_USERS.
   */
  customers: Maybe<SaleorUserCountableConnection>;
  /**
   * Look up digital content by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContent: Maybe<SaleorDigitalContent>;
  /**
   * List of digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContents: Maybe<SaleorDigitalContentCountableConnection>;
  /**
   * List of draft orders. The query will not initiate any external requests, including filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrders: Maybe<SaleorOrderCountableConnection>;
  /**
   * Look up a export file by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  exportFile: Maybe<SaleorExportFile>;
  /**
   * List of export files.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  exportFiles: Maybe<SaleorExportFileCountableConnection>;
  /**
   * Look up a gift card by ID.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCard: Maybe<SaleorGiftCard>;
  /**
   * List of gift card currencies.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardCurrencies: Array<Scalars['String']['output']>;
  /**
   * Gift card related settings from site settings.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardSettings: SaleorGiftCardSettings;
  /**
   * List of gift card tags.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardTags: Maybe<SaleorGiftCardTagCountableConnection>;
  /**
   * List of gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCards: Maybe<SaleorGiftCardCountableConnection>;
  /**
   * List of activity events to display on homepage (at the moment it only contains order-events).
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Field no longer supported
   */
  homepageEvents: Maybe<SaleorOrderEventCountableConnection>;
  /** Return the currently authenticated user. */
  me: Maybe<SaleorUser>;
  /** Look up a navigation menu by ID or name. */
  menu: Maybe<SaleorMenu>;
  /** Look up a menu item by ID. */
  menuItem: Maybe<SaleorMenuItem>;
  /** List of the storefronts's menu items. */
  menuItems: Maybe<SaleorMenuItemCountableConnection>;
  /** List of the storefront's menus. */
  menus: Maybe<SaleorMenuCountableConnection>;
  /** Look up an order by ID or external reference. */
  order: Maybe<SaleorOrder>;
  /**
   * Look up an order by token.
   * @deprecated Field no longer supported
   */
  orderByToken: Maybe<SaleorOrder>;
  /**
   * Order related settings from site settings. Returns `orderSettings` for the first `channel` in alphabetical order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Use the `channel` query to fetch the `orderSettings` field instead.
   */
  orderSettings: Maybe<SaleorOrderSettings>;
  /**
   * List of orders. The query will not initiate any external requests, including filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orders: Maybe<SaleorOrderCountableConnection>;
  /**
   * Return the total sales amount from a specific period.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Field no longer supported
   */
  ordersTotal: Maybe<SaleorTaxedMoney>;
  /** Look up a page by ID or slug. */
  page: Maybe<SaleorPage>;
  /** Look up a page type by ID. */
  pageType: Maybe<SaleorPageType>;
  /** List of the page types. */
  pageTypes: Maybe<SaleorPageTypeCountableConnection>;
  /** List of the shop's pages. */
  pages: Maybe<SaleorPageCountableConnection>;
  /**
   * Look up a payment by ID.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payment: Maybe<SaleorPayment>;
  /**
   * List of payments.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  payments: Maybe<SaleorPaymentCountableConnection>;
  /**
   * Look up permission group by ID.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  permissionGroup: Maybe<SaleorGroup>;
  /**
   * List of permission groups.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  permissionGroups: Maybe<SaleorGroupCountableConnection>;
  /**
   * Look up a plugin by ID.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  plugin: Maybe<SaleorPlugin>;
  /**
   * List of plugins.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  plugins: Maybe<SaleorPluginCountableConnection>;
  /** Look up a product by ID. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  product: Maybe<SaleorProduct>;
  /** Look up a product type by ID. */
  productType: Maybe<SaleorProductType>;
  /** List of the shop's product types. */
  productTypes: Maybe<SaleorProductTypeCountableConnection>;
  /** Look up a product variant by ID or SKU. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  productVariant: Maybe<SaleorProductVariant>;
  /** List of product variants. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  productVariants: Maybe<SaleorProductVariantCountableConnection>;
  /** List of the shop's products. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  products: Maybe<SaleorProductCountableConnection>;
  /**
   * Look up a promotion by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  promotion: Maybe<SaleorPromotion>;
  /**
   * List of the promotions.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  promotions: Maybe<SaleorPromotionCountableConnection>;
  /** Refunds related settings. Returns `RefundSettings` configuration, global for the entire shop. */
  refundSettings: SaleorRefundSettings;
  /**
   * List of top selling products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Field no longer supported
   */
  reportProductSales: Maybe<SaleorProductVariantCountableConnection>;
  /**
   * Look up a sale by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Use the `promotion` query instead.
   */
  sale: Maybe<SaleorSale>;
  /**
   * List of the shop's sales.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Use the `promotions` query instead.
   */
  sales: Maybe<SaleorSaleCountableConnection>;
  /**
   * Look up a shipping zone by ID.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZone: Maybe<SaleorShippingZone>;
  /**
   * List of the shop's shipping zones.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZones: Maybe<SaleorShippingZoneCountableConnection>;
  /** Return information about the shop. */
  shop: SaleorShop;
  /**
   * List of the shop's staff users.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  staffUsers: Maybe<SaleorUserCountableConnection>;
  /**
   * Look up a stock by ID
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  stock: Maybe<SaleorStock>;
  /**
   * List of stocks.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  stocks: Maybe<SaleorStockCountableConnection>;
  /**
   * Look up a tax class.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass: Maybe<SaleorTaxClass>;
  /**
   * List of tax classes.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClasses: Maybe<SaleorTaxClassCountableConnection>;
  /**
   * Look up a tax configuration.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxConfiguration: Maybe<SaleorTaxConfiguration>;
  /**
   * List of tax configurations.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxConfigurations: Maybe<SaleorTaxConfigurationCountableConnection>;
  /**
   * Tax class rates grouped by country.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxCountryConfiguration: Maybe<SaleorTaxCountryConfiguration>;
  /**
   *
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxCountryConfigurations: Maybe<Array<SaleorTaxCountryConfiguration>>;
  /**
   * List of all tax rates available from tax gateway.
   * @deprecated Use `taxClasses` field instead.
   */
  taxTypes: Maybe<Array<SaleorTaxType>>;
  /**
   * Look up a transaction by ID.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS, MANAGE_ORDERS.
   */
  transaction: Maybe<SaleorTransactionItem>;
  /**
   * List of transactions. For apps with `MANAGE_ORDERS` permission, returns all transactions. For apps with just `HANDLE_PAYMENTS` permission, returns only transactions created by that app. For staff users, returns transactions from orders and checkouts in channels they have access to.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS, MANAGE_ORDERS.
   */
  transactions: Maybe<SaleorTransactionCountableConnection>;
  /**
   * Lookup a translatable item by ID.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  translation: Maybe<SaleorTranslatableItem>;
  /**
   * Returns a list of all translatable items of a given kind.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  translations: Maybe<SaleorTranslatableItemConnection>;
  /**
   * Look up a user by ID or email address.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_USERS, MANAGE_ORDERS.
   */
  user: Maybe<SaleorUser>;
  /**
   * Look up a voucher by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  voucher: Maybe<SaleorVoucher>;
  /**
   * List of the shop's vouchers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  vouchers: Maybe<SaleorVoucherCountableConnection>;
  /**
   * Look up a warehouse by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS, MANAGE_SHIPPING.
   */
  warehouse: Maybe<SaleorWarehouse>;
  /**
   * List of warehouses.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS, MANAGE_SHIPPING.
   */
  warehouses: Maybe<SaleorWarehouseCountableConnection>;
  /** Look up a webhook by ID. Requires one of the following permissions: MANAGE_APPS, OWNER. */
  webhook: Maybe<SaleorWebhook>;
  /**
   * List of all available webhook events.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   * @deprecated Use `WebhookEventTypeAsyncEnum` and `WebhookEventTypeSyncEnum` to get available event types.
   */
  webhookEvents: Maybe<Array<SaleorWebhookEvent>>;
  /** Retrieve a sample payload for a given webhook event based on real data. It can be useful for some integrations where sample payload is required. */
  webhookSamplePayload: Maybe<Scalars['JSONString']['output']>;
};


export type SaleorQuery_EntitiesArgs = {
  representations?: InputMaybe<Array<InputMaybe<Scalars['_Any']['input']>>>;
};


export type SaleorQueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryAddressValidationRulesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  cityArea?: InputMaybe<Scalars['String']['input']>;
  countryArea?: InputMaybe<Scalars['String']['input']>;
  countryCode: SaleorCountryCode;
};


export type SaleorQueryAppArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorQueryAppExtensionArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryAppExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAppExtensionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAppFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorAppSortingInput>;
};


export type SaleorQueryAttributeArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorQueryAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorAttributeSortingInput>;
  where?: InputMaybe<SaleorAttributeWhereInput>;
};


export type SaleorQueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorCategorySortingInput>;
  where?: InputMaybe<SaleorCategoryWhereInput>;
};


export type SaleorQueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<SaleorLanguageCodeEnum>;
};


export type SaleorQueryChannelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorQueryCheckoutArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorQueryCheckoutLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCheckoutFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorCheckoutSortingInput>;
};


export type SaleorQueryCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<SaleorLanguageCodeEnum>;
};


export type SaleorQueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCollectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorCollectionSortingInput>;
  where?: InputMaybe<SaleorCollectionWhereInput>;
};


export type SaleorQueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCustomerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorUserSortingInput>;
  where?: InputMaybe<SaleorCustomerWhereInput>;
};


export type SaleorQueryDigitalContentArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryDigitalContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorOrderDraftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorOrderSortingInput>;
  where?: InputMaybe<SaleorDraftOrderWhereInput>;
};


export type SaleorQueryExportFileArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryExportFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorExportFileFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorExportFileSortingInput>;
};


export type SaleorQueryGiftCardArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryGiftCardTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorGiftCardTagFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorGiftCardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorGiftCardSortingInput>;
};


export type SaleorQueryHomepageEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorQueryMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type SaleorQueryMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorMenuItemFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorMenuItemSortingInput>;
};


export type SaleorQueryMenusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorMenuFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorMenuSortingInput>;
};


export type SaleorQueryOrderArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorQueryOrderByTokenArgs = {
  token: Scalars['UUID']['input'];
};


export type SaleorQueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorOrderSortingInput>;
  where?: InputMaybe<SaleorOrderWhereInput>;
};


export type SaleorQueryOrdersTotalArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<SaleorReportingPeriod>;
};


export type SaleorQueryPageArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<SaleorLanguageCodeEnum>;
};


export type SaleorQueryPageTypeArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryPageTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPageTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPageTypeSortingInput>;
};


export type SaleorQueryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorPageSortingInput>;
  where?: InputMaybe<SaleorPageWhereInput>;
};


export type SaleorQueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPaymentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryPermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryPermissionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPermissionGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPermissionGroupSortingInput>;
};


export type SaleorQueryPluginArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryPluginsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPluginFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPluginSortingInput>;
};


export type SaleorQueryProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<SaleorLanguageCodeEnum>;
};


export type SaleorQueryProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductTypeSortingInput>;
};


export type SaleorQueryProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type SaleorQueryProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductVariantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorProductVariantSortingInput>;
  where?: InputMaybe<SaleorProductVariantWhereInput>;
};


export type SaleorQueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorProductOrder>;
  where?: InputMaybe<SaleorProductWhereInput>;
};


export type SaleorQueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPromotionSortingInput>;
  where?: InputMaybe<SaleorPromotionWhereInput>;
};


export type SaleorQueryReportProductSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  period: SaleorReportingPeriod;
};


export type SaleorQuerySaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type SaleorQuerySalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorSaleFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorSaleSortingInput>;
};


export type SaleorQueryShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type SaleorQueryShippingZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorShippingZoneFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryStaffUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorStaffUserInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorUserSortingInput>;
};


export type SaleorQueryStockArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryStocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorStockFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryTaxClassArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryTaxClassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorTaxClassFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorTaxClassSortingInput>;
};


export type SaleorQueryTaxConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryTaxConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorTaxConfigurationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryTaxCountryConfigurationArgs = {
  countryCode: SaleorCountryCode;
};


export type SaleorQueryTransactionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type SaleorQueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleorTransactionWhereInput>;
};


export type SaleorQueryTranslationArgs = {
  id: Scalars['ID']['input'];
  kind: SaleorTranslatableKinds;
};


export type SaleorQueryTranslationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind: SaleorTranslatableKinds;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleorQueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorQueryVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type SaleorQueryVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorVoucherFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorVoucherSortingInput>;
};


export type SaleorQueryWarehouseArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SaleorQueryWarehousesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorWarehouseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorWarehouseSortingInput>;
};


export type SaleorQueryWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type SaleorQueryWebhookSamplePayloadArgs = {
  eventType: SaleorWebhookSampleEventTypeEnum;
};

/** Represents a reduced VAT rate for a particular type of goods. */
export type SaleorReducedRate = {
  __typename?: 'ReducedRate';
  /** Reduced VAT rate in percent. */
  rate: Scalars['Float']['output'];
  /** A type of goods. */
  rateType: Scalars['String']['output'];
};

/**
 * The reference types (product or page type) that are used to narrow down the choices of reference objects.
 * ProductType applicable for reference attribute with `PRODUCT` or `PRODUCT_VARIANT` entity type.
 * PageType applicable for reference attribute with `PAGE` entity type.
 */
export type SaleorReferenceType = SaleorPageType | SaleorProductType;

/** Refresh JWT token. Mutation tries to take refreshToken from the input. If it fails it will try to take `refreshToken` from the http-only cookie `refreshToken`. `csrfToken` is required when `refreshToken` is provided as a cookie. */
export type SaleorRefreshToken = {
  __typename?: 'RefreshToken';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** JWT token, required to authenticate. */
  token: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user: Maybe<SaleorUser>;
};

/**
 * Updates RefundSettings. The `Page` (Model) Type will be cleared from `reasonReferenceType`. When it's cleared, passing reason reference to refund mutations is no longer accepted and will raise error.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorRefundReasonReferenceTypeClear = {
  __typename?: 'RefundReasonReferenceTypeClear';
  errors: Array<SaleorRefundReasonReferenceTypeClearError>;
  /** Refund settings. */
  refundSettings: SaleorRefundSettings;
  /** @deprecated Use `errors` field instead. */
  refundSettingsErrors: Array<SaleorRefundReasonReferenceTypeClearError>;
};

export type SaleorRefundReasonReferenceTypeClearError = {
  __typename?: 'RefundReasonReferenceTypeClearError';
  /** Failed to clear refund reason reference type */
  code: SaleorRefundSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

/**
 * Refund related settings from site settings.
 *
 * Added in Saleor 3.22.
 */
export type SaleorRefundSettings = {
  __typename?: 'RefundSettings';
  /** Model type used for refund reasons. */
  reasonReferenceType: Maybe<SaleorPageType>;
};

export type SaleorRefundSettingsErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'REQUIRED';

/**
 * Update refund settings across all channels.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorRefundSettingsUpdate = {
  __typename?: 'RefundSettingsUpdate';
  errors: Array<SaleorRefundSettingsUpdateError>;
  /** Refund settings. */
  refundSettings: SaleorRefundSettings;
  /** @deprecated Use `errors` field instead. */
  refundSettingsErrors: Array<SaleorRefundSettingsUpdateError>;
};

export type SaleorRefundSettingsUpdateError = {
  __typename?: 'RefundSettingsUpdateError';
  /** Failed to update Refund Settings */
  code: SaleorRefundSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorRefundSettingsUpdateInput = {
  /**
   * The ID of a model type, that will be used to reference refund reasons. All models with of this type will be accepted as refund reasons.
   *
   * Added in Saleor 3.22.
   */
  refundReasonReferenceType: Scalars['ID']['input'];
};

export type SaleorReorderInput = {
  /** The ID of the item to move. */
  id: Scalars['ID']['input'];
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorReportingPeriod =
  | 'THIS_MONTH'
  | 'TODAY';

/**
 * Request email change of the logged in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for account email change.
 * - ACCOUNT_CHANGE_EMAIL_REQUESTED (async): An account email change was requested.
 */
export type SaleorRequestEmailChange = {
  __typename?: 'RequestEmailChange';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** A user instance. */
  user: Maybe<SaleorUser>;
};

/**
 * Sends an email with the account password modification link.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for password reset.
 * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
 * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
 */
export type SaleorRequestPasswordReset = {
  __typename?: 'RequestPasswordReset';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
};

export type SaleorRewardTypeEnum =
  | 'GIFT'
  | 'SUBTOTAL_DISCOUNT';

export type SaleorRewardValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSale = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Sale';
  /** List of categories this sale applies to. */
  categories: Maybe<SaleorCategoryCountableConnection>;
  /**
   * List of channels available for the sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  channelListings: Maybe<Array<SaleorSaleChannelListing>>;
  /**
   * List of collections this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  collections: Maybe<SaleorCollectionCountableConnection>;
  /** The date and time when the sale was created. */
  created: Scalars['DateTime']['output'];
  /** Currency code for sale. */
  currency: Maybe<Scalars['String']['output']>;
  /** Sale value. */
  discountValue: Maybe<Scalars['Float']['output']>;
  /** The end date and time of the sale. */
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the sale. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** The name of the sale. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * List of products this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  products: Maybe<SaleorProductCountableConnection>;
  /** The start date and time of the sale. */
  startDate: Scalars['DateTime']['output'];
  /** Returns translated sale fields for the given language code. */
  translation: Maybe<SaleorSaleTranslation>;
  /** Type of the sale, fixed or percentage. */
  type: SaleorSaleType;
  /** The date and time when the sale was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * List of product variants this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  variants: Maybe<SaleorProductVariantCountableConnection>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSalePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSalePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleorSaleVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Adds products, categories, collections to a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_UPDATED (async): A sale was updated.
 */
export type SaleorSaleAddCatalogues = {
  __typename?: 'SaleAddCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Sale of which catalogue IDs will be modified. */
  sale: Maybe<SaleorSale>;
};

/**
 * Deletes sales.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_DELETED (async): A sale was deleted.
 */
export type SaleorSaleBulkDelete = {
  __typename?: 'SaleBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
};

/**
 * Represents sale channel listing.
 *
 * DEPRECATED: this type will be removed. Use `PromotionRule` type instead.
 */
export type SaleorSaleChannelListing = SaleorNode & {
  __typename?: 'SaleChannelListing';
  /** The channel in which the sale is available. */
  channel: SaleorChannel;
  /** The currency in which the discount value is specified. */
  currency: Scalars['String']['output'];
  /** The value of the discount applied to the sale in the channel. */
  discountValue: Scalars['Float']['output'];
  /** The ID of the channel listing. */
  id: Scalars['ID']['output'];
};

export type SaleorSaleChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** The value of the discount. */
  discountValue: Scalars['PositiveDecimal']['input'];
};

export type SaleorSaleChannelListingInput = {
  /** List of channels to which the sale should be assigned. */
  addChannels?: InputMaybe<Array<SaleorSaleChannelListingAddInput>>;
  /** List of channels from which the sale should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage sale's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleChannelListingUpdate = {
  __typename?: 'SaleChannelListingUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** An updated sale instance. */
  sale: Maybe<SaleorSale>;
};

export type SaleorSaleCountableConnection = {
  __typename?: 'SaleCountableConnection';
  edges: Array<SaleorSaleCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorSaleCountableEdge = {
  __typename?: 'SaleCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorSale;
};

/**
 * Creates a new sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_CREATED (async): A sale was created.
 */
export type SaleorSaleCreate = {
  __typename?: 'SaleCreate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  sale: Maybe<SaleorSale>;
};

/**
 * Event sent when new sale is created.
 *
 * DEPRECATED: this event will be removed. Use `PromotionCreated` event instead.
 */
export type SaleorSaleCreated = SaleorEvent & {
  __typename?: 'SaleCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new sale is created.
 *
 * DEPRECATED: this event will be removed. Use `PromotionCreated` event instead.
 */
export type SaleorSaleCreatedSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_DELETED (async): A sale was deleted.
 */
export type SaleorSaleDelete = {
  __typename?: 'SaleDelete';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  sale: Maybe<SaleorSale>;
};

/**
 * Event sent when sale is deleted.
 *
 * DEPRECATED: this event will be removed. Use `PromotionDeleted` event instead.
 */
export type SaleorSaleDeleted = SaleorEvent & {
  __typename?: 'SaleDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when sale is deleted.
 *
 * DEPRECATED: this event will be removed. Use `PromotionDeleted` event instead.
 */
export type SaleorSaleDeletedSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorSaleFilterInput = {
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  saleType?: InputMaybe<SaleorDiscountValueTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<SaleorDateTimeRangeInput>;
  status?: InputMaybe<Array<SaleorDiscountStatusEnum>>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorSaleInput = {
  /** Categories related to the discount. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collections related to the discount. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date of the voucher in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Voucher name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Products related to the discount. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date of the voucher in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Fixed or percentage. */
  type?: InputMaybe<SaleorDiscountValueTypeEnum>;
  /** Value of the voucher. */
  value?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Removes products, categories, collections from a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_UPDATED (async): A sale was updated.
 */
export type SaleorSaleRemoveCatalogues = {
  __typename?: 'SaleRemoveCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Sale of which catalogue IDs will be modified. */
  sale: Maybe<SaleorSale>;
};

export type SaleorSaleSortField =
  /** Sort sales by creation date. */
  | 'CREATED_AT'
  /** Sort sales by end date. */
  | 'END_DATE'
  /** Sort sales by last modification date. */
  | 'LAST_MODIFIED_AT'
  /** Sort sales by name. */
  | 'NAME'
  /** Sort sales by start date. */
  | 'START_DATE'
  /** Sort sales by type. */
  | 'TYPE'
  /**
   * Sort sales by value.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'VALUE';

export type SaleorSaleSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort sales. */
  direction: SaleorOrderDirection;
  /** Sort sales by the selected field. */
  field: SaleorSaleSortField;
};

/**
 * The event informs about the start or end of the sale.
 *
 * DEPRECATED: this event will be removed. Use `PromotionStarted` and `PromotionEnded` events instead.
 */
export type SaleorSaleToggle = SaleorEvent & {
  __typename?: 'SaleToggle';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/**
 * The event informs about the start or end of the sale.
 *
 * DEPRECATED: this event will be removed. Use `PromotionStarted` and `PromotionEnded` events instead.
 */
export type SaleorSaleToggleSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents sale's original translatable fields and related translations.
 *
 * DEPRECATED: this type will be removed. Use `PromotionTranslatableContent` instead.
 */
export type SaleorSaleTranslatableContent = SaleorNode & {
  __typename?: 'SaleTranslatableContent';
  /** The ID of the sale translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the sale to translate. */
  name: Scalars['String']['output'];
  /**
   * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Get model fields from the root level queries.
   */
  sale: Maybe<SaleorSale>;
  /** The ID of the sale to translate. */
  saleId: Scalars['ID']['output'];
  /** Returns translated sale fields for the given language code. */
  translation: Maybe<SaleorSaleTranslation>;
};


/**
 * Represents sale's original translatable fields and related translations.
 *
 * DEPRECATED: this type will be removed. Use `PromotionTranslatableContent` instead.
 */
export type SaleorSaleTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a sale.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorSaleTranslate = {
  __typename?: 'SaleTranslate';
  errors: Array<SaleorTranslationError>;
  sale: Maybe<SaleorSale>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

/**
 * Represents sale translations.
 *
 * DEPRECATED: this type will be removed. Use `PromotionTranslation` instead.
 */
export type SaleorSaleTranslation = SaleorNode & {
  __typename?: 'SaleTranslation';
  /** The ID of the sale translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated name of sale. */
  name: Maybe<Scalars['String']['output']>;
  /** Represents the sale fields to translate. */
  translatableContent: Maybe<SaleorSaleTranslatableContent>;
};

export type SaleorSaleType =
  | 'FIXED'
  | 'PERCENTAGE';

/**
 * Updates a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_UPDATED (async): A sale was updated.
 * - SALE_TOGGLE (async): Optionally triggered when a sale is started or stopped.
 */
export type SaleorSaleUpdate = {
  __typename?: 'SaleUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  sale: Maybe<SaleorSale>;
};

/**
 * Event sent when sale is updated.
 *
 * DEPRECATED: this event will be removed. Use `PromotionUpdated` event instead.
 */
export type SaleorSaleUpdated = SaleorEvent & {
  __typename?: 'SaleUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when sale is updated.
 *
 * DEPRECATED: this event will be removed. Use `PromotionUpdated` event instead.
 */
export type SaleorSaleUpdatedSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an assigned attribute to an object. */
export type SaleorSelectedAttribute = {
  __typename?: 'SelectedAttribute';
  /** Name of an attribute displayed in the interface. */
  attribute: SaleorAttribute;
  /** Values of an attribute. */
  values: Array<SaleorAttributeValue>;
};

/**
 * Sends a notification confirmation.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for account confirmation.
 * - ACCOUNT_CONFIRMATION_REQUESTED (async): An account confirmation was requested. This event is always sent regardless of settings.
 */
export type SaleorSendConfirmationEmail = {
  __typename?: 'SendConfirmationEmail';
  errors: Array<SaleorSendConfirmationEmailError>;
};

export type SaleorSendConfirmationEmailError = {
  __typename?: 'SendConfirmationEmailError';
  /** The error code. */
  code: SaleorSendConfirmationEmailErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorSendConfirmationEmailErrorCode =
  | 'ACCOUNT_CONFIRMED'
  | 'CONFIRMATION_ALREADY_REQUESTED'
  | 'INVALID'
  | 'MISSING_CHANNEL_SLUG';

export type SaleorSeoInput = {
  /** SEO description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** SEO title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Sets the user's password from the token sent by email using the RequestPasswordReset mutation. */
export type SaleorSetPassword = {
  __typename?: 'SetPassword';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate access token. */
  csrfToken: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** JWT refresh token, required to re-generate access token. */
  refreshToken: Maybe<Scalars['String']['output']>;
  /** JWT token, required to authenticate. */
  token: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user: Maybe<SaleorUser>;
};

export type SaleorShippingError = {
  __typename?: 'ShippingError';
  /** List of channels IDs which causes the error. */
  channels: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorShippingErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of warehouse IDs which causes the error. */
  warehouses: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorShippingErrorCode =
  | 'ALREADY_EXISTS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LESS_THAN_MIN'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/** List shipping methods for checkout. */
export type SaleorShippingListMethodsForCheckout = SaleorEvent & {
  __typename?: 'ShippingListMethodsForCheckout';
  /** The checkout the event relates to. */
  checkout: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods: Maybe<Array<SaleorShippingMethod>>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethod = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'ShippingMethod';
  /** Describes if this shipping method is active and can be selected. */
  active: Scalars['Boolean']['output'];
  /**
   * Shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** Unique ID of ShippingMethod available for Order. */
  id: Scalars['ID']['output'];
  /** Maximum delivery days for this shipping method. */
  maximumDeliveryDays: Maybe<Scalars['Int']['output']>;
  /** Maximum order price for this shipping method. */
  maximumOrderPrice: Maybe<SaleorMoney>;
  /**
   * Maximum order weight for this shipping method.
   * @deprecated Field no longer supported
   */
  maximumOrderWeight: Maybe<SaleorWeight>;
  /** Message connected to this shipping method. */
  message: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Minimum delivery days for this shipping method. */
  minimumDeliveryDays: Maybe<Scalars['Int']['output']>;
  /** Minimal order price for this shipping method. */
  minimumOrderPrice: Maybe<SaleorMoney>;
  /**
   * Minimum order weight for this shipping method.
   * @deprecated Field no longer supported
   */
  minimumOrderWeight: Maybe<SaleorWeight>;
  /** Shipping method name. */
  name: Scalars['String']['output'];
  /** The price of selected shipping method. */
  price: SaleorMoney;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Returns translated shipping method fields for the given language code. */
  translation: Maybe<SaleorShippingMethodTranslation>;
  /**
   * Type of the shipping method.
   * @deprecated Field no longer supported
   */
  type: Maybe<SaleorShippingMethodTypeEnum>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/** Represents shipping method channel listing. */
export type SaleorShippingMethodChannelListing = SaleorNode & {
  __typename?: 'ShippingMethodChannelListing';
  /** The channel associated with the shipping method channel listing. */
  channel: SaleorChannel;
  /** The ID of shipping method channel listing. */
  id: Scalars['ID']['output'];
  /** Maximum order price. */
  maximumOrderPrice: Maybe<SaleorMoney>;
  /** Minimum order price. */
  minimumOrderPrice: Maybe<SaleorMoney>;
  /** Price of the shipping method in the associated channel. */
  price: Maybe<SaleorMoney>;
};

export type SaleorShippingMethodChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Maximum order price to use this shipping method. */
  maximumOrderPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Minimum order price to use this shipping method. */
  minimumOrderPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Shipping price of the shipping method in this channel. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

export type SaleorShippingMethodChannelListingInput = {
  /** List of channels to which the shipping method should be assigned. */
  addChannels?: InputMaybe<Array<SaleorShippingMethodChannelListingAddInput>>;
  /** List of channels from which the shipping method should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage shipping method's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingMethodChannelListingUpdate = {
  __typename?: 'ShippingMethodChannelListingUpdate';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** An updated shipping method instance. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
};

/** Represents shipping method postal code rule. */
export type SaleorShippingMethodPostalCodeRule = SaleorNode & {
  __typename?: 'ShippingMethodPostalCodeRule';
  /** End address range. */
  end: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Inclusion type of the postal code rule. */
  inclusionType: Maybe<SaleorPostalCodeRuleInclusionTypeEnum>;
  /** Start address range. */
  start: Maybe<Scalars['String']['output']>;
};

/** Represents shipping method's original translatable fields and related translations. */
export type SaleorShippingMethodTranslatableContent = SaleorNode & {
  __typename?: 'ShippingMethodTranslatableContent';
  /**
   * Shipping method description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the shipping method translatable content. */
  id: Scalars['ID']['output'];
  /** Shipping method name to translate. */
  name: Scalars['String']['output'];
  /**
   * Shipping method are the methods you'll use to get customer's orders  to them. They are directly exposed to the customers.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   * @deprecated Get model fields from the root level queries.
   */
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** The ID of the shipping method to translate. */
  shippingMethodId: Scalars['ID']['output'];
  /** Returns translated shipping method fields for the given language code. */
  translation: Maybe<SaleorShippingMethodTranslation>;
};


/** Represents shipping method's original translatable fields and related translations. */
export type SaleorShippingMethodTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/** Represents shipping method translations. */
export type SaleorShippingMethodTranslation = SaleorNode & {
  __typename?: 'ShippingMethodTranslation';
  /**
   * Translated description of the shipping method.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the shipping method translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated shipping method name. */
  name: Maybe<Scalars['String']['output']>;
  /** Represents the shipping method fields to translate. */
  translatableContent: Maybe<SaleorShippingMethodTranslatableContent>;
};

/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodType = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'ShippingMethodType';
  /**
   * List of channels available for the method.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  channelListings: Maybe<Array<SaleorShippingMethodChannelListing>>;
  /**
   * Shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description: Maybe<Scalars['JSONString']['output']>;
  /**
   * List of excluded products for the shipping method.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  excludedProducts: Maybe<SaleorProductCountableConnection>;
  /** Shipping method ID. */
  id: Scalars['ID']['output'];
  /** Maximum number of days for delivery. */
  maximumDeliveryDays: Maybe<Scalars['Int']['output']>;
  /** The price of the cheapest variant (including discounts). */
  maximumOrderPrice: Maybe<SaleorMoney>;
  /** Maximum order weight to use this shipping method. */
  maximumOrderWeight: Maybe<SaleorWeight>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Minimal number of days for delivery. */
  minimumDeliveryDays: Maybe<Scalars['Int']['output']>;
  /** The price of the cheapest variant (including discounts). */
  minimumOrderPrice: Maybe<SaleorMoney>;
  /** Minimum order weight to use this shipping method. */
  minimumOrderWeight: Maybe<SaleorWeight>;
  /** Shipping method name. */
  name: Scalars['String']['output'];
  /** Postal code ranges rule of exclusion or inclusion of the shipping method. */
  postalCodeRules: Maybe<Array<SaleorShippingMethodPostalCodeRule>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * Tax class assigned to this shipping method.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass: Maybe<SaleorTaxClass>;
  /** Returns translated shipping method fields for the given language code. */
  translation: Maybe<SaleorShippingMethodTranslation>;
  /** Type of the shipping method. */
  type: Maybe<SaleorShippingMethodTypeEnum>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeExcludedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

export type SaleorShippingMethodTypeEnum =
  | 'PRICE'
  | 'WEIGHT';

/** List of shipping methods available for the country. */
export type SaleorShippingMethodsPerCountry = {
  __typename?: 'ShippingMethodsPerCountry';
  /** The country code. */
  countryCode: SaleorCountryCode;
  /** List of available shipping methods. */
  shippingMethods: Maybe<Array<SaleorShippingMethod>>;
};

export type SaleorShippingPostalCodeRulesCreateInputRange = {
  /** End range of the postal code. */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start range of the postal code. */
  start: Scalars['String']['input'];
};

/**
 * Deletes shipping prices.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceBulkDelete = {
  __typename?: 'ShippingPriceBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
};

/**
 * Creates a new shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceCreate = {
  __typename?: 'ShippingPriceCreate';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone: Maybe<SaleorShippingZone>;
};

/** Event sent when new shipping price is created. */
export type SaleorShippingPriceCreated = SaleorEvent & {
  __typename?: 'ShippingPriceCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping method the event relates to. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new shipping price is created. */
export type SaleorShippingPriceCreatedShippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Event sent when new shipping price is created. */
export type SaleorShippingPriceCreatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceDelete = {
  __typename?: 'ShippingPriceDelete';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** A shipping method to delete. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone: Maybe<SaleorShippingZone>;
};

/** Event sent when shipping price is deleted. */
export type SaleorShippingPriceDeleted = SaleorEvent & {
  __typename?: 'ShippingPriceDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping method the event relates to. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping price is deleted. */
export type SaleorShippingPriceDeletedShippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Event sent when shipping price is deleted. */
export type SaleorShippingPriceDeletedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Exclude products from shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceExcludeProducts = {
  __typename?: 'ShippingPriceExcludeProducts';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** A shipping method with new list of excluded products. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
};

export type SaleorShippingPriceExcludeProductsInput = {
  /** List of products which will be excluded. */
  products: Array<Scalars['ID']['input']>;
};

export type SaleorShippingPriceInput = {
  /** Postal code rules to add. */
  addPostalCodeRules?: InputMaybe<Array<SaleorShippingPostalCodeRulesCreateInputRange>>;
  /** Postal code rules to delete. */
  deletePostalCodeRules?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Shipping method description. */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** Inclusion type for currently assigned postal code rules. */
  inclusionType?: InputMaybe<SaleorPostalCodeRuleInclusionTypeEnum>;
  /** Maximum number of days for delivery. */
  maximumDeliveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum order weight to use this shipping method. */
  maximumOrderWeight?: InputMaybe<Scalars['WeightScalar']['input']>;
  /** Minimal number of days for delivery. */
  minimumDeliveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum order weight to use this shipping method. */
  minimumOrderWeight?: InputMaybe<Scalars['WeightScalar']['input']>;
  /** Name of the shipping method. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone this method belongs to. */
  shippingZone?: InputMaybe<Scalars['ID']['input']>;
  /** ID of a tax class to assign to this shipping method. If not provided, the default tax class will be used. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /** Shipping type: price or weight based. */
  type?: InputMaybe<SaleorShippingMethodTypeEnum>;
};

/**
 * Remove product from excluded list for shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceRemoveProductFromExclude = {
  __typename?: 'ShippingPriceRemoveProductFromExclude';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** A shipping method with new list of excluded products. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
};

/**
 * Creates/updates translations for a shipping method.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorShippingPriceTranslate = {
  __typename?: 'ShippingPriceTranslate';
  errors: Array<SaleorTranslationError>;
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorShippingPriceTranslationInput = {
  /**
   * Translated shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a new shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceUpdate = {
  __typename?: 'ShippingPriceUpdate';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone: Maybe<SaleorShippingZone>;
};

/** Event sent when shipping price is updated. */
export type SaleorShippingPriceUpdated = SaleorEvent & {
  __typename?: 'ShippingPriceUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping method the event relates to. */
  shippingMethod: Maybe<SaleorShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping price is updated. */
export type SaleorShippingPriceUpdatedShippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Event sent when shipping price is updated. */
export type SaleorShippingPriceUpdatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZone = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'ShippingZone';
  /** List of channels for shipping zone. */
  channels: Array<SaleorChannel>;
  /** List of countries available for the method. */
  countries: Array<SaleorCountryDisplay>;
  /** Indicates if the shipping zone is default one. */
  default: Scalars['Boolean']['output'];
  /** Description of a shipping zone. */
  description: Maybe<Scalars['String']['output']>;
  /** The ID of shipping zone. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Shipping zone name. */
  name: Scalars['String']['output'];
  /** Lowest and highest prices for the shipping. */
  priceRange: Maybe<SaleorMoneyRange>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** List of shipping methods available for orders shipped to countries within this shipping zone. */
  shippingMethods: Maybe<Array<SaleorShippingMethodType>>;
  /** List of warehouses for shipping zone. */
  warehouses: Array<SaleorWarehouse>;
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZoneMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZoneMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZonePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZonePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes shipping zones.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneBulkDelete = {
  __typename?: 'ShippingZoneBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
};

export type SaleorShippingZoneCountableConnection = {
  __typename?: 'ShippingZoneCountableConnection';
  edges: Array<SaleorShippingZoneCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorShippingZoneCountableEdge = {
  __typename?: 'ShippingZoneCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorShippingZone;
};

/**
 * Creates a new shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneCreate = {
  __typename?: 'ShippingZoneCreate';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingZone: Maybe<SaleorShippingZone>;
};

export type SaleorShippingZoneCreateInput = {
  /** List of channels to assign to the shipping zone. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to a shipping zone */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of countries in this shipping zone. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default shipping zone will be used for countries not covered by other zones. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the shipping zone. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone's name. Visible only to the staff. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new shipping zone is created. */
export type SaleorShippingZoneCreated = SaleorEvent & {
  __typename?: 'ShippingZoneCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when new shipping zone is created. */
export type SaleorShippingZoneCreatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneDelete = {
  __typename?: 'ShippingZoneDelete';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingZone: Maybe<SaleorShippingZone>;
};

/** Event sent when shipping zone is deleted. */
export type SaleorShippingZoneDeleted = SaleorEvent & {
  __typename?: 'ShippingZoneDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping zone is deleted. */
export type SaleorShippingZoneDeletedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorShippingZoneFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when shipping zone metadata is updated. */
export type SaleorShippingZoneMetadataUpdated = SaleorEvent & {
  __typename?: 'ShippingZoneMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping zone metadata is updated. */
export type SaleorShippingZoneMetadataUpdatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a new shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneUpdate = {
  __typename?: 'ShippingZoneUpdate';
  errors: Array<SaleorShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingZone: Maybe<SaleorShippingZone>;
};

export type SaleorShippingZoneUpdateInput = {
  /** List of channels to assign to the shipping zone. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to a shipping zone */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of countries in this shipping zone. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default shipping zone will be used for countries not covered by other zones. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the shipping zone. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone's name. Visible only to the staff. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of channels to unassign from the shipping zone. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to unassign from a shipping zone */
  removeWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when shipping zone is updated. */
export type SaleorShippingZoneUpdated = SaleorEvent & {
  __typename?: 'ShippingZoneUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping zone is updated. */
export type SaleorShippingZoneUpdatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShop = SaleorObjectWithMetadata & {
  __typename?: 'Shop';
  /** Controls the method used for merging existing orders and giftcards when password-based authentication is used. Learn more at https://docs.saleor.io/upgrade-guides/core/migrate-account-merging */
  accountConfirmMergeMode: SaleorAccountConfirmModeEnum;
  /**
   * Determines if user can login without confirmation when `enableAccountConfirmation` is enabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  allowLoginWithoutConfirmation: Maybe<Scalars['Boolean']['output']>;
  /**
   * List of announcements for this shop.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  announcements: Array<SaleorAnnouncement>;
  /**
   * Enable automatic fulfillment for all digital products.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  automaticFulfillmentDigitalProducts: Maybe<Scalars['Boolean']['output']>;
  /** List of available external authentications. */
  availableExternalAuthentications: Array<SaleorExternalAuthentication>;
  /**
   * List of available payment gateways.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  availablePaymentGateways: Array<SaleorPaymentGateway>;
  /** Shipping methods that are available for the shop. */
  availableShippingMethods: Maybe<Array<SaleorShippingMethod>>;
  /**
   * List of tax apps that can be assigned to the channel. The list will be calculated by Saleor based on the apps that are subscribed to webhooks related to tax calculations: CHECKOUT_CALCULATE_TAXES
   *
   * Added in Saleor 3.19.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, MANAGE_APPS.
   */
  availableTaxApps: Array<SaleorApp>;
  /**
   * List of all currencies supported by shop's channels.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  channelCurrencies: Array<Scalars['String']['output']>;
  /**
   * Charge taxes on shipping.
   * @deprecated Use `ShippingMethodType.taxClass` to determine whether taxes are calculated for shipping methods; if a tax class is set, the taxes will be calculated, otherwise no tax rate will be applied.
   */
  chargeTaxesOnShipping: Scalars['Boolean']['output'];
  /** Company address. */
  companyAddress: Maybe<SaleorAddress>;
  /** List of countries available in the shop. */
  countries: Array<SaleorCountryDisplay>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl: Maybe<Scalars['String']['output']>;
  /** Shop's default country. */
  defaultCountry: Maybe<SaleorCountryDisplay>;
  /**
   * Default number of max downloads per digital content URL.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultDigitalMaxDownloads: Maybe<Scalars['Int']['output']>;
  /**
   * Default number of days which digital content URL will be valid.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultDigitalUrlValidDays: Maybe<Scalars['Int']['output']>;
  /**
   * Default shop's email sender's address.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultMailSenderAddress: Maybe<Scalars['String']['output']>;
  /**
   * Default shop's email sender's name.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultMailSenderName: Maybe<Scalars['String']['output']>;
  /** Default weight unit. */
  defaultWeightUnit: Maybe<SaleorWeightUnitsEnum>;
  /** Shop's description. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Display prices with tax in store.
   * @deprecated Use `Channel.taxConfiguration` to determine whether to display gross or net prices.
   */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Shop's domain data. */
  domain: SaleorDomain;
  /**
   * Determines if account confirmation by email is enabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  enableAccountConfirmationByEmail: Maybe<Scalars['Boolean']['output']>;
  /** Allow to approve fulfillments which are unpaid. */
  fulfillmentAllowUnpaid: Scalars['Boolean']['output'];
  /** Automatically approve all new fulfillments. */
  fulfillmentAutoApprove: Scalars['Boolean']['output'];
  /** Header text. */
  headerText: Maybe<Scalars['String']['output']>;
  /** ID of the shop. */
  id: Scalars['ID']['output'];
  /**
   * Include taxes in prices.
   * @deprecated Use `Channel.taxConfiguration.pricesEnteredWithTax` to determine whether prices are entered with tax.
   */
  includeTaxesInPrices: Scalars['Boolean']['output'];
  /** List of the shops's supported languages. */
  languages: Array<SaleorLanguageDisplay>;
  /**
   * Default number of maximum line quantity in single checkout (per single checkout line).
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  limitQuantityPerCheckout: Maybe<Scalars['Int']['output']>;
  /**
   * Resource limitations and current usage if any set for a shop
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   * @deprecated Field no longer supported
   */
  limits: SaleorLimitInfo;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Shop's name. */
  name: Scalars['String']['output'];
  /** List of available permissions. */
  permissions: Array<SaleorPermission>;
  /** List of possible phone prefixes. */
  phonePrefixes: Array<Scalars['String']['output']>;
  /**
   * When enabled, address fields that are not valid for a given country (according to Google's i18n address data) will be preserved instead of being removed during validation. Validation errors are still returned.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  preserveAllAddressFields: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * Default number of minutes stock will be reserved for anonymous checkout or null when stock reservation is disabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  reserveStockDurationAnonymousUser: Maybe<Scalars['Int']['output']>;
  /**
   * Default number of minutes stock will be reserved for authenticated checkout or null when stock reservation is disabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  reserveStockDurationAuthenticatedUser: Maybe<Scalars['Int']['output']>;
  /** Minor Saleor API version. */
  schemaVersion: Scalars['String']['output'];
  /**
   * List of staff notification recipients.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipients: Maybe<Array<SaleorStaffNotificationRecipient>>;
  /** This field is used as a default value for `ProductVariant.trackInventory`. */
  trackInventoryByDefault: Maybe<Scalars['Boolean']['output']>;
  /** Returns translated shop fields for the given language code. */
  translation: Maybe<SaleorShopTranslation>;
  /**
   * Use legacy update webhook emission. When enabled, update webhooks (e.g. `customerUpdated`,`productVariantUpdated`) are sent even when only metadata changes. When disabled, update webhooks are not sent for metadata-only changes; only metadata-specific webhooks (e.g., `customerMetadataUpdated`, `productVariantMetadataUpdated`) are sent.
   *
   * Added in Saleor 3.22.
   * @deprecated Field no longer supported
   */
  useLegacyUpdateWebhookEmission: Maybe<Scalars['Boolean']['output']>;
  /**
   * Saleor API version.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  version: Scalars['String']['output'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopAvailablePaymentGatewaysArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopAvailableShippingMethodsArgs = {
  address?: InputMaybe<SaleorAddressInput>;
  channel: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopCountriesArgs = {
  filter?: InputMaybe<SaleorCountryFilterInput>;
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Update the shop's address. If the `null` value is passed, the currently selected address will be deleted.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopAddressUpdate = {
  __typename?: 'ShopAddressUpdate';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop: Maybe<SaleorShop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

/**
 * Updates site domain of the shop.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopDomainUpdate = {
  __typename?: 'ShopDomainUpdate';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop: Maybe<SaleorShop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

export type SaleorShopError = {
  __typename?: 'ShopError';
  /** The error code. */
  code: SaleorShopErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorShopErrorCode =
  | 'ALREADY_EXISTS'
  | 'CANNOT_FETCH_TAX_RATES'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/**
 * Fetch tax rates.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopFetchTaxRates = {
  __typename?: 'ShopFetchTaxRates';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop: Maybe<SaleorShop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

/** Event sent when shop metadata is updated. */
export type SaleorShopMetadataUpdated = SaleorEvent & {
  __typename?: 'ShopMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorShopSettingsInput = {
  /** Controls the method used for merging existing orders and giftcards when password-based authentication is used. Learn more at https://docs.saleor.io/upgrade-guides/core/migrate-account-merging */
  accountConfirmMergeMode?: InputMaybe<SaleorAccountConfirmModeEnum>;
  /** Enable possibility to login without account confirmation. */
  allowLoginWithoutConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic fulfillment for all digital products. */
  automaticFulfillmentDigitalProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Charge taxes on shipping.
   *
   * DEPRECATED: this field will be removed. To enable taxes for a shipping method, assign a tax class to the shipping method with `shippingPriceCreate` or `shippingPriceUpdate` mutations.
   */
  chargeTaxesOnShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl?: InputMaybe<Scalars['String']['input']>;
  /** Default number of max downloads per digital content URL. */
  defaultDigitalMaxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /** Default number of days which digital content URL will be valid. */
  defaultDigitalUrlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Default email sender's address. */
  defaultMailSenderAddress?: InputMaybe<Scalars['String']['input']>;
  /** Default email sender's name. */
  defaultMailSenderName?: InputMaybe<Scalars['String']['input']>;
  /** Default weight unit. */
  defaultWeightUnit?: InputMaybe<SaleorWeightUnitsEnum>;
  /** SEO description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Display prices with tax in store.
   *
   * DEPRECATED: this field will be removed. Use `taxConfigurationUpdate` mutation to configure this setting per channel or country.
   */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic account confirmation by email. */
  enableAccountConfirmationByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable ability to approve fulfillments which are unpaid. */
  fulfillmentAllowUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic approval of all new fulfillments. */
  fulfillmentAutoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  /** Header text. */
  headerText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Include taxes in prices.
   *
   * DEPRECATED: this field will be removed. Use `taxConfigurationUpdate` mutation to configure this setting per channel or country.
   */
  includeTaxesInPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default number of maximum line quantity in single checkout. Minimum possible value is 1, default value is 50. */
  limitQuantityPerCheckout?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Shop public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * When enabled, address fields that are not valid for a given country (according to Google's i18n address data) will be preserved instead of being removed during validation. Validation errors are still returned.
   *
   * Added in Saleor 3.22.
   */
  preserveAllAddressFields?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Shop private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Default number of minutes stock will be reserved for anonymous checkout. Enter 0 or null to disable. */
  reserveStockDurationAnonymousUser?: InputMaybe<Scalars['Int']['input']>;
  /** Default number of minutes stock will be reserved for authenticated checkout. Enter 0 or null to disable. */
  reserveStockDurationAuthenticatedUser?: InputMaybe<Scalars['Int']['input']>;
  /** This field is used as a default value for `ProductVariant.trackInventory`. */
  trackInventoryByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Use legacy update webhook emission. When enabled, update webhooks (e.g. `customerUpdated`,`productVariantUpdated`) are sent even when only metadata changes. When disabled, update webhooks are not sent for metadata-only changes; only metadata-specific webhooks (e.g., `customerMetadataUpdated`, `productVariantMetadataUpdated`) are sent.
   *
   * Added in Saleor 3.22.
   *
   * DEPRECATED: this field will be removed.
   */
  useLegacyUpdateWebhookEmission?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Creates/updates translations for shop settings.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorShopSettingsTranslate = {
  __typename?: 'ShopSettingsTranslate';
  errors: Array<SaleorTranslationError>;
  /** Updated shop settings. */
  shop: Maybe<SaleorShop>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorShopSettingsTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates shop settings.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 *
 * Triggers the following webhook events:
 * - SHOP_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
 */
export type SaleorShopSettingsUpdate = {
  __typename?: 'ShopSettingsUpdate';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop: Maybe<SaleorShop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

/** Represents shop translations. */
export type SaleorShopTranslation = SaleorNode & {
  __typename?: 'ShopTranslation';
  /** Translated description of sale. */
  description: Scalars['String']['output'];
  /** Translated header text of sale. */
  headerText: Scalars['String']['output'];
  /** The ID of the shop translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
};

export type SaleorSiteDomainInput = {
  /** Domain name for shop. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Shop site name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes staff users. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_DELETED (async): A staff account was deleted.
 */
export type SaleorStaffBulkDelete = {
  __typename?: 'StaffBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorStaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
};

/**
 * Creates a new staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_CREATED (async): A new staff account was created.
 * - NOTIFY_USER (async): A notification for setting the password.
 * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
 */
export type SaleorStaffCreate = {
  __typename?: 'StaffCreate';
  errors: Array<SaleorStaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
  user: Maybe<SaleorUser>;
};

/** Fields required to create a staff user. */
export type SaleorStaffCreateInput = {
  /** List of permission group IDs to which user should be assigned. */
  addGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a view where users should be redirected to set the password. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new staff user is created. */
export type SaleorStaffCreated = SaleorEvent & {
  __typename?: 'StaffCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_DELETED (async): A staff account was deleted.
 */
export type SaleorStaffDelete = {
  __typename?: 'StaffDelete';
  errors: Array<SaleorStaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
  user: Maybe<SaleorUser>;
};

/** Event sent when staff user is deleted. */
export type SaleorStaffDeleted = SaleorEvent & {
  __typename?: 'StaffDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorStaffError = {
  __typename?: 'StaffError';
  /** A type of address that causes the error. */
  addressType: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorAccountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** List of permission group IDs which cause the error. */
  groups: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions: Maybe<Array<SaleorPermissionEnum>>;
  /** List of user IDs which causes the error. */
  users: Maybe<Array<Scalars['ID']['output']>>;
};

/** Represents status of a staff account. */
export type SaleorStaffMemberStatus =
  /** User account has been activated. */
  | 'ACTIVE'
  /** User account has not been activated yet. */
  | 'DEACTIVATED';

/** Represents a recipient of email notifications send by Saleor, such as notifications about new orders. Notifications can be assigned to staff users or arbitrary email addresses. */
export type SaleorStaffNotificationRecipient = SaleorNode & {
  __typename?: 'StaffNotificationRecipient';
  /** Determines if a notification active. */
  active: Maybe<Scalars['Boolean']['output']>;
  /** Returns email address of a user subscribed to email notifications. */
  email: Maybe<Scalars['String']['output']>;
  /** The ID of the staff notification recipient. */
  id: Scalars['ID']['output'];
  /** Returns a user subscribed to email notifications. */
  user: Maybe<SaleorUser>;
};

/**
 * Creates a new staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorStaffNotificationRecipientCreate = {
  __typename?: 'StaffNotificationRecipientCreate';
  errors: Array<SaleorShopError>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
  staffNotificationRecipient: Maybe<SaleorStaffNotificationRecipient>;
};

/**
 * Deletes staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorStaffNotificationRecipientDelete = {
  __typename?: 'StaffNotificationRecipientDelete';
  errors: Array<SaleorShopError>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
  staffNotificationRecipient: Maybe<SaleorStaffNotificationRecipient>;
};

export type SaleorStaffNotificationRecipientInput = {
  /** Determines if a notification active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email address of a user subscribed to email notifications. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user subscribed to email notifications.. */
  user?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Updates a staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorStaffNotificationRecipientUpdate = {
  __typename?: 'StaffNotificationRecipientUpdate';
  errors: Array<SaleorShopError>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
  staffNotificationRecipient: Maybe<SaleorStaffNotificationRecipient>;
};

/** Event sent when setting a new password for staff is requested. */
export type SaleorStaffSetPasswordRequested = SaleorEvent & {
  __typename?: 'StaffSetPasswordRequested';
  /** The channel data. */
  channel: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop: Maybe<SaleorShop>;
  /** The token required to confirm request. */
  token: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an existing staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_UPDATED (async): A staff account was updated.
 */
export type SaleorStaffUpdate = {
  __typename?: 'StaffUpdate';
  errors: Array<SaleorStaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
  user: Maybe<SaleorUser>;
};

/** Fields required to update a staff user. */
export type SaleorStaffUpdateInput = {
  /** List of permission group IDs to which user should be assigned. */
  addGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** List of permission group IDs from which user should be unassigned. */
  removeGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when staff user is updated. */
export type SaleorStaffUpdated = SaleorEvent & {
  __typename?: 'StaffUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorStaffUserInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SaleorStaffMemberStatus>;
};

/** Represents stock. */
export type SaleorStock = SaleorNode & {
  __typename?: 'Stock';
  /** The ID of stock. */
  id: Scalars['ID']['output'];
  /** Information about the product variant. */
  productVariant: SaleorProductVariant;
  /**
   * Quantity of a product in the warehouse's possession, including the allocated stock that is waiting for shipment.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantity: Scalars['Int']['output'];
  /**
   * Quantity allocated for orders.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantityAllocated: Scalars['Int']['output'];
  /**
   * Quantity reserved for checkouts.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantityReserved: Scalars['Int']['output'];
  /** The warehouse associated with the stock. */
  warehouse: SaleorWarehouse;
};

export type SaleorStockAvailability =
  | 'IN_STOCK'
  | 'OUT_OF_STOCK';

export type SaleorStockBulkResult = {
  __typename?: 'StockBulkResult';
  /** List of errors occurred on create or update attempt. */
  errors: Maybe<Array<SaleorStockBulkUpdateError>>;
  /** Stock data. */
  stock: Maybe<SaleorStock>;
};

/**
 * Updates stocks for a given variant and warehouse. Variant and warehouse selectors have to be the same for all stock inputs. Is not allowed to use 'variantId' in one input and 'variantExternalReference' in another.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 *
 * Triggers the following webhook events:
 * - PRODUCT_VARIANT_STOCK_UPDATED (async): A product variant stock details were updated.
 */
export type SaleorStockBulkUpdate = {
  __typename?: 'StockBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorStockBulkUpdateError>;
  /** List of the updated stocks. */
  results: Array<SaleorStockBulkResult>;
};

export type SaleorStockBulkUpdateError = {
  __typename?: 'StockBulkUpdateError';
  /** The error code. */
  code: SaleorStockBulkUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorStockBulkUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorStockBulkUpdateInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Variant external reference. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** Variant ID. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** Warehouse external reference. */
  warehouseExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse ID. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorStockCountableConnection = {
  __typename?: 'StockCountableConnection';
  edges: Array<SaleorStockCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorStockCountableEdge = {
  __typename?: 'StockCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorStock;
};

export type SaleorStockError = {
  __typename?: 'StockError';
  /** The error code. */
  code: SaleorStockErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorStockErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorStockFilterInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorStockInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Warehouse in which stock is located. */
  warehouse: Scalars['ID']['input'];
};

/** Represents the channel stock settings. */
export type SaleorStockSettings = {
  __typename?: 'StockSettings';
  /** Allocation strategy defines the preference of warehouses for allocations and reservations. */
  allocationStrategy: SaleorAllocationStrategyEnum;
};

export type SaleorStockSettingsInput = {
  /** Allocation strategy options. Strategy defines the preference of warehouses for allocations and reservations. */
  allocationStrategy: SaleorAllocationStrategyEnum;
};

export type SaleorStockUpdateInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Stock. */
  stock: Scalars['ID']['input'];
};

/**
 * Determine how stocks should be updated, while processing an order.
 *
 *     SKIP - stocks are not checked and not updated.
 *     UPDATE - only do update, if there is enough stock.
 *     FORCE - force update, if there is not enough stock.
 *
 */
export type SaleorStockUpdatePolicyEnum =
  | 'FORCE'
  | 'SKIP'
  | 'UPDATE';

/** Enum representing the type of a payment storage in a gateway. */
export type SaleorStorePaymentMethodEnum =
  /** Storage is disabled. The payment is not stored. */
  | 'NONE'
  /** Off session storage type. The payment is stored to be reused even if the customer is absent. */
  | 'OFF_SESSION'
  /** On session storage type. The payment is stored only to be reused when the customer is present in the checkout flow. */
  | 'ON_SESSION';

/** Represents a payment method stored for user (tokenized) in payment gateway. */
export type SaleorStoredPaymentMethod = {
  __typename?: 'StoredPaymentMethod';
  /** Stored credit card details if available. */
  creditCardInfo: Maybe<SaleorCreditCard>;
  /** JSON data returned by Payment Provider app for this payment method. */
  data: Maybe<Scalars['JSON']['output']>;
  /** Payment gateway that stores this payment method. */
  gateway: SaleorPaymentGateway;
  /** Stored payment method ID. */
  id: Scalars['ID']['output'];
  /** Payment method name. Example: last 4 digits of credit card, obfuscated email, etc. */
  name: Maybe<Scalars['String']['output']>;
  /** ID of stored payment method used to make payment actions. Note: method ID is unique only within the payment gateway. */
  paymentMethodId: Scalars['String']['output'];
  supportedPaymentFlows: Maybe<Array<SaleorTokenizedPaymentFlowEnum>>;
  /** Type of the payment method. Example: credit card, wallet, etc. */
  type: Scalars['String']['output'];
};

/** Event sent when user requests to delete a payment method. */
export type SaleorStoredPaymentMethodDeleteRequested = SaleorEvent & {
  __typename?: 'StoredPaymentMethodDeleteRequested';
  /** Channel related to the requested delete action. */
  channel: SaleorChannel;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The ID of the payment method that should be deleted by the payment gateway. */
  paymentMethodId: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The user for which the app should proceed with payment method delete request. */
  user: SaleorUser;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Request to delete a stored payment method on payment provider side.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - STORED_PAYMENT_METHOD_DELETE_REQUESTED (sync): The customer requested to delete a payment method.
 */
export type SaleorStoredPaymentMethodRequestDelete = {
  __typename?: 'StoredPaymentMethodRequestDelete';
  errors: Array<SaleorPaymentMethodRequestDeleteError>;
  /** The result of deleting a stored payment method. */
  result: SaleorStoredPaymentMethodRequestDeleteResult;
};

export type SaleorStoredPaymentMethodRequestDeleteErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Result of deleting a stored payment method.
 *
 *     This enum is used to determine the result of deleting a stored payment method.
 *     SUCCESSFULLY_DELETED - The stored payment method was successfully deleted.
 *     FAILED_TO_DELETE - The stored payment method was not deleted.
 *     FAILED_TO_DELIVER - The request to delete the stored payment method was not
 *     delivered.
 *
 */
export type SaleorStoredPaymentMethodRequestDeleteResult =
  | 'FAILED_TO_DELETE'
  | 'FAILED_TO_DELIVER'
  | 'SUCCESSFULLY_DELETED';

/** Define the filtering options for string fields. */
export type SaleorStringFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorSubscription = {
  __typename?: 'Subscription';
  /**
   * Event sent when new checkout is created.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutCreated: Maybe<SaleorCheckoutCreated>;
  /**
   * Event sent when checkout is fully authorized.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutFullyAuthorized: Maybe<SaleorCheckoutFullyAuthorized>;
  /**
   * Event sent when checkout is fully-paid.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutFullyPaid: Maybe<SaleorCheckoutFullyPaid>;
  /**
   * Event sent when checkout metadata is updated.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutMetadataUpdated: Maybe<SaleorCheckoutMetadataUpdated>;
  /**
   * Event sent when checkout is updated.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutUpdated: Maybe<SaleorCheckoutUpdated>;
  /**
   * Event sent when new draft order is created.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderCreated: Maybe<SaleorDraftOrderCreated>;
  /**
   * Event sent when draft order is deleted.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderDeleted: Maybe<SaleorDraftOrderDeleted>;
  /**
   * Event sent when draft order is updated.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderUpdated: Maybe<SaleorDraftOrderUpdated>;
  /** Look up subscription event. */
  event: Maybe<SaleorEvent>;
  /**
   * Event sent when orders are imported.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderBulkCreated: Maybe<SaleorOrderBulkCreated>;
  /**
   * Event sent when order is cancelled.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderCancelled: Maybe<SaleorOrderCancelled>;
  /**
   * Event sent when order is confirmed.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderConfirmed: Maybe<SaleorOrderConfirmed>;
  /**
   * Event sent when new order is created.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderCreated: Maybe<SaleorOrderCreated>;
  /**
   * Event sent when order becomes expired.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderExpired: Maybe<SaleorOrderExpired>;
  /**
   * Event sent when order is fulfilled.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderFulfilled: Maybe<SaleorOrderFulfilled>;
  /**
   * Event sent when order is fully paid.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderFullyPaid: Maybe<SaleorOrderFullyPaid>;
  /**
   * The order is fully refunded.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderFullyRefunded: Maybe<SaleorOrderFullyRefunded>;
  /**
   * Event sent when order metadata is updated.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderMetadataUpdated: Maybe<SaleorOrderMetadataUpdated>;
  /**
   * Payment has been made. The order may be partially or fully paid.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPaid: Maybe<SaleorOrderPaid>;
  /**
   * The order received a refund. The order may be partially or fully refunded.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderRefunded: Maybe<SaleorOrderRefunded>;
  /**
   * Event sent when order is updated.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderUpdated: Maybe<SaleorOrderUpdated>;
  /**
   * Event sent when product variant discounted price is recalculated.
   *
   * Added in Saleor 3.22.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  productVariantDiscountedPriceUpdated: Maybe<SaleorProductVariantDiscountedPriceUpdated>;
};


export type SaleorSubscriptionCheckoutCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionCheckoutFullyAuthorizedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionCheckoutFullyPaidArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionCheckoutMetadataUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionCheckoutUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionDraftOrderCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionDraftOrderDeletedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionDraftOrderUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderBulkCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderCancelledArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderConfirmedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderExpiredArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderFulfilledArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderFullyPaidArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderFullyRefundedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderMetadataUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderPaidArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderRefundedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionOrderUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorSubscriptionProductVariantDiscountedPriceUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorTaxCalculationStrategy =
  | 'FLAT_RATES'
  | 'TAX_APP';

/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type SaleorTaxClass = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'TaxClass';
  /** Country-specific tax rates for this tax class. */
  countries: Array<SaleorTaxClassCountryRate>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Name of the tax class. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type SaleorTaxClassMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type SaleorTaxClassMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type SaleorTaxClassPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type SaleorTaxClassPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorTaxClassCountableConnection = {
  __typename?: 'TaxClassCountableConnection';
  edges: Array<SaleorTaxClassCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorTaxClassCountableEdge = {
  __typename?: 'TaxClassCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTaxClass;
};

/** Tax rate for a country. When tax class is null, it represents the default tax rate for that country; otherwise it's a country tax rate specific to the given tax class. */
export type SaleorTaxClassCountryRate = {
  __typename?: 'TaxClassCountryRate';
  /** Country in which this tax rate applies. */
  country: SaleorCountryDisplay;
  /** Tax rate value. */
  rate: Scalars['Float']['output'];
  /** Related tax class. */
  taxClass: Maybe<SaleorTaxClass>;
};

/**
 * Creates a tax class.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxClassCreate = {
  __typename?: 'TaxClassCreate';
  errors: Array<SaleorTaxClassCreateError>;
  taxClass: Maybe<SaleorTaxClass>;
};

export type SaleorTaxClassCreateError = {
  __typename?: 'TaxClassCreateError';
  /** The error code. */
  code: SaleorTaxClassCreateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxClassCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxClassCreateInput = {
  /** List of country-specific tax rates to create for this tax class. */
  createCountryRates?: InputMaybe<Array<SaleorCountryRateInput>>;
  /** Name of the tax class. */
  name: Scalars['String']['input'];
};

/**
 * Deletes a tax class. After deleting the tax class any products, product types or shipping methods using it are updated to use the default tax class.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxClassDelete = {
  __typename?: 'TaxClassDelete';
  errors: Array<SaleorTaxClassDeleteError>;
  taxClass: Maybe<SaleorTaxClass>;
};

export type SaleorTaxClassDeleteError = {
  __typename?: 'TaxClassDeleteError';
  /** The error code. */
  code: SaleorTaxClassDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxClassDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxClassFilterInput = {
  countries?: InputMaybe<Array<SaleorCountryCode>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
};

export type SaleorTaxClassRateInput = {
  /** Tax rate value. */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** ID of a tax class for which to update the tax rate */
  taxClassId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorTaxClassSortField =
  /** Sort tax classes by name. */
  | 'NAME';

export type SaleorTaxClassSortingInput = {
  /** Specifies the direction in which to sort tax classes. */
  direction: SaleorOrderDirection;
  /** Sort tax classes by the selected field. */
  field: SaleorTaxClassSortField;
};

/**
 * Updates a tax class.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxClassUpdate = {
  __typename?: 'TaxClassUpdate';
  errors: Array<SaleorTaxClassUpdateError>;
  taxClass: Maybe<SaleorTaxClass>;
};

export type SaleorTaxClassUpdateError = {
  __typename?: 'TaxClassUpdateError';
  /** The error code. */
  code: SaleorTaxClassUpdateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxClassUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxClassUpdateInput = {
  /** Name of the tax class. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of country codes for which to remove the tax class rates. Note: It removes all rates for given country code. */
  removeCountryRates?: InputMaybe<Array<SaleorCountryCode>>;
  /** List of country-specific tax rates to create or update for this tax class. */
  updateCountryRates?: InputMaybe<Array<SaleorCountryRateUpdateInput>>;
};

/** Channel-specific tax configuration. */
export type SaleorTaxConfiguration = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'TaxConfiguration';
  /** A channel to which the tax configuration applies to. */
  channel: SaleorChannel;
  /** Determines whether taxes are charged in the given channel. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** List of country-specific exceptions in tax configuration. */
  countries: Array<SaleorTaxConfigurationPerCountry>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Determines whether prices are entered with the tax included. */
  pricesEnteredWithTax: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel. Empty value for `TAX_APP` set as `taxCalculationStrategy` means that Saleor will iterate over all installed tax apps. If multiple tax apps exist with provided tax app id use the `App` with newest `created` date. Will become mandatory in 4.0 for `TAX_APP` `taxCalculationStrategy`.
   *
   * Added in Saleor 3.19.
   */
  taxAppId: Maybe<Scalars['String']['output']>;
  /** The default strategy to use for tax calculation in the given channel. Taxes can be calculated either using user-defined flat rates or with a tax app. Empty value means that no method is selected and taxes are not calculated. */
  taxCalculationStrategy: Maybe<SaleorTaxCalculationStrategy>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping: Maybe<Scalars['Boolean']['output']>;
};


/** Channel-specific tax configuration. */
export type SaleorTaxConfigurationMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Channel-specific tax configuration. */
export type SaleorTaxConfigurationMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Channel-specific tax configuration. */
export type SaleorTaxConfigurationPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Channel-specific tax configuration. */
export type SaleorTaxConfigurationPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorTaxConfigurationCountableConnection = {
  __typename?: 'TaxConfigurationCountableConnection';
  edges: Array<SaleorTaxConfigurationCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorTaxConfigurationCountableEdge = {
  __typename?: 'TaxConfigurationCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTaxConfiguration;
};

export type SaleorTaxConfigurationFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
};

/** Country-specific exceptions of a channel's tax configuration. */
export type SaleorTaxConfigurationPerCountry = {
  __typename?: 'TaxConfigurationPerCountry';
  /** Determines whether taxes are charged in this country. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** Country in which this configuration applies. */
  country: SaleorCountryDisplay;
  /** Determines whether displayed prices should include taxes for this country. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel and country. If not provided, use the value from the channel's tax configuration.
   *
   * Added in Saleor 3.19.
   */
  taxAppId: Maybe<Scalars['String']['output']>;
  /** A country-specific strategy to use for tax calculation. Taxes can be calculated either using user-defined flat rates or with a tax app. If not provided, use the value from the channel's tax configuration. */
  taxCalculationStrategy: Maybe<SaleorTaxCalculationStrategy>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping: Maybe<Scalars['Boolean']['output']>;
};

export type SaleorTaxConfigurationPerCountryInput = {
  /** Determines whether taxes are charged in this country. */
  chargeTaxes: Scalars['Boolean']['input'];
  /** Country in which this configuration applies. */
  countryCode: SaleorCountryCode;
  /** Determines whether displayed prices should include taxes for this country. */
  displayGrossPrices: Scalars['Boolean']['input'];
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel and country. If not provided, use the value from the channel's tax configuration.
   *
   * Added in Saleor 3.19.
   */
  taxAppId?: InputMaybe<Scalars['String']['input']>;
  /** A country-specific strategy to use for tax calculation. Taxes can be calculated either using user-defined flat rates or with a tax app. If not provided, use the value from the channel's tax configuration. */
  taxCalculationStrategy?: InputMaybe<SaleorTaxCalculationStrategy>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines. Default value is `False`.Can be used only with `taxCalculationStrategy` set to `FLAT_RATES`.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Updates tax configuration for a channel.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxConfigurationUpdate = {
  __typename?: 'TaxConfigurationUpdate';
  errors: Array<SaleorTaxConfigurationUpdateError>;
  taxConfiguration: Maybe<SaleorTaxConfiguration>;
};

export type SaleorTaxConfigurationUpdateError = {
  __typename?: 'TaxConfigurationUpdateError';
  /** The error code. */
  code: SaleorTaxConfigurationUpdateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxConfigurationUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxConfigurationUpdateInput = {
  /** Determines whether taxes are charged in the given channel. */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether prices are entered with the tax included. */
  pricesEnteredWithTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of country codes for which to remove the tax configuration. */
  removeCountriesConfiguration?: InputMaybe<Array<SaleorCountryCode>>;
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel. Empty value for `TAX_APP` set as `taxCalculationStrategy` means that Saleor will iterate over all installed tax apps. If multiple tax apps exist with provided tax app id use the `App` with newest `created` date. It's possible to set plugin by using prefix `plugin:` with `PLUGIN_ID` e.g. with Avalara `plugin:mirumee.taxes.avalara`.Will become mandatory in 4.0 for `TAX_APP` `taxCalculationStrategy`.
   *
   * Added in Saleor 3.19.
   */
  taxAppId?: InputMaybe<Scalars['String']['input']>;
  /** The default strategy to use for tax calculation in the given channel. Taxes can be calculated either using user-defined flat rates or with a tax app. Empty value means that no method is selected and taxes are not calculated. */
  taxCalculationStrategy?: InputMaybe<SaleorTaxCalculationStrategy>;
  /** List of tax country configurations to create or update (identified by a country code). */
  updateCountriesConfiguration?: InputMaybe<Array<SaleorTaxConfigurationPerCountryInput>>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines. Default value is `False`.Can be used only with `taxCalculationStrategy` set to `FLAT_RATES`.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Tax class rates grouped by country. */
export type SaleorTaxCountryConfiguration = {
  __typename?: 'TaxCountryConfiguration';
  /** A country for which tax class rates are grouped. */
  country: SaleorCountryDisplay;
  /** List of tax class rates. */
  taxClassCountryRates: Array<SaleorTaxClassCountryRate>;
};

/**
 * Remove all tax class rates for a specific country.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxCountryConfigurationDelete = {
  __typename?: 'TaxCountryConfigurationDelete';
  errors: Array<SaleorTaxCountryConfigurationDeleteError>;
  /** Updated tax class rates grouped by a country. */
  taxCountryConfiguration: Maybe<SaleorTaxCountryConfiguration>;
};

export type SaleorTaxCountryConfigurationDeleteError = {
  __typename?: 'TaxCountryConfigurationDeleteError';
  /** The error code. */
  code: SaleorTaxCountryConfigurationDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxCountryConfigurationDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Updates tax class rates for a specific country.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxCountryConfigurationUpdate = {
  __typename?: 'TaxCountryConfigurationUpdate';
  errors: Array<SaleorTaxCountryConfigurationUpdateError>;
  /** Updated tax class rates grouped by a country. */
  taxCountryConfiguration: Maybe<SaleorTaxCountryConfiguration>;
};

export type SaleorTaxCountryConfigurationUpdateError = {
  __typename?: 'TaxCountryConfigurationUpdateError';
  /** The error code. */
  code: SaleorTaxCountryConfigurationUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of tax class IDs for which the update failed. */
  taxClassIds: Array<Scalars['String']['output']>;
};

export type SaleorTaxCountryConfigurationUpdateErrorCode =
  | 'CANNOT_CREATE_NEGATIVE_RATE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'ONLY_ONE_DEFAULT_COUNTRY_RATE_ALLOWED';

/**
 * Exempt checkout or order from charging the taxes. When tax exemption is enabled, taxes won't be charged for the checkout or order. Taxes may still be calculated in cases when product prices are entered with the tax included and the net price needs to be known.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxExemptionManage = {
  __typename?: 'TaxExemptionManage';
  errors: Array<SaleorTaxExemptionManageError>;
  taxableObject: Maybe<SaleorTaxSourceObject>;
};

export type SaleorTaxExemptionManageError = {
  __typename?: 'TaxExemptionManageError';
  /** The error code. */
  code: SaleorTaxExemptionManageErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxExemptionManageErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_EDITABLE_ORDER'
  | 'NOT_FOUND';

export type SaleorTaxSourceLine = SaleorCheckoutLine | SaleorOrderLine;

export type SaleorTaxSourceObject = SaleorCheckout | SaleorOrder;

/** Representation of tax types fetched from tax gateway. */
export type SaleorTaxType = {
  __typename?: 'TaxType';
  /** Description of the tax type. */
  description: Maybe<Scalars['String']['output']>;
  /** External tax code used to identify given tax group. */
  taxCode: Maybe<Scalars['String']['output']>;
};

/** Taxable object. */
export type SaleorTaxableObject = {
  __typename?: 'TaxableObject';
  /** The address data. */
  address: Maybe<SaleorAddress>;
  channel: SaleorChannel;
  /** The currency of the object. */
  currency: Scalars['String']['output'];
  /** List of discounts. */
  discounts: Array<SaleorTaxableObjectDiscount>;
  /** List of lines assigned to the object. */
  lines: Array<SaleorTaxableObjectLine>;
  /** Determines if prices contain entered tax.. */
  pricesEnteredWithTax: Scalars['Boolean']['output'];
  /** The price of shipping method, includes shipping voucher discount if applied. */
  shippingPrice: SaleorMoney;
  /** The source object related to this tax object. */
  sourceObject: SaleorTaxSourceObject;
};

/** Taxable object discount. */
export type SaleorTaxableObjectDiscount = {
  __typename?: 'TaxableObjectDiscount';
  /** The amount of the discount. */
  amount: SaleorMoney;
  /** The name of the discount. */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates which part of the order the discount should affect: SUBTOTAL or SHIPPING. */
  type: SaleorTaxableObjectDiscountTypeEnum;
};

/** Indicates which part of the order the discount should affect: SUBTOTAL or SHIPPING. */
export type SaleorTaxableObjectDiscountTypeEnum =
  | 'SHIPPING'
  | 'SUBTOTAL';

export type SaleorTaxableObjectLine = {
  __typename?: 'TaxableObjectLine';
  /** Determines if taxes are being charged for the product. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** The product name. */
  productName: Scalars['String']['output'];
  /** The product sku. */
  productSku: Maybe<Scalars['String']['output']>;
  /** Number of items. */
  quantity: Scalars['Int']['output'];
  /** The source line related to this tax line. */
  sourceLine: SaleorTaxSourceLine;
  /** Price of the order line. The price includes catalogue promotions, specific product and applied once per order voucher discounts. The price does not include the entire order discount. */
  totalPrice: SaleorMoney;
  /** Price of the single item in the order line. The price includes catalogue promotions, specific product and applied once per order voucher discounts. The price does not include the entire order discount. */
  unitPrice: SaleorMoney;
  /** The variant name. */
  variantName: Scalars['String']['output'];
};

/** Represents a monetary value with taxes. In cases where taxes were not applied, net and gross values will be equal. */
export type SaleorTaxedMoney = {
  __typename?: 'TaxedMoney';
  /** Currency code. */
  currency: Scalars['String']['output'];
  /** Amount of money including taxes. */
  gross: SaleorMoney;
  /** Amount of money without taxes. */
  net: SaleorMoney;
  /** Amount of taxes. */
  tax: SaleorMoney;
};

export type SaleorTaxedMoneyInput = {
  /** Gross value of an item. */
  gross: Scalars['PositiveDecimal']['input'];
  /** Net value of an item. */
  net: Scalars['PositiveDecimal']['input'];
};

/** Represents a range of monetary values. */
export type SaleorTaxedMoneyRange = {
  __typename?: 'TaxedMoneyRange';
  /** Lower bound of a price range. */
  start: Maybe<SaleorTaxedMoney>;
  /** Upper bound of a price range. */
  stop: Maybe<SaleorTaxedMoney>;
};

/** Event sent when thumbnail is created. */
export type SaleorThumbnailCreated = SaleorEvent & {
  __typename?: 'ThumbnailCreated';
  /** Thumbnail id. */
  id: Maybe<Scalars['ID']['output']>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** Original media url. */
  mediaUrl: Maybe<Scalars['String']['output']>;
  /** Object the thumbnail refers to. */
  objectId: Maybe<Scalars['ID']['output']>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Thumbnail url. */
  url: Maybe<Scalars['String']['output']>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorThumbnailFormatEnum =
  | 'AVIF'
  | 'ORIGINAL'
  | 'WEBP';

export type SaleorTimePeriod = {
  __typename?: 'TimePeriod';
  /** The length of the period. */
  amount: Scalars['Int']['output'];
  /** The type of the period. */
  type: SaleorTimePeriodTypeEnum;
};

export type SaleorTimePeriodInputType = {
  /** The length of the period. */
  amount: Scalars['Int']['input'];
  /** The type of the period. */
  type: SaleorTimePeriodTypeEnum;
};

export type SaleorTimePeriodTypeEnum =
  | 'DAY'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

/**
 * Represents possible tokenized payment flows that can be used to process payment.
 *
 *     The following flows are possible:
 *     INTERACTIVE - Payment method can be used for 1 click checkout - it's prefilled in
 *     checkout form (might require additional authentication from user)
 *
 */
export type SaleorTokenizedPaymentFlowEnum =
  | 'INTERACTIVE';

/**
 * An object representing a single payment.
 *
 * The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
 */
export type SaleorTransaction = SaleorNode & {
  __typename?: 'Transaction';
  /** Total amount of the transaction. */
  amount: Maybe<SaleorMoney>;
  /** Date and time at which transaction was created. */
  created: Scalars['DateTime']['output'];
  /** Error associated with transaction, if any. */
  error: Maybe<Scalars['String']['output']>;
  /**
   * Response returned by payment gateway.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  gatewayResponse: Scalars['JSONString']['output'];
  /** ID of the transaction. */
  id: Scalars['ID']['output'];
  /** Determines if the transaction was successful. */
  isSuccess: Scalars['Boolean']['output'];
  /** Determines the type of transaction. */
  kind: SaleorTransactionKind;
  /** Determines the payment associated with a transaction. */
  payment: SaleorPayment;
  /** Unique token associated with a transaction. */
  token: Scalars['String']['output'];
};

export type SaleorTransactionAction = {
  __typename?: 'TransactionAction';
  /** Determines the action type. */
  actionType: SaleorTransactionActionEnum;
  /** Transaction request amount. */
  amount: Scalars['PositiveDecimal']['output'];
  /** Currency code. */
  currency: Scalars['String']['output'];
};

/**
 * Represents possible actions on payment transaction.
 *
 *     The following actions are possible:
 *     CHARGE - Represents the charge action.
 *     REFUND - Represents a refund action.
 *     CANCEL - Represents a cancel action. Added in Saleor 3.12.
 *
 */
export type SaleorTransactionActionEnum =
  | 'CANCEL'
  | 'CHARGE'
  | 'REFUND';

/** Event sent when transaction cancelation is requested. */
export type SaleorTransactionCancelationRequested = SaleorEvent & {
  __typename?: 'TransactionCancelationRequested';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when transaction charge is requested. */
export type SaleorTransactionChargeRequested = SaleorEvent & {
  __typename?: 'TransactionChargeRequested';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionCountableConnection = {
  __typename?: 'TransactionCountableConnection';
  edges: Array<SaleorTransactionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorTransactionCountableEdge = {
  __typename?: 'TransactionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTransactionItem;
};

/**
 * Creates transaction for checkout or order.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type SaleorTransactionCreate = {
  __typename?: 'TransactionCreate';
  errors: Array<SaleorTransactionCreateError>;
  transaction: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionCreateError = {
  __typename?: 'TransactionCreateError';
  /** The error code. */
  code: SaleorTransactionCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INVALID'
  | 'METADATA_KEY_REQUIRED'
  | 'NOT_FOUND'
  | 'UNIQUE';

export type SaleorTransactionCreateInput = {
  /** Amount authorized by this transaction. */
  amountAuthorized?: InputMaybe<SaleorMoneyInput>;
  /** Amount canceled by this transaction. */
  amountCanceled?: InputMaybe<SaleorMoneyInput>;
  /** Amount charged by this transaction. */
  amountCharged?: InputMaybe<SaleorMoneyInput>;
  /** Amount refunded by this transaction. */
  amountRefunded?: InputMaybe<SaleorMoneyInput>;
  /** List of all possible actions for the transaction */
  availableActions?: InputMaybe<Array<SaleorTransactionActionEnum>>;
  /** The url that will allow to redirect user to payment provider page with transaction event details. */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The message of the transaction. */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Payment name of the transaction. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Details of the payment method used for the transaction.
   *
   * Added in Saleor 3.22.
   */
  paymentMethodDetails?: InputMaybe<SaleorPaymentMethodDetailsInput>;
  /**
   * Payment private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** PSP Reference of the transaction. */
  pspReference?: InputMaybe<Scalars['String']['input']>;
};

/** Represents transaction's event. */
export type SaleorTransactionEvent = SaleorNode & {
  __typename?: 'TransactionEvent';
  /** The amount related to this event. */
  amount: SaleorMoney;
  /** Date and time at which a transaction event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User or App that created the transaction event. */
  createdBy: Maybe<SaleorUserOrApp>;
  /** The url that will allow to redirect user to payment provider page with transaction details. */
  externalUrl: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Idempotency key assigned to the event. */
  idempotencyKey: Maybe<Scalars['String']['output']>;
  /** Message related to the transaction's event. */
  message: Scalars['String']['output'];
  /** PSP reference of transaction. */
  pspReference: Scalars['String']['output'];
  /**
   * Reason model of the transaction refund.
   *
   * Added in Saleor 3.22.
   */
  reasonReference: Maybe<SaleorPage>;
  /** The type of action related to this event. */
  type: Maybe<SaleorTransactionEventTypeEnum>;
};

export type SaleorTransactionEventInput = {
  /** The message related to the event. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** PSP Reference related to this action. */
  pspReference?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Report the event for the transaction.
 *
 * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
 *
 * Triggers the following webhook events:
 * - TRANSACTION_ITEM_METADATA_UPDATED (async): Optionally called when transaction's metadata was updated.
 * - CHECKOUT_FULLY_PAID (async): Optionally called when the checkout charge status changed to `FULL` or `OVERCHARGED`.
 * - ORDER_UPDATED (async): Optionally called when the transaction is related to the order and the order was updated.
 */
export type SaleorTransactionEventReport = {
  __typename?: 'TransactionEventReport';
  /** Defines if the reported event hasn't been processed earlier. */
  alreadyProcessed: Maybe<Scalars['Boolean']['output']>;
  errors: Array<SaleorTransactionEventReportError>;
  /** The transaction related to the reported event. */
  transaction: Maybe<SaleorTransactionItem>;
  /** The event assigned to this report. if `alreadyProcessed` is set to `true`, the previously processed event will be returned. */
  transactionEvent: Maybe<SaleorTransactionEvent>;
};

export type SaleorTransactionEventReportError = {
  __typename?: 'TransactionEventReportError';
  /** The error code. */
  code: SaleorTransactionEventReportErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionEventReportErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_DETAILS'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/**
 * Represents possible event types.
 *
 *     Added in Saleor 3.12.
 *
 *     The following types are possible:
 *     AUTHORIZATION_SUCCESS - represents success authorization.
 *     AUTHORIZATION_FAILURE - represents failure authorization.
 *     AUTHORIZATION_ADJUSTMENT - represents authorization adjustment.
 *     AUTHORIZATION_REQUEST - represents authorization request.
 *     AUTHORIZATION_ACTION_REQUIRED - represents authorization that needs
 *     additional actions from the customer.
 *     CHARGE_ACTION_REQUIRED - represents charge that needs
 *     additional actions from the customer.
 *     CHARGE_SUCCESS - represents success charge.
 *     CHARGE_FAILURE - represents failure charge.
 *     CHARGE_BACK - represents chargeback.
 *     CHARGE_REQUEST - represents charge request.
 *     REFUND_SUCCESS - represents success refund.
 *     REFUND_FAILURE - represents failure refund.
 *     REFUND_REVERSE - represents reverse refund.
 *     REFUND_REQUEST - represents refund request.
 *     CANCEL_SUCCESS - represents success cancel.
 *     CANCEL_FAILURE - represents failure cancel.
 *     CANCEL_REQUEST - represents cancel request.
 *     INFO - represents info event.
 *
 */
export type SaleorTransactionEventTypeEnum =
  | 'AUTHORIZATION_ACTION_REQUIRED'
  | 'AUTHORIZATION_ADJUSTMENT'
  | 'AUTHORIZATION_FAILURE'
  | 'AUTHORIZATION_REQUEST'
  | 'AUTHORIZATION_SUCCESS'
  | 'CANCEL_FAILURE'
  | 'CANCEL_REQUEST'
  | 'CANCEL_SUCCESS'
  | 'CHARGE_ACTION_REQUIRED'
  | 'CHARGE_BACK'
  | 'CHARGE_FAILURE'
  | 'CHARGE_REQUEST'
  | 'CHARGE_SUCCESS'
  | 'INFO'
  | 'REFUND_FAILURE'
  | 'REFUND_REQUEST'
  | 'REFUND_REVERSE'
  | 'REFUND_SUCCESS';

/** Filter input for transactions. */
export type SaleorTransactionFilterInput = {
  /** Filter by metadata fields of transactions. */
  metadata?: InputMaybe<SaleorMetadataFilterInput>;
  /** Filter by payment method details used to pay for the order. */
  paymentMethodDetails?: InputMaybe<SaleorPaymentMethodDetailsFilterInput>;
  /**
   * Filter by PSP reference of transactions.
   *
   * Added in Saleor 3.22.
   */
  pspReference?: InputMaybe<SaleorStringFilterInput>;
};

/**
 * Determine the transaction flow strategy.
 *
 *     AUTHORIZATION - the processed transaction should be only authorized
 *     CHARGE - the processed transaction should be charged.
 *
 */
export type SaleorTransactionFlowStrategyEnum =
  | 'AUTHORIZATION'
  | 'CHARGE';

/** Initializes a transaction session. It triggers the webhook `TRANSACTION_INITIALIZE_SESSION`, to the requested `paymentGateways`. There is a limit of 100 transaction items per checkout / order. */
export type SaleorTransactionInitialize = {
  __typename?: 'TransactionInitialize';
  /** The JSON data required to finalize the payment. */
  data: Maybe<Scalars['JSON']['output']>;
  errors: Array<SaleorTransactionInitializeError>;
  /** The initialized transaction. */
  transaction: Maybe<SaleorTransactionItem>;
  /** The event created for the initialized transaction. */
  transactionEvent: Maybe<SaleorTransactionEvent>;
};

export type SaleorTransactionInitializeError = {
  __typename?: 'TransactionInitializeError';
  /** The error code. */
  code: SaleorTransactionInitializeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionInitializeErrorCode =
  | 'CHECKOUT_COMPLETION_IN_PROGRESS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'UNIQUE';

/** Event sent when user starts processing the payment. */
export type SaleorTransactionInitializeSession = SaleorEvent & {
  __typename?: 'TransactionInitializeSession';
  /** Action to proceed for the transaction */
  action: SaleorTransactionProcessAction;
  /** The customer's IP address. If not provided as a parameter in the mutation, Saleor will try to determine the customer's IP address on its own. */
  customerIpAddress: Maybe<Scalars['String']['output']>;
  /** Payment gateway data in JSON format, received from storefront. */
  data: Maybe<Scalars['JSON']['output']>;
  /** Idempotency key assigned to the transaction initialize. */
  idempotencyKey: Scalars['String']['output'];
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** Merchant reference assigned to this payment. */
  merchantReference: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Checkout or order */
  sourceObject: SaleorOrderOrCheckout;
  /** Look up a transaction. */
  transaction: SaleorTransactionItem;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Represents a payment transaction. */
export type SaleorTransactionItem = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'TransactionItem';
  /** List of actions that can be performed in the current state of a payment. */
  actions: Array<SaleorTransactionActionEnum>;
  /** Total amount of ongoing authorization requests for the transaction. */
  authorizePendingAmount: SaleorMoney;
  /** Total amount authorized for this payment. */
  authorizedAmount: SaleorMoney;
  /** Total amount of ongoing cancel requests for the transaction. */
  cancelPendingAmount: SaleorMoney;
  /** Total amount canceled for this payment. */
  canceledAmount: SaleorMoney;
  /** Total amount of ongoing charge requests for the transaction. */
  chargePendingAmount: SaleorMoney;
  /** Total amount charged for this payment. */
  chargedAmount: SaleorMoney;
  /** The related checkout. */
  checkout: Maybe<SaleorCheckout>;
  /** Date and time at which payment transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User or App that created the transaction. */
  createdBy: Maybe<SaleorUserOrApp>;
  /** List of all transaction's events. */
  events: Array<SaleorTransactionEvent>;
  /** The url that will allow to redirect user to payment provider page with transaction details. */
  externalUrl: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Message related to the transaction. */
  message: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Date and time at which payment transaction was modified. */
  modifiedAt: Scalars['DateTime']['output'];
  /** Name of the transaction. */
  name: Scalars['String']['output'];
  /** The related order. */
  order: Maybe<SaleorOrder>;
  /**
   * The payment method used for this transaction.
   *
   * Added in Saleor 3.22.
   */
  paymentMethodDetails: Maybe<SaleorPaymentMethodDetails>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** PSP reference of transaction. */
  pspReference: Scalars['String']['output'];
  /**
   * Reason of the refund.
   *
   * Added in Saleor 3.22.
   */
  reason: Maybe<Scalars['String']['output']>;
  /**
   * Reason `Page` (Model) for refund.
   *
   * Added in Saleor 3.22.
   */
  reasonReference: Maybe<SaleorPage>;
  /** Total amount of ongoing refund requests for the transaction. */
  refundPendingAmount: SaleorMoney;
  /** Total amount refunded for this payment. */
  refundedAmount: SaleorMoney;
  /** The transaction token. */
  token: Scalars['UUID']['output'];
};


/** Represents a payment transaction. */
export type SaleorTransactionItemMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment transaction. */
export type SaleorTransactionItemMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a payment transaction. */
export type SaleorTransactionItemPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment transaction. */
export type SaleorTransactionItemPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Event sent when transaction item metadata is updated. */
export type SaleorTransactionItemMetadataUpdated = SaleorEvent & {
  __typename?: 'TransactionItemMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionKind =
  | 'ACTION_TO_CONFIRM'
  | 'AUTH'
  | 'CANCEL'
  | 'CAPTURE'
  | 'CONFIRM'
  | 'EXTERNAL'
  | 'PENDING'
  | 'REFUND'
  | 'REFUND_ONGOING'
  | 'VOID';

/** Processes a transaction session. It triggers the webhook `TRANSACTION_PROCESS_SESSION`, to the assigned `paymentGateways`.  */
export type SaleorTransactionProcess = {
  __typename?: 'TransactionProcess';
  /** The json data required to finalize the payment. */
  data: Maybe<Scalars['JSON']['output']>;
  errors: Array<SaleorTransactionProcessError>;
  /** The processed transaction. */
  transaction: Maybe<SaleorTransactionItem>;
  /** The event created for the processed transaction. */
  transactionEvent: Maybe<SaleorTransactionEvent>;
};

export type SaleorTransactionProcessAction = {
  __typename?: 'TransactionProcessAction';
  actionType: SaleorTransactionFlowStrategyEnum;
  /** Transaction amount to process. */
  amount: Scalars['PositiveDecimal']['output'];
  /** Currency of the amount. */
  currency: Scalars['String']['output'];
};

export type SaleorTransactionProcessError = {
  __typename?: 'TransactionProcessError';
  /** The error code. */
  code: SaleorTransactionProcessErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionProcessErrorCode =
  | 'CHECKOUT_COMPLETION_IN_PROGRESS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_PAYMENT_APP'
  | 'MISSING_PAYMENT_APP_RELATION'
  | 'NOT_FOUND'
  | 'TRANSACTION_ALREADY_PROCESSED';

/** Event sent when user has additional payment action to process. */
export type SaleorTransactionProcessSession = SaleorEvent & {
  __typename?: 'TransactionProcessSession';
  /** Action to proceed for the transaction */
  action: SaleorTransactionProcessAction;
  /** The customer's IP address. If not provided as a parameter in the mutation, Saleor will try to determine the customer's IP address on its own. */
  customerIpAddress: Maybe<Scalars['String']['output']>;
  /** Payment gateway data in JSON format, received from storefront. */
  data: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** Merchant reference assigned to this payment. */
  merchantReference: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Checkout or order */
  sourceObject: SaleorOrderOrCheckout;
  /** Look up a transaction. */
  transaction: SaleorTransactionItem;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Event sent when transaction refund is requested. */
export type SaleorTransactionRefundRequested = SaleorEvent & {
  __typename?: 'TransactionRefundRequested';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /**
   * Granted refund related to refund request.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  grantedRefund: Maybe<SaleorOrderGrantedRefund>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Request an action for payment transaction.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type SaleorTransactionRequestAction = {
  __typename?: 'TransactionRequestAction';
  errors: Array<SaleorTransactionRequestActionError>;
  transaction: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionRequestActionError = {
  __typename?: 'TransactionRequestActionError';
  /** The error code. */
  code: SaleorTransactionRequestActionErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionRequestActionErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_TRANSACTION_ACTION_REQUEST_WEBHOOK'
  | 'NOT_FOUND'
  | 'REQUIRED';

/**
 * Request a refund for payment transaction based on granted refund.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type SaleorTransactionRequestRefundForGrantedRefund = {
  __typename?: 'TransactionRequestRefundForGrantedRefund';
  errors: Array<SaleorTransactionRequestRefundForGrantedRefundError>;
  transaction: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionRequestRefundForGrantedRefundError = {
  __typename?: 'TransactionRequestRefundForGrantedRefundError';
  /** The error code. */
  code: SaleorTransactionRequestRefundForGrantedRefundErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionRequestRefundForGrantedRefundErrorCode =
  | 'AMOUNT_GREATER_THAN_AVAILABLE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_TRANSACTION_ACTION_REQUEST_WEBHOOK'
  | 'NOT_FOUND'
  | 'REFUND_ALREADY_PROCESSED'
  | 'REFUND_IS_PENDING';

/**
 * Update transaction.
 *
 * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
 */
export type SaleorTransactionUpdate = {
  __typename?: 'TransactionUpdate';
  errors: Array<SaleorTransactionUpdateError>;
  transaction: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionUpdateError = {
  __typename?: 'TransactionUpdateError';
  /** The error code. */
  code: SaleorTransactionUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTransactionUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INVALID'
  | 'METADATA_KEY_REQUIRED'
  | 'NOT_FOUND'
  | 'UNIQUE';

export type SaleorTransactionUpdateInput = {
  /** Amount authorized by this transaction. */
  amountAuthorized?: InputMaybe<SaleorMoneyInput>;
  /** Amount canceled by this transaction. */
  amountCanceled?: InputMaybe<SaleorMoneyInput>;
  /** Amount charged by this transaction. */
  amountCharged?: InputMaybe<SaleorMoneyInput>;
  /** Amount refunded by this transaction. */
  amountRefunded?: InputMaybe<SaleorMoneyInput>;
  /** List of all possible actions for the transaction */
  availableActions?: InputMaybe<Array<SaleorTransactionActionEnum>>;
  /** The url that will allow to redirect user to payment provider page with transaction event details. */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The message of the transaction. */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Payment name of the transaction. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Details of the payment method used for the transaction.
   *
   * Added in Saleor 3.22.
   */
  paymentMethodDetails?: InputMaybe<SaleorPaymentMethodDetailsInput>;
  /**
   * Payment private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** PSP Reference of the transaction. */
  pspReference?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorTransactionWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorTransactionWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorTransactionWhereInput>>;
  /** Filter by app identifier. */
  appIdentifier?: InputMaybe<SaleorStringFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by PSP reference. */
  pspReference?: InputMaybe<SaleorStringFilterInput>;
};

export type SaleorTranslatableItem = SaleorAttributeTranslatableContent | SaleorAttributeValueTranslatableContent | SaleorCategoryTranslatableContent | SaleorCollectionTranslatableContent | SaleorMenuItemTranslatableContent | SaleorPageTranslatableContent | SaleorProductTranslatableContent | SaleorProductVariantTranslatableContent | SaleorPromotionRuleTranslatableContent | SaleorPromotionTranslatableContent | SaleorSaleTranslatableContent | SaleorShippingMethodTranslatableContent | SaleorVoucherTranslatableContent;

export type SaleorTranslatableItemConnection = {
  __typename?: 'TranslatableItemConnection';
  edges: Array<SaleorTranslatableItemEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorTranslatableItemEdge = {
  __typename?: 'TranslatableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTranslatableItem;
};

export type SaleorTranslatableKinds =
  | 'ATTRIBUTE'
  | 'ATTRIBUTE_VALUE'
  | 'CATEGORY'
  | 'COLLECTION'
  | 'MENU_ITEM'
  | 'PAGE'
  | 'PRODUCT'
  | 'PROMOTION'
  | 'PROMOTION_RULE'
  | 'SALE'
  | 'SHIPPING_METHOD'
  | 'VARIANT'
  | 'VOUCHER';

/** Event sent when new translation is created. */
export type SaleorTranslationCreated = SaleorEvent & {
  __typename?: 'TranslationCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The translation the event relates to. */
  translation: Maybe<SaleorTranslationTypes>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

export type SaleorTranslationError = {
  __typename?: 'TranslationError';
  /** The error code. */
  code: SaleorTranslationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorTranslationErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorTranslationInput = {
  /**
   * Translated description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorTranslationTypes = SaleorAttributeTranslation | SaleorAttributeValueTranslation | SaleorCategoryTranslation | SaleorCollectionTranslation | SaleorMenuItemTranslation | SaleorPageTranslation | SaleorProductTranslation | SaleorProductVariantTranslation | SaleorPromotionRuleTranslation | SaleorPromotionTranslation | SaleorSaleTranslation | SaleorShippingMethodTranslation | SaleorVoucherTranslation;

/** Event sent when translation is updated. */
export type SaleorTranslationUpdated = SaleorEvent & {
  __typename?: 'TranslationUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** The translation the event relates to. */
  translation: Maybe<SaleorTranslationTypes>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/** Define the filtering options for string fields. */
export type SaleorUuidFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type SaleorUpdateInvoiceInput = {
  /**
   * Fields required to update the invoice metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Invoice number */
  number?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the invoice private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of an invoice to download. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates metadata of an object.Requires permissions to modify and to read the metadata of the object it's attached to.
 *
 * Warning: never store sensitive information, including financial data such as credit card details.
 */
export type SaleorUpdateMetadata = {
  __typename?: 'UpdateMetadata';
  errors: Array<SaleorMetadataError>;
  item: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

/**
 * Updates private metadata of an object. Requires permissions to modify and to read the metadata of the object it's attached to.
 *
 * Warning: never store sensitive information, including financial data such as credit card details.
 */
export type SaleorUpdatePrivateMetadata = {
  __typename?: 'UpdatePrivateMetadata';
  errors: Array<SaleorMetadataError>;
  item: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

export type SaleorUploadError = {
  __typename?: 'UploadError';
  /** The error code. */
  code: SaleorUploadErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorUploadErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_FILE_TYPE'
  | 'UNSUPPORTED_MIME_TYPE';

/** Represents user data. */
export type SaleorUser = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'User';
  /** List of channels the user has access to. The sum of channels from all user groups. If at least one group has `restrictedAccessToChannels` set to False - all channels are returned. */
  accessibleChannels: Maybe<Array<SaleorChannel>>;
  /** List of all user's addresses. */
  addresses: Array<SaleorAddress>;
  /** The avatar of the user. */
  avatar: Maybe<SaleorImage>;
  /**
   * Returns the last open checkout of this user.
   * @deprecated Use the `checkoutTokens` field to fetch the user checkouts.
   */
  checkout: Maybe<SaleorCheckout>;
  /** Returns the checkout ID's assigned to this user. */
  checkoutIds: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Returns the checkout UUID's assigned to this user.
   * @deprecated Use `checkoutIds` instead.
   */
  checkoutTokens: Maybe<Array<Scalars['UUID']['output']>>;
  /** Returns checkouts assigned to this user. The query will not initiate any external requests, including fetching external shipping methods, filtering available shipping methods, or performing external tax calculations. */
  checkouts: Maybe<SaleorCheckoutCountableConnection>;
  /** The data when the user create account. */
  dateJoined: Scalars['DateTime']['output'];
  /** The default billing address of the user. */
  defaultBillingAddress: Maybe<SaleorAddress>;
  /** The default shipping address of the user. */
  defaultShippingAddress: Maybe<SaleorAddress>;
  /** List of user's permission groups which user can manage. */
  editableGroups: Maybe<Array<SaleorGroup>>;
  /** The email address of the user. */
  email: Scalars['String']['output'];
  /**
   * List of events associated with the user.
   *
   * Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF.
   */
  events: Maybe<Array<SaleorCustomerEvent>>;
  /** External ID of this user. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** The given name of the address. */
  firstName: Scalars['String']['output'];
  /** List of the user gift cards. */
  giftCards: Maybe<SaleorGiftCardCountableConnection>;
  /** The ID of the user. */
  id: Scalars['ID']['output'];
  /** Determine if the user is active. */
  isActive: Scalars['Boolean']['output'];
  /** Determines if user has confirmed email. */
  isConfirmed: Scalars['Boolean']['output'];
  /** Determine if the user is a staff admin. */
  isStaff: Scalars['Boolean']['output'];
  /** User language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** The date when the user last time log in to the system. */
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  /** The family name of the address. */
  lastName: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * A note about the customer.
   *
   * Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF.
   */
  note: Maybe<Scalars['String']['output']>;
  /** List of user's orders. The query will not initiate any external requests, including filtering available shipping methods, or performing external tax calculations. Requires one of the following permissions: MANAGE_STAFF, OWNER. */
  orders: Maybe<SaleorOrderCountableConnection>;
  /** List of user's permission groups. */
  permissionGroups: Maybe<Array<SaleorGroup>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Determine if user have restricted access to channels. False if at least one user group has `restrictedAccessToChannels` set to False. */
  restrictedAccessToChannels: Scalars['Boolean']['output'];
  /** Returns a list of user's stored payment methods that can be used in provided channel. The field returns a list of stored payment methods by payment apps. When `amount` is not provided, 0 will be used as default value. */
  storedPaymentMethods: Maybe<Array<SaleorStoredPaymentMethod>>;
  /**
   * List of stored payment sources. The field returns a list of payment sources stored for payment plugins.
   * @deprecated The legacy Payments API is deprecated and will be removed. Use the Transactions API instead.
   */
  storedPaymentSources: Maybe<Array<SaleorPaymentSource>>;
  /** The data when the user last update the account information. */
  updatedAt: Scalars['DateTime']['output'];
  /** List of user's permissions. */
  userPermissions: Maybe<Array<SaleorUserPermission>>;
};


/** Represents user data. */
export type SaleorUserAvatarArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUserCheckoutIdsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Represents user data. */
export type SaleorUserCheckoutTokensArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Represents user data. */
export type SaleorUserCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUserGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUserMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user data. */
export type SaleorUserMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user data. */
export type SaleorUserOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleorCustomerOrderWhereInput>;
};


/** Represents user data. */
export type SaleorUserPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user data. */
export type SaleorUserPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user data. */
export type SaleorUserStoredPaymentMethodsArgs = {
  channel: Scalars['String']['input'];
};


/** Represents user data. */
export type SaleorUserStoredPaymentSourcesArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a user avatar. Only for staff members.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorUserAvatarDelete = {
  __typename?: 'UserAvatarDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user: Maybe<SaleorUser>;
};

/**
 * Create a user avatar. Only for staff members. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorUserAvatarUpdate = {
  __typename?: 'UserAvatarUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user: Maybe<SaleorUser>;
};

/**
 * Activate or deactivate users.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorUserBulkSetActive = {
  __typename?: 'UserBulkSetActive';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAccountError>;
};

export type SaleorUserCountableConnection = {
  __typename?: 'UserCountableConnection';
  edges: Array<SaleorUserCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorUserCountableEdge = {
  __typename?: 'UserCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorUser;
};

export type SaleorUserCreateInput = {
  /** Slug of a channel which will be used for notify user. Optional when only one channel exists. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<SaleorAddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<SaleorAddressInput>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the customer. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * User account is confirmed.
   *
   * DEPRECATED: this field will be removed.
   *
   * The user will be always set as unconfirmed. The confirmation will take place when the user sets the password.
   */
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a view where users should be redirected to set the password. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorUserOrApp = SaleorApp | SaleorUser;

/** Represents user's permissions. */
export type SaleorUserPermission = {
  __typename?: 'UserPermission';
  /** Internal code for permission. */
  code: SaleorPermissionEnum;
  /** Describe action(s) allowed to do by permission. */
  name: Scalars['String']['output'];
  /** List of user permission groups which contains this permission. */
  sourcePermissionGroups: Maybe<Array<SaleorGroup>>;
};


/** Represents user's permissions. */
export type SaleorUserPermissionSourcePermissionGroupsArgs = {
  userId: Scalars['ID']['input'];
};

export type SaleorUserSortField =
  /** Sort users by created at. */
  | 'CREATED_AT'
  /** Sort users by email. */
  | 'EMAIL'
  /** Sort users by first name. */
  | 'FIRST_NAME'
  /** Sort users by last modified at. */
  | 'LAST_MODIFIED_AT'
  /** Sort users by last name. */
  | 'LAST_NAME'
  /** Sort users by order count. */
  | 'ORDER_COUNT';

export type SaleorUserSortingInput = {
  /** Specifies the direction in which to sort users. */
  direction: SaleorOrderDirection;
  /** Sort users by the selected field. */
  field: SaleorUserSortField;
};

/** Represents a VAT rate for a country. */
export type SaleorVat = {
  __typename?: 'VAT';
  /** Country code. */
  countryCode: Scalars['String']['output'];
  /** Country's VAT rate exceptions for specific types of goods. */
  reducedRates: Array<SaleorReducedRate>;
  /** Standard VAT rate in percent. */
  standardRate: Maybe<Scalars['Float']['output']>;
};

export type SaleorVariantAttributeScope =
  | 'ALL'
  | 'NOT_VARIANT_SELECTION'
  | 'VARIANT_SELECTION';

/**
 * Assign an media to a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorVariantMediaAssign = {
  __typename?: 'VariantMediaAssign';
  errors: Array<SaleorProductError>;
  media: Maybe<SaleorProductMedia>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant: Maybe<SaleorProductVariant>;
};

/**
 * Unassign an media from a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorVariantMediaUnassign = {
  __typename?: 'VariantMediaUnassign';
  errors: Array<SaleorProductError>;
  media: Maybe<SaleorProductMedia>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant: Maybe<SaleorProductVariant>;
};

/** Represents availability of a variant in the storefront. */
export type SaleorVariantPricingInfo = {
  __typename?: 'VariantPricingInfo';
  /** The discount amount if in sale (null otherwise). */
  discount: Maybe<SaleorTaxedMoney>;
  /**
   * The discount amount in the local currency.
   * @deprecated Always returns `null`.
   */
  discountLocalCurrency: Maybe<SaleorTaxedMoney>;
  /**
   * The discount amount compared to prior price. Null if product is not on sale or prior price was not provided in VariantChannelListing
   *
   * Added in Saleor 3.21.
   */
  discountPrior: Maybe<SaleorTaxedMoney>;
  /** Whether it is in sale or not. */
  onSale: Maybe<Scalars['Boolean']['output']>;
  /** The price, with any discount subtracted. */
  price: Maybe<SaleorTaxedMoney>;
  /**
   * The discounted price in the local currency.
   * @deprecated Always returns `null`.
   */
  priceLocalCurrency: Maybe<SaleorTaxedMoney>;
  /**
   * The price prior to discount.
   *
   * Added in Saleor 3.21.
   */
  pricePrior: Maybe<SaleorTaxedMoney>;
  /** The price without any discount. */
  priceUndiscounted: Maybe<SaleorTaxedMoney>;
};

/** Verify JWT token. */
export type SaleorVerifyToken = {
  __typename?: 'VerifyToken';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** Determine if token is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** JWT payload. */
  payload: Maybe<Scalars['GenericScalar']['output']>;
  /** User assigned to token. */
  user: Maybe<SaleorUser>;
};

export type SaleorVolumeUnitsEnum =
  | 'ACRE_FT'
  | 'ACRE_IN'
  | 'CUBIC_CENTIMETER'
  | 'CUBIC_DECIMETER'
  | 'CUBIC_FOOT'
  | 'CUBIC_INCH'
  | 'CUBIC_METER'
  | 'CUBIC_MILLIMETER'
  | 'CUBIC_YARD'
  | 'FL_OZ'
  | 'LITER'
  | 'PINT'
  | 'QT';

/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucher = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Voucher';
  /** Determine if the voucher usage should be limited to one use per customer. */
  applyOncePerCustomer: Scalars['Boolean']['output'];
  /** Determine if the voucher should be applied once per order. If set to True, the voucher is applied to a single cheapest eligible product in checkout. */
  applyOncePerOrder: Scalars['Boolean']['output'];
  /** List of categories this voucher applies to. */
  categories: Maybe<SaleorCategoryCountableConnection>;
  /**
   * List of availability in channels for the voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  channelListings: Maybe<Array<SaleorVoucherChannelListing>>;
  /**
   * The code of the voucher.
   *
   * DEPRECATED: this field will be removed.
   */
  code: Maybe<Scalars['String']['output']>;
  /**
   * List of codes available for this voucher.
   *
   * Added in Saleor 3.18.
   */
  codes: Maybe<SaleorVoucherCodeCountableConnection>;
  /**
   * List of collections this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  collections: Maybe<SaleorCollectionCountableConnection>;
  /** List of countries available for the shipping voucher. */
  countries: Maybe<Array<SaleorCountryDisplay>>;
  /** Currency code for voucher. */
  currency: Maybe<Scalars['String']['output']>;
  /** Voucher value. */
  discountValue: Maybe<Scalars['Float']['output']>;
  /** Determines a type of discount for voucher - value or percentage */
  discountValueType: SaleorDiscountValueTypeEnum;
  /** The end date and time of voucher. */
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the voucher. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Determine minimum quantity of items for checkout. */
  minCheckoutItemsQuantity: Maybe<Scalars['Int']['output']>;
  /** Minimum order value to apply voucher. */
  minSpent: Maybe<SaleorMoney>;
  /** The name of the voucher. */
  name: Maybe<Scalars['String']['output']>;
  /** Determine if the voucher is available only for staff members. */
  onlyForStaff: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /**
   * List of products this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  products: Maybe<SaleorProductCountableConnection>;
  /**
   * Determine if the voucher codes can be used once or multiple times.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  singleUse: Scalars['Boolean']['output'];
  /** The start date and time of voucher. */
  startDate: Scalars['DateTime']['output'];
  /** Returns translated voucher fields for the given language code. */
  translation: Maybe<SaleorVoucherTranslation>;
  /** Determines a type of voucher. */
  type: SaleorVoucherTypeEnum;
  /** The number of times a voucher can be used. */
  usageLimit: Maybe<Scalars['Int']['output']>;
  /** Usage count of the voucher. */
  used: Scalars['Int']['output'];
  /**
   * List of product variants this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  variants: Maybe<SaleorProductVariantCountableConnection>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Adds products, categories, collections to a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 */
export type SaleorVoucherAddCatalogues = {
  __typename?: 'VoucherAddCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Voucher of which catalogue IDs will be modified. */
  voucher: Maybe<SaleorVoucher>;
};

/**
 * Deletes vouchers.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_DELETED (async): A voucher was deleted.
 */
export type SaleorVoucherBulkDelete = {
  __typename?: 'VoucherBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
};

/** Represents voucher channel listing. */
export type SaleorVoucherChannelListing = SaleorNode & {
  __typename?: 'VoucherChannelListing';
  /** The channel in which voucher can be applied. */
  channel: SaleorChannel;
  /** Currency code for voucher in a channel. */
  currency: Scalars['String']['output'];
  /** The value of the discount on voucher in a channel. */
  discountValue: Scalars['Float']['output'];
  /** The ID of channel listing. */
  id: Scalars['ID']['output'];
  /** Minimum order value for voucher to apply in channel. */
  minSpent: Maybe<SaleorMoney>;
};

export type SaleorVoucherChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Value of the voucher. */
  discountValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Min purchase amount required to apply the voucher. */
  minAmountSpent?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

export type SaleorVoucherChannelListingInput = {
  /** List of channels to which the voucher should be assigned. */
  addChannels?: InputMaybe<Array<SaleorVoucherChannelListingAddInput>>;
  /** List of channels from which the voucher should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage voucher's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 */
export type SaleorVoucherChannelListingUpdate = {
  __typename?: 'VoucherChannelListingUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** An updated voucher instance. */
  voucher: Maybe<SaleorVoucher>;
};

/**
 * Represents voucher code.
 *
 * Added in Saleor 3.18.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorVoucherCode = {
  __typename?: 'VoucherCode';
  /** Code to use the voucher. */
  code: Maybe<Scalars['String']['output']>;
  /** Date time of code creation. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the voucher code. */
  id: Scalars['ID']['output'];
  /** Whether a code is active or not. */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** Number of times a code has been used. */
  used: Maybe<Scalars['Int']['output']>;
};

/**
 * Deletes voucher codes.
 *
 * Added in Saleor 3.18.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_CODES_DELETED (async): A voucher codes were deleted.
 */
export type SaleorVoucherCodeBulkDelete = {
  __typename?: 'VoucherCodeBulkDelete';
  /** Returns how many codes were deleted. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorVoucherCodeBulkDeleteError>;
};

export type SaleorVoucherCodeBulkDeleteError = {
  __typename?: 'VoucherCodeBulkDeleteError';
  /** The error code. */
  code: SaleorVoucherCodeBulkDeleteErrorCode;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path: Maybe<Scalars['String']['output']>;
  /** List of voucher codes which causes the error. */
  voucherCodes: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorVoucherCodeBulkDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorVoucherCodeCountableConnection = {
  __typename?: 'VoucherCodeCountableConnection';
  edges: Array<SaleorVoucherCodeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorVoucherCodeCountableEdge = {
  __typename?: 'VoucherCodeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorVoucherCode;
};

/**
 * Event sent when voucher code export is completed.
 *
 * Added in Saleor 3.18.
 */
export type SaleorVoucherCodeExportCompleted = SaleorEvent & {
  __typename?: 'VoucherCodeExportCompleted';
  /** The export file for voucher codes. */
  export: Maybe<SaleorExportFile>;
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when new voucher codes were created.
 *
 * Added in Saleor 3.19.
 */
export type SaleorVoucherCodesCreated = SaleorEvent & {
  __typename?: 'VoucherCodesCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The voucher codes the event relates to. */
  voucherCodes: Maybe<Array<SaleorVoucherCode>>;
};

/**
 * Event sent when voucher codes were deleted.
 *
 * Added in Saleor 3.19.
 */
export type SaleorVoucherCodesDeleted = SaleorEvent & {
  __typename?: 'VoucherCodesDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The voucher codes the event relates to. */
  voucherCodes: Maybe<Array<SaleorVoucherCode>>;
};

export type SaleorVoucherCountableConnection = {
  __typename?: 'VoucherCountableConnection';
  edges: Array<SaleorVoucherCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorVoucherCountableEdge = {
  __typename?: 'VoucherCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorVoucher;
};

/**
 * Creates a new voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_CREATED (async): A voucher was created.
 * - VOUCHER_CODES_CREATED (async): A voucher codes were created.
 */
export type SaleorVoucherCreate = {
  __typename?: 'VoucherCreate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  voucher: Maybe<SaleorVoucher>;
};

/** Event sent when new voucher is created. */
export type SaleorVoucherCreated = SaleorEvent & {
  __typename?: 'VoucherCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher: Maybe<SaleorVoucher>;
};


/** Event sent when new voucher is created. */
export type SaleorVoucherCreatedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_DELETED (async): A voucher was deleted.
 */
export type SaleorVoucherDelete = {
  __typename?: 'VoucherDelete';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  voucher: Maybe<SaleorVoucher>;
};

/** Event sent when voucher is deleted. */
export type SaleorVoucherDeleted = SaleorEvent & {
  __typename?: 'VoucherDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher: Maybe<SaleorVoucher>;
};


/** Event sent when voucher is deleted. */
export type SaleorVoucherDeletedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorVoucherDiscountType =
  | 'FIXED'
  | 'PERCENTAGE'
  | 'SHIPPING';

export type SaleorVoucherFilterInput = {
  discountType?: InputMaybe<Array<SaleorVoucherDiscountType>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<SaleorDateTimeRangeInput>;
  status?: InputMaybe<Array<SaleorDiscountStatusEnum>>;
  timesUsed?: InputMaybe<SaleorIntRangeInput>;
};

export type SaleorVoucherInput = {
  /**
   * List of codes to add.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  addCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Voucher should be applied once per customer. */
  applyOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Voucher should be applied to the cheapest item or entire order. */
  applyOncePerOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Categories discounted by the voucher. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Code to use the voucher.
   *
   * DEPRECATED: this field will be removed. Use `addCodes` instead.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Collections discounted by the voucher. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Country codes that can be used with the shipping voucher. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Choices: fixed or percentage. */
  discountValueType?: InputMaybe<SaleorDiscountValueTypeEnum>;
  /** End date of the voucher in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Minimal quantity of checkout items required to apply the voucher. */
  minCheckoutItemsQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Voucher name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Voucher can be used only by staff user. */
  onlyForStaff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Products discounted by the voucher. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * When set to 'True', each voucher code can be used only once; otherwise, codes can be used multiple times depending on `usageLimit`.
   *
   * The option can only be changed if none of the voucher codes have been used.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  singleUse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date of the voucher in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Voucher type: PRODUCT, CATEGORY SHIPPING or ENTIRE_ORDER. */
  type?: InputMaybe<SaleorVoucherTypeEnum>;
  /** Limit number of times this voucher can be used in total. */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Variants discounted by the voucher. */
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when voucher metadata is updated. */
export type SaleorVoucherMetadataUpdated = SaleorEvent & {
  __typename?: 'VoucherMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher: Maybe<SaleorVoucher>;
};


/** Event sent when voucher metadata is updated. */
export type SaleorVoucherMetadataUpdatedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Removes products, categories, collections from a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 */
export type SaleorVoucherRemoveCatalogues = {
  __typename?: 'VoucherRemoveCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Voucher of which catalogue IDs will be modified. */
  voucher: Maybe<SaleorVoucher>;
};

export type SaleorVoucherSortField =
  /** Sort vouchers by code. */
  | 'CODE'
  /** Sort vouchers by end date. */
  | 'END_DATE'
  /**
   * Sort vouchers by minimum spent amount.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'MINIMUM_SPENT_AMOUNT'
  /**
   * Sort vouchers by name.
   *
   * Added in Saleor 3.18.
   */
  | 'NAME'
  /** Sort vouchers by start date. */
  | 'START_DATE'
  /** Sort vouchers by type. */
  | 'TYPE'
  /** Sort vouchers by usage limit. */
  | 'USAGE_LIMIT'
  /**
   * Sort vouchers by value.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'VALUE';

export type SaleorVoucherSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort vouchers. */
  direction: SaleorOrderDirection;
  /** Sort vouchers by the selected field. */
  field: SaleorVoucherSortField;
};

/** Represents voucher's original translatable fields and related translations. */
export type SaleorVoucherTranslatableContent = SaleorNode & {
  __typename?: 'VoucherTranslatableContent';
  /** The ID of the voucher translatable content. */
  id: Scalars['ID']['output'];
  /** Voucher name to translate. */
  name: Maybe<Scalars['String']['output']>;
  /** Returns translated voucher fields for the given language code. */
  translation: Maybe<SaleorVoucherTranslation>;
  /**
   * Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Get model fields from the root level queries.
   */
  voucher: Maybe<SaleorVoucher>;
  /** The ID of the voucher to translate. */
  voucherId: Scalars['ID']['output'];
};


/** Represents voucher's original translatable fields and related translations. */
export type SaleorVoucherTranslatableContentTranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a voucher.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorVoucherTranslate = {
  __typename?: 'VoucherTranslate';
  errors: Array<SaleorTranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
  voucher: Maybe<SaleorVoucher>;
};

/** Represents voucher translations. */
export type SaleorVoucherTranslation = SaleorNode & {
  __typename?: 'VoucherTranslation';
  /** The ID of the voucher translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  /** Translated voucher name. */
  name: Maybe<Scalars['String']['output']>;
  /** Represents the voucher fields to translate. */
  translatableContent: Maybe<SaleorVoucherTranslatableContent>;
};

export type SaleorVoucherTypeEnum =
  | 'ENTIRE_ORDER'
  | 'SHIPPING'
  | 'SPECIFIC_PRODUCT';

/**
 * Updates a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 * - VOUCHER_CODES_CREATED (async): A voucher code was created.
 */
export type SaleorVoucherUpdate = {
  __typename?: 'VoucherUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  voucher: Maybe<SaleorVoucher>;
};

/** Event sent when voucher is updated. */
export type SaleorVoucherUpdated = SaleorEvent & {
  __typename?: 'VoucherUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher: Maybe<SaleorVoucher>;
};


/** Event sent when voucher is updated. */
export type SaleorVoucherUpdatedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents warehouse. */
export type SaleorWarehouse = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'Warehouse';
  /** Address of the warehouse. */
  address: SaleorAddress;
  /** Click and collect options: local, all or disabled. */
  clickAndCollectOption: SaleorWarehouseClickAndCollectOptionEnum;
  /**
   * Warehouse company name.
   * @deprecated Use `Address.companyName` instead.
   */
  companyName: Scalars['String']['output'];
  /** Warehouse email. */
  email: Scalars['String']['output'];
  /** External ID of this warehouse. */
  externalReference: Maybe<Scalars['String']['output']>;
  /** The ID of the warehouse. */
  id: Scalars['ID']['output'];
  /** Determine if the warehouse is private. */
  isPrivate: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields: Maybe<Scalars['Metadata']['output']>;
  /** Warehouse name. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields: Maybe<Scalars['Metadata']['output']>;
  /** Shipping zones supported by the warehouse. */
  shippingZones: SaleorShippingZoneCountableConnection;
  /** Warehouse slug. */
  slug: Scalars['String']['output'];
  /**
   * Stocks that belong to this warehouse.
   *
   * Added in Saleor 3.20.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  stocks: Maybe<SaleorStockCountableConnection>;
};


/** Represents warehouse. */
export type SaleorWarehouseMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents warehouse. */
export type SaleorWarehouseMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents warehouse. */
export type SaleorWarehousePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents warehouse. */
export type SaleorWarehousePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents warehouse. */
export type SaleorWarehouseShippingZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents warehouse. */
export type SaleorWarehouseStocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorWarehouseClickAndCollectOptionEnum =
  | 'ALL'
  | 'DISABLED'
  | 'LOCAL';

export type SaleorWarehouseCountableConnection = {
  __typename?: 'WarehouseCountableConnection';
  edges: Array<SaleorWarehouseCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type SaleorWarehouseCountableEdge = {
  __typename?: 'WarehouseCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorWarehouse;
};

/**
 * Creates a new warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseCreate = {
  __typename?: 'WarehouseCreate';
  errors: Array<SaleorWarehouseError>;
  warehouse: Maybe<SaleorWarehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

export type SaleorWarehouseCreateInput = {
  /** Address of the warehouse. */
  address: SaleorAddressInput;
  /** The email address of the warehouse. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the warehouse. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse name. */
  name: Scalars['String']['input'];
  /**
   * Shipping zones supported by the warehouse.
   *
   * DEPRECATED: this field will be removed. Providing the zone ids will raise a ValidationError.
   */
  shippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Warehouse slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new warehouse is created. */
export type SaleorWarehouseCreated = SaleorEvent & {
  __typename?: 'WarehouseCreated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse: Maybe<SaleorWarehouse>;
};

/**
 * Deletes selected warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseDelete = {
  __typename?: 'WarehouseDelete';
  errors: Array<SaleorWarehouseError>;
  warehouse: Maybe<SaleorWarehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

/** Event sent when warehouse is deleted. */
export type SaleorWarehouseDeleted = SaleorEvent & {
  __typename?: 'WarehouseDeleted';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse: Maybe<SaleorWarehouse>;
};

export type SaleorWarehouseError = {
  __typename?: 'WarehouseError';
  /** The error code. */
  code: SaleorWarehouseErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
  /** List of shipping zones IDs which causes the error. */
  shippingZones: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorWarehouseErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorWarehouseFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  clickAndCollectOption?: InputMaybe<SaleorWarehouseClickAndCollectOptionEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Event sent when warehouse metadata is updated. */
export type SaleorWarehouseMetadataUpdated = SaleorEvent & {
  __typename?: 'WarehouseMetadataUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse: Maybe<SaleorWarehouse>;
};

/**
 * Add shipping zone to given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseShippingZoneAssign = {
  __typename?: 'WarehouseShippingZoneAssign';
  errors: Array<SaleorWarehouseError>;
  warehouse: Maybe<SaleorWarehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

/**
 * Remove shipping zone from given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseShippingZoneUnassign = {
  __typename?: 'WarehouseShippingZoneUnassign';
  errors: Array<SaleorWarehouseError>;
  warehouse: Maybe<SaleorWarehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

export type SaleorWarehouseSortField =
  /** Sort warehouses by name. */
  | 'NAME';

export type SaleorWarehouseSortingInput = {
  /** Specifies the direction in which to sort warehouses. */
  direction: SaleorOrderDirection;
  /** Sort warehouses by the selected field. */
  field: SaleorWarehouseSortField;
};

/**
 * Updates given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseUpdate = {
  __typename?: 'WarehouseUpdate';
  errors: Array<SaleorWarehouseError>;
  warehouse: Maybe<SaleorWarehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

export type SaleorWarehouseUpdateInput = {
  /** Address of the warehouse. */
  address?: InputMaybe<SaleorAddressInput>;
  /** Click and collect options: local, all or disabled. */
  clickAndCollectOption?: InputMaybe<SaleorWarehouseClickAndCollectOptionEnum>;
  /** The email address of the warehouse. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the warehouse. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Visibility of warehouse stocks. */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when warehouse is updated. */
export type SaleorWarehouseUpdated = SaleorEvent & {
  __typename?: 'WarehouseUpdated';
  /** Time of the event. */
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse: Maybe<SaleorWarehouse>;
};

/** Webhook. */
export type SaleorWebhook = SaleorNode & {
  __typename?: 'Webhook';
  /** The app associated with Webhook. */
  app: SaleorApp;
  /** List of asynchronous webhook events. */
  asyncEvents: Array<SaleorWebhookEventAsync>;
  /** Custom headers, which will be added to HTTP request. */
  customHeaders: Maybe<Scalars['JSONString']['output']>;
  /** Event deliveries. */
  eventDeliveries: Maybe<SaleorEventDeliveryCountableConnection>;
  /**
   * List of webhook events.
   * @deprecated Use `asyncEvents` or `syncEvents` instead.
   */
  events: Array<SaleorWebhookEvent>;
  /** The ID of webhook. */
  id: Scalars['ID']['output'];
  /** Informs if webhook is activated. */
  isActive: Scalars['Boolean']['output'];
  /** The name of webhook. */
  name: Maybe<Scalars['String']['output']>;
  /**
   * Used to create a hash signature for each payload.
   * @deprecated As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey: Maybe<Scalars['String']['output']>;
  /** Used to define payloads for specific events. */
  subscriptionQuery: Maybe<Scalars['String']['output']>;
  /** List of synchronous webhook events. */
  syncEvents: Array<SaleorWebhookEventSync>;
  /** Target URL for webhook. */
  targetUrl: Scalars['String']['output'];
};


/** Webhook. */
export type SaleorWebhookEventDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorEventDeliveryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorEventDeliverySortingInput>;
};

/**
 * Creates a new webhook subscription.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type SaleorWebhookCreate = {
  __typename?: 'WebhookCreate';
  errors: Array<SaleorWebhookError>;
  webhook: Maybe<SaleorWebhook>;
  /** @deprecated Use `errors` field instead. */
  webhookErrors: Array<SaleorWebhookError>;
};

export type SaleorWebhookCreateInput = {
  /** ID of the app to which webhook belongs. */
  app?: InputMaybe<Scalars['ID']['input']>;
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: InputMaybe<Array<SaleorWebhookEventTypeAsyncEnum>>;
  /** Custom headers, which will be added to HTTP request. There is a limitation of 5 headers per webhook and 998 characters per header.Only `X-*`, `Authorization*`, and `BrokerProperties` keys are allowed. */
  customHeaders?: InputMaybe<Scalars['JSONString']['input']>;
  /**
   * The events that webhook wants to subscribe.
   *
   * DEPRECATED: this field will be removed. Use `asyncEvents` or `syncEvents` instead.
   */
  events?: InputMaybe<Array<SaleorWebhookEventTypeEnum>>;
  /** Determine if webhook will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the webhook. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Subscription query used to define a webhook payload. */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * The secret key used to create a hash signature with each payload.
   *
   * DEPRECATED: this field will be removed. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: InputMaybe<Array<SaleorWebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a webhook. Before the deletion, the webhook is deactivated to pause any deliveries that are already scheduled. The deletion might fail if delivery is in progress. In such a case, the webhook is not deleted but remains deactivated.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type SaleorWebhookDelete = {
  __typename?: 'WebhookDelete';
  errors: Array<SaleorWebhookError>;
  webhook: Maybe<SaleorWebhook>;
  /** @deprecated Use `errors` field instead. */
  webhookErrors: Array<SaleorWebhookError>;
};

/**
 * Performs a dry run of a webhook event. Supports a single event (the first, if multiple provided in the `query`). Requires permission relevant to processed event.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorWebhookDryRun = {
  __typename?: 'WebhookDryRun';
  errors: Array<SaleorWebhookDryRunError>;
  /** JSON payload, that would be sent out to webhook's target URL. */
  payload: Maybe<Scalars['JSONString']['output']>;
};

export type SaleorWebhookDryRunError = {
  __typename?: 'WebhookDryRunError';
  /** The error code. */
  code: SaleorWebhookDryRunErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorWebhookDryRunErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_ID'
  | 'MISSING_EVENT'
  | 'MISSING_PERMISSION'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'SYNTAX'
  | 'TYPE_NOT_SUPPORTED'
  | 'UNABLE_TO_PARSE';

export type SaleorWebhookError = {
  __typename?: 'WebhookError';
  /** The error code. */
  code: SaleorWebhookErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorWebhookErrorCode =
  | 'DELETE_FAILED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_CUSTOM_HEADERS'
  | 'INVALID_NOTIFY_WITH_SUBSCRIPTION'
  | 'MISSING_EVENT'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SYNTAX'
  | 'UNABLE_TO_PARSE'
  | 'UNIQUE';

/** Webhook event. */
export type SaleorWebhookEvent = {
  __typename?: 'WebhookEvent';
  /** Internal name of the event type. */
  eventType: SaleorWebhookEventTypeEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Asynchronous webhook event. */
export type SaleorWebhookEventAsync = {
  __typename?: 'WebhookEventAsync';
  /** Internal name of the event type. */
  eventType: SaleorWebhookEventTypeAsyncEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Synchronous webhook event. */
export type SaleorWebhookEventSync = {
  __typename?: 'WebhookEventSync';
  /** Internal name of the event type. */
  eventType: SaleorWebhookEventTypeSyncEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Enum determining type of webhook. */
export type SaleorWebhookEventTypeAsyncEnum =
  /** An account email change is requested. */
  | 'ACCOUNT_CHANGE_EMAIL_REQUESTED'
  /** An account confirmation is requested. */
  | 'ACCOUNT_CONFIRMATION_REQUESTED'
  /** An account is confirmed. */
  | 'ACCOUNT_CONFIRMED'
  /** An account is deleted. */
  | 'ACCOUNT_DELETED'
  /** An account delete is requested. */
  | 'ACCOUNT_DELETE_REQUESTED'
  /** An account email was changed */
  | 'ACCOUNT_EMAIL_CHANGED'
  /** Setting a new password for the account is requested. */
  | 'ACCOUNT_SET_PASSWORD_REQUESTED'
  /** A new address created. */
  | 'ADDRESS_CREATED'
  /** An address deleted. */
  | 'ADDRESS_DELETED'
  /** An address updated. */
  | 'ADDRESS_UPDATED'
  /** All the events. */
  | 'ANY_EVENTS'
  /** An app deleted. */
  | 'APP_DELETED'
  /** A new app installed. */
  | 'APP_INSTALLED'
  /** An app status is changed. */
  | 'APP_STATUS_CHANGED'
  /** An app updated. */
  | 'APP_UPDATED'
  /** A new attribute is created. */
  | 'ATTRIBUTE_CREATED'
  /** An attribute is deleted. */
  | 'ATTRIBUTE_DELETED'
  /** An attribute is updated. */
  | 'ATTRIBUTE_UPDATED'
  /** A new attribute value is created. */
  | 'ATTRIBUTE_VALUE_CREATED'
  /** An attribute value is deleted. */
  | 'ATTRIBUTE_VALUE_DELETED'
  /** An attribute value is updated. */
  | 'ATTRIBUTE_VALUE_UPDATED'
  /** A new category created. */
  | 'CATEGORY_CREATED'
  /** A category is deleted. */
  | 'CATEGORY_DELETED'
  /** A category is updated. */
  | 'CATEGORY_UPDATED'
  /** A new channel created. */
  | 'CHANNEL_CREATED'
  /** A channel is deleted. */
  | 'CHANNEL_DELETED'
  /** A channel metadata is updated. */
  | 'CHANNEL_METADATA_UPDATED'
  /** A channel status is changed. */
  | 'CHANNEL_STATUS_CHANGED'
  /** A channel is updated. */
  | 'CHANNEL_UPDATED'
  /** A new checkout is created. */
  | 'CHECKOUT_CREATED'
  /**
   * A checkout was fully authorized (its `authorizeStatus` is `FULL`).
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_AUTHORIZED'
  /**
   * A checkout was fully paid (its `chargeStatus` is `FULL` or `OVERCHARGED`). This event is not sent if payments are only authorized but not fully charged.
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_PAID'
  /** A checkout metadata is updated. */
  | 'CHECKOUT_METADATA_UPDATED'
  /** A checkout is updated. It also triggers all updates related to the checkout. */
  | 'CHECKOUT_UPDATED'
  /** A new collection is created. */
  | 'COLLECTION_CREATED'
  /** A collection is deleted. */
  | 'COLLECTION_DELETED'
  /** A collection metadata is updated. */
  | 'COLLECTION_METADATA_UPDATED'
  /** A collection is updated. */
  | 'COLLECTION_UPDATED'
  /** A new customer account is created. */
  | 'CUSTOMER_CREATED'
  /** A customer account is deleted. */
  | 'CUSTOMER_DELETED'
  /** A customer account metadata is updated. */
  | 'CUSTOMER_METADATA_UPDATED'
  /** A customer account is updated. */
  | 'CUSTOMER_UPDATED'
  /** A draft order is created. */
  | 'DRAFT_ORDER_CREATED'
  /** A draft order is deleted. */
  | 'DRAFT_ORDER_DELETED'
  /** A draft order is updated. */
  | 'DRAFT_ORDER_UPDATED'
  /** A fulfillment is approved. */
  | 'FULFILLMENT_APPROVED'
  /** A fulfillment is cancelled. */
  | 'FULFILLMENT_CANCELED'
  /** A new fulfillment is created. */
  | 'FULFILLMENT_CREATED'
  /** A fulfillment metadata is updated. */
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'FULFILLMENT_TRACKING_NUMBER_UPDATED'
  /** A new gift card created. */
  | 'GIFT_CARD_CREATED'
  /** A gift card is deleted. */
  | 'GIFT_CARD_DELETED'
  /** A gift card export is completed. */
  | 'GIFT_CARD_EXPORT_COMPLETED'
  /** A gift card metadata is updated. */
  | 'GIFT_CARD_METADATA_UPDATED'
  /** A gift card has been sent. */
  | 'GIFT_CARD_SENT'
  /** A gift card status is changed. */
  | 'GIFT_CARD_STATUS_CHANGED'
  /** A gift card is updated. */
  | 'GIFT_CARD_UPDATED'
  /** An invoice is deleted. */
  | 'INVOICE_DELETED'
  /** An invoice for order requested. */
  | 'INVOICE_REQUESTED'
  /** Invoice has been sent. */
  | 'INVOICE_SENT'
  /** A new menu created. */
  | 'MENU_CREATED'
  /** A menu is deleted. */
  | 'MENU_DELETED'
  /** A new menu item created. */
  | 'MENU_ITEM_CREATED'
  /** A menu item is deleted. */
  | 'MENU_ITEM_DELETED'
  /** A menu item is updated. */
  | 'MENU_ITEM_UPDATED'
  /** A menu is updated. */
  | 'MENU_UPDATED'
  /** User notification triggered. */
  | 'NOTIFY_USER'
  /** An observability event is created. */
  | 'OBSERVABILITY'
  /** Orders are imported. */
  | 'ORDER_BULK_CREATED'
  /** An order is cancelled. */
  | 'ORDER_CANCELLED'
  /** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */
  | 'ORDER_CONFIRMED'
  /** A new order is placed. */
  | 'ORDER_CREATED'
  /** An order is expired. */
  | 'ORDER_EXPIRED'
  /** An order is fulfilled. */
  | 'ORDER_FULFILLED'
  /** Payment is made and an order is fully paid. */
  | 'ORDER_FULLY_PAID'
  /** The order is fully refunded. */
  | 'ORDER_FULLY_REFUNDED'
  /** An order metadata is updated. */
  | 'ORDER_METADATA_UPDATED'
  /** Payment has been made. The order may be partially or fully paid. */
  | 'ORDER_PAID'
  /** The order received a refund. The order may be partially or fully refunded. */
  | 'ORDER_REFUNDED'
  /** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */
  | 'ORDER_UPDATED'
  /** A new page is created. */
  | 'PAGE_CREATED'
  /** A page is deleted. */
  | 'PAGE_DELETED'
  /** A new page type is created. */
  | 'PAGE_TYPE_CREATED'
  /** A page type is deleted. */
  | 'PAGE_TYPE_DELETED'
  /** A page type is updated. */
  | 'PAGE_TYPE_UPDATED'
  /** A page is updated. */
  | 'PAGE_UPDATED'
  /** A new permission group is created. */
  | 'PERMISSION_GROUP_CREATED'
  /** A permission group is deleted. */
  | 'PERMISSION_GROUP_DELETED'
  /** A permission group is updated. */
  | 'PERMISSION_GROUP_UPDATED'
  /** A new product is created. */
  | 'PRODUCT_CREATED'
  /** A product is deleted. */
  | 'PRODUCT_DELETED'
  /** A product export is completed. */
  | 'PRODUCT_EXPORT_COMPLETED'
  /** A new product media is created. */
  | 'PRODUCT_MEDIA_CREATED'
  /** A product media is deleted. */
  | 'PRODUCT_MEDIA_DELETED'
  /** A product media is updated. */
  | 'PRODUCT_MEDIA_UPDATED'
  /** A product metadata is updated. */
  | 'PRODUCT_METADATA_UPDATED'
  /** A product is updated. */
  | 'PRODUCT_UPDATED'
  /** A product variant is back in stock. */
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  /** A new product variant is created. */
  | 'PRODUCT_VARIANT_CREATED'
  /** A product variant is deleted. Warning: this event will not be executed when parent product has been deleted. Check PRODUCT_DELETED. */
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_DISCOUNTED_PRICE_UPDATED'
  /** A product variant metadata is updated. */
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  /** A product variant is out of stock. */
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  /** A product variant stock is updated */
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  /** A product variant is updated. */
  | 'PRODUCT_VARIANT_UPDATED'
  /** A promotion is created. */
  | 'PROMOTION_CREATED'
  /** A promotion is deleted. */
  | 'PROMOTION_DELETED'
  /** A promotion is deactivated. */
  | 'PROMOTION_ENDED'
  /** A promotion rule is created. */
  | 'PROMOTION_RULE_CREATED'
  /** A promotion rule is deleted. */
  | 'PROMOTION_RULE_DELETED'
  /** A promotion rule is updated. */
  | 'PROMOTION_RULE_UPDATED'
  /** A promotion is activated. */
  | 'PROMOTION_STARTED'
  /** A promotion is updated. */
  | 'PROMOTION_UPDATED'
  /** A sale is created. */
  | 'SALE_CREATED'
  /** A sale is deleted. */
  | 'SALE_DELETED'
  /** A sale is activated or deactivated. */
  | 'SALE_TOGGLE'
  /** A sale is updated. */
  | 'SALE_UPDATED'
  /** A new shipping price is created. */
  | 'SHIPPING_PRICE_CREATED'
  /** A shipping price is deleted. */
  | 'SHIPPING_PRICE_DELETED'
  /** A shipping price is updated. */
  | 'SHIPPING_PRICE_UPDATED'
  /** A new shipping zone is created. */
  | 'SHIPPING_ZONE_CREATED'
  /** A shipping zone is deleted. */
  | 'SHIPPING_ZONE_DELETED'
  /** A shipping zone metadata is updated. */
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  /** A shipping zone is updated. */
  | 'SHIPPING_ZONE_UPDATED'
  /** Shop metadata is updated. */
  | 'SHOP_METADATA_UPDATED'
  /** A new staff user is created. */
  | 'STAFF_CREATED'
  /** A staff user is deleted. */
  | 'STAFF_DELETED'
  /** Setting a new password for the staff account is requested. */
  | 'STAFF_SET_PASSWORD_REQUESTED'
  /** A staff user is updated. */
  | 'STAFF_UPDATED'
  /** A thumbnail is created. */
  | 'THUMBNAIL_CREATED'
  /** Transaction item metadata is updated. */
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  /** A new translation is created. */
  | 'TRANSLATION_CREATED'
  /** A translation is updated. */
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CODES_CREATED'
  | 'VOUCHER_CODES_DELETED'
  /**
   * A voucher code export is completed.
   *
   * Added in Saleor 3.18.
   */
  | 'VOUCHER_CODE_EXPORT_COMPLETED'
  /** A new voucher created. */
  | 'VOUCHER_CREATED'
  /** A voucher is deleted. */
  | 'VOUCHER_DELETED'
  /** A voucher metadata is updated. */
  | 'VOUCHER_METADATA_UPDATED'
  /** A voucher is updated. */
  | 'VOUCHER_UPDATED'
  /** A new warehouse created. */
  | 'WAREHOUSE_CREATED'
  /** A warehouse is deleted. */
  | 'WAREHOUSE_DELETED'
  /** A warehouse metadata is updated. */
  | 'WAREHOUSE_METADATA_UPDATED'
  /** A warehouse is updated. */
  | 'WAREHOUSE_UPDATED';

/** Enum determining type of webhook. */
export type SaleorWebhookEventTypeEnum =
  /** An account email change is requested. */
  | 'ACCOUNT_CHANGE_EMAIL_REQUESTED'
  /** An account confirmation is requested. */
  | 'ACCOUNT_CONFIRMATION_REQUESTED'
  /** An account is confirmed. */
  | 'ACCOUNT_CONFIRMED'
  /** An account is deleted. */
  | 'ACCOUNT_DELETED'
  /** An account delete is requested. */
  | 'ACCOUNT_DELETE_REQUESTED'
  /** An account email was changed */
  | 'ACCOUNT_EMAIL_CHANGED'
  /** Setting a new password for the account is requested. */
  | 'ACCOUNT_SET_PASSWORD_REQUESTED'
  /** A new address created. */
  | 'ADDRESS_CREATED'
  /** An address deleted. */
  | 'ADDRESS_DELETED'
  /** An address updated. */
  | 'ADDRESS_UPDATED'
  /** All the events. */
  | 'ANY_EVENTS'
  /** An app deleted. */
  | 'APP_DELETED'
  /** A new app installed. */
  | 'APP_INSTALLED'
  /** An app status is changed. */
  | 'APP_STATUS_CHANGED'
  /** An app updated. */
  | 'APP_UPDATED'
  /** A new attribute is created. */
  | 'ATTRIBUTE_CREATED'
  /** An attribute is deleted. */
  | 'ATTRIBUTE_DELETED'
  /** An attribute is updated. */
  | 'ATTRIBUTE_UPDATED'
  /** A new attribute value is created. */
  | 'ATTRIBUTE_VALUE_CREATED'
  /** An attribute value is deleted. */
  | 'ATTRIBUTE_VALUE_DELETED'
  /** An attribute value is updated. */
  | 'ATTRIBUTE_VALUE_UPDATED'
  /** A new category created. */
  | 'CATEGORY_CREATED'
  /** A category is deleted. */
  | 'CATEGORY_DELETED'
  /** A category is updated. */
  | 'CATEGORY_UPDATED'
  /** A new channel created. */
  | 'CHANNEL_CREATED'
  /** A channel is deleted. */
  | 'CHANNEL_DELETED'
  /** A channel metadata is updated. */
  | 'CHANNEL_METADATA_UPDATED'
  /** A channel status is changed. */
  | 'CHANNEL_STATUS_CHANGED'
  /** A channel is updated. */
  | 'CHANNEL_UPDATED'
  /** Event called for checkout tax calculation. */
  | 'CHECKOUT_CALCULATE_TAXES'
  /** A new checkout is created. */
  | 'CHECKOUT_CREATED'
  /** Filter shipping methods for checkout. */
  | 'CHECKOUT_FILTER_SHIPPING_METHODS'
  /**
   * A checkout was fully authorized (its `authorizeStatus` is `FULL`).
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_AUTHORIZED'
  /**
   * A checkout was fully paid (its `chargeStatus` is `FULL` or `OVERCHARGED`). This event is not sent if payments are only authorized but not fully charged.
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_PAID'
  /** A checkout metadata is updated. */
  | 'CHECKOUT_METADATA_UPDATED'
  /** A checkout is updated. It also triggers all updates related to the checkout. */
  | 'CHECKOUT_UPDATED'
  /** A new collection is created. */
  | 'COLLECTION_CREATED'
  /** A collection is deleted. */
  | 'COLLECTION_DELETED'
  /** A collection metadata is updated. */
  | 'COLLECTION_METADATA_UPDATED'
  /** A collection is updated. */
  | 'COLLECTION_UPDATED'
  /** A new customer account is created. */
  | 'CUSTOMER_CREATED'
  /** A customer account is deleted. */
  | 'CUSTOMER_DELETED'
  /** A customer account metadata is updated. */
  | 'CUSTOMER_METADATA_UPDATED'
  /** A customer account is updated. */
  | 'CUSTOMER_UPDATED'
  /** A draft order is created. */
  | 'DRAFT_ORDER_CREATED'
  /** A draft order is deleted. */
  | 'DRAFT_ORDER_DELETED'
  /** A draft order is updated. */
  | 'DRAFT_ORDER_UPDATED'
  /** A fulfillment is approved. */
  | 'FULFILLMENT_APPROVED'
  /** A fulfillment is cancelled. */
  | 'FULFILLMENT_CANCELED'
  /** A new fulfillment is created. */
  | 'FULFILLMENT_CREATED'
  /** A fulfillment metadata is updated. */
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'FULFILLMENT_TRACKING_NUMBER_UPDATED'
  /** A new gift card created. */
  | 'GIFT_CARD_CREATED'
  /** A gift card is deleted. */
  | 'GIFT_CARD_DELETED'
  /** A gift card export is completed. */
  | 'GIFT_CARD_EXPORT_COMPLETED'
  /** A gift card metadata is updated. */
  | 'GIFT_CARD_METADATA_UPDATED'
  /** A gift card has been sent. */
  | 'GIFT_CARD_SENT'
  /** A gift card status is changed. */
  | 'GIFT_CARD_STATUS_CHANGED'
  /** A gift card is updated. */
  | 'GIFT_CARD_UPDATED'
  /** An invoice is deleted. */
  | 'INVOICE_DELETED'
  /** An invoice for order requested. */
  | 'INVOICE_REQUESTED'
  /** Invoice has been sent. */
  | 'INVOICE_SENT'
  | 'LIST_STORED_PAYMENT_METHODS'
  /** A new menu created. */
  | 'MENU_CREATED'
  /** A menu is deleted. */
  | 'MENU_DELETED'
  /** A new menu item created. */
  | 'MENU_ITEM_CREATED'
  /** A menu item is deleted. */
  | 'MENU_ITEM_DELETED'
  /** A menu item is updated. */
  | 'MENU_ITEM_UPDATED'
  /** A menu is updated. */
  | 'MENU_UPDATED'
  /** User notification triggered. */
  | 'NOTIFY_USER'
  /** An observability event is created. */
  | 'OBSERVABILITY'
  /** Orders are imported. */
  | 'ORDER_BULK_CREATED'
  /** Event called for order tax calculation. */
  | 'ORDER_CALCULATE_TAXES'
  /** An order is cancelled. */
  | 'ORDER_CANCELLED'
  /** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */
  | 'ORDER_CONFIRMED'
  /** A new order is placed. */
  | 'ORDER_CREATED'
  /** An order is expired. */
  | 'ORDER_EXPIRED'
  /** Filter shipping methods for order. */
  | 'ORDER_FILTER_SHIPPING_METHODS'
  /** An order is fulfilled. */
  | 'ORDER_FULFILLED'
  /** Payment is made and an order is fully paid. */
  | 'ORDER_FULLY_PAID'
  /** The order is fully refunded. */
  | 'ORDER_FULLY_REFUNDED'
  /** An order metadata is updated. */
  | 'ORDER_METADATA_UPDATED'
  /** Payment has been made. The order may be partially or fully paid. */
  | 'ORDER_PAID'
  /** The order received a refund. The order may be partially or fully refunded. */
  | 'ORDER_REFUNDED'
  /** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */
  | 'ORDER_UPDATED'
  /** A new page is created. */
  | 'PAGE_CREATED'
  /** A page is deleted. */
  | 'PAGE_DELETED'
  /** A new page type is created. */
  | 'PAGE_TYPE_CREATED'
  /** A page type is deleted. */
  | 'PAGE_TYPE_DELETED'
  /** A page type is updated. */
  | 'PAGE_TYPE_UPDATED'
  /** A page is updated. */
  | 'PAGE_UPDATED'
  /** Authorize payment. */
  | 'PAYMENT_AUTHORIZE'
  /** Capture payment. */
  | 'PAYMENT_CAPTURE'
  /** Confirm payment. */
  | 'PAYMENT_CONFIRM'
  | 'PAYMENT_GATEWAY_INITIALIZE_SESSION'
  | 'PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION'
  /** Listing available payment gateways. */
  | 'PAYMENT_LIST_GATEWAYS'
  | 'PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION'
  | 'PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION'
  /** Process payment. */
  | 'PAYMENT_PROCESS'
  /** Refund payment. */
  | 'PAYMENT_REFUND'
  /** Void payment. */
  | 'PAYMENT_VOID'
  /** A new permission group is created. */
  | 'PERMISSION_GROUP_CREATED'
  /** A permission group is deleted. */
  | 'PERMISSION_GROUP_DELETED'
  /** A permission group is updated. */
  | 'PERMISSION_GROUP_UPDATED'
  /** A new product is created. */
  | 'PRODUCT_CREATED'
  /** A product is deleted. */
  | 'PRODUCT_DELETED'
  /** A product export is completed. */
  | 'PRODUCT_EXPORT_COMPLETED'
  /** A new product media is created. */
  | 'PRODUCT_MEDIA_CREATED'
  /** A product media is deleted. */
  | 'PRODUCT_MEDIA_DELETED'
  /** A product media is updated. */
  | 'PRODUCT_MEDIA_UPDATED'
  /** A product metadata is updated. */
  | 'PRODUCT_METADATA_UPDATED'
  /** A product is updated. */
  | 'PRODUCT_UPDATED'
  /** A product variant is back in stock. */
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  /** A new product variant is created. */
  | 'PRODUCT_VARIANT_CREATED'
  /** A product variant is deleted. Warning: this event will not be executed when parent product has been deleted. Check PRODUCT_DELETED. */
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_DISCOUNTED_PRICE_UPDATED'
  /** A product variant metadata is updated. */
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  /** A product variant is out of stock. */
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  /** A product variant stock is updated */
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  /** A product variant is updated. */
  | 'PRODUCT_VARIANT_UPDATED'
  /** A promotion is created. */
  | 'PROMOTION_CREATED'
  /** A promotion is deleted. */
  | 'PROMOTION_DELETED'
  /** A promotion is deactivated. */
  | 'PROMOTION_ENDED'
  /** A promotion rule is created. */
  | 'PROMOTION_RULE_CREATED'
  /** A promotion rule is deleted. */
  | 'PROMOTION_RULE_DELETED'
  /** A promotion rule is updated. */
  | 'PROMOTION_RULE_UPDATED'
  /** A promotion is activated. */
  | 'PROMOTION_STARTED'
  /** A promotion is updated. */
  | 'PROMOTION_UPDATED'
  /** A sale is created. */
  | 'SALE_CREATED'
  /** A sale is deleted. */
  | 'SALE_DELETED'
  /** A sale is activated or deactivated. */
  | 'SALE_TOGGLE'
  /** A sale is updated. */
  | 'SALE_UPDATED'
  /** Fetch external shipping methods for checkout. */
  | 'SHIPPING_LIST_METHODS_FOR_CHECKOUT'
  /** A new shipping price is created. */
  | 'SHIPPING_PRICE_CREATED'
  /** A shipping price is deleted. */
  | 'SHIPPING_PRICE_DELETED'
  /** A shipping price is updated. */
  | 'SHIPPING_PRICE_UPDATED'
  /** A new shipping zone is created. */
  | 'SHIPPING_ZONE_CREATED'
  /** A shipping zone is deleted. */
  | 'SHIPPING_ZONE_DELETED'
  /** A shipping zone metadata is updated. */
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  /** A shipping zone is updated. */
  | 'SHIPPING_ZONE_UPDATED'
  /** Shop metadata is updated. */
  | 'SHOP_METADATA_UPDATED'
  /** A new staff user is created. */
  | 'STAFF_CREATED'
  /** A staff user is deleted. */
  | 'STAFF_DELETED'
  /** Setting a new password for the staff account is requested. */
  | 'STAFF_SET_PASSWORD_REQUESTED'
  /** A staff user is updated. */
  | 'STAFF_UPDATED'
  | 'STORED_PAYMENT_METHOD_DELETE_REQUESTED'
  /** A thumbnail is created. */
  | 'THUMBNAIL_CREATED'
  /** Event called when cancel has been requested for transaction. */
  | 'TRANSACTION_CANCELATION_REQUESTED'
  /** Event called when charge has been requested for transaction. */
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_INITIALIZE_SESSION'
  /** Transaction item metadata is updated. */
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  | 'TRANSACTION_PROCESS_SESSION'
  /** Event called when refund has been requested for transaction. */
  | 'TRANSACTION_REFUND_REQUESTED'
  /** A new translation is created. */
  | 'TRANSLATION_CREATED'
  /** A translation is updated. */
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CODES_CREATED'
  | 'VOUCHER_CODES_DELETED'
  /**
   * A voucher code export is completed.
   *
   * Added in Saleor 3.18.
   */
  | 'VOUCHER_CODE_EXPORT_COMPLETED'
  /** A new voucher created. */
  | 'VOUCHER_CREATED'
  /** A voucher is deleted. */
  | 'VOUCHER_DELETED'
  /** A voucher metadata is updated. */
  | 'VOUCHER_METADATA_UPDATED'
  /** A voucher is updated. */
  | 'VOUCHER_UPDATED'
  /** A new warehouse created. */
  | 'WAREHOUSE_CREATED'
  /** A warehouse is deleted. */
  | 'WAREHOUSE_DELETED'
  /** A warehouse metadata is updated. */
  | 'WAREHOUSE_METADATA_UPDATED'
  /** A warehouse is updated. */
  | 'WAREHOUSE_UPDATED';

/** Enum determining type of webhook. */
export type SaleorWebhookEventTypeSyncEnum =
  /** Event called for checkout tax calculation. */
  | 'CHECKOUT_CALCULATE_TAXES'
  /** Filter shipping methods for checkout. */
  | 'CHECKOUT_FILTER_SHIPPING_METHODS'
  | 'LIST_STORED_PAYMENT_METHODS'
  /** Event called for order tax calculation. */
  | 'ORDER_CALCULATE_TAXES'
  /** Filter shipping methods for order. */
  | 'ORDER_FILTER_SHIPPING_METHODS'
  /** Authorize payment. */
  | 'PAYMENT_AUTHORIZE'
  /** Capture payment. */
  | 'PAYMENT_CAPTURE'
  /** Confirm payment. */
  | 'PAYMENT_CONFIRM'
  | 'PAYMENT_GATEWAY_INITIALIZE_SESSION'
  | 'PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION'
  /** Listing available payment gateways. */
  | 'PAYMENT_LIST_GATEWAYS'
  | 'PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION'
  | 'PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION'
  /** Process payment. */
  | 'PAYMENT_PROCESS'
  /** Refund payment. */
  | 'PAYMENT_REFUND'
  /** Void payment. */
  | 'PAYMENT_VOID'
  /** Fetch external shipping methods for checkout. */
  | 'SHIPPING_LIST_METHODS_FOR_CHECKOUT'
  | 'STORED_PAYMENT_METHOD_DELETE_REQUESTED'
  /** Event called when cancel has been requested for transaction. */
  | 'TRANSACTION_CANCELATION_REQUESTED'
  /** Event called when charge has been requested for transaction. */
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_INITIALIZE_SESSION'
  | 'TRANSACTION_PROCESS_SESSION'
  /** Event called when refund has been requested for transaction. */
  | 'TRANSACTION_REFUND_REQUESTED';

export type SaleorWebhookSampleEventTypeEnum =
  | 'ACCOUNT_CHANGE_EMAIL_REQUESTED'
  | 'ACCOUNT_CONFIRMATION_REQUESTED'
  | 'ACCOUNT_CONFIRMED'
  | 'ACCOUNT_DELETED'
  | 'ACCOUNT_DELETE_REQUESTED'
  | 'ACCOUNT_EMAIL_CHANGED'
  | 'ACCOUNT_SET_PASSWORD_REQUESTED'
  | 'ADDRESS_CREATED'
  | 'ADDRESS_DELETED'
  | 'ADDRESS_UPDATED'
  | 'APP_DELETED'
  | 'APP_INSTALLED'
  | 'APP_STATUS_CHANGED'
  | 'APP_UPDATED'
  | 'ATTRIBUTE_CREATED'
  | 'ATTRIBUTE_DELETED'
  | 'ATTRIBUTE_UPDATED'
  | 'ATTRIBUTE_VALUE_CREATED'
  | 'ATTRIBUTE_VALUE_DELETED'
  | 'ATTRIBUTE_VALUE_UPDATED'
  | 'CATEGORY_CREATED'
  | 'CATEGORY_DELETED'
  | 'CATEGORY_UPDATED'
  | 'CHANNEL_CREATED'
  | 'CHANNEL_DELETED'
  | 'CHANNEL_METADATA_UPDATED'
  | 'CHANNEL_STATUS_CHANGED'
  | 'CHANNEL_UPDATED'
  | 'CHECKOUT_CREATED'
  | 'CHECKOUT_FULLY_AUTHORIZED'
  | 'CHECKOUT_FULLY_PAID'
  | 'CHECKOUT_METADATA_UPDATED'
  | 'CHECKOUT_UPDATED'
  | 'COLLECTION_CREATED'
  | 'COLLECTION_DELETED'
  | 'COLLECTION_METADATA_UPDATED'
  | 'COLLECTION_UPDATED'
  | 'CUSTOMER_CREATED'
  | 'CUSTOMER_DELETED'
  | 'CUSTOMER_METADATA_UPDATED'
  | 'CUSTOMER_UPDATED'
  | 'DRAFT_ORDER_CREATED'
  | 'DRAFT_ORDER_DELETED'
  | 'DRAFT_ORDER_UPDATED'
  | 'FULFILLMENT_APPROVED'
  | 'FULFILLMENT_CANCELED'
  | 'FULFILLMENT_CREATED'
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'FULFILLMENT_TRACKING_NUMBER_UPDATED'
  | 'GIFT_CARD_CREATED'
  | 'GIFT_CARD_DELETED'
  | 'GIFT_CARD_EXPORT_COMPLETED'
  | 'GIFT_CARD_METADATA_UPDATED'
  | 'GIFT_CARD_SENT'
  | 'GIFT_CARD_STATUS_CHANGED'
  | 'GIFT_CARD_UPDATED'
  | 'INVOICE_DELETED'
  | 'INVOICE_REQUESTED'
  | 'INVOICE_SENT'
  | 'MENU_CREATED'
  | 'MENU_DELETED'
  | 'MENU_ITEM_CREATED'
  | 'MENU_ITEM_DELETED'
  | 'MENU_ITEM_UPDATED'
  | 'MENU_UPDATED'
  | 'NOTIFY_USER'
  | 'OBSERVABILITY'
  | 'ORDER_BULK_CREATED'
  | 'ORDER_CANCELLED'
  | 'ORDER_CONFIRMED'
  | 'ORDER_CREATED'
  | 'ORDER_EXPIRED'
  | 'ORDER_FULFILLED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_FULLY_REFUNDED'
  | 'ORDER_METADATA_UPDATED'
  | 'ORDER_PAID'
  | 'ORDER_REFUNDED'
  | 'ORDER_UPDATED'
  | 'PAGE_CREATED'
  | 'PAGE_DELETED'
  | 'PAGE_TYPE_CREATED'
  | 'PAGE_TYPE_DELETED'
  | 'PAGE_TYPE_UPDATED'
  | 'PAGE_UPDATED'
  | 'PERMISSION_GROUP_CREATED'
  | 'PERMISSION_GROUP_DELETED'
  | 'PERMISSION_GROUP_UPDATED'
  | 'PRODUCT_CREATED'
  | 'PRODUCT_DELETED'
  | 'PRODUCT_EXPORT_COMPLETED'
  | 'PRODUCT_MEDIA_CREATED'
  | 'PRODUCT_MEDIA_DELETED'
  | 'PRODUCT_MEDIA_UPDATED'
  | 'PRODUCT_METADATA_UPDATED'
  | 'PRODUCT_UPDATED'
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  | 'PRODUCT_VARIANT_CREATED'
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_DISCOUNTED_PRICE_UPDATED'
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  | 'PRODUCT_VARIANT_UPDATED'
  | 'PROMOTION_CREATED'
  | 'PROMOTION_DELETED'
  | 'PROMOTION_ENDED'
  | 'PROMOTION_RULE_CREATED'
  | 'PROMOTION_RULE_DELETED'
  | 'PROMOTION_RULE_UPDATED'
  | 'PROMOTION_STARTED'
  | 'PROMOTION_UPDATED'
  | 'SALE_CREATED'
  | 'SALE_DELETED'
  | 'SALE_TOGGLE'
  | 'SALE_UPDATED'
  | 'SHIPPING_PRICE_CREATED'
  | 'SHIPPING_PRICE_DELETED'
  | 'SHIPPING_PRICE_UPDATED'
  | 'SHIPPING_ZONE_CREATED'
  | 'SHIPPING_ZONE_DELETED'
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  | 'SHIPPING_ZONE_UPDATED'
  | 'SHOP_METADATA_UPDATED'
  | 'STAFF_CREATED'
  | 'STAFF_DELETED'
  | 'STAFF_SET_PASSWORD_REQUESTED'
  | 'STAFF_UPDATED'
  | 'THUMBNAIL_CREATED'
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  | 'TRANSLATION_CREATED'
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CODES_CREATED'
  | 'VOUCHER_CODES_DELETED'
  | 'VOUCHER_CODE_EXPORT_COMPLETED'
  | 'VOUCHER_CREATED'
  | 'VOUCHER_DELETED'
  | 'VOUCHER_METADATA_UPDATED'
  | 'VOUCHER_UPDATED'
  | 'WAREHOUSE_CREATED'
  | 'WAREHOUSE_DELETED'
  | 'WAREHOUSE_METADATA_UPDATED'
  | 'WAREHOUSE_UPDATED';

/**
 * Trigger a webhook event. Supports a single event (the first, if multiple provided in the `webhook.subscription_query`). Requires permission relevant to processed event. Successfully delivered webhook returns `delivery` with status='PENDING' and empty payload.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorWebhookTrigger = {
  __typename?: 'WebhookTrigger';
  delivery: Maybe<SaleorEventDelivery>;
  errors: Array<SaleorWebhookTriggerError>;
};

export type SaleorWebhookTriggerError = {
  __typename?: 'WebhookTriggerError';
  /** The error code. */
  code: SaleorWebhookTriggerErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Maybe<Scalars['String']['output']>;
};

export type SaleorWebhookTriggerErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_ID'
  | 'MISSING_EVENT'
  | 'MISSING_PERMISSION'
  | 'MISSING_QUERY'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'SYNTAX'
  | 'TYPE_NOT_SUPPORTED'
  | 'UNABLE_TO_PARSE';

/**
 * Updates a webhook subscription.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type SaleorWebhookUpdate = {
  __typename?: 'WebhookUpdate';
  errors: Array<SaleorWebhookError>;
  webhook: Maybe<SaleorWebhook>;
  /** @deprecated Use `errors` field instead. */
  webhookErrors: Array<SaleorWebhookError>;
};

export type SaleorWebhookUpdateInput = {
  /** ID of the app to which webhook belongs. */
  app?: InputMaybe<Scalars['ID']['input']>;
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: InputMaybe<Array<SaleorWebhookEventTypeAsyncEnum>>;
  /** Custom headers, which will be added to HTTP request. There is a limitation of 5 headers per webhook and 998 characters per header.Only `X-*`, `Authorization*`, and `BrokerProperties` keys are allowed. */
  customHeaders?: InputMaybe<Scalars['JSONString']['input']>;
  /**
   * The events that webhook wants to subscribe.
   *
   * DEPRECATED: this field will be removed. Use `asyncEvents` or `syncEvents` instead.
   */
  events?: InputMaybe<Array<SaleorWebhookEventTypeEnum>>;
  /** Determine if webhook will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name of the webhook. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Subscription query used to define a webhook payload. */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use to create a hash signature with each payload.
   *
   * DEPRECATED: this field will be removed. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: InputMaybe<Array<SaleorWebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Represents weight value in a specific weight unit. */
export type SaleorWeight = {
  __typename?: 'Weight';
  /** Weight unit. */
  unit: SaleorWeightUnitsEnum;
  /** Weight value. Returns a value with maximal three decimal places */
  value: Scalars['Float']['output'];
};

export type SaleorWeightUnitsEnum =
  | 'G'
  | 'KG'
  | 'LB'
  | 'OZ'
  | 'TONNE';

/** Represents the WIDGET target options for an app extension. */
export type SaleorWidgetTargetOptions = {
  __typename?: 'WidgetTargetOptions';
  /**
   * HTTP method for Widget target (GET or POST)
   * @deprecated Use `settings` field directly.
   */
  method: SaleorHttpMethod;
};

/** _Entity union as defined by Federation spec. */
export type Saleor_Entity = SaleorAddress | SaleorApp | SaleorCategory | SaleorCollection | SaleorGroup | SaleorOrder | SaleorPageType | SaleorProduct | SaleorProductMedia | SaleorProductType | SaleorProductVariant | SaleorUser;

/** _Service manifest as defined by Federation spec. */
export type Saleor_Service = {
  __typename?: '_Service';
  sdl: Maybe<Scalars['String']['output']>;
};

export type SaleorAccountErrorFragment = { __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode };

export type SaleorAddToBagProductFragment = { __typename?: 'ProductVariant', id: string, sku: string | null, product: { __typename?: 'Product', id: string, name: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, buckleName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null };

export type SaleorAddressFragment = { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type SaleorAddressValidationDataFragment = { __typename?: 'AddressValidationData', requiredFields: Array<string>, countryAreaType: string, postalCodeType: string, cityType: string, countryAreaChoices: Array<{ __typename?: 'ChoiceValue', raw: string | null, verbose: string | null }>, cityChoices: Array<{ __typename?: 'ChoiceValue', raw: string | null, verbose: string | null }> };

export type SaleorAuthUserFragment = { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type SaleorBoolAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> };

type SaleorBusinessIdMetadata_Address_Fragment = { __typename?: 'Address', businessId: string | null };

type SaleorBusinessIdMetadata_App_Fragment = { __typename?: 'App', businessId: string | null };

type SaleorBusinessIdMetadata_Attribute_Fragment = { __typename?: 'Attribute', businessId: string | null };

type SaleorBusinessIdMetadata_Category_Fragment = { __typename?: 'Category', businessId: string | null };

type SaleorBusinessIdMetadata_Channel_Fragment = { __typename?: 'Channel', businessId: string | null };

type SaleorBusinessIdMetadata_Checkout_Fragment = { __typename?: 'Checkout', businessId: string | null };

type SaleorBusinessIdMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', businessId: string | null };

type SaleorBusinessIdMetadata_Collection_Fragment = { __typename?: 'Collection', businessId: string | null };

type SaleorBusinessIdMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', businessId: string | null };

type SaleorBusinessIdMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', businessId: string | null };

type SaleorBusinessIdMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', businessId: string | null };

type SaleorBusinessIdMetadata_Invoice_Fragment = { __typename?: 'Invoice', businessId: string | null };

type SaleorBusinessIdMetadata_Menu_Fragment = { __typename?: 'Menu', businessId: string | null };

type SaleorBusinessIdMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', businessId: string | null };

type SaleorBusinessIdMetadata_Order_Fragment = { __typename?: 'Order', businessId: string | null };

type SaleorBusinessIdMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', businessId: string | null };

type SaleorBusinessIdMetadata_Page_Fragment = { __typename?: 'Page', businessId: string | null };

type SaleorBusinessIdMetadata_PageType_Fragment = { __typename?: 'PageType', businessId: string | null };

type SaleorBusinessIdMetadata_Payment_Fragment = { __typename?: 'Payment', businessId: string | null };

type SaleorBusinessIdMetadata_Product_Fragment = { __typename?: 'Product', businessId: string | null };

type SaleorBusinessIdMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', businessId: string | null };

type SaleorBusinessIdMetadata_ProductType_Fragment = { __typename?: 'ProductType', businessId: string | null };

type SaleorBusinessIdMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', businessId: string | null };

type SaleorBusinessIdMetadata_Promotion_Fragment = { __typename?: 'Promotion', businessId: string | null };

type SaleorBusinessIdMetadata_Sale_Fragment = { __typename?: 'Sale', businessId: string | null };

type SaleorBusinessIdMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', businessId: string | null };

type SaleorBusinessIdMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', businessId: string | null };

type SaleorBusinessIdMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', businessId: string | null };

type SaleorBusinessIdMetadata_Shop_Fragment = { __typename?: 'Shop', businessId: string | null };

type SaleorBusinessIdMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', businessId: string | null };

type SaleorBusinessIdMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', businessId: string | null };

type SaleorBusinessIdMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', businessId: string | null };

type SaleorBusinessIdMetadata_User_Fragment = { __typename?: 'User', businessId: string | null };

type SaleorBusinessIdMetadata_Voucher_Fragment = { __typename?: 'Voucher', businessId: string | null };

type SaleorBusinessIdMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', businessId: string | null };

export type SaleorBusinessIdMetadataFragment =
  | SaleorBusinessIdMetadata_Address_Fragment
  | SaleorBusinessIdMetadata_App_Fragment
  | SaleorBusinessIdMetadata_Attribute_Fragment
  | SaleorBusinessIdMetadata_Category_Fragment
  | SaleorBusinessIdMetadata_Channel_Fragment
  | SaleorBusinessIdMetadata_Checkout_Fragment
  | SaleorBusinessIdMetadata_CheckoutLine_Fragment
  | SaleorBusinessIdMetadata_Collection_Fragment
  | SaleorBusinessIdMetadata_DigitalContent_Fragment
  | SaleorBusinessIdMetadata_Fulfillment_Fragment
  | SaleorBusinessIdMetadata_GiftCard_Fragment
  | SaleorBusinessIdMetadata_Invoice_Fragment
  | SaleorBusinessIdMetadata_Menu_Fragment
  | SaleorBusinessIdMetadata_MenuItem_Fragment
  | SaleorBusinessIdMetadata_Order_Fragment
  | SaleorBusinessIdMetadata_OrderLine_Fragment
  | SaleorBusinessIdMetadata_Page_Fragment
  | SaleorBusinessIdMetadata_PageType_Fragment
  | SaleorBusinessIdMetadata_Payment_Fragment
  | SaleorBusinessIdMetadata_Product_Fragment
  | SaleorBusinessIdMetadata_ProductMedia_Fragment
  | SaleorBusinessIdMetadata_ProductType_Fragment
  | SaleorBusinessIdMetadata_ProductVariant_Fragment
  | SaleorBusinessIdMetadata_Promotion_Fragment
  | SaleorBusinessIdMetadata_Sale_Fragment
  | SaleorBusinessIdMetadata_ShippingMethod_Fragment
  | SaleorBusinessIdMetadata_ShippingMethodType_Fragment
  | SaleorBusinessIdMetadata_ShippingZone_Fragment
  | SaleorBusinessIdMetadata_Shop_Fragment
  | SaleorBusinessIdMetadata_TaxClass_Fragment
  | SaleorBusinessIdMetadata_TaxConfiguration_Fragment
  | SaleorBusinessIdMetadata_TransactionItem_Fragment
  | SaleorBusinessIdMetadata_User_Fragment
  | SaleorBusinessIdMetadata_Voucher_Fragment
  | SaleorBusinessIdMetadata_Warehouse_Fragment
;

export type SaleorCartStrapDrawerFragment = { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, otherSizesSkus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, integratedBuckle: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, compatibleBuckles: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } } };

export type SaleorChannelFragment = { __typename?: 'Channel', slug: string };

export type SaleorCheckoutFragment = { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
    | { __typename: 'ShippingMethod', id: string, name: string }
    | { __typename: 'Warehouse', id: string, name: string }
   | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } };

export type SaleorCheckoutErrorFragment = { __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null };

export type SaleorCheckoutLineFragment = { __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type SaleorChoiceValueFragment = { __typename?: 'ChoiceValue', raw: string | null, verbose: string | null };

type SaleorDeliveryMethod_ShippingMethod_Fragment = { __typename: 'ShippingMethod', id: string, name: string };

type SaleorDeliveryMethod_Warehouse_Fragment = { __typename: 'Warehouse', id: string, name: string };

export type SaleorDeliveryMethodFragment =
  | SaleorDeliveryMethod_ShippingMethod_Fragment
  | SaleorDeliveryMethod_Warehouse_Fragment
;

export type SaleorDropdownAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> };

export type SaleorEyewearAttributesFragment = { __typename?: 'Product', eyewearMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameShape: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, coreWire: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, templeTipDetail: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frontalPins: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensSurface: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensCoating: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, uvProtection: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frontalWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bundleVariations: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModelStory: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, manualUrl: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null };

export type SaleorImageFragment = { __typename?: 'Image', alt: string | null, url: string };

export type SaleorLineProductFragment = { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null };

export type SaleorMoneyFragment = { __typename?: 'Money', amount: number, currency: string };

export type SaleorMultiselectAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> };

export type SaleorNumericAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> };

export type SaleorOrderFragment = { __typename?: 'Order', id: string, userEmail: string | null, isShippingRequired: boolean, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type SaleorOrderErrorFragment = { __typename?: 'OrderError', code: SaleorOrderErrorCode, field: string | null, message: string | null };

export type SaleorProductMediaFragment = { __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null };

export type SaleorProductThumbnailFragment = { __typename?: 'Product', thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null };

export type SaleorProductTypeFragment = { __typename?: 'Product', productType: { __typename?: 'ProductType', id: string, name: string, slug: string } };

export type SaleorProductUrlBaseFragment = { __typename?: 'Product', collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } };

export type SaleorProductVariantEyewearBasicDetailsFragment = { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'ProductTranslation', description: string | null, name: string | null } | null, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, mediaLarge: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, pricing: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameShape: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, coreWire: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, templeTipDetail: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frontalPins: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensSurface: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensCoating: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, uvProtection: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frontalWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bundleVariations: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModelStory: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, manualUrl: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type SaleorProductVariantLineFragment = { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } };

export type SaleorProductVariantStrapBasicDetailsFragment = { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'ProductTranslation', description: string | null, name: string | null } | null, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, mediaLarge: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, pricing: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, otherSizesSkus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, integratedBuckle: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, lugSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lug: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lugType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapBuckleType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleBuckles: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapLength: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type SaleorProductVariantWatchBasicDetailsFragment = { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'ProductTranslation', description: string | null, name: string | null } | null, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, mediaLarge: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, specificText: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, relatedProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, manualUrl: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, pricing: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingPartner: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingCampaign: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, distributionStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, limited: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, comReference: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, modelStory: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, subCollection: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, waterResistance: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, waterResistanceTextComputed: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, diameter: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, carouselProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caliber: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movement: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, chronograph: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, vibration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, jewel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, calendar: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caseback: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, bezel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, crown: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, crystal: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, headWeight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lug: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementManufacture: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, bundleVariations: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, comCategories: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, designerChoice: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, personalizedEngraving: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, caseDimensions: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementDiameter: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementHeight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, otherFunctions: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, batteryLife: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type SaleorShippingMethodFragment = { __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } };

export type SaleorStrapAttributesFragment = { __typename?: 'Product', otherSizesSkus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, integratedBuckle: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, lugSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lug: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lugType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapBuckleType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleBuckles: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapLength: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null };

export type SaleorTaxedMoneyFragment = { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } };

export type SaleorTransactionItemFragment = { __typename?: 'TransactionItem', id: string, paymentData: string | null, paymentMethod: string | null, forGiftPaymentData: string | null, oricoFinancingAppPaymentData: string | null, genericPaymentData: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type: SaleorTransactionEventTypeEnum | null, createdAt: string, pspReference: string, amount: { __typename?: 'Money', amount: number, currency: string } }> };

export type SaleorWatchAttributesFragment = { __typename?: 'Product', marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingPartner: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingCampaign: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, distributionStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, limited: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, comReference: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, modelStory: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, subCollection: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, waterResistance: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, waterResistanceTextComputed: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, diameter: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, relatedProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, carouselProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caliber: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movement: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, chronograph: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, vibration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, jewel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, calendar: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caseback: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, bezel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, crown: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, crystal: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, headWeight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lug: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementManufacture: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, manualUrl: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, bundleVariations: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, comCategories: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, designerChoice: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, personalizedEngraving: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, caseDimensions: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementDiameter: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementHeight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, otherFunctions: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, batteryLife: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null };

export type SaleorAccountAddressCreateMutationVariables = Exact<{
  input: SaleorAddressInput;
  type?: InputMaybe<SaleorAddressTypeEnum>;
}>;


export type SaleorAccountAddressCreateMutation = { __typename?: 'Mutation', accountAddressCreate: { __typename?: 'AccountAddressCreate', address: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorAccountAddressDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaleorAccountAddressDeleteMutation = { __typename?: 'Mutation', accountAddressDelete: { __typename?: 'AccountAddressDelete', address: { __typename?: 'Address', id: string } | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorAccountAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SaleorAddressInput;
}>;


export type SaleorAccountAddressUpdateMutation = { __typename?: 'Mutation', accountAddressUpdate: { __typename?: 'AccountAddressUpdate', address: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorAccountRegisterMutationVariables = Exact<{
  input: SaleorAccountRegisterInput;
}>;


export type SaleorAccountRegisterMutation = { __typename?: 'Mutation', accountRegister: { __typename?: 'AccountRegister', requiresConfirmation: boolean | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorAccountSetDefaultAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type: SaleorAddressTypeEnum;
}>;


export type SaleorAccountSetDefaultAddressMutation = { __typename?: 'Mutation', accountSetDefaultAddress: { __typename?: 'AccountSetDefaultAddress', user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorAccountUpdateMutationVariables = Exact<{
  input: SaleorAccountInput;
}>;


export type SaleorAccountUpdateMutation = { __typename?: 'Mutation', accountUpdate: { __typename?: 'AccountUpdate', user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorAddressSetDefaultMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  type: SaleorAddressTypeEnum;
  userId: Scalars['ID']['input'];
}>;


export type SaleorAddressSetDefaultMutation = { __typename?: 'Mutation', addressSetDefault: { __typename?: 'AddressSetDefault', user: { __typename?: 'User', id: string } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorCheckoutAddPromoCodeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutAddPromoCodeMutation = { __typename?: 'Mutation', checkoutAddPromoCode: { __typename?: 'CheckoutAddPromoCode', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutBillingAddressUpdateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  address: SaleorAddressInput;
  languageCode: SaleorLanguageCodeEnum;
  validationRules?: InputMaybe<SaleorCheckoutAddressValidationRules>;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutBillingAddressUpdateMutation = { __typename?: 'Mutation', checkoutBillingAddressUpdate: { __typename?: 'CheckoutBillingAddressUpdate', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutCreateMutationVariables = Exact<{
  channel: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  lines: Array<SaleorCheckoutLineInput> | SaleorCheckoutLineInput;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutCreateMutation = { __typename?: 'Mutation', checkoutCreate: { __typename?: 'CheckoutCreate', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutCustomerAttachMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutCustomerAttachMutation = { __typename?: 'Mutation', checkoutCustomerAttach: { __typename?: 'CheckoutCustomerAttach', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutDeliveryMethodUpdateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  deliveryMethodId: Scalars['ID']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutDeliveryMethodUpdateMutation = { __typename?: 'Mutation', checkoutDeliveryMethodUpdate: { __typename?: 'CheckoutDeliveryMethodUpdate', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutEmailUpdateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutEmailUpdateMutation = { __typename?: 'Mutation', checkoutEmailUpdate: { __typename?: 'CheckoutEmailUpdate', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutLinesAddMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SaleorCheckoutLineInput> | SaleorCheckoutLineInput;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutLinesAddMutation = { __typename?: 'Mutation', checkoutLinesAdd: { __typename?: 'CheckoutLinesAdd', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutLinesDeleteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  linesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutLinesDeleteMutation = { __typename?: 'Mutation', checkoutLinesDelete: { __typename?: 'CheckoutLinesDelete', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutLinesUpdateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SaleorCheckoutLineUpdateInput> | SaleorCheckoutLineUpdateInput;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutLinesUpdateMutation = { __typename?: 'Mutation', checkoutLinesUpdate: { __typename?: 'CheckoutLinesUpdate', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutRemovePromoCodeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['ID']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutRemovePromoCodeMutation = { __typename?: 'Mutation', checkoutRemovePromoCode: { __typename?: 'CheckoutRemovePromoCode', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorCheckoutShippingAddressUpdateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  address: SaleorAddressInput;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorCheckoutShippingAddressUpdateMutation = { __typename?: 'Mutation', checkoutShippingAddressUpdate: { __typename?: 'CheckoutShippingAddressUpdate', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
        | { __typename: 'ShippingMethod', id: string, name: string }
        | { __typename: 'Warehouse', id: string, name: string }
       | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'CheckoutError', field: string | null, code: SaleorCheckoutErrorCode, message: string | null }> } | null };

export type SaleorConfirmAccountMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SaleorConfirmAccountMutation = { __typename?: 'Mutation', confirmAccount: { __typename?: 'ConfirmAccount', errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorConfirmEmailChangeMutationVariables = Exact<{
  token: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaleorConfirmEmailChangeMutation = { __typename?: 'Mutation', confirmEmailChange: { __typename?: 'ConfirmEmailChange', user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorCustomerCreateMutationVariables = Exact<{
  input: SaleorUserCreateInput;
}>;


export type SaleorCustomerCreateMutation = { __typename?: 'Mutation', customerCreate: { __typename?: 'CustomerCreate', user: { __typename?: 'User', id: string, isActive: boolean, email: string, defaultShippingAddress: { __typename?: 'Address', id: string } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorCustomerUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SaleorCustomerInput;
}>;


export type SaleorCustomerUpdateMutation = { __typename?: 'Mutation', customerUpdate: { __typename?: 'CustomerUpdate', user: { __typename?: 'User', id: string, isActive: boolean, email: string, defaultShippingAddress: { __typename?: 'Address', id: string } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorOrderUpdateMutationVariables = Exact<{
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorOrderUpdateInput;
}>;


export type SaleorOrderUpdateMutation = { __typename?: 'Mutation', orderUpdate: { __typename?: 'OrderUpdate', order: { __typename?: 'Order', id: string, userEmail: string | null, isShippingRequired: boolean, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'OrderError', code: SaleorOrderErrorCode, field: string | null, message: string | null }> } | null };

export type SaleorPasswordChangeMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SaleorPasswordChangeMutation = { __typename?: 'Mutation', passwordChange: { __typename?: 'PasswordChange', user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorPaymentGatewayInitializeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  paymentGateways?: InputMaybe<Array<SaleorPaymentGatewayToInitialize> | SaleorPaymentGatewayToInitialize>;
}>;


export type SaleorPaymentGatewayInitializeMutation = { __typename?: 'Mutation', paymentGatewayInitialize: { __typename?: 'PaymentGatewayInitialize', gatewayConfigs: Array<{ __typename?: 'PaymentGatewayConfig', id: string, data: any | null, errors: Array<{ __typename?: 'PaymentGatewayConfigError', code: SaleorPaymentGatewayConfigErrorCode, field: string | null, message: string | null }> | null }> | null, errors: Array<{ __typename?: 'PaymentGatewayInitializeError', code: SaleorPaymentGatewayInitializeErrorCode, field: string | null, message: string | null }> } | null };

export type SaleorRequestEmailChangeMutationVariables = Exact<{
  newEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaleorRequestEmailChangeMutation = { __typename?: 'Mutation', requestEmailChange: { __typename?: 'RequestEmailChange', user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorRequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type SaleorRequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: { __typename?: 'RequestPasswordReset', errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorSetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SaleorSetPasswordMutation = { __typename?: 'Mutation', setPassword: { __typename?: 'SetPassword', token: string | null, refreshToken: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorTokenCreateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SaleorTokenCreateMutation = { __typename?: 'Mutation', tokenCreate: { __typename?: 'CreateToken', token: string | null, refreshToken: string | null, csrfToken: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorTokenRefreshMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type SaleorTokenRefreshMutation = { __typename?: 'Mutation', tokenRefresh: { __typename?: 'RefreshToken', token: string | null, errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorTokensDeactivateAllMutationVariables = Exact<{ [key: string]: never; }>;


export type SaleorTokensDeactivateAllMutation = { __typename?: 'Mutation', tokensDeactivateAll: { __typename?: 'DeactivateAllUserTokens', errors: Array<{ __typename?: 'AccountError', field: string | null, message: string | null, code: SaleorAccountErrorCode }> } | null };

export type SaleorTransactionInitializeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  amount: Scalars['PositiveDecimal']['input'];
  gatewayId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
}>;


export type SaleorTransactionInitializeMutation = { __typename?: 'Mutation', transactionInitialize: { __typename?: 'TransactionInitialize', data: any | null, transaction: { __typename?: 'TransactionItem', id: string, pspReference: string, actions: Array<SaleorTransactionActionEnum>, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', id: string, type: SaleorTransactionEventTypeEnum | null, message: string, createdAt: string, amount: { __typename?: 'Money', amount: number, currency: string } }> } | null, transactionEvent: { __typename?: 'TransactionEvent', id: string, type: SaleorTransactionEventTypeEnum | null, message: string, createdAt: string, amount: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'TransactionInitializeError', code: SaleorTransactionInitializeErrorCode, field: string | null, message: string | null }> } | null };

export type SaleorTransactionProcessMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SaleorTransactionProcessMutation = { __typename?: 'Mutation', transactionProcess: { __typename?: 'TransactionProcess', data: any | null, transaction: { __typename?: 'TransactionItem', id: string, pspReference: string, actions: Array<SaleorTransactionActionEnum>, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', id: string, type: SaleorTransactionEventTypeEnum | null, message: string, createdAt: string, amount: { __typename?: 'Money', amount: number, currency: string } }> } | null, transactionEvent: { __typename?: 'TransactionEvent', id: string, type: SaleorTransactionEventTypeEnum | null, message: string, createdAt: string, amount: { __typename?: 'Money', amount: number, currency: string } } | null, errors: Array<{ __typename?: 'TransactionProcessError', code: SaleorTransactionProcessErrorCode, field: string | null, message: string | null }> } | null };

export type SaleorAddressValidationRulesQueryVariables = Exact<{
  countryCode: SaleorCountryCode;
}>;


export type SaleorAddressValidationRulesQuery = { __typename?: 'Query', addressValidationRules: { __typename?: 'AddressValidationData', requiredFields: Array<string>, countryAreaType: string, postalCodeType: string, cityType: string, countryAreaChoices: Array<{ __typename?: 'ChoiceValue', raw: string | null, verbose: string | null }>, cityChoices: Array<{ __typename?: 'ChoiceValue', raw: string | null, verbose: string | null }> } | null };

export type SaleorBundleVariationProductsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaleorBundleVariationProductsQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapCategoryMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null } } }> } | null };

export type SaleorCartStrapDrawerStrapsQueryVariables = Exact<{
  languageCode: SaleorLanguageCodeEnum;
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel: Scalars['String']['input'];
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: SaleorThumbnailFormatEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaleorCartStrapDrawerStrapsQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, otherSizesSkus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, integratedBuckle: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, compatibleBuckles: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } } } }> } | null };

export type SaleorGetCheckoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorGetCheckoutQuery = { __typename?: 'Query', checkout: { __typename?: 'Checkout', id: string, email: string | null, languageCode: SaleorLanguageCodeEnum, isShippingRequired: boolean, voucherCode: string | null, discountName: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, preOrderData: string | null, orderType: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } | null, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId: string | null, relatedProductStrapId: string | null, relatedProductWatchId: string | null, strapPackReference: string | null, hasWarrantyExtension: string | null, relatedBraceletSize: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, color: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxInch: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMinMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, wristSizeMaxMm: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, billingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description: string | null, minimumDeliveryDays: number | null, maximumDeliveryDays: number | null, price: { __typename?: 'Money', amount: number, currency: string } }>, deliveryMethod:
      | { __typename: 'ShippingMethod', id: string, name: string }
      | { __typename: 'Warehouse', id: string, name: string }
     | null, discount: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string } } | null };

export type SaleorGwpDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
}>;


export type SaleorGwpDetailsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, name: string, attribute: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, slug: string | null }, values: Array<{ __typename?: 'AttributeValue', id: string, name: string | null, translation: { __typename?: 'AttributeValueTranslation', plainText: string | null, name: string } | null }> } | null } | null };

export type SaleorMeQueryVariables = Exact<{ [key: string]: never; }>;


export type SaleorMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress: { __typename?: 'Address', id: string, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, cityArea: string, postalCode: string, countryArea: string, phone: string | null, isDefaultBillingAddress: boolean | null, isDefaultShippingAddress: boolean | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null };

export type SaleorGetOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorGetOrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, number: string, created: string, status: SaleorOrderStatus, statusDisplay: string, userEmail: string | null, shippingMethodName: string | null, orderStatus: string | null, orderBrand: string | null, orderType: string | null, preOrderData: string | null, deliveryMode: string | null, isOfflinePayment: string | null, isGift: string | null, giftFrom: string | null, giftMessage: string | null, businessId: string | null, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, created: string, trackingNumber: string, status: SaleorFulfillmentStatus, trackingUrl: string | null, returnBid: string | null, returnCreatedAt: string | null, returnStatus: string | null, returnNumber: string | null, lines: Array<{ __typename?: 'FulfillmentLine', orderLine: { __typename?: 'OrderLine', id: string } | null }> | null }>, lines: Array<{ __typename?: 'OrderLine', id: string, quantity: number, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku: string | null, name: string, product: { __typename?: 'Product', id: string, name: string, slug: string, productType: { __typename?: 'ProductType', name: string, slug: string }, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, shotType: string | null }> | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } }>, subtotal: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingAddress: { __typename?: 'Address', firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, postalCode: string, countryArea: string, phone: string | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress: { __typename?: 'Address', firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, city: string, postalCode: string, countryArea: string, phone: string | null, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, channel: { __typename?: 'Channel', slug: string } } | null };

export type SaleorOrderByTransactionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaleorOrderByTransactionQuery = { __typename?: 'Query', transaction: { __typename?: 'TransactionItem', id: string, order: { __typename?: 'Order', id: string } | null } | null };

export type SaleorGetOrderStatusEventsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaleorGetOrderStatusEventsQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, events: Array<{ __typename?: 'OrderEvent', message: string | null, date: string | null }> } | null };

export type SaleorOrderTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaleorOrderTransactionsQuery = { __typename?: 'Query', order: { __typename?: 'Order', orderSource: string | null, isOfflinePayment: string | null, transactions: Array<{ __typename?: 'TransactionItem', id: string, paymentData: string | null, paymentMethod: string | null, forGiftPaymentData: string | null, oricoFinancingAppPaymentData: string | null, genericPaymentData: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type: SaleorTransactionEventTypeEnum | null, createdAt: string, pspReference: string, amount: { __typename?: 'Money', amount: number, currency: string } }> }> } | null };

export type SaleorPayPerLinkOrderDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaleorPayPerLinkOrderDataQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, orderStatus: string | null, payPerLinkToken: string | null, payPerLinkExpiration: string | null, total: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number } } } | null };

export type SaleorProductVariantEyewearBasicDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  largeMediaSize: Scalars['Int']['input'];
  imagesFormat: SaleorThumbnailFormatEnum;
  ugMedia?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaleorProductVariantEyewearBasicDetailsQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'ProductTranslation', description: string | null, name: string | null } | null, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, mediaLarge: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, pricing: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameShape: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frameMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, coreWire: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, templeTipDetail: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frontalPins: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensSurface: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lensCoating: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, uvProtection: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, frontalWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bundleVariations: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModelStory: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, manualUrl: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type SaleorProductVariantPriceQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type SaleorProductVariantPriceQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null };

export type SaleorProductVariantStrapBasicDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  largeMediaSize: Scalars['Int']['input'];
  imagesFormat: SaleorThumbnailFormatEnum;
  ugMedia?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaleorProductVariantStrapBasicDetailsQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'ProductTranslation', description: string | null, name: string | null } | null, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, mediaLarge: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, pricing: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, otherSizesSkus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, integratedBuckle: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, lugSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lug: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lugType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapBuckleType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleBuckles: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapLength: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type SaleorProductVariantWatchBasicDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  largeMediaSize: Scalars['Int']['input'];
  imagesFormat: SaleorThumbnailFormatEnum;
  ugMedia?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaleorProductVariantWatchBasicDetailsQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'ProductTranslation', description: string | null, name: string | null } | null, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, mediaLarge: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, specificText: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, relatedProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, compatibleStraps: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, manualUrl: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, pricing: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail: { __typename?: 'Image', alt: string | null, url: string } | null, collections: Array<{ __typename?: 'Collection', name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null }> | null, model: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug: string | null, name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, defaultVariant: { __typename?: 'ProductVariant', sku: string | null } | null, watchName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, eyewearModel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, digitalItemName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingPartner: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, marketingCampaign: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, distributionStatus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, launchDate: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name: string | null }> } | null, limited: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, comReference: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, buckleSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, modelStory: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, subCollection: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, waterResistance: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, waterResistanceTextComputed: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, diameter: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, carouselProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caliber: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movement: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, chronograph: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, vibration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, jewel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, calendar: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, caseback: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, bezel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, crown: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, crystal: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, headWeight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, lug: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, warrantyExtensionDuration: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementManufacture: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, bundleVariations: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, comCategories: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, designerChoice: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, personalizedEngraving: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, caseDimensions: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementDiameter: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, movementHeight: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, otherFunctions: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, batteryLife: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMarketingDescription: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type SaleorProductsByMarketingPartnerQueryVariables = Exact<{
  modelName: Scalars['String']['input'];
  marketingPartner: Scalars['String']['input'];
  strapMaterial: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaleorProductsByMarketingPartnerQuery = { __typename?: 'Query', products: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, defaultVariant: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, attributes: Array<{ __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, name: string | null, slug: string | null, inputType: SaleorAttributeInputTypeEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, externalReference: string | null, slug: string | null, inputType: SaleorAttributeInputTypeEnum | null }> }> } }> } | null };

export type SaleorProductsBySkusForGtmQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaleorProductsBySkusForGtmQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, quantityAvailable: number | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, collections: Array<{ __typename?: 'Collection', slug: string }> | null, caseMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, strapMaterial: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, size: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, comCategories: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } } } }> } | null };

export type SaleorProductsBySlugsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaleorProductsBySlugsQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } } }> } | null };

export type SaleorStrapBucklesQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<SaleorProductVariantFilterInput>;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: SaleorThumbnailFormatEnum;
}>;


export type SaleorStrapBucklesQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, product: { __typename?: 'Product', id: string, name: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, buckleName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } }> } | null };

export type SaleorStrapToolsQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<SaleorProductFilterInput>;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: SaleorThumbnailFormatEnum;
}>;


export type SaleorStrapToolsQuery = { __typename?: 'Query', products: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, defaultVariant: { __typename?: 'ProductVariant', id: string, sku: string | null, product: { __typename?: 'Product', id: string, name: string, translation: { __typename?: 'ProductTranslation', name: string | null } | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, buckleName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, toolName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } }, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null } }> } | null };

export type SaleorProductTypeBySlugQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filter?: InputMaybe<SaleorProductTypeFilterInput>;
}>;


export type SaleorProductTypeBySlugQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypeCountableConnection', edges: Array<{ __typename?: 'ProductTypeCountableEdge', node: { __typename?: 'ProductType', id: string, slug: string } }> } | null };

export type SaleorStrapSizesQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  limit: Scalars['Int']['input'];
  filter: SaleorProductVariantFilterInput;
}>;


export type SaleorStrapSizesQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, pricing: { __typename?: 'VariantPricingInfo', price: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', otherSizesSkus: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, currentSize: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null, unit: SaleorMeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, value: string | null, slug: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, productType: { __typename?: 'ProductType', id: string, name: string, slug: string } } } }> } | null };

export type SaleorUgCollectionDetailsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
}>;


export type SaleorUgCollectionDetailsQuery = { __typename?: 'Query', collection: { __typename?: 'Collection', id: string, name: string, slug: string, description: string | null, translation: { __typename?: 'CollectionTranslation', name: string | null, description: string | null } | null, products: { __typename?: 'ProductCountableConnection', totalCount: number | null } | null } | null };

export type SaleorUgCollectionProductsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  first: Scalars['Int']['input'];
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  ugMedia?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaleorUgCollectionProductsQuery = { __typename?: 'Query', collection: { __typename?: 'Collection', id: string, name: string, slug: string, translation: { __typename?: 'CollectionTranslation', name: string | null } | null, products: { __typename?: 'ProductCountableConnection', totalCount: number | null, edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, media: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: SaleorProductMediaType, originalUrl?: string, sourcePath?: string | null, delta?: string | null, strapPreviewCoordinates: string | null, backEngravingCoordinates: string | null, shotType: string | null }> | null, variants: Array<{ __typename?: 'ProductVariant', sku: string | null }> | null, model: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionText: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionName: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, carouselProducts: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null } }> } | null } | null };

export type SaleorUgRelatedProductsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel: Scalars['String']['input'];
  languageCode: SaleorLanguageCodeEnum;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaleorUgRelatedProductsQuery = { __typename?: 'Query', productVariants: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, collections: Array<{ __typename?: 'Collection', slug: string }> | null, model: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, dialColor: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, collectionLabel: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', name: string | null, plainText: string | null, slug: string | null, externalReference: string | null, translation: { __typename?: 'AttributeValueTranslation', name: string, plainText: string | null } | null }> } | null, designerChoice: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean: boolean | null, slug: string | null }> } | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, media: Array<{ __typename?: 'ProductMedia', sortOrder: number | null, alt: string, url: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }> | null } } }> } | null };

export type SaleorUserCheckQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SaleorUserCheckQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, isActive: boolean } | null };

export type SaleorUserCheckoutsQueryVariables = Exact<{
  userEmail: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaleorUserCheckoutsQuery = { __typename?: 'Query', checkouts: { __typename?: 'CheckoutCountableConnection', edges: Array<{ __typename?: 'CheckoutCountableEdge', node: { __typename?: 'Checkout', id: string, created: string, updatedAt: string, orderBrand: string | null, channel: { __typename?: 'Channel', slug: string }, user: { __typename?: 'User', id: string, email: string } | null, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number }> } }> } | null };

export type SaleorUserOrdersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SaleorCustomerOrderWhereInput>;
  thumbnailSize?: InputMaybe<Scalars['Int']['input']>;
  imagesFormat?: InputMaybe<SaleorThumbnailFormatEnum>;
}>;


export type SaleorUserOrdersQuery = { __typename?: 'Query', me: { __typename?: 'User', orders: { __typename?: 'OrderCountableConnection', totalCount: number | null, edges: Array<{ __typename?: 'OrderCountableEdge', node: { __typename?: 'Order', id: string, number: string, created: string, status: SaleorOrderStatus, statusDisplay: string, orderStatus: string | null, orderBrand: string | null, businessId: string | null, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, status: SaleorFulfillmentStatus, created: string, returnBid: string | null, returnCreatedAt: string | null, returnStatus: string | null, lines: Array<{ __typename?: 'FulfillmentLine', orderLine: { __typename?: 'OrderLine', id: string, productName: string, variantName: string, quantity: number, totalPrice: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', amount: number, currency: string } }, variant: { __typename?: 'ProductVariant', sku: string | null, product: { __typename?: 'Product', productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } } | null } | null }> | null }>, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, lines: Array<{ __typename?: 'OrderLine', id: string, productName: string, variantName: string, quantity: number, variant: { __typename?: 'ProductVariant', sku: string | null, product: { __typename?: 'Product', productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null } } | null, thumbnail: { __typename?: 'Image', url: string, alt: string | null } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string | null } } | null } | null };

export const AccountErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountErrorFragment, unknown>;
export const ProductTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorProductTypeFragment, unknown>;
export const MultiselectAttributeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorMultiselectAttributeFragment, unknown>;
export const MoneyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorMoneyFragment, unknown>;
export const TaxedMoneyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorTaxedMoneyFragment, unknown>;
export const AddToBagProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddToBagProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorAddToBagProductFragment, unknown>;
export const ChoiceValueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChoiceValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChoiceValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}},{"kind":"Field","name":{"kind":"Name","value":"verbose"}}]}}]} as unknown as DocumentNode<SaleorChoiceValueFragment, unknown>;
export const AddressValidationDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressValidationData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressValidationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredFields"}},{"kind":"Field","name":{"kind":"Name","value":"countryAreaChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChoiceValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cityChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChoiceValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryAreaType"}},{"kind":"Field","name":{"kind":"Name","value":"postalCodeType"}},{"kind":"Field","name":{"kind":"Name","value":"cityType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChoiceValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChoiceValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}},{"kind":"Field","name":{"kind":"Name","value":"verbose"}}]}}]} as unknown as DocumentNode<SaleorAddressValidationDataFragment, unknown>;
export const AddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SaleorAddressFragment, unknown>;
export const AuthUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SaleorAuthUserFragment, unknown>;
export const BusinessIdMetadataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessIdMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectWithMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"businessId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.bid","block":false}}]}]}}]} as unknown as DocumentNode<SaleorBusinessIdMetadataFragment, unknown>;
export const ImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SaleorImageFragment, unknown>;
export const BoolAttributeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorBoolAttributeFragment, unknown>;
export const CartStrapDrawerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartStrapDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"otherSizesSkus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-other-sizes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integratedBuckle"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-integrated-buckle","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleBuckles"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-compatible-buckles","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorCartStrapDrawerFragment, unknown>;
export const ChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<SaleorChannelFragment, unknown>;
export const DropdownAttributeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]} as unknown as DocumentNode<SaleorDropdownAttributeFragment, unknown>;
export const ProductThumbnailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]} as unknown as DocumentNode<SaleorProductThumbnailFragment, unknown>;
export const LineProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]} as unknown as DocumentNode<SaleorLineProductFragment, unknown>;
export const ProductVariantLineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}}]} as unknown as DocumentNode<SaleorProductVariantLineFragment, unknown>;
export const CheckoutLineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}}]} as unknown as DocumentNode<SaleorCheckoutLineFragment, unknown>;
export const ShippingMethodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorShippingMethodFragment, unknown>;
export const DeliveryMethodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SaleorDeliveryMethodFragment, unknown>;
export const CheckoutFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SaleorCheckoutFragment, unknown>;
export const CheckoutErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutErrorFragment, unknown>;
export const OrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCharged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAuthorized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SaleorOrderFragment, unknown>;
export const OrderErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorOrderErrorFragment, unknown>;
export const ProductUrlBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorProductUrlBaseFragment, unknown>;
export const ProductMediaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}}]} as unknown as DocumentNode<SaleorProductMediaFragment, unknown>;
export const NumericAttributeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorNumericAttributeFragment, unknown>;
export const EyewearAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EyewearAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eyewearMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-short-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameShape"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-colour","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-material","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"coreWire"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-core-wire","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"templeTipDetail"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-temple-tip-detail","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frontalPins"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frontal-pins","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensSurface"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-surface","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-colour","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensCoating"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-coating","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uvProtection"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-uv-protection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frontalWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frontal-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"templeLength"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-temple-length","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bridgeWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-bridge-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundleVariations"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"pim-bundle-variations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModelStory"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorEyewearAttributesFragment, unknown>;
export const ProductVariantEyewearBasicDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantEyewearBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUrlBase"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mediaLarge"},"name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EyewearAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayGrossPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EyewearAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eyewearMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-short-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameShape"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-colour","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-material","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"coreWire"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-core-wire","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"templeTipDetail"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-temple-tip-detail","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frontalPins"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frontal-pins","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensSurface"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-surface","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-colour","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensCoating"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-coating","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uvProtection"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-uv-protection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frontalWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frontal-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"templeLength"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-temple-length","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bridgeWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-bridge-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundleVariations"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"pim-bundle-variations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModelStory"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SaleorProductVariantEyewearBasicDetailsFragment, unknown>;
export const StrapAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StrapAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"otherSizesSkus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-other-sizes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integratedBuckle"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-integrated-buckle","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-lug-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lug"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-bar-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapBuckleType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-s-buckle-type","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleBuckles"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-compatible-buckles","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapLength"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-length","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]} as unknown as DocumentNode<SaleorStrapAttributesFragment, unknown>;
export const ProductVariantStrapBasicDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantStrapBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUrlBase"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mediaLarge"},"name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StrapAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayGrossPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StrapAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"otherSizesSkus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-other-sizes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integratedBuckle"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-integrated-buckle","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-lug-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lug"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-bar-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapBuckleType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-s-buckle-type","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleBuckles"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-compatible-buckles","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapLength"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-length","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SaleorProductVariantStrapBasicDetailsFragment, unknown>;
export const WatchAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WatchAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingPartner"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-partner","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingCampaign"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-campaign","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"distributionStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-distribution-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"limited"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-limited-edition","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comReference"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-reference","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-type-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"modelStory"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"subCollection"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-sub-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"waterResistance"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-water-resistant-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"waterResistanceTextComputed"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-water-resistant-mktg-text-computed","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"diameter"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-diameter","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"thickness"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-thickness","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"weight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-net-product-weight","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"powerReserve"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-power-reserve","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-related-products","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"carouselProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-carousel-products-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caliber"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calibre-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movement"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-desc-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"chronograph"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-chronograph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vibration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-frequence-vph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jewel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-number-of-jewels","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calendar"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calendar","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseback"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wba-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bezel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbz-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crown"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wcr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crystal"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdu-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"headWeight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-net-watch-head-weight","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"height"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-height","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caliber"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calibre-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-bar-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lug"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-warranty-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementManufacture"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-manufacture","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calendar"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calendar","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"chronograph"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-chronograph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundleVariations"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"pim-bundle-variations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comCategories"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-categories","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"designerChoice"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-designerchoice","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"personalizedEngraving"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wba-personalized-engraving","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseDimensions"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-dimensions-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementDiameter"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-diameter","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementHeight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-height","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"otherFunctions"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-other-functions","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"batteryLife"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-battery-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorWatchAttributesFragment, unknown>;
export const ProductVariantWatchBasicDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantWatchBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUrlBase"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mediaLarge"},"name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"specificText"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-specific-text","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-related-products","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WatchAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayGrossPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WatchAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingPartner"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-partner","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingCampaign"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-campaign","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"distributionStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-distribution-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"limited"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-limited-edition","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comReference"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-reference","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-type-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"modelStory"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"subCollection"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-sub-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"waterResistance"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-water-resistant-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"waterResistanceTextComputed"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-water-resistant-mktg-text-computed","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"diameter"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-diameter","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"thickness"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-thickness","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"weight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-net-product-weight","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"powerReserve"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-power-reserve","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-related-products","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"carouselProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-carousel-products-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caliber"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calibre-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movement"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-desc-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"chronograph"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-chronograph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vibration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-frequence-vph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jewel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-number-of-jewels","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calendar"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calendar","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseback"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wba-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bezel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbz-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crown"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wcr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crystal"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdu-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"headWeight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-net-watch-head-weight","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"height"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-height","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caliber"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calibre-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-bar-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lug"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-warranty-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementManufacture"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-manufacture","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calendar"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calendar","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"chronograph"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-chronograph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundleVariations"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"pim-bundle-variations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comCategories"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-categories","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"designerChoice"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-designerchoice","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"personalizedEngraving"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wba-personalized-engraving","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseDimensions"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-dimensions-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementDiameter"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-diameter","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementHeight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-height","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"otherFunctions"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-other-functions","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"batteryLife"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-battery-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SaleorProductVariantWatchBasicDetailsFragment, unknown>;
export const TransactionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"ADYEN_APP.PAYMENT_DATA","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"paymentMethod"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"transaction.payment_method","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"forGiftPaymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"4GIFT.PAYMENT_DATA","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"oricoFinancingAppPaymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"ORICO_FINANCING_APP.PAYMENT_DATA","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"genericPaymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"transaction.payment_data","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"authorizedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargePendingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pspReference"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorTransactionItemFragment, unknown>;
export const AccountAddressCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountAddressCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressTypeEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountAddressCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountAddressCreateMutation, SaleorAccountAddressCreateMutationVariables>;
export const AccountAddressDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountAddressDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountAddressDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountAddressDeleteMutation, SaleorAccountAddressDeleteMutationVariables>;
export const AccountAddressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountAddressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountAddressUpdateMutation, SaleorAccountAddressUpdateMutationVariables>;
export const AccountRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountRegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRegister"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiresConfirmation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountRegisterMutation, SaleorAccountRegisterMutationVariables>;
export const AccountSetDefaultAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountSetDefaultAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountSetDefaultAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountSetDefaultAddressMutation, SaleorAccountSetDefaultAddressMutationVariables>;
export const AccountUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAccountUpdateMutation, SaleorAccountUpdateMutationVariables>;
export const AddressSetDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddressSetDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressSetDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorAddressSetDefaultMutation, SaleorAddressSetDefaultMutationVariables>;
export const CheckoutAddPromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutAddPromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutAddPromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"promoCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutAddPromoCodeMutation, SaleorCheckoutAddPromoCodeMutationVariables>;
export const CheckoutBillingAddressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutBillingAddressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validationRules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutAddressValidationRules"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutBillingAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"validationRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validationRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutBillingAddressUpdateMutation, SaleorCheckoutBillingAddressUpdateMutationVariables>;
export const CheckoutCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lines"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLineInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lines"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lines"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutCreateMutation, SaleorCheckoutCreateMutationVariables>;
export const CheckoutCustomerAttachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutCustomerAttach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutCustomerAttach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutCustomerAttachMutation, SaleorCheckoutCustomerAttachMutationVariables>;
export const CheckoutDeliveryMethodUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutDeliveryMethodUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutDeliveryMethodUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"deliveryMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutDeliveryMethodUpdateMutation, SaleorCheckoutDeliveryMethodUpdateMutationVariables>;
export const CheckoutEmailUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutEmailUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutEmailUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutEmailUpdateMutation, SaleorCheckoutEmailUpdateMutationVariables>;
export const CheckoutLinesAddDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutLinesAdd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lines"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLineInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutLinesAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lines"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lines"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutLinesAddMutation, SaleorCheckoutLinesAddMutationVariables>;
export const CheckoutLinesDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutLinesDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linesIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutLinesDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"linesIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linesIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutLinesDeleteMutation, SaleorCheckoutLinesDeleteMutationVariables>;
export const CheckoutLinesUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutLinesUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lines"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLineUpdateInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutLinesUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lines"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lines"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutLinesUpdateMutation, SaleorCheckoutLinesUpdateMutationVariables>;
export const CheckoutRemovePromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutRemovePromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCodeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutRemovePromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"promoCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"promoCodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutRemovePromoCodeMutation, SaleorCheckoutRemovePromoCodeMutationVariables>;
export const CheckoutShippingAddressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutShippingAddressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutShippingAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorCheckoutShippingAddressUpdateMutation, SaleorCheckoutShippingAddressUpdateMutationVariables>;
export const ConfirmAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorConfirmAccountMutation, SaleorConfirmAccountMutationVariables>;
export const ConfirmEmailChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmEmailChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmEmailChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorConfirmEmailChangeMutation, SaleorConfirmEmailChangeMutationVariables>;
export const CustomerCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CustomerCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorCustomerCreateMutation, SaleorCustomerCreateMutationVariables>;
export const CustomerUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CustomerUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorCustomerUpdateMutation, SaleorCustomerUpdateMutationVariables>;
export const OrderUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalReference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalReference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalReference"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCharged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAuthorized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaleorOrderUpdateMutation, SaleorOrderUpdateMutationVariables>;
export const PasswordChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PasswordChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passwordChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorPasswordChangeMutation, SaleorPasswordChangeMutationVariables>;
export const PaymentGatewayInitializeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaymentGatewayInitialize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PositiveDecimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentGateways"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentGatewayToInitialize"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGatewayInitialize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentGateways"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentGateways"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorPaymentGatewayInitializeMutation, SaleorPaymentGatewayInitializeMutationVariables>;
export const RequestEmailChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestEmailChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestEmailChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorRequestEmailChangeMutation, SaleorRequestEmailChangeMutationVariables>;
export const RequestPasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPasswordReset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorRequestPasswordResetMutation, SaleorRequestPasswordResetMutationVariables>;
export const SetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorSetPasswordMutation, SaleorSetPasswordMutationVariables>;
export const TokenCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TokenCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"csrfToken"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorTokenCreateMutation, SaleorTokenCreateMutationVariables>;
export const TokenRefreshDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TokenRefresh"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRefresh"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorTokenRefreshMutation, SaleorTokenRefreshMutationVariables>;
export const TokensDeactivateAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TokensDeactivateAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokensDeactivateAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<SaleorTokensDeactivateAllMutation, SaleorTokensDeactivateAllMutationVariables>;
export const TransactionInitializeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransactionInitialize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PositiveDecimal"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gatewayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionInitialize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentGateway"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gatewayId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pspReference"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"authorizedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorTransactionInitializeMutation, SaleorTransactionInitializeMutationVariables>;
export const TransactionProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransactionProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pspReference"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"authorizedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorTransactionProcessMutation, SaleorTransactionProcessMutationVariables>;
export const AddressValidationRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddressValidationRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressValidationRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressValidationData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChoiceValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChoiceValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}},{"kind":"Field","name":{"kind":"Name","value":"verbose"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressValidationData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddressValidationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredFields"}},{"kind":"Field","name":{"kind":"Name","value":"countryAreaChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChoiceValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cityChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChoiceValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryAreaType"}},{"kind":"Field","name":{"kind":"Name","value":"postalCodeType"}},{"kind":"Field","name":{"kind":"Name","value":"cityType"}}]}}]} as unknown as DocumentNode<SaleorAddressValidationRulesQuery, SaleorAddressValidationRulesQueryVariables>;
export const BundleVariationProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BundleVariationProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapCategoryMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-category-materials","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]} as unknown as DocumentNode<SaleorBundleVariationProductsQuery, SaleorBundleVariationProductsQueryVariables>;
export const CartStrapDrawerStrapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CartStrapDrawerStraps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartStrapDrawer"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartStrapDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"otherSizesSkus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-other-sizes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integratedBuckle"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-integrated-buckle","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleBuckles"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-compatible-buckles","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}}]}}]}}]} as unknown as DocumentNode<SaleorCartStrapDrawerStrapsQuery, SaleorCartStrapDrawerStrapsQueryVariables>;
export const GetCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductThumbnail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxInch"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-inch","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMinMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-min-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wristSizeMaxMm"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-wrist-size-max-mm","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductThumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineProduct"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckoutLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"undiscountedUnitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductBuckleId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.buckle","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductStrapId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.product.strap","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedProductWatchId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"related.watch","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"strapPackReference"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"strap_pack_reference","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasWarrantyExtension"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"has.warranty_ext","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"relatedBraceletSize"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"relatedBraceletSize","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minimumDeliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDeliveryDays"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryMethod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckoutLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isShippingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"voucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountName"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]}]}}]} as unknown as DocumentNode<SaleorGetCheckoutQuery, SaleorGetCheckoutQueryVariables>;
export const GwpDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GwpDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-gwp-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaleorGwpDetailsQuery, SaleorGwpDetailsQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthUser"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityArea"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultBillingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}}]}}]}}]} as unknown as DocumentNode<SaleorMeQuery, SaleorMeQueryVariables>;
export const GetOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BusinessIdMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDisplay"}},{"kind":"Field","alias":{"kind":"Name","value":"orderStatus"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.status","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderBrand"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.brand","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.type","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"preOrderData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"preorder_data","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"deliveryMode"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.delivery_mode","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"totalAuthorized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCharged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodName"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"trackingUrl"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"fulfillment.tracking_url","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"returnBid"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.bid","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"returnCreatedAt"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.created_at","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"returnStatus"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.status","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"returnNumber"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.bid","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"isOfflinePayment"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.is_offline_payment","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"isGift"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftFrom"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_from","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"giftMessage"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"gift_message","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress1"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryArea"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessIdMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectWithMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"businessId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.bid","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorGetOrderQuery, SaleorGetOrderQueryVariables>;
export const OrderByTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderByTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorOrderByTransactionQuery, SaleorOrderByTransactionQueryVariables>;
export const GetOrderStatusEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderStatusEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorGetOrderStatusEventsQuery, SaleorGetOrderStatusEventsQueryVariables>;
export const OrderTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orderSource"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.source","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"isOfflinePayment"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.is_offline_payment","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"ADYEN_APP.PAYMENT_DATA","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"paymentMethod"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"transaction.payment_method","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"forGiftPaymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"4GIFT.PAYMENT_DATA","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"oricoFinancingAppPaymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"ORICO_FINANCING_APP.PAYMENT_DATA","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"genericPaymentData"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"transaction.payment_data","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"authorizedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargePendingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pspReference"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorOrderTransactionsQuery, SaleorOrderTransactionsQueryVariables>;
export const PayPerLinkOrderDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PayPerLinkOrderData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"orderStatus"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.status","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"payPerLinkToken"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.pay_per_link_token","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"payPerLinkExpiration"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.pay_per_link_token_expiration_time","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaleorPayPerLinkOrderDataQuery, SaleorPayPerLinkOrderDataQueryVariables>;
export const ProductVariantEyewearBasicDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantEyewearBasicDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantEyewearBasicDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EyewearAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eyewearMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-short-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameShape"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-colour","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frameMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frame-material","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"coreWire"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-core-wire","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"templeTipDetail"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-temple-tip-detail","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frontalPins"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frontal-pins","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensSurface"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-surface","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-colour","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensCoating"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-coating","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uvProtection"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-uv-protection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frontalWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-frontal-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"templeLength"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-temple-length","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lensWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-lens-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bridgeWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-bridge-width","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundleVariations"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"pim-bundle-variations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModelStory"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantEyewearBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUrlBase"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mediaLarge"},"name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EyewearAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayGrossPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SaleorProductVariantEyewearBasicDetailsQuery, SaleorProductVariantEyewearBasicDetailsQueryVariables>;
export const ProductVariantPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorProductVariantPriceQuery, SaleorProductVariantPriceQueryVariables>;
export const ProductVariantStrapBasicDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantStrapBasicDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantStrapBasicDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StrapAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"otherSizesSkus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-other-sizes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integratedBuckle"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-integrated-buckle","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-lug-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lug"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-bar-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapBuckleType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-s-buckle-type","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleBuckles"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-compatible-buckles","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapLength"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-length","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantStrapBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUrlBase"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mediaLarge"},"name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StrapAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayGrossPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SaleorProductVariantStrapBasicDetailsQuery, SaleorProductVariantStrapBasicDetailsQueryVariables>;
export const ProductVariantWatchBasicDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantWatchBasicDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariantWatchBasicDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUrlBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"watchName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-product-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-warranty-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eyewearModel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"mer-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"digitalItemName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-item-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NumericAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WatchAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"marketingStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingPartner"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-partner","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"marketingCampaign"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-campaign","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"distributionStatus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-distribution-status","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"launchDate"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-launch-date","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"limited"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-limited-edition","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comReference"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-reference","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-type-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"modelStory"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"subCollection"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-sub-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"waterResistance"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-water-resistant-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"waterResistanceTextComputed"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-water-resistant-mktg-text-computed","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"diameter"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-diameter","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"thickness"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-thickness","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"weight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-net-product-weight","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"powerReserve"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-power-reserve","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-related-products","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"carouselProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-carousel-products-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caliber"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calibre-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movement"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-desc-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"chronograph"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-chronograph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"vibration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-frequence-vph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jewel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-number-of-jewels","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calendar"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calendar","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseback"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wba-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bezel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbz-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crown"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wcr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crystal"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdu-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"headWeight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-net-watch-head-weight","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"height"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-height","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caliber"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calibre-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lugWidth"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NumericAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapType"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-bar-shape","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lug"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-distance-between-horns","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-warranty-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"warrantyExtensionDuration"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-warranty-extension-duration","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementManufacture"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-movement-manufacture","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calendar"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-calendar","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"chronograph"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-chronograph","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundleVariations"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"pim-bundle-variations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comCategories"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-categories","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"designerChoice"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-designerchoice","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"personalizedEngraving"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wba-personalized-engraving","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseDimensions"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-dimensions-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementDiameter"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-diameter","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movementHeight"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-height","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"otherFunctions"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-other-functions","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"batteryLife"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmo-battery-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMarketingDescription"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-description-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariantWatchBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUrlBase"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mediaLarge"},"name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"largeMediaSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"specificText"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-specific-text","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"relatedProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-related-products","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compatibleStraps"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wmf-compatible-straps","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manualUrl"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"manual-url","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WatchAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayGrossPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SaleorProductVariantWatchBasicDetailsQuery, SaleorProductVariantWatchBasicDetailsQueryVariables>;
export const ProductsByMarketingPartnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsByMarketingPartner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketingPartner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"strapMaterial"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"32"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"modelName"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-marketing-partner","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"marketingPartner"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"strapMaterial"}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"inputType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"inputType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaleorProductsByMarketingPartnerQuery, SaleorProductsByMarketingPartnerQueryVariables>;
export const ProductsBySkusForGtmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsBySkusForGtm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"caseMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wca-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-color","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strapMaterial"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-material-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"size"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comCategories"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-categories","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]} as unknown as DocumentNode<SaleorProductsBySkusForGtmQuery, SaleorProductsBySkusForGtmQueryVariables>;
export const ProductsBySlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsBySlugs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaleorProductsBySlugsQuery, SaleorProductsBySlugsQueryVariables>;
export const StrapBucklesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StrapBuckles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddToBagProduct"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddToBagProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorStrapBucklesQuery, SaleorStrapBucklesQueryVariables>;
export const StrapToolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StrapTools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddToBagProduct"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddToBagProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buckleName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbu-name-mktg","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"toolName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-tool-name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorStrapToolsQuery, SaleorStrapToolsQueryVariables>;
export const ProductTypeBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTypeBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaleorProductTypeBySlugQuery, SaleorProductTypeBySlugQueryVariables>;
export const StrapSizesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StrapSizes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"otherSizesSkus"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-other-sizes","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentSize"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wbr-current-size","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiselectAttribute"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductType"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiselectAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorStrapSizesQuery, SaleorStrapSizesQueryVariables>;
export const UgCollectionDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UgCollectionDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SaleorUgCollectionDetailsQuery, SaleorUgCollectionDetailsQueryVariables>;
export const UgCollectionProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UgCollectionProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionText"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection-text","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionName"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"carouselProducts"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-carousel-products-not-in-pim","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"originalUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"sourcePath"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"source_path","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"delta"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"delta","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ugMedia"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"strapPreviewCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.strap_preview_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"backEngravingCoordinates"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.back_engraving_coordinates","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"shotType"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"asset.shot_type","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]} as unknown as DocumentNode<SaleorUgCollectionProductsQuery, SaleorUgCollectionProductsQueryVariables>;
export const UgRelatedProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UgRelatedProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"model"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-model","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dialColor"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"wdi-color-of-dial","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collectionLabel"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-collection","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownAttribute"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"designerChoice"},"name":{"kind":"Name","value":"attribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"com-designerchoice","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoolAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"0"}}]},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DropdownAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoolAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<SaleorUgRelatedProductsQuery, SaleorUgRelatedProductsQueryVariables>;
export const UserCheckDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<SaleorUserCheckQuery, SaleorUserCheckQueryVariables>;
export const UserCheckoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCheckouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATION_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"orderBrand"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.brand","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaleorUserCheckoutsQuery, SaleorUserCheckoutsQueryVariables>;
export const UserOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerOrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"120"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ThumbnailFormatEnum"}},"defaultValue":{"kind":"EnumValue","value":"WEBP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BusinessIdMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDisplay"}},{"kind":"Field","alias":{"kind":"Name","value":"orderStatus"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.status","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"orderBrand"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.brand","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"fulfillments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","alias":{"kind":"Name","value":"returnBid"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.bid","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"returnCreatedAt"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.created_at","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"returnStatus"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"return.status","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imagesFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxedMoney"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessIdMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectWithMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"businessId"},"name":{"kind":"Name","value":"metafield"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"order.bid","block":false}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxedMoney"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxedMoney"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<SaleorUserOrdersQuery, SaleorUserOrdersQueryVariables>;